export const bg = {
    addDatabase: {
        addDatabase: "ÐÐ¾Ð±Ð°Ð²Ð¸ Ð±Ð°Ð·Ð° Ð´Ð°Ð½Ð½Ð¸",
        addFromFile: "ÐÐ¾Ð±Ð°Ð²Ð¸ Ð¾Ñ ÑÐ°Ð¹Ð»",
        analyse: "Analyse",
        analysingYourData: "Analysing your data",
        createFromExcel: "Create from Excel",
        databaseImport: "Database import",
        databaseNotImported: "Import has finished with errors",
        databasePrepared: "Database successfully prepared",
        excelFile: "Excel file",
        fileInformation: "File information",
        fixErrors: "To continue please fix following errors and retry",
        importingYourData: "Importing your data",
        productFilesPath: "Product files path",
        productImagesPath: "Product images path"
    },
    availablePrice: {
        allPackage: "All packages",
        onePackage: "One package",
        priceType: "ÐÐ¸Ð´ ÑÐµÐ½Ð°",
        setPriceVatVisibility: "Set VAT visibility",
        setVisibilityAndOrder: "ÐÐ°Ð´Ð°Ð²Ð°Ð½Ðµ Ð½Ð° Ð²Ð¸Ð´Ð¸Ð¼Ð¾ÑÑ Ð¸ ÑÐµÐ´ Ð½Ð° ÑÐ¸Ð¿Ð¾Ð²ÐµÑÐµ ÑÐµÐ½Ð¸",
        withAndWithoutVat: "ÐÐ°ÐºÑÐ¾ ÑÑÑ, ÑÐ°ÐºÐ° Ð¸ Ð±ÐµÐ· ÐÐÐ¡",
        withVat: "Ð¡Ð°Ð¼Ð¾ Ñ ÐÐÐ¡",
        withoutVat: "Ð¡Ð°Ð¼Ð¾ Ð±ÐµÐ· ÐÐÐ¡"
    },
    barvis: {
        base: "ÐÐ¼Ð° Ð½Ðµ Ð±Ð°Ð·Ð°ÑÐ°",
        bigCanSize: "ÐÐ¾Ð»ÐµÐ¼Ð¸ Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ¸",
        coating: "ÐÐ¾ÐºÑÐ¸ÑÐ¸Ðµ",
        identifier: "ÐÐ´ÐµÐ½ÑÐ¸ÑÐ¸ÐºÐ°ÑÐ¾Ñ",
        laboratory: "ÐÐ°Ð±Ð¾ÑÐ°ÑÐ¾ÑÐ¸Ñ",
        orderOverview: "ÐÑÐµÐ³Ð»ÐµÐ´ Ð½Ð° Ð¿Ð¾ÑÑÑÐºÐ°ÑÐ°",
        rank: "Ð Ð°Ð½Ð³",
        smallCanSize: "ÐÐ°Ð»ÐºÐ¸ Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ¸"
    },
    basicSetup: {
        alreadyLoggedIn: "ÐÐµÑÐµ ÑÑÐµ Ð²Ð»ÐµÐ·Ð»Ð¸ Ð² ÑÐ¸ÑÑÐµÐ¼Ð°ÑÐ° ÐºÐ°ÑÐ¾ %{login}.",
        askSupplier: "ÐÐ¾Ð¼Ð¾Ð»ÐµÑÐµ Ð²Ð°ÑÐ¸Ñ Ð´Ð¾ÑÑÐ°Ð²ÑÐ¸Ðº Ð½Ð° ÑÐ¾ÑÑÑÐµÑ Ð´Ð° Ð²Ð¸ Ð¿ÑÐµÐ´Ð¾ÑÑÐ°Ð²Ð¸ Ð¿Ð¾Ð²ÐµÑÐµ Ð»Ð¸ÑÐµÐ½Ð·Ð¸.",
        asterisk: "ÐÐ»ÐµÐ¼ÐµÐ½ÑÐ¸ÑÐµ, Ð¼Ð°ÑÐºÐ¸ÑÐ°Ð½Ð¸ ÑÑÑ Ð·Ð²ÐµÐ·Ð´Ð¸ÑÐºÐ°, ÑÑÑÐ±Ð²Ð° Ð´Ð° Ð±ÑÐ´Ð°Ñ Ð¿Ð¾Ð¿ÑÐ»Ð½ÐµÐ½Ð¸.",
        identificationKeys: "Identification keys",
        importCustomData:
            "ÐÐºÐ¾ Ðµ Ð¿ÑÐ¸Ð»Ð¾Ð¶Ð¸Ð¼Ð¾, Ð¸Ð¼Ð¿Ð¾ÑÑÐ¸ÑÐ°Ð¹ÑÐµ Ð²Ð°ÑÐ¸ÑÐµ Ð¿ÐµÑÑÐ¾Ð½Ð°Ð»Ð¸Ð·Ð¸ÑÐ°Ð½Ð¸ Ð´Ð°Ð½Ð½Ð¸ Ð¾Ñ Ð¿ÑÐµÐ´Ð¸ÑÐ½Ð¸Ñ ÑÐ¾ÑÑÑÐµÑ Ð·Ð° ÑÐ°Ð·Ð¿ÑÐµÐ´ÐµÐ»ÑÐ½Ðµ.",
        learnIdentification: "ÐÐ°ÑÑÐµÑÐµ Ð¸Ð´ÐµÐ½ÑÐ¸ÑÐ¸ÐºÐ°ÑÐ¸Ð¾Ð½Ð½Ð¸ÑÐµ ÐºÐ»ÑÑÐ¾Ð²Ðµ Ð¾Ñ Ð²Ð°ÑÐ¸Ñ Ð´Ð¾ÑÑÐ°Ð²ÑÐ¸Ðº Ð½Ð° ÑÐ¾ÑÑÑÐµÑ.",
        login: "Ð¡Ð»ÐµÐ´Ð²Ð°ÑÐ¸ÑÐµ ÑÑÑÐ¿ÐºÐ¸ Ð¾Ñ Ð¿ÑÑÐ²Ð¾Ð½Ð°ÑÐ°Ð»Ð½Ð°ÑÐ° Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ° Ð¸Ð·Ð¸ÑÐºÐ²Ð°Ñ Ð°Ð´Ð¼Ð¸Ð½Ð¸ÑÑÑÐ°ÑÐ¾ÑÑÐºÐ¸ Ð¿ÑÐ°Ð²Ð°.",
        noDatabase: "ÐÑÐµ Ð¾ÑÐµ Ð½Ðµ Ðµ Ð´Ð¾Ð±Ð°Ð²ÐµÐ½Ð° Ð±Ð°Ð·Ð° Ð´Ð°Ð½Ð½Ð¸, Ð¿Ð¾Ð½Ðµ ÐµÐ´Ð½Ð° ÑÑÑÐ±Ð²Ð° Ð´Ð° Ð±ÑÐ´Ðµ Ð¿Ð¾ÑÑÐ°Ð²ÐµÐ½Ð°.",
        offlineLicensing: "Offline licensing",
        productSelection: "Product selection",
        registrationForm: "Registration form",
        seeQuestionMark: "ÐÐ¸Ð¶ÑÐµ Ð¼Ð°Ð»ÐºÐ¸ÑÐµ Ð²ÑÐ¿ÑÐ¾ÑÐ¸ÑÐµÐ»Ð½Ð¸, Ð·Ð° Ð´Ð° Ð½Ð°ÑÑÐ¸ÑÐµ Ð¿Ð¾Ð²ÐµÑÐµ Ð·Ð° Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ°ÑÐ°.",
        selectDefaultPrinter: "ÐÐ·Ð±ÐµÑÐµÑÐµ Ð¿ÑÐ¸Ð½ÑÐµÑÐ° Ð¿Ð¾ Ð¿Ð¾Ð´ÑÐ°Ð·Ð±Ð¸ÑÐ°Ð½Ðµ Ð¸ Ð·Ð°Ð´Ð°Ð¹ÑÐµ Ð´Ð¾Ð¿ÑÐ»Ð½Ð¸ÑÐµÐ»Ð½Ð° ÐºÐ¾Ð½ÑÐ¸Ð³ÑÑÐ°ÑÐ¸Ñ.",
        selectDefaultTemplate:
            "ÐÐ·Ð±ÐµÑÐµÑÐµ ÑÐ°Ð±Ð»Ð¾Ð½Ð¸ÑÐµ Ð¿Ð¾ Ð¿Ð¾Ð´ÑÐ°Ð·Ð±Ð¸ÑÐ°Ð½Ðµ Ð¾Ñ Ð²ÐµÑÐµ ÑÑÑÐµÑÑÐ²ÑÐ²Ð°ÑÐ¸ÑÐµ, ÑÑÐ·Ð´Ð°Ð¹ÑÐµ Ð½Ð¾Ð² ÑÐ°Ð±Ð»Ð¾Ð½ Ð¸Ð»Ð¸ Ð·Ð°ÑÐµÐ´ÐµÑÐµ ÑÐ²Ð¾Ð¹ ÑÐ¾Ð±ÑÑÐ²ÐµÐ½.",
        selectDispenser: "ÐÐ·Ð±ÐµÑÐµÑÐµ ÑÐ¸Ð¿Ð° Ð´Ð¾Ð·Ð°ÑÐ¾Ñ, ÐºÐ¾Ð¹ÑÐ¾ Ð¸Ð·Ð¿Ð¾Ð»Ð·Ð²Ð°ÑÐµ.",
        selectLanguage: "ÐÐ·Ð±ÐµÑÐµÑÐµ Ð²Ð°ÑÐ¸Ñ ÐµÐ·Ð¸Ðº.",
        selectProducts: "ÐÐ·Ð±ÐµÑÐµÑÐµ ÐµÐ´Ð¸Ð½ Ð¾Ñ Ð½Ð°Ð»Ð¸ÑÐ½Ð¸ÑÐµ Ð¿ÑÐ¾Ð´ÑÐºÑÐ¸, ÐºÐ¾Ð¸ÑÐ¾ Ð¸ÑÐºÐ°ÑÐµ Ð´Ð° Ð°ÐºÑÐ¸Ð²Ð¸ÑÐ°ÑÐµ.",
        selectSpectroType: "ÐÐ·Ð±ÐµÑÐµÑÐµ ÑÐ¸Ð¿Ð° ÑÐ¿ÐµÐºÑÑÐ¾, ÐºÐ¾Ð¹ÑÐ¾ Ð¸Ð·Ð¿Ð¾Ð»Ð·Ð²Ð°ÑÐµ.",
        setAdditionalPrinterOptions: "ÐÐ°Ð´Ð°Ð¹ÑÐµ Ð´Ð¾Ð¿ÑÐ»Ð½Ð¸ÑÐµÐ»Ð½Ð¸ Ð¾Ð¿ÑÐ¸Ð¸ Ð·Ð° Ð¿ÑÐ¸Ð½ÑÐµÑ.",
        setAutomaticUpdates: "ÐÐ°Ð´Ð°Ð¹ÑÐµ Ð¾Ð¿ÑÐ¸Ð¸ÑÐµ Ð·Ð° Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐ½Ð¸ Ð°ÐºÑÑÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ð¸.",
        setCustomItems:
            "ÐÐ°Ð´Ð°Ð¹ÑÐµ Ð¿ÐµÑÑÐ¾Ð½Ð°Ð»Ð¸Ð·Ð¸ÑÐ°Ð½Ð¸ ÐµÐ»ÐµÐ¼ÐµÐ½ÑÐ¸ Ð¸ Ð²Ð¸Ð´Ð¸Ð¼Ð¾ÑÑ Ð½Ð° Ð´Ð°Ð½Ð½Ð¸ÑÐµ.Â ÐÑÐµÐ²ÑÑÑÐµÑÐµ Ð½Ð°Ð´Ð¾Ð»Ñ, Ð·Ð° Ð´Ð° Ð²Ð¸Ð´Ð¸ÑÐµ Ð¾ÑÐµ Ð¾Ð¿ÑÐ¸Ð¸.",
        setEnvironment: "ÐÐ°Ð´Ð°Ð¹ÑÐµ Ð¾Ð±ÑÐ°ÑÐ° ÑÑÐµÐ´Ð° Ð½Ð° ÑÐ¾ÑÑÑÐµÑÐ°.Â ÐÑÐµÐ²ÑÑÑÐµÑÐµ Ð½Ð°Ð´Ð¾Ð»Ñ, Ð·Ð° Ð´Ð° Ð²Ð¸Ð´Ð¸ÑÐµ Ð¾ÑÐµ Ð¾Ð¿ÑÐ¸Ð¸.",
        setFormulaRepresentation: "ÐÐ°Ð´Ð°Ð¹ÑÐµ Ð¿ÑÐµÐ´ÑÑÐ°Ð²ÑÐ½Ðµ Ð½Ð° ÑÐ¾ÑÐ¼ÑÐ»Ð°ÑÐ°.Â ÐÑÐµÐ²ÑÑÑÐµÑÐµ Ð½Ð°Ð´Ð¾Ð»Ñ, Ð·Ð° Ð´Ð° Ð²Ð¸Ð´Ð¸ÑÐµ Ð¾ÑÐµ Ð¾Ð¿ÑÐ¸Ð¸.",
        summary:
            "ÐÐ¾Ð¶ÐµÑÐµ Ð´Ð° Ð¿ÑÐ¾Ð¼ÐµÐ½Ð¸ÑÐµ ÑÐµÐ·Ð¸ Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ¸ Ð¿Ð¾ Ð²ÑÑÐºÐ¾ Ð²ÑÐµÐ¼Ðµ Ð¸ Ð´Ð° Ð½Ð°Ð¼ÐµÑÐ¸ÑÐµ Ð¾ÑÐµ Ð¾Ð¿ÑÐ¸Ð¸ Ð·Ð° ÐºÐ¾Ð½ÑÐ¸Ð³ÑÑÐ¸ÑÐ°Ð½Ðµ.Â ÐÐ°ÑÐ»Ð°Ð´ÐµÑÐµ ÑÐµ Ð´Ð° Ð¸Ð·Ð¿Ð¾Ð»Ð·Ð²Ð°ÑÐµ %{name}!",
        summarySuccess: "ÐÑÐ¸ÑÐºÐ¸ ÑÑÐµ Ð½Ð°ÑÑÑÐ¾ÐµÐ½Ð¸!"
    },
    beforeDispenseColorantBatch: {
        batchNumber: "Batch number: %{batchNumber}",
        colorantIsDefective: "The canister is filled with a defective batch of colorant. Do not use this batch.",
        defectiveInfoLine1: "Please do not use colorant",
        defectiveInfoLine2: "with this batch number.",
        emptyQuickTint: "Empty the canister using Quick tint.",
        warningInfoLine1: "Colorant",
        warningInfoLine2: "with this batch number may be damaged."
    },
    canisterLevel: {
        canisterLevel: "ÐÐ¸Ð²Ð¾ Ð² ÑÐµÐ·ÐµÑÐ²Ð¾Ð°ÑÐ°",
        criticalLevelCanister: "Critical canister levels",
        fillToMax: "ÐÐ°Ð¿ÑÐ»Ð½Ð¸ Ð´Ð¾ max",
        maxDispenseLevel: "ÐÐ¾Ð·Ð¸ÑÐ°Ð¹ÑÐµ Ð¼Ð°ÐºÑ",
        otherCanisters: "ÐÑÑÐ³Ð¸ ÑÐµÐ·ÐµÑÐ²Ð¾Ð°ÑÐ¸",
        warningLevelCanister: "Warning canister levels"
    },
    canisterRefillHistoryModal: {
        batchNumberOfFilling: "Batch number of filling",
        ufiCodeStatus: "UFI code status"
    },
    canistersTab: {
        availableServiceActions: "ÐÐ°Ð»Ð¸ÑÐ½Ð¸ Ð´ÐµÐ¹ÑÑÐ²Ð¸Ñ Ð·Ð° Ð¾Ð±ÑÐ»ÑÐ¶Ð²Ð°Ð½Ðµ",
        canisterInformation: "ÐÐ½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ Ð·Ð° ÐºÑÑÐ¸Ð¸",
        canisterPreview: "ÐÑÐµÐ³Ð»ÐµÐ´ Ð½Ð° ÑÐµÐ·ÐµÑÐ²Ð¾Ð°ÑÐ°",
        currentLevel: "Ð¢ÐµÐºÑÑÐ¾ Ð½Ð¸Ð²Ð¾",
        errors: "ÐÑÐµÑÐºÐ¸",
        fillState: "Ð¡ÑÑÑÐ¾ÑÐ½Ð¸Ðµ Ð½Ð° Ð½Ð°Ð¿ÑÐ»Ð²Ð°Ð½Ðµ",
        fillToMax: "ÐÐ°Ð¿ÑÐ»Ð½Ð¸ Ð´Ð¾ max",
        fillingAmount: "Filling amount",
        finalLevel: "Final level",
        minimumAmount: "ÐÐ¸Ð½Ð¸Ð¼Ð°Ð»Ð½Ð¾ Ð½Ð¸Ð²Ð¾",
        minimumLevel: "ÐÐ¸Ð½Ð¸Ð¼Ð°Ð»Ð½Ð¾ Ð½Ð¸Ð²Ð¾",
        moveTableToRefill: "ÐÐ°Ð²ÑÑÑÐ¸ Ð¼Ð°ÑÐ°ÑÐ° Ð·Ð° Ð·Ð°Ð¿ÑÐ»Ð²Ð°Ð½Ðµ",
        refillNoAmount: "ÐÑÐ¼Ð° Ð²ÑÐ²ÐµÐ´ÐµÐ½Ð¾ ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾",
        refillOverLimit: "ÐÑÐ²ÐµÐ´ÐµÐ½Ð¾ ÑÐ¾ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾ Ð½Ð°Ð´Ð²Ð¸ÑÐ°Ð²Ð° Ð¼Ð°ÐºÑÐ¸Ð¼Ð°Ð»Ð½Ð¸Ñ ÐºÐ°Ð¿Ð°ÑÐ¸ÑÐµÑ Ð½Ð° ÐºÐ¾Ð½ÑÐµÐ¹Ð½ÐµÑÐ°",
        refillSummary: "%{amount} %{unit} of the colorant %{colorant} will be added to the canister %{canisterId}.",
        systemWarningAmount: "ÐÑÐµÐ´ÑÐ¿ÑÐµÐ¶Ð´ÐµÐ½Ð¸Ðµ Ð·Ð° Ð½Ð¸Ð²Ð¾",
        warningAmount: "ÐÑÐµÐ´ÑÐ¿ÑÐµÐ´Ð¸ÑÐµÐ»Ð½Ð¾ Ð½Ð¸Ð²Ð¾"
    },
    changeDatabase: {
        changeDatabase: "Ð¡Ð¼ÐµÐ½Ð¸ Ð±Ð°Ð·Ð°ÑÐ° Ð´Ð°Ð½Ð½Ð¸",
        databaseWarning: "Database %{databaseName} cannot be used due to"
    },
    changelog: {
        allVersion: "All versions",
        changelog: "Changelog",
        link: "Link",
        links: "Links",
        version: "Version",
        versionFilter: "Version filter"
    },
    checkBeforeDispensing: {
        checkBeforeDispensingModal: "There is not enough colorant in the canisters for %{numOfPackages} packages.",
        fillAdditionally: "Fill additionally",
        refillToMax: "Refill to max"
    },
    cleanChannels: {
        cleanAllChannels: "ÐÐ¾ÑÐ¸ÑÑÐ¸ Ð²ÑÐ¸ÑÐºÐ¸ ÐºÐ°Ð½Ð°Ð»Ð¸",
        cleanChannels: "ÐÐ¾ÑÐ¸ÑÑÐ¸ ÐºÐ°Ð½Ð°Ð»",
        cleaningTime: "ÐÑÐµÐ¼Ðµ Ð·Ð° Ð¿Ð¾ÑÐ¸ÑÑÐ²Ð°Ð½Ðµ",
        selectChannels: "ÐÐ·Ð±Ð¾Ñ Ð½Ð° ÐºÐ°Ð½Ð°Ð»",
        startCleaning: "Ð¡ÑÐ°ÑÑÐ¸ÑÐ°Ð¹ Ð¿Ð¾ÑÐ¸ÑÑÐ²Ð°Ð½Ðµ"
    },
    clientServerSettings: {
        activeServer: "ÐÐºÑÐ¸Ð²Ð½Ð¸ ÑÑÑÐ²ÑÑÐ¸",
        addNewServer: "ÐÐ¾Ð±Ð°Ð²Ð¸ Ð½Ð¾Ð² ÑÑÑÐ²ÑÑ",
        availableServers: "ÐÑÑÐ³Ð¸ Ð´Ð¾ÑÑÑÐ¿Ð½Ð¸ ÑÑÑÐ²ÑÑÐ¸",
        clientIdentifier: "ÐÐ´ÐµÐ½ÑÐ¸ÑÐ¸ÐºÐ°ÑÐ¾Ñ Ð½Ð° ÐºÐ»Ð¸ÐµÐ½ÑÐ°",
        clientServerSettings: "ÐÐ»Ð¸ÐµÐ½ÑÑÐºÐ¸ Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ¸ Ð½Ð° ÑÑÑÐ²ÑÑÐ°",
        disabledStatus: "ÐÐ°Ð±ÑÐ°Ð½ÐµÐ½Ð¾",
        editServer: "Ð ÐµÐ´Ð°ÐºÑÐ¸ÑÐ°Ð¹ ÑÑÑÐ²ÑÑÐ°",
        fillRequiredFields: "Ð¢ÑÑÐ±Ð²Ð° Ð´Ð° ÑÐµ Ð¿Ð¾Ð¿ÑÐ»Ð½ÑÑ Ð·Ð°Ð´ÑÐ»Ð¶Ð¸ÑÐµÐ»Ð½Ð¸ÑÐµ Ð¿Ð¾Ð»ÐµÑÐ°",
        noOtherServers: "ÐÑÐ¼Ð° Ð´ÑÑÐ³Ð¸ Ð°ÐºÑÐ¸Ð²Ð½Ð¸ ÑÑÑÐ²ÑÑÐ¸",
        offlineStatus: "ÐÐ·Ð²ÑÐ½ Ð»Ð¸Ð½Ð¸Ñ",
        onlineStatus: "ÐÐ° Ð»Ð¸Ð½Ð¸Ñ",
        port: "ÐÐ¾ÑÑ",
        serverName: "ÐÐ¼Ðµ Ð½Ð° ÑÑÑÐ²ÑÑÐ°",
        serverNameMissing: "ÐÐ¼ÐµÑÐ¾ Ð½Ð° ÑÑÑÐ²ÑÑÐ° ÑÑÑÐ±Ð²Ð° Ð´Ð° Ð±ÑÐ´Ðµ Ð¿Ð¾Ð¿ÑÐ»Ð½ÐµÐ½Ð¾",
        stabileConnection: "ÐÐ° Ð´Ð° Ð¾ÑÐ¸Ð³ÑÑÐ¸ÑÐµ ÑÑÐ°Ð±Ð¸Ð»Ð½Ð° Ð²ÑÑÐ·ÐºÐ°, Ð¸Ð·Ð¿Ð¾Ð»Ð·Ð²Ð°Ð¹ÑÐµ ÑÑÐ°ÑÐ¸ÑÐµÐ½ IP Ð°Ð´ÑÐµÑ.",
        wrongFormatIp: "ÐÑÐµÑÐµÐ½ ÑÐ¾ÑÐ¼Ð°Ñ Ð½Ð° IP Ð°Ð´ÑÐµÑ"
    },
    colorSearchTab: {
        notEveryItemSelected: "One or more items are not selected"
    },
    colorTab: {
        colorTone: "Ð¦Ð²ÐµÑÐµÐ½ ÑÐ¾Ð½",
        fandeckPosition: "ÐÐ¾Ð·Ð¸ÑÐ¸Ñ Ð½Ð° ÑÐ²ÐµÑÐ½Ð¸Ñ ÐºÐ°ÑÑÐµÐ»",
        moreInfoIcons: "More info icons",
        notExistingFormula: "ÐÐµÑÑÑÐµÑÑÐ²ÑÐ²Ð°ÑÐ° ÑÐ¾ÑÐ¼ÑÐ»Ð°",
        orderBy: "ÐÐ¾Ð´ÑÐµÐ´ÐµÐ½Ð¸ Ð¿Ð¾",
        selectYourGrid: "ÐÐ·Ð±ÐµÑÐµÑÐµ Ð²Ð°ÑÐ°ÑÐ° Ð¼ÑÐµÐ¶Ð°",
        showInPanel: "ÐÐ¾ÐºÐ°Ð·Ð²Ð°Ð½Ðµ Ð² Ð¿Ð°Ð½ÐµÐ»Ð°",
        warningIcon: "ÐÐµÑÑÑÐµÑÑÐ²ÑÐ²Ð°ÑÐ° Ð¸ÐºÐ¾Ð½Ð° Ð·Ð° Ð¿ÑÐµÐ´ÑÐ¿ÑÐµÐ¶Ð´ÐµÐ½Ð¸Ðµ Ð·Ð° ÑÐ¾ÑÐ¼ÑÐ»Ð°"
    },
    colorantBatchNumberSettings: {
        batchNumberByPercentage: "Use Batch numbers by percentage",
        batchNumberFromLastFilling: "Use Batch numbers from the last filling",
        defectiveBatchOfColorant: "Defective Batch of colorant",
        enableBatchNumber: "Enable colorant Batch numbers",
        possibleDamagedBatchOfColorant: "Possibly damaged Batch of colorant",
        scanOrTypeBatchNumber: "Scan or type Batch number"
    },
    colorantPanel: {
        manualMachine: "machine"
    },
    colorantsTable: {
        numberOfColorants: "ÐÑÐ¾Ð¹ Ð½Ð° ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ¸ÑÐµ",
        preview: "ÐÑÐµÐ³Ð»ÐµÐ´",
        prices: "Ð¦ÐµÐ½Ð¸"
    },
    currencySettings: {
        addNewCurrency: "ÐÐ¾Ð±Ð°Ð²ÑÐ½Ðµ Ð½Ð° Ð½Ð¾Ð²Ð° Ð²Ð°Ð»ÑÑÐ°",
        codePlaceholder: "ÐÐ¾Ð´",
        currencySettings: "ÐÐ°Ð»ÑÑÐ½Ð¸ Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ¸",
        namePlaceholder: "ÐÐ¼Ðµ",
        ratePlaceholder: "ÐÐ°Ð»ÑÑÐµÐ½ ÐºÑÑÑ",
        setDecimalPlaces: "ÐÐ°Ð´Ð°Ð²Ð°Ð½Ðµ Ð½Ð° Ð´ÐµÑÑÐ¸ÑÐ½Ð¸ Ð·Ð½Ð°ÑÐ¸",
        setMainCurrency: "ÐÐ°Ð´Ð°Ð²Ð°Ð½Ðµ Ð½Ð° Ð¾ÑÐ½Ð¾Ð²Ð½Ð°ÑÐ° Ð²Ð°Ð»ÑÑÐ°",
        setRounding: "ÐÐ°Ð´Ð°Ð²Ð°Ð½Ðµ Ð½Ð° Ð·Ð°ÐºÑÑÐ³Ð»ÐµÐ½Ð¸Ðµ",
        symbolPlaceholder: "Ð¡Ð¸Ð¼Ð²Ð¾Ð»"
    },
    customFandecks: {
        customFandecks: "ÐÐµÑÑÐ¾Ð½Ð°Ð»ÐµÐ½ ÑÐ²ÐµÑÐµÐ½ ÐºÐ°ÑÑÐµÐ»",
        deleteButtonWarning: "All formulas in fandeck will be removed too.",
        deleteCustomFandeck:
            "Do you really want to delete this custom fandeck? All formulas in this fandeck will be deleted too.",
        disableStandardFandecks: "Show only custom fandecks",
        enableStandardFandecks: "Show standard fandecks",
        fandeckName: "ÐÐ¼Ðµ Ð½Ð° ÑÐ²ÐµÑÐ½Ð¸Ñ ÐºÐ°ÑÑÐµÐ»"
    },
    customRedlike: {
        addColorantFromBrand: "Add colorant from %{brandName} brand",
        addNewCustomer: "ÐÐ¾Ð±Ð°Ð²ÑÐ½Ðµ Ð½Ð° Ð½Ð¾Ð² ÐºÐ»Ð¸ÐµÐ½Ñ",
        addNewNote: "ÐÐ¾Ð±Ð°Ð²ÑÐ½Ðµ Ð½Ð° Ð½Ð¾Ð²Ð° Ð±ÐµÐ»ÐµÐ¶ÐºÐ°",
        addedDate: "ÐÐ¾Ð±Ð°Ð²ÐµÐ½Ð° Ð´Ð°ÑÐ°",
        addedQuantity: "ÐÐ¾Ð±Ð°Ð²ÐµÐ½Ð¾ ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾",
        availableMachine: "ÐÐ°Ð»Ð¸ÑÐ½Ð° Ð¼Ð°ÑÐ¸Ð½Ð°",
        brand: "ÐÐ°ÑÐºÐ°",
        brandPlease: "ÐÐ¾Ð»Ñ Ð¸Ð·Ð±ÐµÑÐµÑÐµ Ð¼Ð°ÑÐºÐ°",
        cancelCustomer: "ÐÑÐ¼ÑÐ½Ð° Ð½Ð° ÐºÐ»Ð¸ÐµÐ½Ñ",
        colorPlease: "ÐÐ¾Ð»Ñ, Ð¸Ð·Ð±ÐµÑÐµÑÐµ ÑÐ²ÑÑ",
        confirmCustomerData: "ÐÐ¾ÑÐ²ÑÑÐ¶Ð´Ð°Ð²Ð°Ð½Ðµ Ð½Ð° ÐºÐ»Ð¸ÐµÐ½ÑÑÐºÐ¸ÑÐµ Ð´Ð°Ð½Ð½Ð¸",
        confirmNoteData: "ÐÐ¾ÑÐ²ÑÑÐ¶Ð´Ð°Ð²Ð°Ð½Ðµ Ð½Ð° Ð´Ð°Ð½Ð½Ð¸ÑÐµ Ð¾Ñ Ð±ÐµÐ»ÐµÐ¶ÐºÐ°ÑÐ°",
        confirmSelectedUser: "ÐÑÐºÐ°ÑÐµ Ð»Ð¸ Ð´Ð° Ð¸Ð·Ð¿Ð¾Ð»Ð·Ð²Ð°ÑÐµ ÐºÐ»Ð¸ÐµÐ½Ñ %{customerName} Ð·Ð° ÑÐ°Ð·Ð¸ Ð¿Ð¾ÑÑÑÐºÐ°.",
        confirmed: "ÐÐ¾ÑÐ²ÑÑÐ´ÐµÐ½Ð¾",
        controlData: "ÐÐºÐ¾Ð½ÑÐ°ÑÐµÐ»ÐµÐ½ ÐºÐ¾Ð½ÑÑÐ¾Ð» Ð½Ð° Ð´Ð°Ð½Ð½Ð¸ÑÐµ",
        customerCellNumber: "ÐÐ¾Ð¼ÐµÑ Ð½Ð° ÐºÐ»ÐµÑÐºÐ°ÑÐ° Ð½Ð° ÐºÐ»Ð¸ÐµÐ½ÑÐ°",
        customerFilter: "Ð¤Ð¸Ð»ÑÑÑ Ð¿Ð¾ ÐºÐ»Ð¸ÐµÐ½Ñ",
        customerName: "ÐÐ¾ÑÑÐµÐ±Ð¸ÑÐµÐ»ÑÐºÐ¾ Ð¸Ð¼Ðµ",
        customerPhone: "Ð¢ÐµÐ»ÐµÑÐ¾Ð½ Ð½Ð° ÐºÐ»Ð¸ÐµÐ½ÑÐ°",
        customerPlease: "ÐÐ¾Ð»Ñ, Ð¸Ð·Ð±ÐµÑÐµÑÐµ ÐºÐ»Ð¸ÐµÐ½Ñ",
        dateFilter: "ÐÐ°ÑÐ° ÑÐ¸Ð»ÑÑÑ",
        enterPin: "ÐÑÐ²ÐµÐ´ÐµÑÐµ ÐÐÐ ÐºÐ¾Ð´Ð°",
        enterTheNumberOfPackages: "ÐÑÐ²ÐµÐ´ÐµÑÐµ Ð±ÑÐ¾Ñ Ð½Ð° Ð¿Ð°ÐºÐµÑÐ¸ÑÐµ",
        existingCustomer: "User Already Exists",
        fandeckPlease: "ÐÐ¾Ð»Ñ Ð¸Ð·Ð±ÐµÑÐµÑÐµ ÑÐ²ÐµÑÐµÐ½ ÐºÐ°ÑÑÐµÐ»",
        fillCanisterHistory: "ÐÑÑÐ¾ÑÐ¸Ñ Ð½Ð° Ð¿ÑÐ»Ð½ÐµÐ½Ðµ Ð½Ð° ÑÐµÐ·ÐµÑÐ²Ð¾Ð°Ñ",
        findCustomer:
            "ÐÐ° Ð´Ð° Ð¿ÑÐ¸ÑÐ²Ð¾Ð¸ÑÐµ ÐºÐ°ÑÑÐ° Ð·Ð° Ð»Ð¾ÑÐ»Ð½Ð¾ÑÑ Ð½Ð° ÑÐ°Ð·Ð¸ Ð¿Ð¾ÑÑÑÐºÐ° Ð¼Ð¾Ð»Ñ ÑÐºÐ°Ð½Ð¸ÑÐ°Ð¹ÑÐµ Ð±Ð°ÑÐºÐ¾Ð´ Ð¸Ð»Ð¸ ÑÑÑÑÐµÑÐµ  Ð¸Ð¼ÐµÐ¹Ð» Ð°Ð´ÑÐµÑ",
        findCustomerByEmail: "Ð¤Ð¸Ð»ÑÑÑ Ð½Ð° ÐºÐ»Ð¸ÐµÐ½Ñ Ð¿Ð¾ Ð¸Ð¼ÐµÐ¹Ð» Ð¸Ð»Ð¸ Ð±Ð°ÑÐºÐ¾Ð´",
        finishPreviousStep: "(ÐÐ¾Ð»Ñ Ð·Ð°Ð²ÑÑÑÐ¸ Ð¿ÑÐµÐ´Ð¸ÑÐ½Ð°ÑÐ° ÑÑÑÐ¿ÐºÐ°)",
        formulaUnit: "ÐÐ´Ð¸Ð½Ð¸ÑÐ° Ð·Ð° ÑÐ¾ÑÐ¼ÑÐ»Ð¸",
        getBackToList: "ÐÑÑÐ½ÐµÑÐµ ÑÐµ Ð² ÑÐ¿Ð¸ÑÑÐºÐ° Ñ ÐºÐ»Ð¸ÐµÐ½ÑÐ¸ÑÐµ",
        historyOfOrders: "ÐÑÑÐ¾ÑÐ¸Ñ Ð½Ð° Ð¿Ð¾ÑÑÑÐºÐ¸ÑÐµ",
        insertNote: "ÐÑÐµÐ¼Ð¸Ð½ÐµÑÐµ ÐºÑÐ¼ Ð²Ð¼ÑÐºÐ²Ð°Ð½Ðµ Ð½Ð° Ð±ÐµÐ»ÐµÐ¶ÐºÐ°",
        loadHistoryOrder: "ÐÑÐºÐ°ÑÐµ Ð»Ð¸ Ð´Ð° ÑÐµ Ð·Ð°ÑÐµÐ´Ð¸ Ð¸Ð·Ð±ÑÐ°Ð½Ð°ÑÐ° Ð¿Ð¾ÑÑÑÐºÐ°?",
        loyaltyCards: "ÐÐ°ÑÑÐ¸ Ð·Ð° Ð»Ð¾ÑÐ»Ð½Ð¾ÑÑ",
        machineIsAvailable: "ÐÐÐ¨ÐÐÐÐ¢Ð Ð ÐÐÐÐÐ§ÐÐ",
        machineIsUnavailable: "ÐÐÐ¨ÐÐÐÐ¢Ð ÐÐ Ð ÐÐÐÐÐ§ÐÐ",
        newLoyaltyCard: "ÐÐ¾Ð²Ð° ÐºÐ°ÑÑÐ° Ð·Ð° Ð»Ð¾ÑÐ»Ð½Ð¾ÑÑ",
        noAvailableMachine: "ÐÐ°ÑÐ¸Ð½Ð°ÑÐ° Ð½Ðµ Ðµ Ð½Ð°Ð»Ð¸ÑÐ½Ð°",
        noCustomerSelected: "No customer is selected. Do you want continue?",
        notePlease: "ÐÐ¾Ð»Ñ Ð²ÑÐ²ÐµÐ´ÐµÑÐµ Ð±ÐµÐ»ÐµÐ¶ÐºÐ°",
        openHistory: "ÐÑÐ²Ð¾ÑÐ¸ Ð¸ÑÑÐ¾ÑÐ¸Ñ",
        orAdd: "Ð¸Ð»Ð¸ Ð´Ð¾Ð±Ð°Ð²ÑÐ½Ðµ Ð½Ð° ÐºÐ»Ð¸ÐµÐ½ÑÐ¸",
        orSelect: "Ð¸Ð»Ð¸ Ð¸Ð·Ð±ÐµÑÐµÑÐµ ÐºÐ»Ð¸ÐµÐ½Ñ",
        orderModification: "The original order will be modified. Do you want to continue?",
        orderOverview: "ÐÑÐµÐ³Ð»ÐµÐ´ Ð½Ð° Ð¿Ð¾ÑÑÑÐºÐ°ÑÐ°",
        orderToMachine: "ÐÐÐÐ ÐÐ¢ÐÐ¢Ð ÐÐÐ¯Ð¢Ð ÐÐÐ ÐªÐ§ÐÐ ÐÐªÐ ÐÐÐ¨ÐÐÐÐ¢Ð",
        ordersHistory: "ÐÑÑÐ¾ÑÐ¸Ñ Ð½Ð° Ð¿Ð¾ÑÑÑÐºÐ¸ÑÐµ",
        packagePlease: "ÐÐ¾Ð»Ñ Ð¸Ð·Ð±ÐµÑÐµÑÐµ Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ°",
        pleaseSelectBrand: "ÐÐ¾Ð»Ñ Ð¸Ð·Ð±ÐµÑÐµÑÐµ Ð¼Ð°ÑÐºÐ°",
        previewImage: "ÐÐ¸Ð·ÑÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ñ Ð½Ð° IMG",
        previewPackage: "ÐÐ¸Ð·ÑÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ñ Ð½Ð° Ð¿Ð°ÐºÐµÑÐ°",
        productPlease: "ÐÐ¾Ð»Ñ Ð¸Ð·Ð±ÐµÑÐµÑÐµ Ð¿ÑÐ¾Ð´ÑÐºÑ",
        resetFilters: "ÐÑÐ»Ð¸ÑÐ°Ð½Ðµ Ð½Ð° Ð²ÑÐ¸ÑÐºÐ¸ ÑÐ¸Ð»ÑÑÐ¸",
        searchForHistoricalOrders: "ÐÐ»Ð¸ ÑÑÑÑÐ¸ Ð·Ð° Ð¿Ð¾ÑÑÑÐºÐ¸ Ð² Ð¸ÑÑÐ¾ÑÐ¸Ñ",
        selectBrand: "ÐÐ¾Ð»Ñ Ð¸Ð·Ð±ÐµÑÐµÑÐµ ÐÐ°ÑÐºÐ°",
        selectColor: "ÐÑÐµÐ¼Ð¸Ð½Ð¸ ÐºÑÐ¼ Ð¸Ð·Ð±Ð¾Ñ Ð½Ð° ÑÐ²ÑÑ",
        selectCustomer: "ÐÑÐµÐ¼Ð¸Ð½Ð¸ ÐºÑÐ¼ Ð¸Ð·Ð±Ð¾Ñ Ð½Ð° ÐºÐ»Ð¸ÐµÐ½Ñ",
        selectExistingCustomer: "ÐÐ·Ð±ÐµÑÐµÑÐµ ÑÑÑÐµÑÑÐ²ÑÐ²Ð°Ñ ÐºÐ»Ð¸ÐµÐ½Ñ",
        selectFandeck: "ÐÑÐµÐ¼Ð¸Ð½Ð¸ ÐºÑÐ¼ Ð¸Ð·Ð±Ð¾Ñ Ð½Ð° ÑÐ²ÐµÑÐµÐ½ ÐºÐ°ÑÑÐµÐ»",
        selectManually: "If you want to use this color in %{brandNames} brand, please select it manually.",
        selectPackage: "ÐÑÐµÐ¼Ð¸Ð½Ð¸ ÐºÑÐ¼ Ð¸Ð·Ð±Ð¾Ñ Ð½Ð° Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ°",
        selectProduct: "ÐÑÐµÐ¼Ð¸Ð½Ð¸ ÐºÑÐ¼ Ð¸Ð·Ð±Ð¾Ñ Ð½Ð° Ð¿ÑÐ¾Ð´ÑÐºÑ",
        shotsCoefficient: "ÐÐ¾ÐµÑÐ¸ÑÐ¸ÐµÐ½Ñ Ð½Ð° ÑÐ¾ÑÐ¾Ð²Ðµ",
        showDetail: "ÐÐ¾ÐºÐ°Ð¶Ð¸ Ð´ÐµÑÐ°Ð¹Ð»Ð¸",
        showHideEshopName: "Show/Hide the eshop name of the color in a separate column",
        showKeyboard: "ÐÐ¾ÐºÐ°Ð·Ð²Ð°Ð½Ðµ Ð½Ð° ÐºÐ»Ð°Ð²Ð¸Ð°ÑÑÑÐ°ÑÐ°",
        skipCustomerButton: "skip select customer",
        skipCustomerText: "ÐÑÐ¾Ð¿ÑÑÐ½Ð¸ Ð°ÐºÐ¾ Ð½Ðµ Ð¸ÑÐºÐ°ÑÐµ Ð´Ð° Ð²ÑÐ²ÐµÐ¶Ð´Ð°ÑÐµ ÐºÐ»Ð¸ÐµÐ½Ñ",
        skipNote: "ÐÑÐ¾Ð¿ÑÑÐºÐ°Ð½Ðµ Ð½Ð° Ð±ÐµÐ»ÐµÐ¶ÐºÐ° Ð¸ Ð¿ÑÐµÐ³Ð»ÐµÐ´ Ð² ÑÐµÐ·ÑÐ¼Ðµ",
        spectroBrand: "Searching in brand %{brandName}",
        statusAccepted: "Ð¿ÑÐ¸ÐµÑ",
        statusCanceled: "Ð¾ÑÐ¼ÐµÐ½ÐµÐ½",
        statusCreated: "ÑÑÐ·Ð´Ð°Ð´ÐµÐ½",
        statusDone: "Ð½Ð°Ð¿ÑÐ°Ð²ÐµÐ½Ð¾",
        statusPartlyDone: "ÑÐ°ÑÑÐ¸ÑÐ½Ð¾ Ð½Ð°Ð¿ÑÐ°Ð²ÐµÐ½Ð¾",
        statusPreparing: "Ð¿ÑÐ¸Ð³Ð¾ÑÐ²ÑÐ½Ðµ",
        summaryChosenBase: "Ð±Ð°Ð·Ð°",
        summaryChosenBrand: "Ð¼Ð°ÑÐºÐ°",
        summaryChosenCanSize: "ÑÐ°Ð·Ð¼ÐµÑ Ð½Ð° Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ°ÑÐ°",
        summaryChosenColor: "ÑÐ²ÑÑ",
        summaryChosenColorCard: "ÑÐ²ÐµÑÐµÐ½ ÐºÐ°ÑÑÐµÐ»",
        summaryChosenProduct: "Ð¿ÑÐ¾Ð´ÑÐºÑ",
        summaryChosenQuantity: "ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾",
        summaryColorPreview: "color preview",
        summaryCustomNote: "ÐÐµÑÑÐ¾Ð½Ð°Ð»Ð¸Ð·Ð¸ÑÐ°Ð½Ð° Ð±ÐµÐ»ÐµÐ¶ÐºÐ°",
        summaryCustomerNumber: "ÐºÐ»Ð¸ÐµÐ½ÑÑÐºÐ¸ Ð½Ð¾Ð¼ÐµÑ",
        summaryFormula: "ÑÐ¾ÑÐ¼ÑÐ»Ð°",
        summaryFormulaNote: "ÑÐ¾ÑÐ¼ÑÐ»Ð° Ð±ÐµÐ»ÐµÐ¶ÐºÐ°",
        summaryNote: "Ð±ÐµÐ»ÐµÐ¶ÐºÐ°",
        sureAboutSend: "ÐÐ°Ð¸ÑÑÐ¸Ð½Ð° Ð»Ð¸ Ð¸ÑÐºÐ°ÑÐµ Ð´Ð° Ð¸Ð·Ð¿ÑÐ°ÑÐ¸ÑÐµ Ð¿Ð¾ÑÑÑÐºÐ°?",
        useCustomerInOrder: "ÐÑÐºÐ°ÑÐµ Ð»Ð¸ Ð´Ð° Ð¸Ð·Ð¿Ð¾Ð»Ð·Ð²Ð°ÑÐµ %{customerName} Ð² ÑÐ»ÐµÐ´Ð½Ð¸Ñ ÑÐµÐ´?",
        uuid: "Uuid",
        viewSummary: "ÐÐ±Ð¾Ð±ÑÐµÐ½Ð¸Ðµ ",
        volume: "volume"
    },
    customRedlikeAnother: {
        pinOrderConfirmation: "ÐÐ¾ÑÐ²ÑÑÐ¶Ð´ÐµÐ½Ð¸Ðµ Ð½Ð° Ð¿Ð¾ÑÑÑÐºÐ° Ñ ÐÐÐ",
        pinScreenSaverConfirmation: "ÐÐ¾ÑÐ²ÑÑÐ¶Ð´ÐµÐ½Ð¸Ðµ Ð½Ð° ÑÐºÑÐ¸Ð¹Ð½ÑÐµÐ¹Ð²ÑÑ Ñ ÐÐÐ",
        pinSettingsConfirmation: "ÐÐ¾ÑÐ²ÑÑÐ¶Ð´Ð°Ð²Ð°Ð½Ðµ Ð½Ð° Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ¸ÑÐµ Ð½Ð° ÐÐÐ",
        printAuto: "ÐÐ° ÑÐµ ÑÐ°Ð·ÑÐµÑÐ¸ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐ½Ð¾ Ð¾ÑÐ¿ÐµÑÐ°ÑÐ²Ð°Ð½Ðµ",
        printerSettings: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ Ð½Ð° Ð¿ÑÐ¸Ð½ÑÐµÑÐ°",
        selectColorWithFandeck: "ÐÐ±Ñ Ð¸Ð·Ð±Ð¾Ñ Ð½Ð° ÑÐ²ÑÑ Ð¸ ÑÐ²ÐµÑÐµÐ½ ÐºÐ°ÑÑÐµÐ»",
        setKeyboard: "Ð£ÑÑÐ°Ð½Ð¾Ð²ÐµÑÐµ ÐºÐ»Ð°Ð²Ð¸Ð°ÑÑÑÐ°",
        setKioskMode: "ÐÐ°Ð´Ð°Ð²Ð°Ð½Ðµ Ð½Ð° ÑÐµÐ¶Ð¸Ð¼ Ð¿Ð°Ð²Ð¸Ð»Ð¸Ð¾Ð½",
        setLanguage: "ÐÐ°Ð´Ð°Ð²Ð°Ð½Ðµ Ð½Ð° ÐµÐ·Ð¸Ðº",
        setModule: "ÐÐ°Ð´Ð°Ð²Ð°Ð½Ðµ Ð½Ð° Ð¼Ð¾Ð´ÑÐ»",
        setQuickSelect: "ÐÐ°Ð´Ð°Ð²Ð°Ð½Ðµ Ð½Ð° Ð±ÑÑÐ· Ð¸Ð·Ð±Ð¾Ñ",
        setScreensaverTimeout: "ÐÐ°Ð´Ð°Ð²Ð°Ð½Ðµ Ð½Ð° Ð¸Ð·ÑÐ°ÐºÐ²Ð°Ð½Ðµ Ð½Ð° ÑÐºÑÐ¸Ð¹Ð½ÑÐµÐ¹Ð²ÑÑ",
        setUnit: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ° Ð½Ð° ÐµÐ´Ð¸Ð½Ð¸ÑÐ°"
    },
    customRedlikeMachine: {
        action: "ÐÐµÐ¹ÑÑÐ²Ð¸Ðµ",
        additionalPrint: "ÐÐ¾Ð¿ÑÐ»Ð½Ð¸ÑÐµÐ»ÐµÐ½ Ð¿ÐµÑÐ°Ñ",
        brand: "ÐÐ°ÑÐºÐ°",
        brandAccess: "ÐÐ¾ÑÑÐµÐ±Ð¸ÑÐµÐ» '%{userName} ' Ð½ÑÐ¼Ð° Ð´Ð¾ÑÑÑÐ¿ Ð´Ð¾ Ð´Ð°Ð½Ð½Ð¸ Ð¾Ñ Ð¼Ð°ÑÐºÐ°ÑÐ° '%{brandName} '",
        can: "ÐÐ¿Ð°ÐºÐ¾Ð²ÐºÐ° Ð¿Ð¾ÑÑÐ°Ð²ÐµÐ½Ð°",
        canistersLevel: "ÐÑÐµÐ³Ð»ÐµÐ´ Ð½Ð° Ð½Ð¸Ð²Ð¾ÑÐ¾ Ð² ÑÐµÐ·ÐµÑÐ²Ð¾Ð°ÑÐ¸ÑÐµ",
        closeDetailInformation: "ÐÐ°ÑÐ²Ð¾ÑÐ¸ Ð´ÐµÑÐ°Ð¹Ð»Ð¸",
        colorantsAmount: "ÐÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾ Ð¾ÑÐ²ÐµÑÐ¸ÑÐµÐ»Ð¸",
        confirmRefill: "ÐÐ¾ÑÐ²ÑÑÐ¶Ð´Ð°Ð²Ð°Ð½Ðµ Ð½Ð° Ð½Ð°Ð¿ÑÐ»Ð²Ð°Ð½Ðµ Ñ Ð¾ÑÐ²ÐµÑÐ¸ÑÐµÐ»",
        deleteOrder: "ÐÐ·ÑÑÐ¸Ð²Ð°Ð½Ðµ Ð½Ð° Ð¿Ð¾ÑÑÑÐºÐ°",
        dialogNoMachine: "ÐÐ°ÑÐ¸Ð½Ð°ÑÐ° Ð½Ðµ Ðµ ÑÐ²ÑÑÐ·Ð°Ð½Ð°",
        dialogNoRcc: "RCC  Ð½Ðµ Ðµ ÑÐ²ÑÑÐ·Ð°Ð½",
        dispense: "ÐÐ¾Ð·Ð¸ÑÐ°Ð¹ÑÐµ",
        dispenserInErrorState: "ÐÐ¸ÑÐ¿ÐµÐ½ÑÐµÑÑÑ Ðµ Ð² ÑÑÑÑÐ¾ÑÐ½Ð¸Ðµ Ð½Ð° Ð³ÑÐµÑÐºÐ°",
        dispensingIsOk: "ÐÐ¸ÑÐ¿ÐµÐ½ÑÐµÑÑÑ Ðµ ÐÐ",
        emergencyButtonPressed: "Emergency button pressed",
        errorCode: "ÐÐ¾Ð´ Ð½Ð° Ð³ÑÐµÑÐºÐ°",
        errorEvents: "ÐÑÐµÑÐºÐ¸ Ð½Ð° Ð´Ð¸ÑÐ¿ÐµÐ½ÑÐµÑÐ°",
        errorReset: "ÐÑÐ»Ð¸ÑÐ°Ð½Ðµ Ð½Ð°  Ð³ÑÐµÑÐºÐ°",
        explanation: "ÐÐ±ÑÑÐ½ÐµÐ½Ð¸Ðµ",
        imageNotAvailable: "ÐÐ·Ð¾Ð±ÑÐ°Ð¶ÐµÐ½Ð¸ÐµÑÐ¾ Ð½Ðµ Ðµ Ð½Ð° ÑÐ°Ð·Ð¿Ð¾Ð»Ð¾Ð¶ÐµÐ½Ð¸Ðµ",
        incorrectCanister: "ÐÐµÐ¿ÑÐ°Ð²Ð¸Ð»Ð½Ð¾ ÑÐºÐ°Ð½Ð¸ÑÐ°Ð½Ð¸ ÑÐµÐ·ÐµÑÐ²Ð¾Ð°ÑÐ¸",
        incorrectColorant: "ERROR: Incorrect colorant scanned. Please scan correct colorant",
        lastEvents: "ÐÐ¾ÑÐ»ÐµÐ´Ð½Ð¸ ÑÑÐ±Ð¸ÑÐ¸Ñ",
        machineActions: "Dispenser status",
        machineConfiguration: "ÐÐ¾Ð½ÑÐ¸Ð³ÑÑÐ°ÑÐ¸Ñ Ð½Ð° Ð´Ð¸ÑÐ¿ÐµÐ½ÑÐµÑÐ°",
        machineError: "ÐÑÐµÑÐºÐ° Ð² Ð¼Ð°ÑÐ¸Ð½Ð°ÑÐ°",
        machineIsBusy: "ÐÐ°ÑÐ¸Ð½Ð°ÑÐ° Ðµ Ð·Ð°ÐµÑÐ°",
        machineNotAvailable: "ÐÐ°ÑÐ¸Ð½Ð°ÑÐ° Ð½Ðµ Ðµ Ð½Ð°Ð»Ð¸ÑÐ½Ð°",
        machineTinting: "Please wait, machine tinting...",
        manualScan: "Ð ÑÑÐ½Ð¾ ÑÐºÐ°Ð½Ð¸ÑÐ°Ð½Ðµ",
        notEnoughSpace: "ÐÐ ÐÐ¨ÐÐ: ÐÑÐ¼Ð° Ð´Ð¾ÑÑÐ°ÑÑÑÐ½Ð¾ Ð¼ÑÑÑÐ¾ Ð·Ð° ÑÐ°Ð·Ð¸ Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ° Ð¾ÑÐ²ÐµÑÐ¸ÑÐµÐ»",
        numberOfCanistersUnderCriticalLevel: "ÐÑÐ¾Ð¹ Ð½Ð° ÑÐµÐ·ÐµÑÐ²Ð¾Ð°ÑÐ¸ Ð¿Ð¾Ð´ ÐºÑÐ¸ÑÐ¸ÑÐ½Ð¾ÑÐ¾ Ð½Ð¸Ð²Ð¾ Ðµ %{0}",
        numberOfCanistersUnderWarningLevel: "ÐÑÐ¾Ð¹ Ð½Ð° ÑÐµÐ·ÐµÑÐ²Ð¾Ð°ÑÐ¸ Ð¿Ð¾Ð´ Ð½Ð¸Ð²Ð¾ Ð¿ÑÐµÐ´ÑÐ¿ÑÐµÐ¶Ð´ÐµÐ½Ð¸Ðµ %{0}",
        offlinePressed: "ÐÑÐ»Ð°Ð¹Ð½ Ð±ÑÑÐ¾Ð½ Ð½Ð°ÑÐ¸ÑÐ½Ð°Ñ",
        orderSettings: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ Ð½Ð° Ð¿Ð¾ÑÑÑÐºÐ°ÑÐ°",
        otherOrderInformation: "ÐÐ¾Ð´ÑÐ¾Ð±Ð½Ð¾ÑÑÐ¸ Ð·Ð° Ð¿Ð¾ÑÑÑÐºÐ°ÑÐ°",
        packageCount: "ÐÑÐ¾Ð¹ Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ¸",
        packageWithSeparator: "ÐÐ¿Ð°ÐºÐ¾Ð²ÐºÐ°",
        received: "ÐÑÐ¸ÐµÑ",
        receivedOrders: "ÐÐ¾Ð»ÑÑÐµÐ½Ð¸ Ð¿Ð¾ÑÑÑÐºÐ¸",
        receivedTime: "ÐÑÐµÐ¼Ðµ Ð½Ð° Ð¿Ð¾Ð»ÑÑÐ°Ð²Ð°Ð½Ðµ",
        recirculation: "Ð ÐµÑÐ¸ÑÐºÑÐ»Ð°ÑÐ¸Ñ",
        refillInformation: "ÐÑÐ²ÐµÑÐ¸ÑÐµÐ»: %{0}, ÐÐ°ÑÐµÐ¶Ð´Ð°Ð½Ðµ: %{1}, Ð ÐµÐ·ÐµÑÐ²Ð¾Ð°Ñ: %{2}",
        resetErrors: "ÐÑÐ»Ð¸ÑÐ°Ð½Ðµ Ð½Ð° Ð³ÑÐµÑÐºÐ¸",
        scanCanister: "Ð¡ÐºÐ°Ð½Ð¸ÑÐ°Ð¹ÑÐµ ÑÐ¾Ð·Ð¸ ÑÐµÐ·ÐµÑÐ²Ð¾Ð°Ñ",
        scanColorantPackage: "Scan proper colorant package",
        selectedOrder: "ÐÐ·Ð±ÑÐ°Ð½Ð° Ð¿Ð¾ÑÑÑÐºÐ°",
        shelfMovingDown: "Ð Ð°ÑÑÑÑ ÑÐµ Ð´Ð²Ð¸Ð¶Ð¸ Ð½Ð°Ð´Ð¾Ð»Ñ",
        shelfMovingUp: "Ð Ð°ÑÑÑÑ ÑÐµ Ð´Ð²Ð¸Ð¶Ð¸ Ð½Ð°Ð³Ð¾ÑÐµ",
        solution: "Ð ÐµÑÐµÐ½Ð¸Ðµ",
        startDispensing: "Ð¡ÑÐ°ÑÑ Ð½Ð° Ð´Ð¾Ð·Ð¸ÑÐ°Ð½Ðµ",
        stirring: "Ð Ð°Ð·Ð±ÑÑÐºÐ²Ð°Ð½Ðµ",
        touchToStartFilling: "ÐÐ¾ÐºÐ¾ÑÐ½ÐµÑÐµ Ð·Ð° Ð´Ð° Ð·Ð°Ð¿Ð¾ÑÐ½Ðµ Ð·Ð°ÑÐµÐ¶Ð´Ð°Ð½Ðµ Ñ Ð¾ÑÐ²ÐµÑÐ¸ÑÐµÐ»",
        unknownBrand: "ÐÐµÐ¸Ð·Ð²ÐµÑÑÐ½Ð° Ð¼Ð°ÑÐºÐ°"
    },
    customRedlikeSettings: {
        addPos: "Pos Info",
        addServer: "ÐÐ¾Ð±Ð°Ð²ÑÐ½Ðµ Ð½Ð° ÑÑÑÐ²ÑÑ",
        adminOperations: "Admin operations",
        adminSettings: "ÐÐ´Ð¼Ð¸Ð½ Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ¸",
        another: "ÐÑÑÐ³",
        aslOrService: "ASL Ð¸Ð»Ð¸ ÑÑÐ»ÑÐ³Ð°",
        availableMachines: "ÐÐ°Ð»Ð¸ÑÐ½Ð¸ Ð¼Ð°ÑÐ¸Ð½Ð¸",
        barcode: "ÐÐ°ÑÐºÐ¾Ð´",
        basicOperations: "ÐÑÐ½Ð¾Ð²Ð½Ð¸ Ð¾Ð¿ÐµÑÐ°ÑÐ¸Ð¸",
        canisterBarcodes: "ÐÐ°ÑÐºÐ¾Ð´Ð¾Ð²Ðµ Ð½Ð° ÑÐµÐ·ÐµÑÐ²Ð¾Ð°ÑÐ¸ÑÐµ",
        canisterLevels: "ÐÐ¸Ð²Ð° Ð½Ð° ÑÐµÐ·ÐµÑÐ²Ð¾Ð°ÑÐ°",
        closeConnection: "Close connection",
        closeRedlike: "ÐÐ°ÑÐ²Ð¾ÑÐ¸ %{name}",
        databaseList: "ÐÐ°Ð·Ð° Ð´Ð°Ð½Ð½Ð¸",
        disabledStatus: "Ð´ÐµÐ°ÐºÑÐ¸Ð²Ð¸ÑÐ°Ð½Ð¾",
        dispenseLogicType: "ÐÐ¾Ð³Ð¸ÐºÐ° Ð½Ð° Ð´Ð¾Ð·Ð¸ÑÐ°Ð½Ðµ",
        dropServers: "ÐÐ°Ð´Ð°ÑÐ¸ ÑÑÑÐ²ÑÑÐ¸",
        editServer: "Ð ÐµÐ´Ð°ÐºÑÐ¸ÑÐ°Ð½Ðµ Ð½Ð° ÑÑÑÐ²ÑÑÐ°",
        lastEvent: "ÐÐ¾ÑÐ»ÐµÐ´Ð½Ð¾ ÑÑÐ±Ð¸ÑÐ¸Ðµ",
        logOut: "ÐÐ·Ð»ÐµÐ· Ð¾Ñ Ð¿ÑÐ¾ÑÐ¸Ð»Ð° ÑÐ¸",
        machineConfiguration: "ÐÐ¾Ð½ÑÐ¸Ð³ÑÑÐ°ÑÐ¸Ñ",
        maxDispenseAmount: "ÐÐ°ÐºÑÐ¸Ð¼Ð°Ð»Ð½Ð¾ ÐºÐ¾Ð»Ð¸ÑÐµÑÐ²Ð¾ Ð½Ð° Ð´Ð¾Ð·Ð¸ÑÐ°Ð½Ðµ",
        offlineStatus: "Ð¾ÑÐ»Ð°Ð¹Ð½",
        onlineStatus: "Ð¾Ð½Ð»Ð°Ð¹Ð½",
        openFrondesk: "ÐÑÐ²Ð¾ÑÐµÑÐµ Ð¿ÑÐµÐ´Ð½Ð¸Ñ Ð¿Ð°Ð½ÐµÐ»",
        print: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ Ð·Ð° Ð¿ÐµÑÐ°Ñ",
        rebootPC: "Ð ÐµÑÑÐ°ÑÑÐ¸ÑÐ°Ð¹ÑÐµ ÐºÐ¾Ð¼Ð¿ÑÑÑÑÐ°",
        restartRedlike: "Ð ÐµÑÑÐ°ÑÑ %{name}",
        restoreConnection: "ÐÑÐ·ÑÑÐ°Ð½Ð¾Ð²ÑÐ²Ð°Ð½Ðµ Ð½Ð° Ð²ÑÑÐ·ÐºÐ°",
        scanCanisterBarcode: "Ð¡ÐºÐ°Ð½Ð¸ÑÐ°Ð½Ðµ Ð½Ð° Ð±Ð°ÑÐºÐ¾Ð´ Ð½Ð° ÑÐµÐ·ÐµÑÐ²Ð¾Ð°ÑÐ°",
        scanOrDeleteCanisterBarcode: "Ð¡ÐºÐ°Ð½Ð¸ÑÐ°Ð½Ðµ Ð¸Ð»Ð¸ Ð¸Ð·ÑÑÐ¸Ð²Ð°Ð½Ðµ Ð½Ð° Ð±Ð°ÑÐºÐ¾Ð´",
        setCanisterBarcode: "Set canister barcode",
        swVersion: "Ð¡Ð¾ÑÑÑÐµÑÐ½Ð° Ð²ÐµÑÑÐ¸Ñ",
        systemFunctions: "Ð¤ÑÐ½ÐºÑÐ¸Ð¸ Ð½Ð° ÑÐ¸ÑÑÐµÐ¼Ð°ÑÐ°",
        userSettings: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ Ð½Ð° Ð¿Ð¾ÑÑÐµÐ±Ð¸ÑÐµÐ»Ñ"
    },
    customTab: {
        cifCombinationCheck:
            "The color %{colorName} already exists in fandeck %{fandeckName}, but it contains different spectral data. Would you like to overwrite existing data?",
        editColor: "ÐÐ¾ÑÐ¸Ð³Ð¸ÑÐ°Ð¹ ÑÐ²ÐµÑÐ°",
        editColorant: "ÐÐ¾ÑÐ¸Ð³Ð¸ÑÐ°Ð¹ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ°",
        emptyColorant: "There is colorant with empty amount",
        formulaCombinationCheck:
            'The formula with the color name "%{colorName}" already exists. Would you like to overwrite existing formula with the new one?',
        formulaForMasterProduct: "Formula for master product",
        formulaForMasterProductWithParam: "Formula for master product %{productName}",
        isNotAvailable: "ÐÐµ Ðµ Ð½Ð°Ð»Ð¸ÑÐµÐ½",
        noBaseSelected: "ÐÐ·Ð¸ÑÐºÐ²Ð° ÑÐµ Ð±Ð°Ð·Ð°",
        noColorantsSelected: "ÐÐµ ÑÐ° Ð¸Ð·Ð±ÑÐ°Ð½Ð¸ Ð¾ÑÐ²ÐµÑÐ¸ÑÐµÐ»Ð¸",
        noFandeckSelected: "ÐÐ·Ð¸ÑÐºÐ²Ð° ÑÐµ ÑÐ²ÐµÑÐµÐ½ ÐºÐ°ÑÑÐµÐ»",
        noNameOrCode: "Color name and code are required",
        noProductSelected: "ÐÐ·Ð¸ÑÐºÐ²Ð° ÑÐµ Ð¿ÑÐ¾Ð´ÑÐºÑ",
        productPreview: "ÐÑÐµÐ³Ð»ÐµÐ´ Ð½Ð° Ð¿ÑÐ¾Ð´ÑÐºÑÐ°",
        saveCustomRecipe: "ÐÐ°Ð¿Ð°Ð·Ð¸ Ð¿ÐµÑÑÐ¾Ð½Ð°Ð»Ð½Ð°ÑÐ° ÑÐµÑÐµÐ¿ÑÐ°",
        saveIsNotAvailable: "ÐÐµ Ðµ Ð½Ð°Ð»Ð¸ÑÐ½Ð¾ Ð·Ð°Ð¿Ð°Ð·Ð²Ð°Ð½Ðµ",
        showSiblingProducts: "Show sibling products",
        siblingProducts: "Sibling products by master product"
    },
    customersTab: {
        addCustomer: "ÐÐ¾Ð±Ð°Ð²Ð¸ ÐºÐ»Ð¸ÐµÐ½Ñ",
        additionalSettings: "Additional Settings",
        adress: "ÐÐ´ÑÐµÑ",
        createAndSelect: "Create and select",
        createNewCustomer: "Ð¡ÑÐ·Ð´Ð°Ð²Ð°Ð½Ðµ Ð½Ð° Ð½Ð¾Ð² ÐºÐ»Ð¸ÐµÐ½Ñ",
        editCustomer: "Ð ÐµÐ´Ð°ÐºÑÐ¸ÑÐ°Ð¹ ÐºÐ»Ð¸ÐµÐ½Ñ",
        expiration: "Customer %{name} will expire in %{dayCount} days",
        identificationNumber: "Identification number",
        information: "ÐÐ½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ Ð·Ð° Ð²ÑÑÐ·ÐºÐ°",
        listOfCustomers: "Ð¡Ð¿Ð¸ÑÑÐº Ð½Ð° ÐºÐ»Ð¸ÐµÐ½ÑÐ¸ÑÐµ",
        rabat: "ÐÑÑÑÑÐ¿ÐºÐ°",
        selectCustomer: "ÐÐ·Ð±ÐµÑÐµÑÐµ ÐºÐ»Ð¸ÐµÐ½Ñ",
        spentLastMonth: "ÐÐ·ÑÐ°ÑÑÐµÐ½Ð¸ Ð¿Ð°ÑÐ¸ Ð¿ÑÐµÐ· Ð¿Ð¾ÑÐ»ÐµÐ´Ð½Ð¸Ñ Ð¼ÐµÑÐµÑ",
        spentMoney: "ÐÐ·ÑÐ°Ð·ÑÐ¾Ð´Ð²Ð°Ð½Ð¸ Ð¿Ð°ÑÐ¸",
        typeOfMargin: "ÐÐ¸Ð´ Ð¿ÐµÑÐ°Ð»Ð±Ð°",
        zipCode: "Ð.Ð."
    },
    dialog: {
        cheaperColorSearch: "Cheaper color search is in progress",
        competitiveColorSearch: "ÐÐ¾Ð½ÐºÑÑÐµÐ½ÑÐ½Ð°ÑÐ° ÑÐ²ÐµÑÐ½Ð° ÑÐµÑÐ¸Ñ Ðµ Ð² ÑÐ¾Ð´",
        reallyChangeModule: "ÐÐ°Ð¸ÑÑÐ¸Ð½Ð° Ð»Ð¸ Ð¸ÑÐºÐ°ÑÐµ Ð´Ð° Ð¿ÑÐ¾Ð¼ÐµÐ½Ð¸ÑÐµ Ð¼Ð¾Ð´ÑÐ»Ð°?",
        reallyCloseRedlike:
            "ÐÐ°Ð¸ÑÑÐ¸Ð½Ð° Ð»Ð¸ Ð¸ÑÐºÐ°ÑÐµ Ð´Ð° Ð·Ð°ÑÐ²Ð¾ÑÐ¸ÑÐµ %{name}?Â ÐÑÐ¸ÑÐºÐ¸ Ð¿Ð°Ð½ÐµÐ»Ð¸ %{name} ÑÐµ Ð±ÑÐ´Ð°Ñ Ð·Ð°ÑÐ²Ð¾ÑÐµÐ½Ð¸, Ð½ÐµÐ·Ð°Ð¿Ð°Ð·ÐµÐ½Ð¸ÑÐµ Ð¿ÑÐ¾Ð¼ÐµÐ½Ð¸ ÑÐµ Ð±ÑÐ´Ð°Ñ Ð·Ð°Ð³ÑÐ±ÐµÐ½Ð¸.",
        reallyDeleteOrder:
            "ÐÐ°Ð¸ÑÑÐ¸Ð½Ð° Ð»Ð¸ Ð¸ÑÐºÐ°ÑÐµ Ð´Ð° Ð¸Ð·ÑÑÐ¸ÐµÑÐµ ÑÐ°Ð·Ð¸ Ð¿Ð¾ÑÑÑÐºÐ°?Â ÐÑÐ¸ÑÐºÐ¸ Ð´Ð°Ð½Ð½Ð¸, ÑÐ²ÑÑÐ·Ð°Ð½Ð¸ Ñ ÑÐ°Ð·Ð¸ Ð¿Ð¾ÑÑÑÐºÐ°, ÑÐµ Ð±ÑÐ´Ð°Ñ Ð·Ð°Ð³ÑÐ±ÐµÐ½Ð¸.",
        reallyRebootPC:
            "ÐÐ°Ð¸ÑÑÐ¸Ð½Ð° Ð»Ð¸ Ð¸ÑÐºÐ°ÑÐµ Ð´Ð° ÑÐµÑÑÐ°ÑÑÐ¸ÑÐ°ÑÐµ ÑÐ¾Ð·Ð¸ ÐºÐ¾Ð¼Ð¿ÑÑÑÑ?Â ÐÑÐ¸ÑÐºÐ¸ Ð¿Ð°Ð½ÐµÐ»Ð¸ ÑÐµ Ð±ÑÐ´Ð°Ñ Ð·Ð°ÑÐ²Ð¾ÑÐµÐ½Ð¸, Ð½ÐµÐ·Ð°Ð¿Ð°Ð·ÐµÐ½Ð¸ÑÐµ Ð¿ÑÐ¾Ð¼ÐµÐ½Ð¸ ÑÐµ Ð±ÑÐ´Ð°Ñ Ð·Ð°Ð³ÑÐ±ÐµÐ½Ð¸.",
        reallyRestartRedlike:
            "ÐÐ°Ð¸ÑÑÐ¸Ð½Ð° Ð»Ð¸ Ð¸ÑÐºÐ°ÑÐµ Ð´Ð° ÑÐµÑÑÐ°ÑÑÐ¸ÑÐ°ÑÐµ %{name}?Â ÐÑÐ¸ÑÐºÐ¸ Ð¿Ð°Ð½ÐµÐ»Ð¸ ÑÐµ Ð±ÑÐ´Ð°Ñ Ð·Ð°ÑÐ²Ð¾ÑÐµÐ½Ð¸, Ð½ÐµÐ·Ð°Ð¿Ð°Ð·ÐµÐ½Ð¸ÑÐµ Ð¿ÑÐ¾Ð¼ÐµÐ½Ð¸ ÑÐµ Ð±ÑÐ´Ð°Ñ Ð·Ð°Ð³ÑÐ±ÐµÐ½Ð¸.",
        reallyShutdownPc:
            "ÐÐ°Ð¸ÑÑÐ¸Ð½Ð° Ð»Ð¸ Ð¸ÑÐºÐ°ÑÐµ Ð´Ð° Ð¸Ð·ÐºÐ»ÑÑÐ¸ÑÐµ ÑÐ¾Ð·Ð¸ ÐºÐ¾Ð¼Ð¿ÑÑÑÑ?Â ÐÑÐ¸ÑÐºÐ¸ Ð¿Ð°Ð½ÐµÐ»Ð¸ %{name} ÑÐµ Ð±ÑÐ´Ð°Ñ Ð·Ð°ÑÐ²Ð¾ÑÐµÐ½Ð¸, Ð½ÐµÐ·Ð°Ð¿Ð°Ð·ÐµÐ½Ð¸ÑÐµ Ð¿ÑÐ¾Ð¼ÐµÐ½Ð¸ ÑÐµ Ð±ÑÐ´Ð°Ñ Ð·Ð°Ð³ÑÐ±ÐµÐ½Ð¸.",
        unlockComputer: "Computer will be unlocked."
    },
    dispenseLogicTypes: {
        1: "ÐÑÐ²ÐµÑÐµÑÐµ ÑÐ°Ð¼Ð¾ Ð¼Ð°ÐºÑÐ¸Ð¼Ð°Ð»Ð½Ð¾ÑÐ¾ ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾ Ð·Ð° Ð¾ÑÐ²ÐµÑÑÐ²Ð°Ð½Ðµ",
        2: "Ð Ð°Ð·ÑÐµÑÐ°Ð²Ð°Ð½Ðµ Ð½Ð° ÑÑÑÐ½Ð¾ Ð´Ð¾Ð·Ð¸ÑÐ°Ð½Ðµ Ð¿ÑÐ¸ Ð¸Ð·Ð¿Ð¾Ð»Ð·Ð²Ð°Ð½Ðµ Ð½Ð° ÑÐºÐ°Ð»Ð° Ð·Ð° ÑÑÐ¼Ð¸ Ð½Ð°Ð´ Ð¼Ð°ÐºÑÐ¸Ð¼Ð°Ð»Ð½Ð¾ÑÐ¾ ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾",
        3: "ÐÐ¾Ð¿ÑÐ»Ð²Ð°Ð½Ðµ Ð¿Ð¾ Ð²ÑÐµÐ¼Ðµ Ð½Ð° ÑÐ¾Ð½Ð¸ÑÐ°Ð½Ðµ (ÑÐ°Ð·Ð´ÐµÐ»ÐµÑÐµ ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾ÑÐ¾ Ð½Ð° Ð¿Ð¾-Ð¼Ð°Ð»ÐºÐ¸ Ð¿Ð°ÑÑÐµÑÐ°)",
        4: "Force manual dispensing using scale only in case of custom package"
    },
    editCustomFandeck: {
        fandeckName: "ÐÐ¼Ðµ Ð½Ð° ÑÐ²ÐµÑÐ½Ð¸Ñ ÐºÐ°ÑÑÐµÐ»"
    },
    editFormulaRgbModal: {
        apply: "ÐÑÐ¸Ð»Ð¾Ð¶Ð¸",
        blue: "Ð¡Ð¸Ð½ÑÐ¾",
        green: "ÐÐµÐ»ÐµÐ½Ð¾",
        modalLabel: "Ð ÐµÐ´Ð°ÐºÑÐ¸ÑÐ°Ð½Ðµ Ð½Ð° ÑÐ²ÐµÑÐ°",
        red: "Ð§ÐµÑÐ²ÐµÐ½Ð¾",
        tryGenerateRgb: "Try to generate RGB by colorant amounts"
    },
    environmentsSettings: {
        allowAutoCloseTab: "Close formula tab automatically",
        allowBarcodes: "Ð Ð°Ð·ÑÐµÑÐ°Ð²Ð°Ð½Ðµ Ð½Ð° Ð±Ð°ÑÐºÐ¾Ð´Ð¾Ð²Ðµ",
        allowBuildingSitePanel: "Allow building site specification",
        allowCustomers: "ÐÐ¾Ð·Ð²Ð¾Ð»ÐµÑÐµ Ð½Ð° ÐºÐ»Ð¸ÐµÐ½ÑÐ¸ÑÐµ",
        allowDeleteConfirmation: "ÐÐ¾Ð·Ð²Ð¾Ð»ÐµÑÐµ Ð¸Ð·ÑÑÐ¸Ð²Ð°Ð½Ðµ Ð¿Ð¾ÑÐ²ÑÑÐ¶Ð´ÐµÐ½Ð¸Ðµ",
        allowDiskSpaceNotification: "Allow disk space notification",
        allowDispensing: "ÐÐ¾Ð·Ð²Ð¾Ð»ÐµÑÐµ Ð´Ð¾Ð·Ð¸ÑÐ°Ð½Ðµ",
        allowFileTransfer: "Allow automatic file transfer",
        allowFormulaModificationPanel: "Allow formula modification panel",
        allowFormulaStatusPanel: "Allow formula status panel",
        allowInternalNotes: "Allow internal notes",
        allowLight: "ÐÐ¾Ð·Ð²Ð¾Ð»ÐµÑÐµ %{name}",
        allowOrderNotificationModal: "ÐÐ¾ÐºÐ°Ð¶Ð¸ Ð½Ð¾Ð²Ð¸ Ð¸Ð·Ð²ÐµÑÑÐ¸Ñ Ð·Ð° Ð¿Ð¾ÑÑÑÐºÐ¸",
        allowOrdering: "ÐÐ¾Ð·Ð²Ð¾Ð»ÐµÑÐµ Ð¿Ð¾ÑÑÑÐºÐ°",
        allowPricing: "Ð Ð°Ð·ÑÐµÑÐ°Ð²Ð°Ð½Ðµ Ð½Ð° ÑÐµÐ½Ð¾Ð¾Ð±ÑÐ°Ð·ÑÐ²Ð°Ð½ÐµÑÐ¾",
        allowPrint: "Allow print",
        allowProductPreviewImage: "ÐÐ¾Ð·Ð²Ð¾Ð»ÑÐ²Ð°Ð½Ðµ Ð½Ð° Ð²Ð¸Ð·ÑÐ°Ð»Ð¸Ð·Ð¸ÑÐ°Ð½Ð¾ÑÐ¾ Ð¸Ð·Ð¾Ð±ÑÐ°Ð¶ÐµÐ½Ð¸Ðµ Ð½Ð° Ð¿ÑÐ¾Ð´ÑÐºÑÐ° Ð¿Ð¾ Ð²ÑÐµÐ¼Ðµ Ð½Ð° Ð¿Ð¾Ð´Ð°Ð²Ð°Ð½ÐµÑÐ¾",
        allowQualityControl: "Allow quality control",
        allowSearchCheaperColors: "Allow searching for cheaper colors",
        allowSound: "Allow sound notification",
        allowSpectro: "ÐÐ¾Ð·Ð²Ð¾Ð»ÐµÑÐµ Spectro",
        allowTabs: "Allow tabs",
        applyZoom: "ÐÑÐ¸Ð»Ð°Ð³Ð°Ð½Ðµ Ð½Ð° ÑÐ²ÐµÐ»Ð¸ÑÐµÐ½Ð¸Ðµ",
        automaticLogout: "Automatic logout",
        barcodeScan: "Barcode Scan",
        canisterBarcode: "Canister barcodes",
        canisterLevel: "Canister level",
        changelog: "ÐÐ½ÐµÐ²Ð½Ð¸Ðº Ð½Ð° Ð¿ÑÐ¾Ð¼ÐµÐ½Ð¸ÑÐµ",
        closeTab: "ÐÐ°ÑÐ²Ð°ÑÑÐ½Ðµ Ð½Ð° Ð¿Ð¾Ð´Ð¿ÑÐ¾Ð·Ð¾ÑÐµÑÐ°",
        colorDifference: "Color difference",
        colorPanelNavItem: "Color Palette",
        competitiveColorSearch: "ÐÐ¾Ð½ÐºÑÑÐµÐ½ÑÐ½Ð¾ ÑÑÑÑÐµÐ½Ðµ Ð½Ð° ÑÐ²ÐµÑÐ¾Ð²Ðµ",
        customBanner: "ÐÐµÑÑÐ¾Ð½Ð°Ð»Ð¸Ð·Ð¸ÑÐ°Ð½ Ð±Ð°Ð½ÐµÑ",
        customCurrencyFormat: "Currency format",
        customDateFormat: "Date format",
        customNumberFormat: "Number format",
        customTimeFormat: "Time format",
        deltaA: "Delta A",
        deltaB: "Delta B",
        deltaE: "Delta E",
        deltaL: "Delta L",
        deltaMetamerism: "Delta metamerism",
        discount: "Show discount",
        dispensingHistory: "Dispensing History",
        dispensingNotes: "ÐÐ¾Ð·Ð²Ð¾Ð»ÐµÑÐµ Ð±ÐµÐ»ÐµÐ¶ÐºÐ¸ Ð·Ð° Ð´Ð¾Ð·Ð¸ÑÐ°Ð½Ðµ",
        enableCustomers: "Ð Ð°Ð·ÑÐµÑÐ°Ð²Ð°Ð½Ðµ Ð½Ð° ÐºÐ»Ð¸ÐµÐ½ÑÐ¸",
        enableDeleteConfirmation: "Ð Ð°Ð·ÑÐµÑÐ°Ð²Ð°Ð½Ðµ Ð½Ð° Ð¿Ð¾ÑÐ²ÑÑÐ¶Ð´ÐµÐ½Ð¸Ðµ Ð·Ð° Ð¸Ð·ÑÑÐ¸Ð²Ð°Ð½Ðµ",
        enableDispensing: "ÐÐºÑÐ¸Ð²Ð¸ÑÐ°Ð½Ðµ Ð½Ð° Ð´Ð¾Ð·Ð¸ÑÐ°Ð½Ðµ",
        enableLight: "ÐÐºÑÐ¸Ð²Ð¸ÑÐ°Ð½Ðµ %{name}",
        enableMarginMarkup: "ÐÐºÑÐ¸Ð²Ð¸ÑÐ°Ð½Ðµ Ð½Ð° Ð¼Ð°ÑÐ¶ Ð¸Ð»Ð¸ Ð½Ð°Ð´ÑÐµÐ½ÐºÐ°",
        enableNotes: "ÐÐºÑÐ¸Ð²Ð¸ÑÐ°Ð½Ðµ Ð½Ð° Ð±ÐµÐ»ÐµÐ¶ÐºÐ¸",
        enableOrdering: "ÐÐºÑÐ¸Ð²Ð¸ÑÐ°Ð½Ðµ Ð½Ð° Ð¿Ð¾ÑÑÑÐºÐ°",
        enableProductPreviewImage: "ÐÐºÑÐ¸Ð²Ð¸ÑÐ°Ð½Ðµ Ð½Ð° Ð¸Ð·Ð¾Ð±ÑÐ°Ð¶ÐµÐ½Ð¸ÐµÑÐ¾ Ð·Ð° Ð¿ÑÐµÐ´Ð²Ð°ÑÐ¸ÑÐµÐ»ÐµÐ½ Ð¿ÑÐµÐ³Ð»ÐµÐ´ Ð½Ð° Ð¿ÑÐ¾Ð´ÑÐºÑÐ°",
        enableSpectro: "ÐÐºÑÐ¸Ð²Ð¸ÑÐ°Ð½Ðµ Ð½Ð° Spectro",
        enableVirtualKeyboard: "ÐÐ¾Ð·Ð²Ð¾Ð»ÐµÑÐµ Ð²Ð¸ÑÑÑÐ°Ð»Ð½Ð° ÐºÐ»Ð°Ð²Ð¸Ð°ÑÑÑÐ°",
        environmentsSettings: "Ð ÐµÐ³Ð¸Ð¾Ð½Ð°Ð»Ð½Ð¸ Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ¸",
        exportTranslationKeys: "ÐÐºÑÐ¿Ð¾ÑÑÐ¸ÑÐ°Ð½Ðµ Ð½Ð° ÐºÐ»ÑÑÐ¾Ð²Ðµ Ð·Ð° Ð¿ÑÐµÐ²Ð¾Ð´",
        formulaNotes: "Ð Ð°Ð·ÑÐµÑÐ¸ Ð±ÐµÐ»ÐµÐ¶ÐºÐ¸ Ð·Ð° ÑÐ¾ÑÐ¼ÑÐ»Ð¸",
        hintTooltips: "ÐÐ¾ÑÑÐ½ÐµÐ½Ð¸Ñ Ð·Ð° Ð¿Ð¾Ð´ÑÐµÑÐ°Ð½Ðµ",
        image: "ÐÐ·Ð¾Ð±ÑÐ°Ð¶ÐµÐ½Ð¸Ðµ",
        keyboardShortcuts: "ÐÐ¾Ð¼Ð±Ð¸Ð½Ð°ÑÐ¸Ñ Ð¾Ñ ÐºÐ»Ð°Ð²Ð¸ÑÐ¸",
        languageBased: "Language based",
        lockYourComputer: "ÐÐ°ÐºÐ»ÑÑÐµÑÐµ ÐºÐ¾Ð¼Ð¿ÑÑÑÑÐ° ÑÐ¸",
        machineReset: "Machine reset",
        manageTranslations: "Ð£Ð¿ÑÐ°Ð²Ð»ÐµÐ½Ð¸Ðµ Ð½Ð° Ð¿ÑÐµÐ²Ð¾Ð´Ð¸ÑÐµ",
        margin: "Ð¡Ð°Ð¼Ð¾ Ð¼Ð°ÑÐ¶",
        markup: "Ð¡Ð°Ð¼Ð¾ Ð·Ð° Ð½Ð°Ð´ÑÐµÐ½ÐºÐ°",
        matchingRowCount: "Set number of results found",
        maxNumberTabs: "ÐÐ°ÐºÑÐ¸Ð¼Ð°Ð»ÐµÐ½ Ð±ÑÐ¾Ð¹ ÑÐ°Ð·Ð´ÐµÐ»Ð¸ Ð·Ð° ÑÐ¾ÑÐ¼ÑÐ»Ð¸",
        memoryTabs: "Store recently opened tabs",
        moreInfo: "Ð¦Ð²ÑÑ + Ð¸Ð·Ð¾Ð±ÑÐ°Ð¶ÐµÐ½Ð¸Ðµ + Ð¿Ð¾Ð²ÐµÑÐµ Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ",
        navigationItems: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ Ð½Ð° Ð½Ð°Ð²Ð¸Ð³Ð°ÑÐ¸Ð¾Ð½Ð½Ð¸ÑÐµ ÐµÐ»ÐµÐ¼ÐµÐ½ÑÐ¸",
        newTab: "ÐÐ¾Ð² Ð¿ÑÐ¾Ð·Ð¾ÑÐµÑ",
        numberOfPriceGroups: "Number of price groups",
        order: "ÐÐ¾ÑÑÑÐºÐ°",
        orderId: "ÐÐ´ÐµÐ½ÑÐ¸ÑÐ¸ÐºÐ°ÑÐ¸Ð¾Ð½ÐµÐ½ Ð½Ð¾Ð¼ÐµÑ Ð½Ð° Ð¿Ð¾ÑÑÑÐºÐ°ÑÐ°",
        ordersHistory: "ÐÑÑÐ¾ÑÐ¸Ñ Ð½Ð° Ð¿Ð¾ÑÑÑÐºÐ¸ÑÐµ",
        overwriteLastTab: "Overwrite last formula tab",
        priceCalculation: "Price calculation",
        priceDefBothPurchasePrimary: "Both, purchase primary",
        priceDefBothSellPrimary: "Both, sell primary",
        priceDefPurchaseOnly: "Purchase price only",
        priceDefSellOnly: "Sell price only",
        priceDefinition: "Price definition",
        priceGroupsEnabled: "Enable price groups",
        runLightAtStartUp: "Ð¡ÑÐ°ÑÑÐ¸ÑÐ°Ð¹ %{light} Ð¿ÑÐ¸ ÑÑÐ°ÑÑÐ¸ÑÐ°Ð½Ðµ",
        screenSaverTimeout: "Screensaver timeout",
        selectedSpectro: "Selected %{spectro} spectro.",
        selectedSpectroNone: "No spectro selected.",
        setAutomaticClientStart: "Ð¡ÑÐ°ÑÑÐ¸ÑÐ°Ð¹ %{name} Ð¿ÑÐ¸ ÑÑÐ°ÑÑÐ¸ÑÐ°Ð½ÐµÑÐ¾ Ð½Ð° ÐºÐ¾Ð¼Ð¿ÑÑÑÑÐ°",
        setCustomHomeButton: "ÐÐ°Ð´Ð°Ð²Ð°Ð½Ðµ Ð½Ð° Ð´ÐµÐ¹ÑÑÐ²Ð¸Ðµ Ð½Ð° Ð±ÑÑÐ¾Ð½Ð° Ð·Ð° Ð½Ð°ÑÐ°Ð»Ð¾",
        setDecimalPlaces: "ÐÐ°Ð´Ð°Ð²Ð°Ð½Ðµ Ð½Ð° Ð´ÐµÑÐµÑÐ¸ÑÐ½Ð¸ Ð·Ð½Ð°ÑÐ¸",
        setFormulaPreview: "ÐÐ°Ð´Ð°Ð²Ð°Ð½Ðµ Ð½Ð° Ð¿ÑÐµÐ³Ð»ÐµÐ´ Ð½Ð° ÑÐ¾ÑÐ¼ÑÐ»Ð°",
        setFormulaUnit: "ÐÐ°Ð´Ð°Ð²Ð°Ð½Ðµ Ð½Ð° ÐµÐ´Ð¸Ð½Ð¸ÑÐ° Ð·Ð° ÑÐ¾ÑÐ¼ÑÐ»Ð°",
        setFts: "ÐÐ·Ð¿Ð¾Ð»Ð·Ð²Ð°Ð¹ÑÐµ Ð¿ÑÐ»Ð½Ð¾ÑÐµÐºÑÑÐ¾Ð²Ð¾ ÑÑÑÑÐµÐ½Ðµ",
        setInfoItemInRgb: "Set visible information in the formula RGB preview",
        setKeyboardShortcuts: "ÐÐ°Ð´Ð°Ð²Ð°Ð½Ðµ Ð½Ð° ÐºÐ»Ð°Ð²Ð¸ÑÐ½Ð¸ ÐºÐ¾Ð¼Ð±Ð¸Ð½Ð°ÑÐ¸Ð¸",
        setKioskMode: "ÐÐ°Ð´Ð°Ð²Ð°Ð½Ðµ Ð½Ð° ÑÐµÐ¶Ð¸Ð¼ Ð¿Ð°Ð²Ð¸Ð»Ð¸Ð¾Ð½",
        setKioskModeOff: "ÐÐ·ÐºÐ»ÑÑÐµÑÐµ ÑÐµÐ¶Ð¸Ð¼Ð° Ð¿Ð°Ð²Ð¸Ð»Ð¸Ð¾Ð½",
        setKioskModeOn: "ÐÐºÐ»ÑÑÐ²Ð°Ð½Ðµ Ð½Ð° ÑÐµÐ¶Ð¸Ð¼ Ð¿Ð°Ð²Ð¸Ð»Ð¸Ð¾Ð½",
        setNavigationItems: "ÐÐ°Ð´Ð°Ð²Ð°Ð½Ðµ Ð½Ð° Ð½Ð°Ð²Ð¸Ð³Ð°ÑÐ¸Ð¾Ð½Ð½Ð¸ ÐµÐ»ÐµÐ¼ÐµÐ½ÑÐ¸",
        setNavigationItemsList: "ÐÐ°Ð´Ð°Ð²Ð°Ð½Ðµ Ð½Ð° Ð²Ð¸Ð´Ð¸Ð¼Ð¾ÑÑ Ð¸ ÑÐµÐ´ Ð½Ð° Ð½Ð°Ð²Ð¸Ð³Ð°ÑÐ¸Ð¾Ð½Ð½Ð¸ÑÐµ ÐµÐ»ÐµÐ¼ÐµÐ½ÑÐ¸",
        setOrderSearchItems: "ÐÐ°Ð´Ð°Ð²Ð°Ð½Ðµ Ð½Ð° Ð¿Ð°ÑÐ°Ð¼ÐµÑÑÐ¸ Ð·Ð° ÑÑÑÑÐµÐ½Ðµ Ð½Ð° Ð¿Ð¾ÑÑÑÐºÐ¸",
        setRounding: "ÐÐ°Ð´Ð°Ð²Ð°Ð½Ðµ Ð½Ð° Ð·Ð°ÐºÑÑÐ³Ð»ÐµÐ½Ð¸Ðµ",
        setSearchParameters: "ÐÐ°Ð´Ð°Ð²Ð°Ð½Ðµ Ð½Ð° Ð¿Ð°ÑÐ°Ð¼ÐµÑÑÐ¸ Ð·Ð° ÑÑÑÑÐµÐ½Ðµ Ð¿Ð¾ ÑÐ¾ÑÐ¼ÑÐ»Ð°",
        setTabLimit: "ÐÐ°Ð´Ð°Ð²Ð°Ð½Ðµ Ð½Ð° Ð»Ð¸Ð¼Ð¸Ñ Ð½Ð° ÑÐ°Ð±ÑÐ»Ð°ÑÐ¾Ñ",
        setYourLanguage: "ÐÐ°ÑÐ¸ÑÑ ÐµÐ·Ð¸Ðº",
        setZoom: "ÐÐ°Ð´Ð°Ð²Ð°Ð½Ðµ Ð½Ð° ÑÐ²ÐµÐ»Ð¸ÑÐµÐ½Ð¸Ðµ",
        showLocalPrices: "Show local prices",
        skipPlaceCanDialogEnabled:
            "Ð¢Ð°Ð·Ð¸ Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ° Ð½Ðµ Ð¼Ð¾Ð¶Ðµ Ð´Ð° Ð±ÑÐ´Ðµ Ð¿ÑÐ¾Ð¼ÐµÐ½ÐµÐ½Ð°  Ð·Ð°ÑÐ¾ÑÐ¾ Ð¼ÑÑÑÐ¾ÑÐ¾ Ð¼Ð¾Ð¶Ðµ Ð´Ð¸Ð°Ð»Ð¾Ð³Ð¾Ð²Ð¸Ñ Ðµ Ð±Ð¸Ð» Ð´ÐµÐ°ÐºÑÐ¸Ð²Ð¸ÑÐ°Ð½ Ð² Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ¸ÑÐµ Ð½Ð° Ð¼Ð°ÑÐ¸Ð½Ð°ÑÐ°",
        sortItems: "Ð¡Ð¾ÑÑÐ¸ÑÐ°Ð½Ðµ Ð½Ð° Ð½Ð°Ð²Ð¸Ð³Ð°ÑÐ¸Ð¾Ð½Ð½Ð¸ ÐµÐ»ÐµÐ¼ÐµÐ½ÑÐ¸",
        startDispensing: "Ð¡ÑÐ°ÑÑ Ð´Ð¾Ð·Ð¸ÑÐ°Ð½Ðµ",
        stir: "Ð Ð°Ð·Ð±ÑÑÐºÐ²Ð°Ð½Ðµ"
    },
    error: {
        errorDetail: "ÐÐµÑÐ°Ð¹Ð»Ð¸ Ð½Ð° Ð³ÑÐµÑÐºÐ°ÑÐ°",
        errorOccurred:
            "An unexpected error occurred. Contact our support at %{0}, and we'll get back to you as soon as we can.",
        hideDetail: "Ð¡ÐºÑÐ¸Ð¹ Ð´ÐµÑÐ°Ð¹Ð»Ð¸ÑÐµ"
    },
    favoritesTab: {
        addFolder: "ÐÐ¾Ð±Ð°Ð²Ð¸ Ð¿Ð°Ð¿ÐºÐ°",
        closeTabToLoadFormula: "ÐÐ°ÑÐ²Ð¾ÑÐµÑÐµ ÑÐ°Ð·Ð´ÐµÐ»Ð° Ð·Ð° Ð·Ð°ÑÐµÐ¶Ð´Ð°Ð½Ðµ Ð½Ð° ÑÐ¾ÑÐ¼ÑÐ»Ð°",
        deleteFolder: "ÐÐ·ÑÑÐ¸Ð¹ Ð¿Ð°Ð¿ÐºÐ°ÑÐ°",
        editFolder: "Ð ÐµÐ´Ð°ÐºÑÐ¸ÑÐ°Ð¹ Ð¿Ð°Ð¿ÐºÐ°ÑÐ°",
        favoriteFormulas: "ÐÑÐ±Ð¸Ð¼Ð¸ ÑÐ¾ÑÐ¼ÑÐ»Ð¸",
        formulaNotes: "ÐÐµÐ»ÐµÐ¶ÐºÐ¸ Ð·Ð° ÑÐ¾ÑÐ¼ÑÐ»Ð°",
        message: {
            formulasFromFolder: "Ð¤Ð¾ÑÐ¼ÑÐ»Ð¸ Ð¾Ñ Ð¿Ð°Ð¿ÐºÐ°",
            moveAllFormulas: "ÐÐ·Ð¼ÐµÑÑÐ¸ Ð²ÑÐ¸ÑÐºÐ¸ ÑÐ¾ÑÐ¼ÑÐ»Ð¸",
            removeAllFormulas: "ÐÑÐµÐ¼Ð°ÑÐ½Ð¸ Ð²ÑÐ¸ÑÐºÐ¸ ÑÐ¾ÑÐ¼ÑÐ»Ð¸",
            wantToDeleteFolder: "ÐÑÐºÐ°ÑÐµ Ð´Ð° Ð¸Ð·ÑÑÐ¸ÐµÑÐµ Ð¿Ð°Ð¿ÐºÐ°ÑÐ°"
        },
        newFolder: "ÐÐ¾Ð²Ð° Ð¿Ð°Ð¿ÐºÐ°",
        packages: "ÐÐ¿Ð°ÐºÐ¾Ð²ÐºÐ¸",
        pricePerPackage: "Ð¦ÐµÐ½Ð° Ð·Ð° Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ°",
        regularPrice: "ÐÐ±Ð¸ÑÐ°Ð¹Ð½Ð° ÑÐµÐ½Ð°",
        removeFromFavorites: "ÐÑÐµÐ¼ÐµÑÑÐ¸ Ð¾Ñ ÐÑÐ±Ð¸Ð¼Ð¸",
        specialPriceOff: "Ð¡Ð¿ÐµÑÐ¸Ð°Ð»Ð½Ð° ÑÐµÐ½Ð° %{number}% ÐÐ·ÐºÐ».",
        specialPriceVIP: "Ð¡Ð¿ÐµÑÐ¸Ð°Ð»Ð½Ð° ÑÐµÐ½Ð° VIP"
    },
    fileTransfer: {
        afterImport: "After import",
        alreadyExists: "Task for given type and format already exists",
        customFormulaSimple: "Custom formula simple",
        direction: "Direction",
        exportTask: "File export task",
        fileTransferNotification: "File transfer notification",
        flashMessage: "Flash message",
        importTask: "File import task",
        noInformation: "No information",
        protocol: {
            folder: "Folder",
            ftp: "FTP protocol",
            ftps: "FTPS protocol",
            redlikeStorage: "%{softwareName} FTP storage protocol",
            sftp: "SFTP protocol"
        },
        protocolDescription: {
            folder: "Protocol checking files in defined local folder.",
            ftp: "Protocol checking files in remote FTP folder using standard FTP connection.",
            ftps: "Protocol checking files in remote FTPS (FTP-SSL / FTP Secure) server using standard FTP connection.",
            redlikeStorage: "Protocol checking files in %{softwareName} storage."
        },
        remoteFolder: "Remote folder",
        startType: "Start type",
        statusbar: "Statusbar information",
        testConnection: "Test connection",
        xMoreLeft: "(%{amount} more left)",
        xmlImporting: "XML file is being imported"
    },
    filtering: {
        consumptionType: "Consumption type",
        filter: "Ð¤Ð¸Ð»ÑÑÑ",
        from: "ÐÑ",
        to: "ÐÑÐ¼"
    },
    findText: {
        findTextTitle: "Find text",
        removeMarks: "Remove marks",
        search: "Search word"
    },
    flashMessage: {
        VMNotAllowed: "VM not allowed",
        addedToStock: "Successfully added items to stock",
        allRecordsDeleted: "All imported records were successfully deleted",
        autologinFailed: "Database autologin failed.",
        autotaskDuplicateName:
            "Database integrity error: %{0} item with %{1} %{2} already exists, please use different %{3}",
        barcodeIsUsed: "The barcode is already used.",
        barcodeNotFound: "ÐÐ°ÑÐºÐ¾Ð´ÑÑ Ð½Ðµ Ðµ Ð¾ÑÐºÑÐ¸Ñ",
        bugReportSent: "Your bug report was sent.",
        cannoctConnectToServer: "ÐÐµ Ð¼Ð¾Ð¶ÐµÑÐµ Ð´Ð° ÑÐµ ÑÐ²ÑÑÐ¶ÐµÑÐµ Ñ ÑÑÑÐ²ÑÑ",
        cannotWriteLicense: "Cannot write license",
        clientConnectionRejected: "ÐÐ»Ð¸ÐµÐ½ÑÑÐºÐ°ÑÐ° Ð²ÑÑÐ·ÐºÐ° Ðµ Ð¾ÑÑÐ²ÑÑÐ»ÐµÐ½Ð°",
        clientNotLoggedIn: "ÐÐ»Ð¸ÐµÐ½ÑÑÑ Ð½Ðµ Ðµ Ð²Ð¿Ð¸ÑÐ°Ð½",
        colorFromInactiveDatabase: "Color is from inactive database %{0}.",
        colorantPackageRemovedStock: "Colorant package successfully removed from stock.",
        competitiveSearchEmpty:
            "No competitive colors could be found. Change searching parameters or select a different color.",
        competitiveSearchSelectProduct: "Please select product to start competitive color search.",
        computerBackdated: "Computer backdated",
        connectionFailed: "Connection test failed: %{0}",
        connectionSuccess: "Connection test was successful",
        corruptedLicenseFile: "License file corrupted",
        customFormulaCreated: "Custom formula successfully created.",
        customFormulaCreationError: "Error while creating custom formula.",
        customFormulaFromXmlCreationError:
            "Error while creating custom formula with colorants '%{colorants}' for combination of product '%{product}', fandeck '%{fandeck}', color '%{color}' and base '%{base}'.",
        customerNotFound: "The customer was not found",
        dataNotAvailable: "Server cannot connect to database",
        datacolorMatching: {
            couldNotConnect: "Could not connect to Datacolor Matching, either server down or PC is offline.",
            disabled: "Datacolor Matching disabled.",
            internalError: "Datacolor Matching internal error: '%{0}'",
            invalidCredentials: "No or invalid credentials for Datacolor Matching provided, contact database provider.",
            noCansAvailable: "No cans available for selected color file (product line), contact database provider."
        },
        defaultMessage: "Ð¡ÑÐ¾Ð±ÑÐµÐ½Ð¸Ðµ Ð¿Ð¾ Ð¿Ð¾Ð´ÑÐ°Ð·Ð±Ð¸ÑÐ°Ð½Ðµ",
        deleteAll: "Delete all",
        deletingImportedData: "Deleting imported records.",
        disableWinterPlugin:
            "You can disable the winter plugin by using the drop-down list on the right side of the tab navigation",
        duplicateBarcode: "Duplicate barcode already exists.",
        duplicateName: "ÐÑÐ±Ð»Ð¸ÑÐ°Ð½Ð¾ Ð¸Ð¼Ðµ",
        emptyFandeck: "Selected fandeck is empty.",
        emptyStock: "There are no records in stock for the item you have used.",
        expiredLicense: "License has expired",
        exportSuccess: "Data have been exported successfully",
        fandeckExist: "Ð¢Ð¾Ð²Ð° Ð¿ÐµÑÑÐ¾Ð½Ð°Ð»Ð¸Ð·Ð¸ÑÐ°Ð½Ð¾ Ð¸Ð¼Ðµ Ð½Ð° ÑÐ°Ð½Ð´ÐµÐºÐ° Ð²ÐµÑÐµ ÑÑÑÐµÑÑÐ²ÑÐ²Ð°.",
        featureNotAutorized: "Feature not autorized",
        fileExportComplete: "Ð¤Ð°Ð¹Ð»ÑÑ Ðµ ÐµÐºÑÐ¿Ð¾ÑÑÐ¸ÑÐ°Ð½ ÑÑÐ¿ÐµÑÐ½Ð¾.",
        fileExportError: "An error occurred during file export.",
        fileSaveComplete: "File was successfully saved.",
        fileSaveError: "An error occurred during file saving.",
        fileTransferCustomFormulaRecordsAdded: "New custom formula records were added from the received file.",
        fileTransferCustomFormulaRecordsNotFullyProcessed:
            "Could not fully process custom formula data in file: '%{0}', see error log files for more info.",
        fileTransferCustomFormulaRecordsProcessed:
            "The new custom formula records (%{0} of the %{1}) were succesfully added from the recieved file.",
        fileTransferCustomerRecordsAdded: "New customer records were added from the received file.",
        fileTransferCustomerRecordsNotFullyProcessed:
            "Could not fully process customer data in file: '%{0}', see error log files for more info.",
        fileTransferCustomerRecordsProcessed:
            "The new customer records (%{0} of the %{1}) were succesfully added from the recieved file.",
        fileTransferFileNotProvided: "File not provided or is empty.",
        fileTransferHistoryRecordsAdded: "New dispensing history records were added from the received file.",
        fileTransferHistoryRecordsNotFullyProcessed:
            "Could not fully process dispensing history data in file: '%{0}', see error log files for more info.",
        fileTransferHistoryRecordsProcessed:
            "The new history records (%{0} of the %{1}) were succesfully added from the recieved file.",
        fileTransferInvalidFile: "Could not process data in file, file is not valid.",
        fileTransferOrderRecordsAdded: "New order records were added from the received file.",
        fileTransferOrderRecordsNotFullyProcessed:
            "Could not fully process order data in file: '%{0}', see error log files for more info.",
        fileTransferOrderRecordsProcessed:
            "The new order records (%{0} of the %{1}) were succesfully added from the recieved file.",
        fileTransferUnknownVersion: "Could not detect version of file.",
        filetransferNoData: "No database connection, check settings",
        formulaDataUnavailable: "Formula data is not available",
        helperDefaultMessage: "An unexpected error occurred during the last Helper Server action",
        helperServerError: "Helper Server error",
        importAborted: "Import process has been aborted",
        importSuccess: "Data have been imported successfully",
        incompatibleBaseCan: "ÐÐµÑÑÐ²Ð¼ÐµÑÑÐ¸Ð¼Ð° Ð±Ð°Ð·Ð¾Ð²Ð° Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ°",
        incorrectPassword: "Your old password is not correct. Please enter a correct one.",
        invalidCurrency: "Currency code is not valid. Euro is set as a default currency.",
        invalidDatabaseName: "ÐÐµÐ²Ð°Ð»Ð¸Ð´Ð½Ð¾ Ð¸Ð¼Ðµ Ð½Ð° Ð±Ð°Ð·Ð° Ð´Ð°Ð½Ð½Ð¸",
        invalidEmail: "ÐÐµÐ²Ð°Ð»Ð¸Ð´ÐµÐ½ email",
        invalidFormulaColorants:
            "There is the software issue in the formula. Formula could be wrong! Contact your support!",
        invalidLicenseCompanyUserKey: "Invalid company-user key",
        invalidLicenseFile: "Invalid license file",
        invalidLicenseIdentificationKeys: "Your license identification keys are not valid",
        invalidLicenseKey: "ÐÐµÐ²Ð°Ð»Ð¸Ð´ÐµÐ½ Ð»Ð¸ÑÐµÐ½Ð·Ð¸Ð¾Ð½ÐµÐ½ ÐºÐ»ÑÑ",
        invalidLicenseProduct: "License file does not match the product",
        invalidRccResponse: "An unexpected error occurred during processing of the last RCC response",
        invalidServerResponse: "ÐÐµÐ²Ð°Ð»Ð¸Ð´ÐµÐ½ Ð¾ÑÐ³Ð¾Ð²Ð¾Ñ Ð¾Ñ ÑÑÑÐ²ÑÑÐ°",
        invalidUrl: "ÐÐµÐ²Ð°Ð»Ð¸Ð´ÐµÐ½ URL",
        itemNotFound: "ÐÐ»ÐµÐ¼ÐµÐ½ÑÑÑ Ð½Ðµ Ðµ Ð¾ÑÐºÑÐ¸Ñ",
        keyboardShortcutUsedInModal:
            "This keyboard shortcut cannot be used in the modal window. Please close the modal window.",
        keyboardShortcutValidation: "You cannot have same keyboard shortcut for two different actions",
        licenseHasBeenRevoked:
            "ÐÐ¸ÑÐµÐ½Ð·ÑÑ Ð²Ð¸ Ðµ Ð¾ÑÐ½ÐµÑ.Â ÐÐ° Ð´Ð° Ð³Ð¾ Ð¿Ð¾Ð´Ð½Ð¾Ð²Ð¸ÑÐµ, Ð¼Ð¾Ð»Ñ, ÑÐ²ÑÑÐ¶ÐµÑÐµ ÑÐµ Ñ Ð²Ð°ÑÐ¸Ñ Ð´Ð¾ÑÑÐ°Ð²ÑÐ¸Ðº Ð½Ð° ÑÐ¾ÑÑÑÐµÑ.",
        licenseProlongationNeeded:
            "ÐÐµÐ¾Ð±ÑÐ¾Ð´Ð¸Ð¼Ð¾ Ðµ ÑÐ´ÑÐ»Ð¶Ð°Ð²Ð°Ð½Ðµ Ð½Ð° Ð»Ð¸ÑÐµÐ½Ð·Ð° (ÑÐ²ÑÑÐ¶ÐµÑÐµ PC Ñ ÐÐ½ÑÐµÑÐ½ÐµÑ, Ð·Ð° Ð´Ð° Ð¿Ð¾Ð»ÑÑÐ¸ÑÐµ Ð½Ð¾Ð² Ð»Ð¸ÑÐµÐ½Ð·)",
        licenseUpToDate: "Your license is up to date. No update necessary.",
        licenseUpdateUnsuccessful: "Could not update license.",
        licenseUpdated: "License has been successfully updated.",
        licensedOnDifferentComputer: "Originally licensed on a different computer",
        logFileArchiveDownloadComplete: "Downloading of log archive was successfully completed",
        loginError: "ÐÑÐµÑÐºÐ° Ð¿Ð¾ Ð²ÑÐµÐ¼Ðµ Ð½Ð° Ð²Ð¿Ð¸ÑÐ²Ð°Ð½Ðµ",
        logoutError: "ÐÑÐµÑÐºÐ° Ð¿Ð¾ Ð²ÑÐµÐ¼Ðµ Ð½Ð° Ð¾ÑÐ¿Ð¸ÑÐ²Ð°Ð½Ðµ",
        machineIsConnecting: "Machine is connecting, please wait",
        machineIsNotConnected: "ÐÐ°ÑÐ¸Ð½Ð°ÑÐ° Ð½Ðµ Ðµ ÑÐ²ÑÑÐ·Ð°Ð½Ð°",
        malformedFormula: "Formula is malformed.",
        matching: {
            correctionNotPossible: "Correction cannot be done, use reformulation.",
            forbidden: "Request '%{0}' failed: forbidden.",
            internalServerError: "Internal server error.",
            invalidBase: "Invalid base in product.",
            invalidBipp: "Invalid base in product package.",
            invalidColorantId: "Invalid colorant with ID: %{0}.",
            invalidColorantName: "Invalid colorant with name: %{0}.",
            invalidColorfile: "Invalid color file with ID: %{0} for product with ID: %{1}.",
            invalidIlluminant: "Invalid illuminant: %{0}",
            invalidProduct: "Invalid product with ID: %{0}.",
            invalidSpectralCurve: "Invalid spectral curve.",
            noColorfiles: "No color files defined for product with ID: %{0}.",
            notAuthorized: "Request '%{0}' failed: unauthorized.",
            notFound: "Request '%{0}' failed: not found.",
            reformulationNotPossible: "Reformulation cannot be done.",
            unknownError: "Unknown error.",
            validationError: "Request '%{0}' failed due to validation errors: %{0}."
        },
        maxFileSizeExceeded: "Maximum file size of %{0} MB exceeded",
        maxTabs: "max ÐÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾ ÑÐ°Ð·Ð´ÐµÐ»Ð¸",
        noTemplate: "ÐÑÐ¿ÐµÑÐ°ÑÐ²Ð°Ð½ÐµÑÐ¾ Ð½Ðµ Ð¼Ð¾Ð¶Ðµ Ð´Ð° ÑÐµ Ð¸Ð·Ð²ÑÑÑÐ¸, ÑÑÐ¹ ÐºÐ°ÑÐ¾ Ð½ÑÐ¼Ð° Ð½Ð°Ð»Ð¸ÑÐ½Ð¸ ÑÐ°Ð±Ð»Ð¾Ð½Ð¸.",
        openNewTab: "Please open a new formula tab to load formula using barcode",
        orderAlreadyAcquired: "Order has been already acquired, it has to be released first",
        orderCreated: "ÐÐ°ÑÐ²ÐºÐ°ÑÐ° Ðµ ÑÑÐ¿ÐµÑÐ½Ð¾ Ð¸Ð·Ð¿ÑÐ°ÑÐµÐ½Ð°",
        passwordIsNotUnique: "Old password must differ from the new one.",
        printCannotBeCarriedOut: "ÐÑÐ¿ÐµÑÐ°ÑÐ²Ð°Ð½ÐµÑÐ¾ Ð½Ðµ Ð¼Ð¾Ð¶Ðµ Ð´Ð° ÑÐµ Ð¸Ð·Ð²ÑÑÑÐ¸, ÑÑÐ¹ ÐºÐ°ÑÐ¾ Ð¸Ð¼ÐµÑÐ¾ Ð½Ð° Ð¿ÑÐ¸Ð½ÑÐµÑÐ° Ðµ Ð½ÐµÐ²Ð°Ð»Ð¸Ð´Ð½Ð¾.",
        problemWithFileExport: "Unfortunately, a problem occurred while saving file to disk.",
        productFileWarning: "Product file is only available online.",
        productNotLicensed: "Product is not licensed",
        rccDefaultMessage: "RCC ÑÑÐ¾Ð±ÑÐµÐ½Ð¸Ðµ Ð¿Ð¾ Ð¿Ð¾Ð´ÑÐ°Ð·Ð±Ð¸ÑÐ°Ð½Ðµ",
        rccError: "RCC Ð³ÑÐµÑÐºÐ°",
        rccNeedRestart: "ÐÐ¾Ð»Ñ ÑÐµÑÑÐ°ÑÑÐ¸ÑÐ°Ð¹ÑÐµ RCC",
        restoredSettings: "Settings have been restored.",
        revokedLicense: "License was revoked",
        runningOutOfSpace: "The computer is running out of free space.",
        savedFormulaToHistory: "Formula was successfully saved into history.",
        savedLogArchive: "Log archive was successfully saved into your directory.",
        scanning: "Scanning in progress",
        serverError: "ÐÑÐµÑÐºÐ° Ð² ÑÑÑÐ²ÑÑÐ°",
        setClientIdentifier: "Please set your client identifier",
        showLess: "ÐÐ¾ÐºÐ°Ð¶Ð¸ Ð¿Ð¾-Ð¼Ð°Ð»ÐºÐ¾",
        showMore: "ÐÐ¾ÐºÐ°Ð¶Ð¸ Ð¿Ð¾Ð²ÐµÑÐµ",
        spectroIsDisconnecting: "Spectro is disconnecting, please wait",
        spectroIsNotConnected: "Ð¡Ð¿ÐµÐºÑÑÐ¾ÑÐ¾ÑÐ¾Ð¼ÐµÑÑÑÐ° Ð½Ðµ Ðµ ÑÐ²ÑÑÐ·Ð°Ð½",
        spectroIsNotSelected: "Ð¡Ð¿ÐµÐºÑÑÐ¾ÑÐ¾ÑÐ¾Ð¼ÐµÑÑÑÐ° Ð½Ðµ Ðµ Ð¸Ð·Ð±ÑÐ°Ð½",
        tmcNotAvailable: "%{tmc} is not available. Please check your %{collector}.",
        tmcNotConnected: "%{tmc} is not connected. Please start your %{collector} and restart server.",
        unknownError: "ÐÐµÐ¸Ð·Ð²ÐµÑÑÐ½Ð° Ð³ÑÐµÑÐºÐ°: %{0}",
        userAlreadyLoggedIn: "ÐÐ¾ÑÑÐµÐ±Ð¸ÑÐµÐ»ÑÑ Ð²ÐµÑÐµ Ðµ Ð²Ð¿Ð¸ÑÐ°Ð½",
        versionNotAllowedByLicense: "Software version is too new and is not allowed for your license.",
        webApiConnectionError: "Could not connect to Web Api server",
        webApiInternalError: "Web Api server internal error",
        webApiInvalidUser: "Web Api server invalid user",
        webApiNoLicenseAvailable: "Web Api server no license available",
        wrongDataSaved: "Wrong data was saved to XML file in the %{0} folder.",
        wrongHelpInput: "ÐÑÐµÑÐµÐ½ ÑÐ¾ÑÐ¼Ð°Ñ Ð½Ð° %{0} Ð²ÑÐ¾Ð´.",
        wrongRccVersion: "ÐÐ¾Ð»Ñ, Ð¿ÑÐ¾Ð²ÐµÑÐµÑÐµ Ð²ÐµÑÑÐ¸ÑÑÐ° Ð½Ð° Ð²Ð°ÑÐ°ÑÐ° RCC . ÐÐ°ÑÐ¸ÑÑ ÐºÐ»Ð¸ÐµÐ½Ñ Ðµ ÑÑÐ²Ð¼ÐµÑÑÐ¸Ð¼ ÑÐ°Ð¼Ð¾ Ñ RCC %{0}."
    },
    footer: {
        aboutApplication: "About application",
        activeUser: "Active user",
        logOut: "ÐÑÐ¿Ð¸ÑÐ²Ð°Ð½Ðµ Ð¾Ñ Ð¿ÑÐ¾ÑÐ¸Ð»Ð°",
        machineErrors: "ÐÑÐµÑÐºÐ¸ Ð½Ð° Ð¼Ð°ÑÐ¸Ð½Ð°ÑÐ°"
    },
    formulaProperties: {
        exterior: "Exterior",
        interior: "Interior",
        invalid: "Invalid",
        solvent: "Solvent based",
        universal: "Universal",
        water: "Water based"
    },
    formulaSettings: {
        allUnits: "All units available in the database",
        allowCustomFormulas: "ÐÐ¾Ð·Ð²Ð¾Ð»Ð¸ Ð¿Ð¾ÑÑÐµÐ±Ð¸ÑÐµÐ»ÑÐºÐ¸ ÑÐ¾ÑÐ¼ÑÐ»Ð¸",
        allowCustomPackageSize: "ÐÐ¾Ð·Ð²Ð¾Ð»ÑÐ²Ð°Ð½Ðµ Ð½Ð° Ð¿ÐµÑÑÐ¾Ð½Ð°Ð»Ð¸Ð·Ð¸ÑÐ°Ð½ ÑÐ°Ð·Ð¼ÐµÑ Ð½Ð° Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ°",
        allowFormulaAutomaticNaming: "Ð Ð°Ð·ÑÐµÑÐ¸ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐ½Ð¾ÑÐ¾ Ð¸Ð¼ÐµÐ½ÑÐ²Ð°Ð½Ðµ",
        automaticNaming: "Ð¤Ð¾ÑÐ¼ÑÐ»Ð° Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐ½Ð¾ Ð¸Ð¼ÐµÐ½ÑÐ²Ð°Ð½Ðµ",
        basePanelSize: "Set size of base panel",
        bippPanelSize: "Set size of base in product package panel",
        blendColorNameAndCode: "Blend color name and color code",
        buttonBellowMoreInfo: "Show button below formula notes",
        buttonInColorantPanel: "Show button in Colorants panel",
        colorCodePrimary: "Color code as primary",
        colorPanel: "Color palette",
        colorPreviewAsImage: "Color preview as image",
        colorPreviewResizable: "Resizable color preview",
        competitiveColorSearch: "ÐÐ¾Ð½ÐºÑÑÐµÐ½ÑÐ½Ð¾ ÑÑÑÑÐµÐ½Ðµ Ð½Ð° ÑÐ²ÐµÑÐ¾Ð²Ðµ",
        customFormula: "Custom formula",
        customFormulaForMasterProduct: "Allow create custom formulas for master product",
        customFormulaForMasterProductDefault: "Checked by default",
        customFormulas: "Custom Formulas",
        customPackageSettingsUnitGrav: "Custom package settings gravimetric unit",
        customPackageSettingsUnitVol: "Custom package settings volumetric unit",
        customPackageSize: "ÐÐµÑÑÐ¾Ð½Ð°Ð»Ð¸Ð·Ð¸ÑÐ°Ð½ ÑÐ°Ð·Ð¼ÐµÑ Ð½Ð° Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ°",
        customUnits: "Choose custom units",
        dropDownCalculate: "Expand the drop down menu to the height of the window",
        editColorants: "Ð ÐµÐ´Ð°ÐºÑÐ¸ÑÐ°Ð½Ðµ Ð½Ð° Ð¾ÑÐ²ÐµÑÐ¸ÑÐµÐ»Ð¸",
        editColorantsAllowed: "ÐÐ¾Ð·Ð²Ð¾Ð»Ð¸ ÑÐµÐ´Ð°ÐºÑÐ¸ÑÐ°Ð½Ðµ Ð¾ÑÐ²ÐµÑÐ¸ÑÐµÐ»Ð¸",
        fandeckPanelSize: "Set size of fandeck panel",
        favoriteFormulas: "ÐÑÐ±Ð¸Ð¼Ð¸ ÑÐ¾ÑÐ¼ÑÐ»Ð¸",
        formulaColorPreview: "ÐÑÐµÐ³Ð»ÐµÐ´ Ð½Ð° ÑÐ²ÐµÑÐ° Ð½Ð° ÑÐ¾ÑÐ¼ÑÐ»Ð°",
        formulaDataSettings: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ Ð½Ð° Ð´Ð°Ð½Ð½Ð¸ Ð·Ð° ÑÐ¾ÑÐ¼ÑÐ»Ð¸",
        formulaPanel: "ÐÐ°Ð½ÐµÐ» Ð·Ð° ÑÐ¾ÑÐ¼ÑÐ»Ð¸",
        formulaPanelSize: "Set size of color panel",
        formulaSettings: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ Ð½Ð° ÑÐ¾ÑÐ¼ÑÐ»Ð°",
        generateColorPreview: "Generate color preview",
        gravimetricOnly: "Gravimetric units only",
        hideAlternativeFormulas: "Hide alternative formulas",
        hideFormulaProperties: "Hide formula properties",
        hideHistoricalFormulas: "Hide historical formulas",
        imagesLocal: "Use only image from local database",
        imagesOnline: "Primarily, try to open online image, if it fails, open local image",
        infoPanelResizable: "Resizable more info panel",
        numberOfColorants: "Number of shown colorants",
        orderByDistance: "Order of search results by the distance",
        productDependent: "Unit depends on the selected product",
        productFilesDialog: "Show dialog to open local file or online file",
        productFilesLocal: "Use only product files from local database",
        productFilesOnline: "Primarily, try to open online product file, if it fails, open local file",
        productPanelSize: "Set size of product panel",
        searchPanelQuickSelect: "Quick select",
        setAdditionalFormulaPanel: "ÐÐ°Ð´Ð°Ð¹ Ð´Ð¾Ð¿ÑÐ»Ð½Ð¸ÑÐµÐ»ÐµÐ½ Ð¿Ð°Ð½ÐµÐ» Ð·Ð° ÑÐ¾ÑÐ¼ÑÐ»Ð¸",
        setCompetitiveColorSearch: "Enable competitive color search",
        setInitialFormulaPanel: "ÐÐ°Ð´Ð°Ð²Ð°Ð½Ðµ Ð½Ð° Ð¿ÑÑÐ²Ð¾Ð½Ð°ÑÐ°Ð»ÐµÐ½ Ð¿Ð°Ð½ÐµÐ» Ð·Ð° ÑÐ¾ÑÐ¼ÑÐ»Ð°",
        setMaxToleranceForCompetitiveColors: "ÐÐ°Ð´Ð°Ð¹ÑÐµ Ð¼Ð°ÐºÑÐ¸Ð¼Ð°Ð»Ð½Ð° ÑÐ¾Ð»ÐµÑÐ°Ð½ÑÐ½Ð¾ÑÑ Ð·Ð° ÐºÐ¾Ð½ÐºÑÑÐµÐ½ÑÐ½Ð¾ ÑÑÑÑÐµÐ½Ðµ Ð½Ð° ÑÐ²ÐµÑÐ¾Ð²Ðµ",
        setNumberOfCompetitiveColors: "ÐÐ°Ð´Ð°Ð¹ÑÐµ Ð±ÑÐ¾Ð¹ ÐºÐ¾Ð½ÐºÑÑÐµÐ½ÑÐ½Ð¸ ÑÐ²ÐµÑÐ¾Ð²Ðµ",
        setSearchPanel: "ÐÐ°Ð´Ð°Ð²Ð°Ð½Ðµ Ð½Ð° Ð¿Ð°Ð½ÐµÐ» Ð·Ð° ÑÑÑÑÐµÐ½Ðµ",
        setVisibilityAndOrder: "ÐÐ°Ð´Ð°Ð¹ÑÐµ Ð²Ð¸Ð´Ð¸Ð¼Ð¾ÑÑ Ð¸ ÑÐµÐ´ Ð½Ð° ÑÐ°Ð·Ð»Ð¸ÑÐ½Ð¸ Ð´Ð°Ð½Ð½Ð¸ Ð·Ð° ÑÐ¾ÑÐ¼ÑÐ»Ð¸ ",
        setVisibleUnit: "ÐÐ°Ð´Ð°Ð¹ÑÐµ Ð²Ð¸Ð´Ð¸Ð¼Ð¸ ÐµÐ´Ð¸Ð½Ð¸ÑÐ¸",
        showColorPreview: "ÐÐ¾ÐºÐ°Ð¶Ð¸ Ð¿ÑÐµÐ³Ð»ÐµÐ´ Ð½Ð° ÑÐ²ÐµÑÐ°",
        showInFormulaStatusPanel: "Show in formula status panel",
        showInMoreInfoPanel: "Show in formula notes",
        sorting: "Colorant panel sorting",
        useBase: "Use selection item for base",
        useBaseInProductPackage: "Use selection item for base in product package",
        useColorCode: "Use color code",
        useColorName: "Use color name",
        useFandeckGroups: "Use fandeck groups",
        useProduct: "Use selection item for product",
        useProductCode: "Use product code",
        useProductGroups: "Use product groups",
        volumetricOnly: "Volumetric units only"
    },
    general: {
        accepted: "Accepted",
        active: "ÐÐºÑÐ¸Ð²ÐµÐ½",
        actual: "ÐÐ°ÑÑÐ¾ÑÑ",
        actualLevel: "Ð¢ÐµÐºÑÑÐ¾ Ð½Ð¸Ð²Ð¾",
        add: "ÐÐ¾Ð±Ð°Ð²Ð¸",
        addColorant: "ÐÐ¾Ð±Ð°Ð²Ð¸ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½Ñ",
        addColorantForPackage: "Add colorant for package",
        addFile: "Add file",
        all: "ÐÑÐ¸ÑÐºÐ¸",
        amount: "ÐÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾",
        applyNow: "Apply now",
        attachments: "Attachments",
        automaticCorrection: "Automatic correction",
        automatically: "Automatically",
        available: "Available",
        back: "ÐÐ±ÑÐ°ÑÐ½Ð¾",
        base: "ÐÐ°Ð·Ð°",
        baseInProductPackage: "ÐÐ°Ð·Ð° Ð² Ð¿ÑÐ¾Ð´ÑÐºÑÐ° Ð¸ Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ°",
        batchNumber: "Batch number",
        bottom: "Ð´ÑÐ½Ð¾",
        buildingSite: "Building site",
        calculate: "Calculate",
        can: "ÐÐ¿Ð°ÐºÐ¾Ð²ÐºÐ°",
        canSize: "ÑÐ°Ð·Ð¼ÐµÑ Ð½Ð° Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ°ÑÐ°",
        cancel: "ÐÐ½ÑÐ»Ð¸ÑÐ°Ð½Ðµ",
        canister: "Canister",
        canisterId: "ÐÐ¾Ð½ÑÐµÐ¹Ð½ÐµÑ ID",
        canisterIndex: "Canister Index",
        canisters: "Ð ÐµÐ·ÐµÑÐ²Ð¾Ð°ÑÐ¸",
        cap: "ÐÐ°Ð¿Ð°ÑÐºÐ°",
        capacity: "ÐÐ¼ÐµÑÑÐ¸Ð¼Ð¾ÑÑ",
        channels: "ÐÐ°Ð½Ð°Ð»Ð¸",
        choose: "ÐÐ·Ð±Ð¸ÑÐ°Ð¼",
        city: "Ð³ÑÐ°Ð´",
        clean: "ÑÐ¸ÑÑ",
        clear: "ÐÐ·ÑÐ¸ÑÑÐ¸",
        client: "ÐÐ»Ð¸ÐµÐ½Ñ",
        close: "ÐÐ°ÑÐ²Ð¾ÑÐ¸",
        closeAll: "Close all",
        collapseAll: "Collapse all",
        color: "Ð¦Ð²ÑÑ",
        colorCode: "ÐÐ¾Ð´ Ð½Ð° ÑÐ²ÐµÑÐ°",
        colorFile: "Colorfile",
        colorName: "ÐÐ¼Ðµ Ð½Ð° ÑÐ²ÑÑ",
        colorPreview: "ÐÐ¸Ð·ÑÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ñ Ð½Ð° ÑÐ²ÑÑ",
        colorant: "ÐÐ¾Ð»Ð¾ÑÐ°Ð½Ñ",
        colorantBatchNumber: "Colorant Batch number",
        colorantPackage: "ÐÐ¿Ð°ÐºÐ¾Ð²ÐºÐ° Ð½Ð° ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ°",
        colorants: "ÐÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ¸",
        colors: "Colors",
        company: "Ð¢ÑÑÐ³Ð¾Ð²ÑÐºÐ¾ Ð´ÑÑÐ¶ÐµÑÑÐ²Ð¾",
        competitiveColor: "Competitive color",
        confirm: "ÐÐ¾ÑÐ²ÑÑÐ¶Ð´ÐµÐ½Ð¸Ðµ",
        confirmDeletion: "ÐÐ°Ð¸ÑÑÐ¸Ð½Ð° Ð»Ð¸ Ð¸ÑÐºÐ°ÑÐµ Ð´Ð° Ð¸Ð·ÑÑÐ¸ÐµÑÐµ ÑÐ¾Ð·Ð¸ ÐµÐ»ÐµÐ¼ÐµÐ½Ñ Ð·Ð° Ð¿Ð¾ÑÑÐ¾ÑÐ½Ð½Ð¾?",
        confirmHelpSettings: "ÐÐ°Ð¸ÑÑÐ¸Ð½Ð° Ð»Ð¸ Ð¸ÑÐºÐ°ÑÐµ Ð´Ð° Ð·Ð°Ð¿Ð°Ð·Ð¸ÑÐµ ÑÐ¾ÑÐ¼Ð°ÑÐ° Ð¸ Ð´Ð° Ð¾ÑÑÐ°Ð²Ð¸ÑÐµ Ð¿Ð¾Ð»ÐµÑÐ°ÑÐ° Ð¿ÑÐ°Ð·Ð½Ð¸?",
        connect: "Ð¡Ð²ÑÑÐ·Ð²Ð°Ð½Ðµ",
        continue: "ÐÑÐ¾Ð´ÑÐ»Ð¶Ð¸",
        correction: "Correction",
        country: "Country",
        created: "Ð¡ÑÐ·Ð´Ð°Ð´ÐµÐ½",
        creationDateOf: "Creation date of",
        criticalLevel: "ÐÑÐ¸ÑÐ¸ÑÐ½Ð¾ Ð½Ð¸Ð²Ð¾",
        currency: "Currency",
        currentBatchNumber: "Current batch number",
        currentUfiCode: "Current UFI code",
        custom: "ÐÐµÑÑÐ¾Ð½Ð°Ð»Ð¸Ð·Ð¸ÑÐ°Ð½",
        customData: "Custom data",
        customFandeck: "ÐÐµÑÑÐ¾Ð½Ð°Ð»ÐµÐ½ÑÐ²ÐµÑÐµÐ½ ÐºÐ°ÑÑÐµÐ»",
        customFormula: "Custom formula",
        customPackage: "ÐÐµÑÑÐ¾Ð½Ð°Ð»Ð¸Ð·Ð¸ÑÐ°Ð½Ð° Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ°",
        customPackageSettings: "Custom package settings",
        customer: "ÐÐ»Ð¸ÐµÐ½Ñ",
        customerVersion: "ÐÐµÑÑÐ¸Ñ Ð½Ð° ÐºÐ»Ð¸ÐµÐ½ÑÐ°",
        customers: "ÐÐ»Ð¸ÐµÐ½ÑÐ¸",
        database: "ÐÐ°Ð·Ð° Ð´Ð°Ð½Ð½Ð¸",
        date: "ÐÐ°ÑÐ°",
        default: "Default",
        delete: "ÐÐ·ÑÑÐ¸Ð¹",
        deleteImportedData: "Delete imported records",
        delta: "Delta",
        description: "ÐÐ¿Ð¸ÑÐ°Ð½Ð¸Ðµ",
        disconnect: "ÐÑÐµÐºÑÑÐ²Ð°Ð½Ðµ Ð½Ð° Ð²ÑÑÐ·ÐºÐ°ÑÐ°",
        discount: "Discount",
        discover: "ÐÐ°Ð¼ÐµÑÐ¸",
        dispense: "ÐÐ¾Ð·Ð¸ÑÐ°Ð½Ðµ",
        dispensing: "ÐÐ¾Ð·Ð¸ÑÐ°Ð½Ðµ",
        doNotShowAgain: "Do not show this message again.",
        downloadingFile: "ÐÐ·ÑÐµÐ³Ð»ÑÐ½Ðµ Ð½Ð° ÑÐ°Ð¹Ð»Ð¾Ð²Ðµ",
        edit: "Ð ÐµÐ´Ð°ÐºÑÐ¸ÑÐ°Ð½Ðµ",
        email: "ÐÐ»ÐµÐºÑÑÐ¾Ð½Ð½Ð° Ð¿Ð¾ÑÐ°",
        enabled: "Ð Ð°Ð·ÑÐµÑÐµÐ½Ð¾",
        error: "ÐÑÐµÑÐºÐ°",
        expandAll: "Expand all",
        exportData: "Export data",
        exportPdf: "Export PDF",
        fan: "Ð¦Ð²ÐµÑÐµÐ½ ÐºÐ°ÑÑÐµÐ»",
        fandeck: "Ð¦Ð²ÐµÑÐµÐ½ ÐºÐ°ÑÑÐµÐ»",
        fandeckCode: "Fandeck code",
        fandeckName: "ÐÐ¼Ðµ Ð½Ð° ÑÐ²ÐµÑÐµÐ½ ÐºÐ°ÑÑÐµÐ»",
        fandecks: "Fandecks",
        favorite: "Ð¤Ð°Ð²Ð¾ÑÐ¸Ñ",
        fileTransfer: "File transfer",
        filling: "ÐÐ°ÑÐµÐ¶Ð´Ð°Ð½Ðµ",
        fillingDate: "Filling date",
        find: "ÐÐ°Ð¼ÐµÑÐ¸",
        finish: "Finish",
        finishedCorrection: "Finished correction",
        formula: "Ð¤Ð¾ÑÐ¼ÑÐ»Ð°",
        formulas: "Formulas",
        frontdesk: "Frontdesk",
        getQrCode: "ÐÐ·ÐµÐ¼Ð¸ QR ÐºÐ¾Ð´",
        gravimetric: "Gravimetric",
        historical: "Historical",
        history: "ÐÑÑÐ¾ÑÐ¸Ñ",
        hours: "Hou.",
        id: "Id",
        images: "Images",
        in: "In",
        index: "Index",
        insertBarcode: "ÐÐ¾Ð»Ñ Ð²ÑÐ²ÐµÐ´ÐµÑÐµ Ð±Ð°ÑÐºÐ¾Ð´",
        install: "ÐÐ½ÑÑÐ°Ð»Ð¸ÑÐ°Ð¹",
        installed: "ÐÐ½ÑÑÐ°Ð»Ð¸ÑÐ°Ð½Ð°",
        instructions: "Instructions",
        internalNote: "Internal note",
        interval: "Interval",
        ip: "IP Ð°Ð´ÑÐµÑ",
        itemNumber: "Item no.",
        itemXOfY: "Item %{x}/%{y}",
        itemsCount: "Items count",
        later: "Later",
        limit: "Limit",
        load: "Load",
        loadFormula: "ÐÐ°ÑÐµÐ´ÐµÑÐµ ÑÐ¾ÑÐ¼ÑÐ»Ð°",
        localVersion: "ÐÐµÑÑÐ½Ð° Ð²ÐµÑÑÐ¸Ñ",
        machine: "ÐÐ°ÑÐ¸Ð½Ð°",
        manualCorrection: "Manual correction",
        manually: "Manually",
        margin: "ÐÐ°ÑÐ¶",
        markup: "ÐÐ°Ð´ÑÐµÐ½ÐºÐ°",
        matching: "Matching",
        matchingFormula: "Matching formula",
        maxLevel: "Max ÐÐ¸Ð²Ð¾",
        maxValue: "Max value",
        maximum: "ÐÐ°ÐºÑÐ¸Ð¼Ð°Ð»ÐµÐ½",
        mayTakeAWhile: "This may take a while",
        measured: "Measured",
        metamarism: "Metamarism",
        minimum: "ÐÐ¸Ð½Ð¸Ð¼ÑÐ¼",
        minutes: "Min.",
        missingItem: "ÐÐ¸Ð¿ÑÐ²Ð°Ñ ÐµÐ»ÐµÐ¼ÐµÐ½Ñ",
        missingRequiredItems: "ÐÑÐ¸ÑÐºÐ¸ Ð·Ð°Ð´ÑÐ»Ð¶Ð¸ÑÐµÐ»Ð½Ð¸ ÐµÐ»ÐµÐ¼ÐµÐ½ÑÐ¸ (Ð¼Ð°ÑÐºÐ¸ÑÐ°Ð½Ð¸ ÑÑÑ Ð·Ð²ÐµÐ·Ð´Ð¸ÑÐºÐ°) ÑÑÑÐ±Ð²Ð° Ð´Ð° Ð±ÑÐ´Ð°Ñ Ð¿Ð¾Ð¿ÑÐ»Ð½ÐµÐ½Ð¸",
        modified: "Modified",
        modifiedAutomaticCorrection: "Target color correction",
        modifiedCustomFormula: "Modified custom formula",
        modifiedStandardFormula: "Modified standard formula",
        moduleChange: "Module change",
        more: "ÐÐ¾Ð²ÐµÑÐµ",
        moreInfo: "ÐÐ¾Ð²ÐµÑÐµ Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ",
        moveDown: "ÐÑÐµÐ¼ÐµÑÑÐ¸ Ð½Ð°Ð´Ð¾Ð»Ñ",
        moveUp: "ÐÑÐµÐ¼ÐµÑÑÐ¸ Ð½Ð°Ð³Ð¾ÑÐµ",
        myOrders: "ÐÐ¾Ð¸ÑÐµ Ð¿Ð¾ÑÑÑÐºÐ¸",
        name: "ÐÐ¼Ðµ",
        nameTitle: "ÐÐ¼Ðµ",
        new: "ÐÐ¾Ð²",
        next: "Ð¡Ð»ÐµÐ´Ð²Ð°ÑÐ¸Ñ",
        no: "ÐÐµ",
        noColorantsAvailable: "ÐÑÐ¼Ð° Ð¾ÑÐ²ÐµÑÐ¸ÑÐµÐ»Ð¸",
        noFormulas: "ÐÑÐµ Ð¾ÑÐµ Ð½ÑÐ¼Ð° ÑÐ¾ÑÐ¼ÑÐ»Ð¸",
        noPricesAvailable: "ÐÑÐ¼Ð° Ð½Ð°Ð»Ð¸ÑÐ½Ð¸ ÑÐµÐ½Ð¸",
        nominalAmount: "ÐÐ¾Ð¼Ð¸Ð½Ð°Ð»Ð½Ð° ÑÑÐ¾Ð¹Ð½Ð¾ÑÑ",
        notAvailable: "ÐÐµ Ðµ Ð½Ð°Ð»Ð¸ÑÐµÐ½",
        note: "ÐÐµÐ»ÐµÐ¶ÐºÐ°",
        numberOfCanisters: "ÐÑÐ¾Ð¹ Ð½Ð° ÑÐµÐ·ÐµÑÐ²Ð¾Ð°ÑÐ¸",
        numberOfItemCount: "Number of '%{item}': %{count}",
        numberOfLabels: "ÐÑÐ¾Ð¹ Ð½Ð° ÐµÑÐ¸ÐºÐµÑÐ¸",
        numberOfPackages: "ÐÑÐ¾Ð¹ Ð½Ð° Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ¸ÑÐµ",
        off: "ÐÐ·ÐºÐ»ÑÑÐµÐ½Ð¾",
        ok: "ÐÐ",
        on: "ÐÐºÐ»ÑÑÐµÐ½Ð¾",
        onFocus: "On focus",
        open: "ÐÑÐ²Ð¾ÑÐµÐ½Ð¾",
        operator: "Operator",
        options: "ÐÐ°ÑÑÑÐ¾Ð¸ÐºÐ¸",
        order: "Order",
        other: "ÐÑÑÐ³Ð¸",
        otherError: "ÐÑÑÐ³Ð° Ð³ÑÐµÑÐºÐ°",
        out: "Out",
        overwrite: "Overwrite",
        package: "ÐÐ¿Ð°ÐºÐ¾Ð²ÐºÐ°",
        packagePreview: "ÐÑÐµÐ³Ð»ÐµÐ´ Ð½Ð° Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ°",
        partialUpdates: "Partial updates",
        phone: "Ð¢ÐµÐ»ÐµÑÐ¾Ð½",
        pleaseWait: "Please wait",
        previous: "Previous",
        price: "Ð¦ÐµÐ½Ð°",
        priceGroup: "Price group",
        print: "ÐÑÐ¸Ð½ÑÐ¸ÑÐ°Ð¹",
        printTask: "Print task",
        processingStep: "Processing %{step}",
        product: "ÐÑÐ¾Ð´ÑÐºÑ",
        productCode: "Product code",
        productName: "Product name",
        products: "ÐÑÐ¾Ð´ÑÐºÑÐ¸",
        pump1: "ÐÐ¾Ð¼Ð¿Ð° 1",
        pump2: "ÐÐ¾Ð¼Ð¿Ð° 2",
        purchasePrice: "Purchase price",
        purge: "ÐÑÐ¾ÑÐ¸ÑÑÐ²Ð°Ð½Ðµ",
        qualityControl: "Quality control",
        quantity: "ÐÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾",
        quantityQty: "QTY",
        quickTint: "ÐÑÑÐ·Ð¾ ÑÐ¾Ð½Ð¸ÑÐ°Ð½Ðµ",
        rccIsNotAvailable: "RCC Ð½Ðµ Ðµ Ð½Ð°Ð»Ð¸ÑÐµ",
        rccIsNotConnected: "RCC Ð½Ðµ Ðµ ÑÐ²ÑÑÐ·Ð°Ð½",
        rccNotLicensed: " RCC Ð½Ðµ Ðµ Ð»Ð¸ÑÐµÐ½Ð·Ð¸ÑÐ°Ð½",
        reconnect: "ÐÐ¾Ð²ÑÐ¾ÑÐ½Ð¾ ÑÐ²ÑÑÐ·Ð²Ð°Ð½Ðµ",
        refill: "ÐÐ°ÑÐµÐµÐ¶Ð´Ð°Ð½Ðµ",
        refillManualLevelCorrection: "Manual correction",
        reformulation: "Reformulation",
        reloadTab: "Reload Tab",
        reset: "ÐÑÐ»Ð¸ÑÐ°Ð½Ðµ",
        restart: "Ð ÐµÑÑÐ°ÑÑ",
        restore: "Restore",
        retint: "Retint",
        revision: "Ð ÐµÐ²Ð¸Ð·Ð¸Ñ",
        safetySheet: "Safety sheet",
        save: "ÐÐ°Ð¿Ð°Ð·Ð¸",
        saveAs: "ÐÐ°Ð¿Ð°Ð·Ð¸ ÐºÐ°ÑÐ¾",
        saveToDispensingHistory: "ÐÐ°Ð¿Ð°Ð·Ð²Ð°Ð½Ðµ Ð² Ð¸ÑÑÐ¾ÑÐ¸ÑÑÐ°",
        searchResult: "Search result",
        searching: "Searching",
        seconds: "Sec.",
        select: "Select",
        selectAll: "ÐÐ·Ð±ÐµÑÐ¸ Ð²ÑÐ¸ÑÐºÐ¸",
        selectChannels: "ÐÐ·Ð±ÐµÑÐµÑÐµ ÐºÐ°Ð½Ð°Ð»",
        selectColumns: "Select columns to work with",
        selectXFirst: "Select %{item} first",
        sellPrice: "Sell price",
        settings: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸",
        shelf: "Ð Ð°ÑÑ",
        showItem: "Show %{item}",
        showOptions: "Show another options",
        size: "Size",
        skip: "ÐÑÐ¾Ð¿ÑÑÐ½Ð¸",
        smartPurge: "Smart purge",
        softwareRestartInSeconds: "%{software} will be automatically restarted in %{seconds} seconds",
        sortResults: "Sort results",
        spectro: "Ð¡Ð¿ÐµÐºÑÑÐ¾ÑÐ¾ÑÐ¾Ð¼ÐµÑÑÑ",
        standardFormula: "Standard formula",
        status: "Ð¡ÑÐ°ÑÑÑ",
        street: "Ð£Ð»Ð¸ÑÐ°",
        sum: "Sum",
        summary: "Ð ÐµÐ·ÑÐ¼Ðµ",
        sync: "Ð¡Ð¸Ð½ÑÑÐ¾Ð½Ð¸Ð·Ð¸ÑÐ°Ð½Ðµ",
        technicalSheet: "Technical sheet",
        templates: "Ð¨Ð°Ð±Ð»Ð¾Ð½Ð¸",
        threshold: "Threshold",
        ticketing: "Ticketing",
        tintometricSystem: "Tintometric system",
        toDispenseOrders: "To Dispense Orders",
        top: "ÐÑÐ³Ð¾ÑÐµ",
        total: "ÐÐ±ÑÐ° ÑÑÐ¼Ð°",
        totalAmount: "Total amount",
        totalBaseAmount: "Total base amount",
        totalColorantAmount: "Total colorants amount",
        type: "Type",
        ufiCode: "UFI code",
        ufiThreshold: "UFI threshold",
        unableToSynchronize: "Unable to synchronize",
        undefined: "Undefined",
        unit: "Unit",
        units: "ÐÐ´Ð¸Ð½Ð¸ÑÐ¸",
        unknown: "Unknown",
        update: "ÐÐºÑÑÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ñ",
        updated: "ÐÐ±Ð½Ð¾Ð²ÐµÐ½Ð¾",
        user: "ÐÐ¾ÑÑÐµÐ±Ð¸ÑÐµÐ»",
        value: "Value",
        vat: "ÐÐÐ¡",
        verified: "Verified",
        version: "ÐÐµÑÑÐ¸Ñ",
        versionId: "ID ÐÐµÑÑÐ¸Ñ ",
        versionStructure: "Ð¡ÑÑÑÐºÑÑÑÐ° Ð½Ð° Ð²ÐµÑÑÐ¸ÑÑÐ°",
        volumetric: "Volumetric",
        warning: "ÐÐ½Ð¸Ð¼Ð°Ð½Ð¸Ðµ",
        warningLevel: "ÐÑÐµÐ´ÑÐ¿ÑÐµÐ´Ð¸ÑÐµÐ»Ð½Ð¾ Ð½Ð¸Ð²Ð¾",
        withoutName: "(without name)",
        workingProperly: "Working properly",
        yes: "ÐÐ°",
        zoom: "Ð£Ð²ÐµÐ»Ð¸ÑÐ¸"
    },
    help: {
        autotasks: {
            brushMaintenance:
                "Set this autotask to have %{name} request the action for cleaning the brush container automatically at the defined time. The dispenser operator needs to remove, clean, and then return the brush container manually.",
            capMaintenance:
                "Set this autotask to have %{name} request the action for cleaning the cap automatically at the defined time. The dispenser operator needs to clean the autocap manually after it opens.",
            cleanAll:
                "Set this autotask to have the dispenser perform the action for cleaning all channels automatically at the defined time.",
            cleanChannels:
                "Set this autotask to have the dispenser perform the action for cleaning specific channels automatically at the defined time.",
            computerReboot: "Set this autotask to have the computer rebooted automatically at the define time.",
            computerShutdown: "Set this autotask to have the computer turned off automatically at the define time.",
            dispenserCleaning:
                "Set this autotask to have %{name} request the action for cleaning the dispenser automatically at the defined time. The dispenser operator needs to clean the machine with a cloth manually.",
            humidifierWaterLevelMaintenance:
                "Set this autotask to have %{name} request the action for refilling the humidifier automatically at the defined time. The dispenser operator needs to check and refill the water in the humidifier manually.",
            purgeAll:
                "Set this autotask to have the dispenser perform the action for purging all channels automatically at the defined time.",
            purgeChannels:
                "Set this autotask to have the dispenser perform the action for purging specific channels automatically at the defined time.",
            recirculateAll:
                "Set this autotask to have the dispenser perform the action for recirculating all channels automatically at the defined time.",
            recirculateChannels:
                "Set this autotask to have the dispenser perform the action for recirculating specific channels automatically at the defined time.",
            refillAll:
                "Set this autotask to have %{name} request the action for refilling all channels automatically at the defined time. The dispenser operator needs to refill colorants into all canisters manually.",
            refillCanisters:
                "Set this autotask to have %{name} request the action for refilling specific channels automatically at the defined time. The dispenser operator needs to manually refill colorants into canisters which do not meet the refill criterion.",
            smartPurgeAll:
                "Set this autotask to have the dispenser perform the action for smart purging all channels automatically at the defined time. Purge will be carried out unless the Smart purge rules are met.",
            smartPurgeChannels:
                "Set this autotask to have the dispenser perform the action for smart purging specific channels automatically at the defined time. Purge will be carried out unless the Smart purge rules are met.",
            stirAll:
                "Set this autotask to have the dispenser perform request the action for stirring all channels automatically at the defined time.",
            stirCanisters:
                "Set this autotask to have the dispenser perform request the action for stirring specific channels automatically at the defined time.",
            switchPlateMaintenance:
                "Set this autotask to have %{name} request the action for cleaning the switch plate automatically at the defined time. The dispenser operator needs to remove, clean, and then return the switch plate manually."
        },
        colorantBatchNumber: {
            batchNumberByPercentage:
                "The Batch number which prevails is used for printing considering its actual amount in the canister. Navigate to Canister settings to define the threshold for each canister.",
            batchNumberFromLastFilling:
                "The Batch from the last refill given by the operator is used for printing regardless the refilled amount.",
            enableBatchNumber: "With this setting on, refilled colorant batches are tracked."
        },
        connection: {
            add: "Allows to add a new server manually if it could not be detected via the Discover function.",
            clientIdentifier:
                "The setting enables to identify this client if there are more clients connected to one server.",
            disconnect:
                "Information about the currently used server. The disconnect button allows to leave this server and switch to another one if available.",
            discover: "Discovers whether there are any other servers available in the network.",
            dropServers: "Deletes all previously detected servers from the list.",
            dropServersNotAvailable: "No server available",
            edit: "Allows to manually edit an already found server.",
            editDisabled: "No server selected."
        },
        continue: "Do you really want to continue?",
        driverSettings: {
            alfaRestApi: {
                host: "ÐÑÐ²ÐµÐ´ÐµÑÐµ Ð¸Ð¼ÐµÑÐ¾ Ð½Ð° ÑÐ¾ÑÑÐ° Ð½Ð° ÐºÐ¾Ð¼Ð¿ÑÑÑÑÐ° Ð¸Ð»Ð¸ IP Ð°Ð´ÑÐµÑÐ° Ð½Ð° ÐºÐ¾Ð¼Ð¿ÑÑÑÑÐ°.",
                machineType: "ÐÐ°Ð¶Ð¸ Ð·Ð° Ð²ÑÐ¸ÑÐºÐ¸ Ð¼Ð°ÑÐ¸Ð½Ð¸ Ð½Ð° Alfa.Â Windows, ÐºÐ°ÐºÑÐ¾ Ð¸ Linux."
            },
            corobDsProxy: {
                machineType:
                    "ÐÐ°Ð¶Ð¸ Ð·Ð° Ð¿Ð¾ÐºÐ¾Ð»ÐµÐ½Ð¸Ñ Slave (D200, D600 ..), 4G (Ð¿ÑÑÐ²Ð¸ÑÑ) Ð¸ 5G (EvoFlx).Â DspProxy ÑÑÑÐ±Ð²Ð° Ð´Ð° Ð±ÑÐ´Ðµ Ð¸Ð½ÑÑÐ°Ð»Ð¸ÑÐ°Ð½.Â Ð¡Ð°Ð¼Ð¾ Ð·Ð° Windows."
            },
            corobEvoDriver: {
                machineType:
                    "ÐÐ°Ð¶Ð¸ Ð·Ð° Ð¿Ð¾ÐºÐ¾Ð»ÐµÐ½Ð¸Ðµ 5G (EvoFlx).Â EVOservice ÑÑÑÐ±Ð²Ð° Ð´Ð° Ð±ÑÐ´Ðµ Ð¸Ð½ÑÑÐ°Ð»Ð¸ÑÐ°Ð½.Â Windows, ÐºÐ°ÐºÑÐ¾ Ð¸ Linux."
            },
            corobFlex500LLD: {
                dispenserConfigurationFile:
                    "ÐÐ·Ð±ÐµÑÐµÑÐµ ÐºÐ¾Ð½ÑÐ¸Ð³ÑÑÐ°ÑÐ¸Ð¾Ð½Ð½Ð¸Ñ ÑÐ°Ð¹Ð» Ð½Ð° Ð´Ð¾Ð·Ð°ÑÐ¾ÑÐ°.Â ÐÑÐµÐ´Ð²Ð°ÑÐ¸ÑÐµÐ»Ð½Ð¾ Ð·Ð°Ð´Ð°Ð´ÐµÐ½Ð° Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ°",
                hldRootDir: "ÐÐ·Ð±ÐµÑÐµÑÐµ Ð¾ÑÐ½Ð¾Ð²Ð½Ð°ÑÐ° Ð¿Ð°Ð¿ÐºÐ° Ð½Ð° HLD.Â ÐÑÐµÐ´Ð²Ð°ÑÐ¸ÑÐµÐ»Ð½Ð¾ Ð·Ð°Ð´Ð°Ð´ÐµÐ½Ð° Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ°",
                machineType:
                    "Valid for Corob Flex (500, 520, 540) = former Lenteq. HLD must be installed. Windows only."
            },
            corobNextDriver: {
                machineType:
                    "ÐÐ°Ð¶Ð¸ Ð·Ð° Ð¿Ð¾ÐºÐ¾Ð»ÐµÐ½Ð¸Ñ Slave (D200, D600 ..), 4G (Ð¿ÑÑÐ²Ð¸ÑÑ) Ð¸ 5G (EvoFlx).Â NextDriver ÑÑÑÐ±Ð²Ð° Ð´Ð° Ð±ÑÐ´Ðµ Ð¸Ð½ÑÑÐ°Ð»Ð¸ÑÐ°Ð½.Â Ð¡Ð°Ð¼Ð¾ Ð·Ð° Linux."
            },
            dromontDDrv: {
                databasePath: "ÐÑÑ ÐºÑÐ¼ ÑÐ°Ð¹Ð»Ð° Ð½Ð° Ð±Ð°Ð·Ð°ÑÐ° Ð´Ð°Ð½Ð½Ð¸ Ñ Ð´Ð°Ð½Ð½Ð¸ Ð·Ð° ÐºÐ°Ð»Ð¸Ð±ÑÐ¸ÑÐ°Ð½Ðµ.Â ÐÑÐµÐ´Ð²Ð°ÑÐ¸ÑÐµÐ»Ð½Ð¾ Ð·Ð°Ð´Ð°Ð´ÐµÐ½Ð° Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ°",
                driverPath: "ÐÑÑ ÐºÑÐ¼ Ð´ÑÐ°Ð¹Ð²ÐµÑÐ° (D_DRV.exe).Â ÐÑÐµÐ´Ð²Ð°ÑÐ¸ÑÐµÐ»Ð½Ð¾ Ð·Ð°Ð´Ð°Ð´ÐµÐ½Ð° Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ°",
                machineType:
                    "ÐÐ¾ÑÐ²ÐµÐ½Ð° ÐºÐ¾Ð¼ÑÐ½Ð¸ÐºÐ°ÑÐ¸Ñ Ð½Ð° ÑÐ°Ð·Ð¿ÑÐµÐ´ÐµÐ»Ð¸ÑÐµÐ»Ñ ÑÑÐµÐ· Ð·Ð°Ð´Ð°Ð´ÐµÐ½Ð¸ Ð¿ÑÑÐµÐºÐ¸.Â ÐÐ°Ð¶Ð¸ Ð·Ð° Ð¿Ð¾ÐºÐ¾Ð»ÐµÐ½Ð¸Ñ V1 Ð¸ V2.Â D_SET ÑÑÑÐ±Ð²Ð° Ð´Ð° Ð±ÑÐ´Ðµ Ð¸Ð½ÑÑÐ°Ð»Ð¸ÑÐ°Ð½.Â Windows, ÐºÐ°ÐºÑÐ¾ Ð¸ Linux.",
                resultPath:
                    "ÐÑÑÑÑ ÐºÑÐ¼ ÑÐ°Ð¹Ð»Ð° Ñ ÑÐµÐ·ÑÐ»ÑÐ°ÑÐ¸, ÑÑÐ·Ð´Ð°Ð´ÐµÐ½ ÑÐ»ÐµÐ´ Ð¿ÑÐ¸ÐºÐ»ÑÑÐ²Ð°Ð½Ðµ Ð½Ð° Ð¾Ð¿ÐµÑÐ°ÑÐ¸ÑÑÐ°.Â ÐÑÐµÐ´Ð²Ð°ÑÐ¸ÑÐµÐ»Ð½Ð¾ Ð·Ð°Ð´Ð°Ð´ÐµÐ½Ð° Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ°",
                serviceSoftwarePath:
                    "ÐÑÑ ÐºÑÐ¼ ÑÐµÑÐ²Ð¸Ð·Ð½Ð¸Ñ ÑÐ¾ÑÑÑÐµÑ Ð½Ð° Dromont (D_SET.exe).Â ÐÐ±ÐµÐ·Ð¼Ð°ÑÐ»ÐµÑÐµ Ð¿ÑÐµÐ´Ð²Ð°ÑÐ¸ÑÐµÐ»Ð½Ð¾ Ð·Ð°Ð´Ð°Ð´ÐµÐ½Ð°ÑÐ° Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ°"
            },
            dromontDirect: {
                machineType:
                    "ÐÐ¸ÑÐµÐºÑÐ½Ð° ÐºÐ¾Ð¼ÑÐ½Ð¸ÐºÐ°ÑÐ¸Ñ Ñ ÑÐ°Ð·Ð¿ÑÐµÐ´ÐµÐ»Ð¸ÑÐµÐ».Â ÐÐ°Ð¶Ð¸ Ð·Ð° Ð¿Ð¾ÐºÐ¾Ð»ÐµÐ½Ð¸Ñ V1 Ð¸ V2.Â D_SET ÑÑÑÐ±Ð²Ð° Ð´Ð° Ð±ÑÐ´Ðµ Ð¸Ð½ÑÑÐ°Ð»Ð¸ÑÐ°Ð½.Â Windows, ÐºÐ°ÐºÑÐ¾ Ð¸ Linux.",
                rootDir: "Select the main Dromont folder. Default pre-set."
            },
            dromontMisura: {
                driverPath:
                    "ÐÑÑÑÑ ÐºÑÐ¼ Ð´ÑÐ°Ð¹Ð²ÐµÑÐ° (MisuraRetail.exe) Ð¼Ð¾Ð¶Ðµ Ð´Ð° ÑÐµ Ð¿ÑÐ¾Ð¼ÐµÐ½Ð¸ Ð²ÑÐ· Ð¾ÑÐ½Ð¾Ð²Ð° Ð½Ð° Ð²ÐµÑÑÐ¸ÑÑÐ° Misura Retail.Â ÐÑÐµÐ´Ð²Ð°ÑÐ¸ÑÐµÐ»Ð½Ð¾ Ð·Ð°Ð´Ð°Ð´ÐµÐ½Ð° Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ°",
                extensionPath: "ÐÑÑ ÐºÑÐ¼ ÐºÐ¾Ð¼ÑÐ½Ð¸ÐºÐ°ÑÐ¸Ð¾Ð½ÐµÐ½ ÑÐ°Ð¹Ð» Ð·Ð° ÑÐ»ÑÐ¶ÐµÐ±Ð½Ð¸ Ð´ÐµÐ¹ÑÑÐ²Ð¸Ñ.",
                formulaPath: "ÐÑÑ ÐºÑÐ¼ ÐºÐ¾Ð¼ÑÐ½Ð¸ÐºÐ°ÑÐ¸Ð¾Ð½ÐµÐ½ ÑÐ°Ð¹Ð» Ð·Ð° Ð¿Ð¾Ð´Ð°Ð²Ð°Ð½Ðµ.",
                machineType: "ÐÐ°Ð¶Ð¸ Ð·Ð° Ð¿Ð¾ÐºÐ¾Ð»ÐµÐ½Ð¸Ðµ V3.Â Dromont Misura ÑÑÑÐ±Ð²Ð° Ð´Ð° Ð±ÑÐ´Ðµ Ð¸Ð½ÑÑÐ°Ð»Ð¸ÑÐ°Ð½.Â Ð¡Ð°Ð¼Ð¾ Ð·Ð° Windows."
            },
            fastAndFluidIDD: {
                machineType: "ÐÐ°Ð¶Ð¸ Ð·Ð° Ð²ÑÐ¸ÑÐºÐ¸ Ð¼Ð°ÑÐ¸Ð½Ð¸ F&F.Â Ð¡Ð°Ð¼Ð¾ Ð·Ð° Windows.",
                path: "ÐÐ¾Ð´Ð´ÑÑÐ¶Ð°Ð½Ð¸ ÑÐ° IDD2 (HA 450, HA 650, X-smart Ð¸ Ñ.Ð½.) - ÑÑÑÐ±Ð²Ð° Ð´Ð° Ð±ÑÐ´Ð°Ñ Ð»Ð¸ÑÐµÐ½Ð·Ð¸ÑÐ°Ð½Ð¸, IDD3 (HP 500 Ð¸ Ñ.Ð½.), IDD4 (HA 180, HA 480, HA 680, Xprotint Ð¸ Ñ.Ð½.)"
            },
            fastAndFluidUIDD: {
                host: "Type in the computer host name or computer IP address.",
                machineType: "ÐÐ°Ð¶Ð¸ Ð·Ð° Ð²ÑÐ¸ÑÐºÐ¸ Ð¼Ð°ÑÐ¸Ð½Ð¸ F&F.Â Windows, ÐºÐ°ÐºÑÐ¾ Ð¸ Linux.",
                password: "Type in the user password.",
                port: "Select the port number.",
                user: "Type in the user name."
            },
            heroPCPDriver: {
                machineType: "ÐÐ°Ð¶Ð¸ Ð·Ð° Ð²ÑÐ¸ÑÐºÐ¸ Ð¼Ð°ÑÐ¸Ð½Ð¸ Hero.Â Ð¡Ð°Ð¼Ð¾ Ð·Ð° Windows."
            },
            italtinto: {
                machineType:
                    "ÐÐ°Ð¶Ð¸ Ð·Ð° Ð²ÑÐ¸ÑÐºÐ¸ Ð¼Ð°ÑÐ¸Ð½Ð¸ Italtinto.Â Wcal Ð¸Ð»Ð¸ ItaltintoCal ÑÑÑÐ±Ð²Ð° Ð´Ð° Ð±ÑÐ´Ð°Ñ Ð¸Ð½ÑÑÐ°Ð»Ð¸ÑÐ°Ð½Ð¸.Â Ð¡Ð°Ð¼Ð¾ Ð·Ð° Windows.",
                path: "ÐÑÑ ÐºÑÐ¼ ÐºÐ¾ÑÐ¸Ð³Ð¸ÑÐ°Ð½Ð¸Ñ ÐºÐ¾Ð½ÑÐ¸Ð³ÑÑÐ°ÑÐ¸Ð¾Ð½ÐµÐ½ ÑÐ°Ð¹Ð» Italtinto."
            },
            manualAdvanced: {
                machineType: "ÐÐ°Ð¶Ð¸ Ð·Ð° Ð²ÑÐ¸ÑÐºÐ¸ ÑÑÑÐ½Ð¸ Ð¼Ð°ÑÐ¸Ð½Ð¸ Ñ Ð²ÐºÐ»ÑÑÐµÐ½Ð° Ð¿Ð¾Ð´Ð´ÑÑÐ¶ÐºÐ° Ð·Ð° ÐºÑÑÐ¸Ð¸.Â Windows, ÐºÐ°ÐºÑÐ¾ Ð¸ Linux.",
                path: "ÐÑÑ ÐºÑÐ¼ ÐºÐ¾Ð½ÑÐ¸Ð³ÑÑÐ°ÑÐ¸Ð¾Ð½Ð½Ð¸Ñ ÑÐ°Ð¹Ð» Ñ Ð´Ð°Ð½Ð½Ð¸ Ð·Ð° Ð´Ð¾Ð·Ð°ÑÐ¾ÑÐ° Ð¸ ÐºÑÑÐ¸Ð¸ÑÐµ."
            },
            manualSimple: {
                machineType: "ÐÐ°Ð¶Ð¸ Ð·Ð° Ð²ÑÐ¸ÑÐºÐ¸ ÑÑÑÐ½Ð¸ Ð¼Ð°ÑÐ¸Ð½Ð¸.Â Windows, ÐºÐ°ÐºÑÐ¾ Ð¸ Linux.",
                path: "ÐÑÑ ÐºÑÐ¼ ÐºÐ¾Ð½ÑÐ¸Ð³ÑÑÐ°ÑÐ¸Ð¾Ð½Ð½Ð¸Ñ ÑÐ°Ð¹Ð» Ñ Ð´Ð°Ð½Ð½Ð¸ Ð·Ð° Ð´Ð¾Ð·Ð°ÑÐ¾ÑÐ°."
            },
            none: {
                machineType: "No dispenser driver is selected."
            },
            santintColorLink3: {
                machineType: "ÐÐ°Ð¶Ð¸ Ð·Ð° Ð²ÑÐ¸ÑÐºÐ¸ Ð¼Ð°ÑÐ¸Ð½Ð¸ Santint.Â Ð¡Ð°Ð¼Ð¾ Ð·Ð° Windows."
            },
            simulation: {
                machineType: "ÐÐ°Ð¶Ð¸ Ð·Ð° ÑÐ¸Ð¼ÑÐ»Ð°ÑÐ¸Ð¾Ð½ÐµÐ½ Ð´Ð¾Ð·Ð°ÑÐ¾Ñ, Ð°ÐºÐ¾ ÐºÑÐ¼ ÐºÐ¾Ð¼Ð¿ÑÑÑÑÐ° Ð½ÑÐ¼Ð° ÑÐ²ÑÑÐ·Ð°Ð½ Ð¸ÑÑÐ¸Ð½ÑÐºÐ¸ Ð´Ð¾Ð·Ð°ÑÐ¾Ñ.",
                path: "ÐÑÑ ÐºÑÐ¼ ÑÐ¸Ð¼ÑÐ»Ð°ÑÐ¸Ð¾Ð½Ð½Ð¸Ñ ÐºÐ¾Ð½ÑÐ¸Ð³ÑÑÐ°ÑÐ¸Ð¾Ð½ÐµÐ½ ÑÐ°Ð¹Ð», ÐºÐ¾Ð¹ÑÐ¾ ÑÑÑÐ±Ð²Ð° Ð´Ð° Ð±ÑÐ´Ðµ Ð² ÑÑÐ¾ÑÐ²ÐµÑÑÑÐ²Ð¸Ðµ Ñ Ð²Ð¼ÑÐºÐ½Ð°ÑÐ° Ð±Ð°Ð·Ð° Ð´Ð°Ð½Ð½Ð¸."
            },
            udcp: {
                machineType: "UDCP dispenser"
            }
        },
        environment: {
            activeServerPlugins: "The overview of additional software plugins.",
            allowAutoCloseTab:
                "With the setting on, each formula tab will be closed automatically after the dispensing process has been finished.",
            allowAutomaticClientStart:
                "Ð¡ ÑÐ°Ð·Ð¸ Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ°, %{name} ÑÐµ ÑÐµ ÑÑÐ°ÑÑÐ¸ÑÐ° Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐ½Ð¾ ÑÐ»ÐµÐ´ ÑÑÐ°ÑÑÐ¸ÑÐ°Ð½ÐµÑÐ¾ Ð½Ð° ÐºÐ¾Ð¼Ð¿ÑÑÑÑÐ°.",
            allowAutomaticPrint:
                "ÐÑÐ¸ÐºÐµÑÑÑ ÑÐµ ÑÐµ Ð¾ÑÐ¿ÐµÑÐ°ÑÐ²Ð° Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐ½Ð¾. ÐÐ·Ð¸ÑÐºÐ²Ð° Ð´Ð¾Ð¿ÑÐ»Ð½Ð¸ÑÐµÐ»Ð½Ð° Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ° Ð·Ð° Ð¿ÐµÑÐ°Ñ Ð¿ÑÐµÐ´Ð¸ Ð¿Ð¾Ð´Ð°Ð²Ð°Ð½ÐµÑÐ¾, ÑÐ»ÐµÐ´ Ð¿Ð¾Ð´Ð°Ð²Ð°Ð½Ðµ Ð¸Ð»Ð¸ Ð¸ Ð´Ð²ÐµÑÐµ.",
            allowBuildingSitePanel: "On Formula Panel, building site panel will be available.",
            allowCustomers: "Ð Ð¿Ð°Ð½ÐµÐ»Ð° Ð·Ð° ÑÐ¾ÑÐ¼ÑÐ»Ð¸ ÑÐµ Ð±ÑÐ´Ðµ Ð´Ð¾ÑÑÑÐ¿Ð½Ð° ÑÐµÐºÑÐ¸Ñ Ð·Ð° ÐºÐ»Ð¸ÐµÐ½ÑÐ¸.",
            allowDispensing: "On Formula panel, Dispense button  will be activated.",
            allowFileTransfer: "With this setting on, automatic data import and export by file transfer is available.",
            allowFormulaModificationPanel: "On Formula Panel, Modification panel will be activated.",
            allowFormulaStatusPanel: "On Formula Panel, Status panel will be activated.",
            allowLight: "%{name} will be accessible..",
            allowOrdering: "ÐÐ° Ð¿Ð°Ð½ÐµÐ»Ð° Ð·Ð° ÑÐ¾ÑÐ¼ÑÐ»Ð¸ ÑÐµ ÑÐµ Ð°ÐºÑÐ¸Ð²Ð¸ÑÐ° Ð±ÑÑÐ¾Ð½ÑÑ ÐÐ¾ÑÑÑÐ°Ð¹.",
            allowPricing:
                "ÐÐ° Ð¿Ð°Ð½ÐµÐ»Ð° Ð¤Ð¾ÑÐ¼ÑÐ»Ð° ÑÐµÐ½Ð¸ÑÐµ Ð¼Ð¾Ð³Ð°Ñ Ð´Ð° ÑÐµ Ð¸Ð·Ð¿Ð¾Ð»Ð·Ð²Ð°Ñ.Â ÐÐ¸Ð´Ð¸Ð¼Ð¾ÑÑÑÐ° Ð½Ð° ÑÐµÐ½Ð¸ÑÐµ Ðµ Ð·Ð°Ð´Ð°Ð´ÐµÐ½Ð° Ð² ÐÐ¾ÑÑÑÐ¿Ð½Ð¸ ÑÐµÐ½Ð¸.Â Ð¦ÐµÐ½Ð¸ÑÐµ ÑÐ° Ð¾Ð¿ÑÐµÐ´ÐµÐ»ÐµÐ½Ð¸ Ð² ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ Ð½Ð° ÑÐµÐ½Ð¸ÑÐµ.",
            allowProductPreviewImage: "ÐÐ·Ð¾Ð±ÑÐ°Ð¶ÐµÐ½Ð¸ÐµÑÐ¾ Ð½Ð° Ð¿ÑÐ¾Ð´ÑÐºÑÐ° ÑÐµ Ð±ÑÐ´Ðµ Ð¿Ð¾ÐºÐ°Ð·Ð°Ð½ Ð¿Ð¾ Ð²ÑÐµÐ¼Ðµ Ð½Ð° Ð´Ð¾Ð·Ð¸ÑÐ°Ð½Ðµ.",
            allowQualityControl: "Quality control will be activated.",
            allowSearchCheaperColors: "On Formula Panel, the function to search for cheaper colors will be available.",
            allowSoundNotification: "ÐÐ·Ð²ÐµÑÑÐ¸ÐµÑÐ¾ Ð·Ð° Ð¿Ð¾ÑÑÑÐºÐ° Ð²ÑÐ·Ð¿ÑÐ¾Ð¸Ð·Ð²ÐµÐ¶Ð´Ð° Ð¼ÑÐ·Ð¸ÐºÐ°Ð»Ð½Ð° Ð¼ÐµÐ»Ð¾Ð´Ð¸Ñ Ð¿ÑÐ¸ Ð½ÐµÐ¹Ð½Ð¾ÑÐ¾ Ð¿Ð¾Ð»ÑÑÐ°Ð²Ð°Ð½Ðµ ",
            allowSpectro: "Ð Ð°Ð·Ð´ÐµÐ» Spectro ÑÐµ Ð±ÑÐ´Ðµ Ð´Ð¾ÑÑÑÐ¿ÐµÐ½.",
            allowTabs: "With this setting on, working with multiple tabs simultaneously is available.",
            applyZoom:
                "Zoom ÑÐ²ÐµÐ»Ð¸ÑÐ°Ð²Ð° Ð¸Ð»Ð¸ Ð½Ð°Ð¼Ð°Ð»ÑÐ²Ð° ÑÐ°Ð·Ð´ÐµÐ»Ð¸ÑÐµÐ»Ð½Ð°ÑÐ° ÑÐ¿Ð¾ÑÐ¾Ð±Ð½Ð¾ÑÑ. ÐÐ»Ð°Ð²Ð¸ÑÐ½Ð¸ÑÐµ ÐºÐ¾Ð¼Ð±Ð¸Ð½Ð°ÑÐ¸Ð¸ CTRL + Ð¸ CTRL-ÑÑÑÐ¾ ÑÐ° Ð¿ÑÐ¸Ð»Ð¾Ð¶Ð¸Ð¼Ð¸.",
            automaticLogout: "Set after how many minutes the automatic logout should be activated.",
            availableDatabases: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ÑÐµ Ð¿Ð¾Ð·Ð²Ð¾Ð»ÑÐ²Ð°Ñ Ð¿ÑÐµÐ²ÐºÐ»ÑÑÐ²Ð°Ð½Ðµ Ð¼ÐµÐ¶Ð´Ñ Ð±Ð°Ð·Ð¸ Ð´Ð°Ð½Ð½Ð¸, Ð°ÐºÐ¾ Ð¸Ð¼Ð° Ð¿Ð¾Ð²ÐµÑÐµ Ð¾Ñ ÐµÐ´Ð½Ð° Ð½Ð°Ð»Ð¸ÑÐ½Ð°.",
            backupLocalDB: "Exports the local databse. The exported file can be used as database backup.",
            barcodeTesting:
                "Ð¡ÑÐµÐ´Ð°ÑÐ° Ð·Ð° ÑÐµÑÑÐ²Ð°Ð½Ðµ Ð½Ð° Ð±Ð°ÑÐºÐ¾Ð´ ÑÐ»ÑÐ¶Ð¸ Ð·Ð° Ð¿ÑÐ¾Ð²ÐµÑÐºÐ° Ð½Ð° Ð¿ÑÐ°Ð²Ð¸Ð»Ð½Ð¾ÑÑÑÐ° Ð½Ð° ÑÐºÐ°Ð½Ð¸ÑÐ°Ð½Ð¸Ñ Ð±Ð°ÑÐºÐ¾Ð´, ÐºÐ°ÑÐ¾ Ð³Ð¾ ÑÑÐ°Ð²Ð½ÑÐ²Ð° Ñ Ð±Ð°ÑÐºÐ¾Ð´Ð¾Ð²ÐµÑÐµ, Ð²Ð¼ÑÐºÐ½Ð°ÑÐ¸ Ð² Ð±Ð°Ð·Ð°ÑÐ° Ð´Ð°Ð½Ð½Ð¸.",
            customBanner: "ÐÐ°Ð´Ð°Ð¹ÑÐµ ÑÐ²Ð¾Ðµ Ð»Ð¾Ð³Ð¾ Ð¸Ð»Ð¸ Ð±Ð°Ð½ÐµÑ Ð¸ Ð½ÐµÐ³Ð¾Ð²Ð°ÑÐ° Ð¿Ð¾Ð·Ð¸ÑÐ¸Ñ.",
            customCurrencyFormat:
                "Custom currency format can override default currency format based on selected language. ",
            customDateFormat: "Custom date format can override default date format based on selected language.",
            customNumberFormat: "Custom numer format can override default numer format based on selected language.",
            customTimeFormat: "Custom time format can override default time format based on selected language.",
            defaultPrinter:
                "ÐÐ·Ð±ÑÐ°Ð½Ð¸ÑÑ Ð¿ÑÐ¸Ð½ÑÐµÑ ÑÐµ ÑÐµ Ð¸Ð·Ð¿Ð¾Ð»Ð·Ð²Ð° Ð¿ÑÐ¸ Ð¾ÑÐ¿ÐµÑÐ°ÑÐ²Ð°Ð½Ðµ Ð½Ð° ÐµÑÐ¸ÐºÐµÑÐ¸, Ð¾ÑÐ²ÐµÐ½ Ð°ÐºÐ¾ Ð½Ðµ Ðµ Ð¿ÑÐ¾Ð¼ÐµÐ½ÐµÐ½ Ð² Ð¿ÑÐ¾Ð·Ð¾ÑÐµÑÐ° Ð¾Ð¿ÑÐ¸Ð¸ Ð½Ð° Ð¿ÑÐ¸Ð½ÑÐµÑÐ°.",
            defaultTemplate:
                "ÐÐ·Ð±ÑÐ°Ð½Ð¸ÑÑ ÑÐ°Ð±Ð»Ð¾Ð½ ÑÐµ ÑÐµ Ð¸Ð·Ð¿Ð¾Ð»Ð·Ð²Ð° Ð¿ÑÐ¸ Ð¾ÑÐ¿ÐµÑÐ°ÑÐ²Ð°Ð½Ðµ Ð½Ð° ÐµÑÐ¸ÐºÐµÑÐ¸, Ð¾ÑÐ²ÐµÐ½ Ð°ÐºÐ¾ Ð½Ðµ Ðµ Ð¿ÑÐ¾Ð¼ÐµÐ½ÐµÐ½ Ð² Ð¿ÑÐ¾Ð·Ð¾ÑÐµÑÐ° Ñ Ð¾Ð¿ÑÐ¸Ð¸ Ð·Ð° Ð¿ÑÐ¸Ð½ÑÐµÑ.",
            deleteImportedData:
                "ÐÐ·ÑÑÐ¸Ð²Ð° Ð¿ÑÐµÐ´Ð²Ð°ÑÐ¸ÑÐµÐ»Ð½Ð¾ Ð²Ð½ÐµÑÐµÐ½Ð¸ÑÐµ Ð¿ÐµÑÑÐ¾Ð½Ð°Ð»Ð¸Ð·Ð¸ÑÐ°Ð½Ð¸ Ð´Ð°Ð½Ð½Ð¸.Â ÐÐ°Ð½Ð½Ð¸ÑÐµ Ð¼Ð¾Ð³Ð°Ñ Ð´Ð° Ð±ÑÐ´Ð°Ñ Ð¸Ð¼Ð¿Ð¾ÑÑÐ¸ÑÐ°Ð½Ð¸ Ð¾ÑÐ½Ð¾Ð²Ð¾ ÑÐ»ÐµÐ´ Ð¸Ð·ÑÑÐ¸Ð²Ð°Ð½Ðµ.",
            diskSpaceNotification: "Checks the available disk space and notifies in case of insufficient space.",
            dispensingNotes: "ÐÐ° Ð¿Ð°Ð½ÐµÐ»Ð° Ð·Ð° ÑÐ¾ÑÐ¼ÑÐ»Ð¸ ÑÐµ Ð±ÑÐ´Ðµ Ð´Ð¾ÑÑÑÐ¿Ð½Ð° ÑÐµÐºÑÐ¸Ñ Ð·Ð° Ð¿Ð¾Ð´Ð°Ð²Ð°Ð½Ðµ Ð½Ð° Ð±ÐµÐ»ÐµÐ¶ÐºÐ¸.",
            downloadListEmpty: "No downloads in progress",
            enableVirtualKeyboard: "Ð %{name} Ð²Ð¸ÑÑÑÐ°Ð»Ð½Ð°ÑÐ° ÐºÐ»Ð°Ð²Ð¸Ð°ÑÑÑÐ° ÑÐµ Ð±ÑÐ´Ðµ Ð´Ð¾ÑÑÑÐ¿Ð½Ð°.",
            exportLocalSettings: "Exports the local settings of this computer.",
            exportStaticSql:
                "Exports the local settings of this computer. The exported file can be used to create a database with this setup.",
            exportTranslationKeys:
                "Export the newest translations and after translating, send them by email to your software supplier to have them imported.",
            favoriteButton: "Click to add the formula as favorite",
            formulaNotes: "ÐÐ° Ð¿Ð°Ð½ÐµÐ»Ð° Ð·Ð° ÑÐ¾ÑÐ¼ÑÐ»Ð¸ ÑÐµ Ð±ÑÐ´Ðµ Ð´Ð¾ÑÑÑÐ¿Ð½Ð° ÑÐµÐºÑÐ¸ÑÑÐ° Ñ Ð±ÐµÐ»ÐµÐ¶ÐºÐ¸ Ð·Ð° ÑÐ¾ÑÐ¼ÑÐ»Ð¸.",
            helpSettings: "ÐÐ½ÑÐ¾ÑÐ¼Ð°ÑÐ¸ÑÑÐ° ÑÐµ Ð²Ð¸Ð¶Ð´Ð° Ð² ÑÐ°Ð·Ð´ÐµÐ»Ð° ÐÐ¾Ð¼Ð¾Ñ Ð½Ð° Ð¿Ð°Ð½ÐµÐ»Ð° Ð·Ð° Ð±ÑÑÐ· Ð´Ð¾ÑÑÑÐ¿.",
            importCustomData: "ÐÐ¼Ð¿Ð¾ÑÑÐ¸ÑÐ° Ð»Ð¾ÐºÐ°Ð»Ð½Ð¸ÑÐµ Ð¿ÐµÑÑÐ¾Ð½Ð°Ð»Ð¸Ð·Ð¸ÑÐ°Ð½Ð¸ Ð´Ð°Ð½Ð½Ð¸ Ð²ÑÐ· Ð¾ÑÐ½Ð¾Ð²Ð° Ð½Ð° Ð¸Ð·Ð±ÑÐ°Ð½Ð¸Ñ ÑÐ¾ÑÐ¼Ð°Ñ.",
            importExcelFile: "Import the excel file with data to be added to database.",
            importsLocalSettings: "Imports the local settings of this computer.",
            internalNote: "On Formula panel, internal note section will be accessible.",
            lockComputer:
                "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ÑÐµ Ð³Ð°ÑÐ°Ð½ÑÐ¸ÑÐ°Ñ, ÑÐµ ÑÑÐµÐ´Ð°ÑÐ° Ð½Ð° %{name} Ð½Ðµ Ð¼Ð¾Ð¶Ðµ Ð´Ð° Ð±ÑÐ´Ðµ Ð¾ÑÑÐ°Ð²ÐµÐ½Ð° - ÑÐ¾Ð²Ð° Ð´Ð°Ð²Ð° Ð²ÑÐ·Ð¼Ð¾Ð¶Ð½Ð¾ÑÑ Ð·Ð° Ð²ÑÑÑÐ¾Ð²Ð½Ð¾ Ð¸Ð·Ð¶Ð¸Ð²ÑÐ²Ð°Ð½Ðµ Ð² ÑÐµÐ¶Ð¸Ð¼ Ð½Ð° ÐºÐ¸Ð¾ÑÐº.Â ÐÑÐ¸Ð»Ð¾Ð¶Ð¸Ð¼Ð¾ ÑÐ°Ð¼Ð¾ Ð·Ð° Windows.",
            maxNumberTabs:
                "ÐÐ³ÑÐ°Ð½Ð¸ÑÐµÐ½Ð¸ÐµÑÐ¾ Ð·Ð° ÑÐ°Ð±ÑÐ»Ð°ÑÐ¾ÑÐ¸ Ð¾Ð¿ÑÐµÐ´ÐµÐ»Ñ ÐºÐ¾Ð»ÐºÐ¾ ÑÐ°Ð·Ð´ÐµÐ»Ð° ÑÐ¾ÑÐ¼ÑÐ»Ð¸ Ð¼Ð¾Ð³Ð°Ñ Ð´Ð° ÑÐµ Ð¾ÑÐ²Ð°ÑÑÑ ÐµÐ´Ð½Ð¾Ð²ÑÐµÐ¼ÐµÐ½Ð½Ð¾.",
            memoryTabs: "Allow reopening of recently opened tabs after the software starts.",
            printAfterDispensing:
                "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ°ÑÐ° Ð¸Ð·Ð¸ÑÐºÐ²Ð° Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ Ð·Ð° ÑÐ¾Ð²Ð° ÐºÐ¾Ð»ÐºÐ¾ ÐµÐºÐ·ÐµÐ¼Ð¿Ð»ÑÑÐ° Ð½Ð° ÐµÑÐ¸ÐºÐµÑÐ° ÑÑÑÐ±Ð²Ð° Ð´Ð° Ð±ÑÐ´Ð°Ñ Ð¾ÑÐ¿ÐµÑÐ°ÑÐ°Ð½Ð¸ ÑÐ»ÐµÐ´ Ð¿ÑÐ¾ÑÐµÑÐ° Ð½Ð° Ð´Ð¾Ð·Ð¸ÑÐ°Ð½Ðµ.",
            printAsImage:
                "ÐÐµÑÐ°Ñ ÐºÐ°ÑÐ¾ Ð¸Ð·Ð¾Ð±ÑÐ°Ð¶ÐµÐ½Ð¸Ðµ Ð¿Ð¾Ð¼Ð°Ð³Ð° Ð·Ð° ÑÐµÑÐ°Ð²Ð°Ð½Ðµ Ð½Ð° Ð¿ÑÐ¾Ð±Ð»ÐµÐ¼Ð¸ÑÐµ, ÐºÐ¾Ð³Ð°ÑÐ¾ ÑÑÐ°Ð½Ð´Ð°ÑÑÐ½Ð¸Ñ Ð¿ÐµÑÐ°Ñ Ð½Ð°ÑÐ¸Ð½ Ðµ Ð½ÐµÑÑÐ¿ÐµÑÐ½Ð¾. ÐÐµ Ð³Ð¾ Ð¸Ð·Ð¿Ð¾Ð»Ð·Ð²Ð°Ð¹ÑÐµ, ÐºÐ¾Ð³Ð°ÑÐ¾ ÑÑÐ°Ð½Ð´Ð°ÑÑÐ½Ð¸ÑÑ Ð¿ÐµÑÐ°Ñ ÑÐ°Ð±Ð¾ÑÐ¸ Ð¿ÑÐ°Ð²Ð¸Ð»Ð½Ð¾. Ð¡ÑÐ²Ð¼ÐµÑÑÐ¸Ð¼ ÑÐ°Ð¼Ð¾ Ñ Linux.",
            printBeforeDispensing:
                "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ°ÑÐ° Ð¸Ð·Ð¸ÑÐºÐ²Ð° Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ Ð·Ð° ÑÐ¾Ð²Ð° ÐºÐ¾Ð»ÐºÐ¾ ÐµÐºÐ·ÐµÐ¼Ð¿Ð»ÑÑÐ° Ð½Ð° ÐµÑÐ¸ÐºÐµÑÐ° ÑÑÑÐ±Ð²Ð° Ð´Ð° Ð±ÑÐ´Ð°Ñ Ð¾ÑÐ¿ÐµÑÐ°ÑÐ°Ð½Ð¸ Ð¿ÑÐµÐ´Ð¸ Ð¿ÑÐ¾ÑÐµÑÐ° Ð½Ð° Ð´Ð¾Ð·Ð¸ÑÐ°Ð½Ðµ.",
            printEnabled:
                "This setting enables using printer with the software. Additional settings are in Print Settings.",
            printOnRequest: "ÐÐ° Ð¤Ð¾ÑÐ¼ÑÐ»Ð° Ð¿Ð°Ð½ÐµÐ», Ð±ÑÑÐ¾Ð½ Print ÑÐµ Ð±ÑÐ´Ðµ Ð°ÐºÑÐ¸Ð²Ð¸ÑÐ°Ð½.",
            printTaskVariable: "The print task is processed only if given print variable is available in print data",
            quickTintTemplate: "ÐÐ·Ð±ÑÐ°Ð½Ð¸ÑÑ ÑÐ°Ð±Ð»Ð¾Ð½ ÑÐµ ÑÐµ Ð¸Ð·Ð¿Ð¾Ð»Ð·Ð²Ð° Ð¿ÑÐ¸ Ð¾ÑÐ¿ÐµÑÐ°ÑÐ²Ð°Ð½Ðµ Ð½Ð° ÐµÑÐ¸ÐºÐµÑÐ¸ÑÐµ Ð·Ð° Ð±ÑÑÐ·Ð¾ ÑÐ¾Ð½Ð¸ÑÐ°Ð½Ðµ.",
            restoreLocalSettings: "Restores the local settings of this computer.",
            runLightAtStartUp: "%{light} ÑÐµ Ð±ÑÐ´Ðµ ÑÑÐ°ÑÑÐ¸ÑÐ°Ð½Ð¾ Ð²Ð¼ÐµÑÑÐ¾ %{name}.",
            screenSaverTimeout: "Set after how many minutes, the screensaver should be activated.",
            selectCustomDataFormat:
                "ÐÐ·Ð±ÐµÑÐµÑÐµ ÑÐ¾ÑÐ¼Ð°ÑÐ° Ð½Ð° Ð¾ÑÐ¸Ð³Ð¸Ð½Ð°Ð»Ð½Ð¸ÑÐµ Ð´Ð°Ð½Ð½Ð¸, ÐºÐ¾Ð¸ÑÐ¾ ÑÐµ Ð±ÑÐ´Ð°Ñ Ð¸Ð¼Ð¿Ð¾ÑÑÐ¸ÑÐ°Ð½Ð¸.Â ÐÑÐµÐºÐ¸ ÑÐ¾ÑÐ¼Ð°Ñ Ð¼Ð¾Ð¶Ðµ Ð´Ð° Ð¸Ð·Ð¸ÑÐºÐ²Ð° ÑÐ°Ð·Ð»Ð¸ÑÐ½Ð¸ Ð´Ð¾Ð¿ÑÐ»Ð½Ð¸ÑÐµÐ»Ð½Ð¸ ÑÐ°Ð¹Ð»Ð¾Ð²Ðµ Ð¸ Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ¸.",
            setCustomHomeButton: "ÐÑÑÐ¾Ð½ÑÑ ÐÐ°ÑÐ°Ð»Ð¾ Ð² %{name} ÑÐµ Ð¿ÑÐµÐ½Ð°ÑÐ¾ÑÐ¸ ÐºÑÐ¼ Ð¸Ð·Ð±ÑÐ°Ð½Ð¸Ñ Ð¿Ð°Ð½ÐµÐ».",
            setFts: "ÐÑÐ»Ð½Ð¾ÑÐµÐºÑÑÐ¾Ð²Ð¾ÑÐ¾ ÑÑÑÑÐµÐ½Ðµ Ð¿Ð¾Ð·Ð²Ð¾Ð»ÑÐ²Ð° Ð¿ÑÐ»Ð½Ð¾ÑÐµÐºÑÑÐ¾Ð²Ð¾ ÑÑÑÑÐµÐ½Ðµ Ð½Ð° ÑÐ¾ÑÐ¼ÑÐ»Ð¸ (ÑÑÑÐ¾ Ð¾Ñ ÑÑÐµÐ´Ð°ÑÐ° Ð½Ð° Ð´ÑÐ¼Ð°ÑÐ° Ð¸ Ñ.Ð½.).",
            setKeyboardShortcuts:
                "ÐÐµ Ðµ Ð²ÑÐ·Ð¼Ð¾Ð¶Ð½Ð¾ Ð´Ð° ÑÐµ Ð·Ð°Ð´Ð°Ð´Ðµ ÐµÐ´Ð½Ð° Ð¸ ÑÑÑÐ° ÐºÐ»Ð°Ð²Ð¸ÑÐ½Ð° ÐºÐ¾Ð¼Ð±Ð¸Ð½Ð°ÑÐ¸Ñ Ð·Ð° Ð´Ð²Ðµ ÑÐ°Ð·Ð»Ð¸ÑÐ½Ð¸ Ð´ÐµÐ¹ÑÑÐ²Ð¸Ñ.",
            setNumberOfDecimalPlaces:
                "ÐÐ°ÐºÑÑÐ³Ð»ÑÐ²Ð°Ð½Ðµ Ð·Ð°Ð´Ð°Ð²Ð° ÐºÐ¾Ð»ÐºÐ¾ Ð´ÐµÑÐµÑÐ¸ÑÐ½Ð¸ Ð·Ð½Ð°ÐºÐ° Ð½Ð° Ð¾ÑÐ²ÐµÑÐ¸ÑÐµÐ»Ð¸ÑÐµ Ð¸Ð·Ð¿Ð¾Ð»Ð·Ð²Ð°Ð½Ð¸ Ð²ÑÐ² ÑÐ¾ÑÐ¼ÑÐ»Ð°ÑÐ° ÑÐµ Ð±ÑÐ´Ð°Ñ Ð¿Ð¾ÐºÐ°Ð·Ð°Ð½Ð¸.",
            setOrderSearchParameters:
                "Ð¢ÑÑÑÐµÐ½ÐµÑÐ¾ Ð½Ð° Ð¿Ð¾ÑÑÑÐºÐ¸ Ð¾Ð¿ÑÐµÐ´ÐµÐ»Ñ ÐºÐ¾Ð¸ Ð¿Ð°ÑÐ°Ð¼ÐµÑÑÐ¸ Ð´Ð° ÑÐµ Ð¸Ð·Ð¿Ð¾Ð»Ð·Ð²Ð°Ñ Ð¿ÑÐ¸ ÑÑÑÑÐµÐ½Ðµ Ð¼ÐµÐ¶Ð´Ñ Ð¿Ð¾ÑÑÑÐºÐ¸ÑÐµ. ÐÐ¾ÑÑÑÐ¿Ð½Ð¾ ÑÐ°Ð¼Ð¾ Ð² %{name}.",
            setOverwriteLastTab:
                "When choosing a new formula via global search whereas formula tab limit is reached, the last loaded formula tab will be overwritten by the new formula selection.",
            setSearchPanel:
                "ÐÐ°Ð´Ð°Ð¹ÑÐµ ÑÐ²Ð¾Ñ ÑÐ¾Ð±ÑÑÐ²ÐµÐ½Ð° Ð²Ð¸Ð´Ð¸Ð¼Ð¾ÑÑ Ð¸ ÑÐµÐ´ Ð½Ð° ÐµÐ»ÐµÐ¼ÐµÐ½ÑÐ¸, Ð¸Ð·Ð¿Ð¾Ð»Ð·Ð²Ð°Ð½Ð¸ Ð¿ÑÐ¸ ÑÑÑÑÐµÐ½Ðµ Ð½Ð° Ð½Ð¾Ð²Ð° ÑÐ¾ÑÐ¼ÑÐ»Ð°.",
            setVisibilityAndOrder:
                "ÐÐ·Ð±ÑÐ°Ð½Ð¸ÑÐµ Ð½Ð°Ð²Ð¸Ð³Ð°ÑÐ¸Ð¾Ð½Ð½Ð¸ ÐµÐ»ÐµÐ¼ÐµÐ½ÑÐ¸ ÑÐµ Ð±ÑÐ´Ð°Ñ Ð²Ð¸Ð´Ð¸Ð¼Ð¸ Ð½Ð° Ð±ÑÑÐ· Ð¿Ð°Ð½ÐµÐ» Ð·Ð° Ð´Ð¾ÑÑÑÐ¿. ÐÐ°Ð¹-Ð²Ð¸ÑÐ¾ÐºÐ°ÑÐ° Ð¿Ð¾Ð·Ð¸ÑÐ¸Ñ ÑÑÐº Ð¾Ð¿ÑÐµÐ´ÐµÐ»Ñ Ð»ÑÐ²Ð°ÑÐ° Ð¿Ð¾Ð·Ð¸ÑÐ¸Ñ Ð² Ð¿Ð°Ð½ÐµÐ»Ð°. ÐÐ°ÐºÑÐ¸Ð¼Ð°Ð»Ð½Ð¾ ÑÐ°Ð·ÑÐµÑÐµÐ½Ð¾ ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾ Ð½Ð° Ð½Ð°Ð²Ð¸Ð³Ð°ÑÐ¸Ð¾Ð½Ð½Ð¸ ÐµÐ»ÐµÐ¼ÐµÐ½ÑÐ¸ Ðµ 6.",
            setYourLanguage: "ÐÑÐ¾Ð¼ÑÐ½Ð° Ð½Ð° ÐµÐ·Ð¸ÐºÐ° Ð¸Ð·Ð¸ÑÐºÐ²Ð° ÑÐµÑÑÐ°ÑÑÐ¸ÑÐ°Ð½Ðµ.",
            settingsSearch: "Look up various settings if you are unsure where to find them.",
            showNewOrderNotifications:
                "ÐÐ·Ð²ÐµÑÑÐ¸ÐµÑÐ¾ Ð·Ð° Ð¿Ð¾ÑÑÑÐºÐ° Ðµ Ð¸Ð·ÑÐºÐ°ÑÐ°Ñ Ð¿ÑÐ¾Ð·Ð¾ÑÐµÑ, Ð² ÐºÐ¾Ð¹ÑÐ¾ ÑÐµ Ð¾Ð±ÑÐ²ÑÐ²Ð°, ÑÐµ Ðµ Ð¿Ð¾Ð»ÑÑÐµÐ½Ð° Ð½Ð¾Ð²Ð° Ð¿Ð¾ÑÑÑÐºÐ°.",
            sorting:
                "ÐÑÑÐ·o ÑÐ¾Ð½Ð¸ÑÐ°Ð½Ðµ Ð¼Ð¾Ð¶Ðµ Ð´Ð° Ð¸Ð¼Ð° Ñ ÑÐµÐ·ÐµÑÐ¾Ð°ÑÐ¸ Ð¿Ð¾Ð´ÑÐµÐ´ÐµÐ½Ð¸ ÑÐ¿Ð¾ÑÐµÐ´ Ð¸Ð¼ÐµÐ½Ð°ÑÐ° Ð½Ð° Ð¾ÑÐ²ÐµÑÐ¸ÑÐµÐ»Ð¸ÑÐµ Ð¸Ð»Ð¸ Ð¾Ñ  Ð¸Ð´ÐµÐ½ÑÐ¸ÑÐ¸ÐºÐ°ÑÐ¾ÑÐ¸ÑÐµ Ð½Ð° ÑÐµÐ·ÐµÑÐ²Ð¾Ð°ÑÐ¸ÑÐµ.",
            turnOnKioskMode: "ÐÐ°Ð²Ð¸Ð»Ð¸Ð¾Ð½ÐµÐ½ ÑÐµÐ¶Ð¸Ð¼ Ð½Ð° ÐºÐ¾Ð¶Ð¸ Ð² Ð»ÐµÐ½ÑÐ°ÑÐ° Ð½Ð° Ð·Ð°Ð´Ð°ÑÐ¸ÑÐµ.",
            windowClosingRules:
                "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ°ÑÐ° ÑÐµÑÐ°Ð²Ð° Ð´Ð°Ð»Ð¸ Ð¿ÑÐ¾Ð·Ð¾ÑÐµÑÑÑ Ð·Ð° Ð±ÑÑÐ·Ð¾ Ð¾ÑÐ²ÐµÑÑÐ²Ð°Ð½Ðµ Ð´Ð° ÑÐµ Ð·Ð°ÑÐ²Ð°ÑÑ Ð¿ÑÐµÐ´Ð¸ Ð¸Ð»Ð¸ ÑÐ»ÐµÐ´ Ð½Ð°ÑÐ°Ð»Ð¾ÑÐ¾ Ð½Ð° Ð¿ÑÐ¾ÑÐµÑÐ° Ð½Ð° Ð´Ð¾Ð·Ð¸ÑÐ°Ð½Ðµ."
        },
        formulaSettings: {
            additionalFormulaTab: "The setting decides which panel will be shown when opening a new formula tab.",
            allowCustomFormulas: "Ð¡ÑÐ·Ð´Ð°Ð²Ð°Ð½Ðµ Ð¸ ÑÑÑÑÐµÐ½Ðµ Ð½Ð° Ð¿Ð¾ÑÑÐµÐ±Ð¸ÑÐµÐ»ÑÐºÐ¸ ÑÐ¾ÑÐ¼ÑÐ»Ð¸ ÑÐµ ÑÐµ Ð°ÐºÑÐ¸Ð²Ð¸ÑÐ°.",
            allowCustomPackageSize: "ÐÐ° ÑÐ¾ÑÐ¼ÑÐ»Ð° Ð¿Ð°Ð½ÐµÐ» ÑÐµ Ð±ÑÐ´Ðµ Ð°ÐºÑÐ¸Ð²Ð¸ÑÐ°Ð½Ð° Ð¾Ð¿ÑÐ¸Ñ Ð·Ð° ÑÐ°Ð·Ð¼ÐµÑ Ð½Ð° Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ° Ð¿Ð¾ Ð¸Ð·Ð±Ð¾Ñ.",
            allowEditingColorants:
                "ÐÐ° Ð¿Ð°Ð½ÐµÐ»Ð° Ð·Ð° ÑÐ¾ÑÐ¼ÑÐ»Ð¸ ÑÐµ Ð±ÑÐ´Ðµ Ð°ÐºÑÐ¸Ð²Ð¸ÑÐ°Ð½ Ð±ÑÑÐ¾Ð½ Ð ÐµÐ´Ð°ÐºÑÐ¸ÑÐ°Ð½Ðµ Ð½Ð° ÐºÐ¾Ð»Ð¾ÑÐ°Ð½Ñ(Ð²Ð¸Ð´Ð¸Ð¼ ÑÐ»ÐµÐ´ Ð¸Ð·Ð±Ð¾ÑÐ° Ð½Ð° Ð¾ÑÐ²ÐµÑÐ¸ÑÐµÐ»).",
            alternativeFormulasPosition: "Defines how to access alternative formulas.",
            basePanelSize: "Set size of base on Formula panel",
            bippPanelSize: "Set size of base in product package on Formula panel",
            blendColorNameAndCode:
                "The setting joins together the search fields for Color name and code to create one search field only.",
            color: "ÐÐ° Ð¿Ð°Ð½ÐµÐ»Ð° Ð·Ð° ÑÐ¾ÑÐ¼ÑÐ»Ð¸ ÑÐ²ÐµÑÐ¾Ð²Ð°ÑÐ° Ð²Ð¸Ð·ÑÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ñ ÑÐµ Ð±ÑÐ´Ðµ ÐµÐ´Ð¸Ð½ÑÑÐ²ÐµÐ½Ð¾ Ð²Ð¸Ð´Ð¸Ð¼Ð° Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ.",
            colorCodePrimary: "Color code will be displayed first in the search field.",
            colorPreviewAsImage: "On Formula panel, the color preview will be represented by image.",
            colorPreviewResizable: "Allows to resize color preview panel.",
            colorantPanelLimit:
                "The settings sets the number of colorants that will be always visible before it hides under scroll bar.",
            colorantPanelOrderBy: "Formula panel can have the colorants ordered according to the names or by amounts.",
            customCanOption: "Choose which measurement units can be used for custom package size on Formula panel.",
            customCanSettingsUnit:
                "Choose which measurement unit can be used as default for custom package settings on Formula panel.",
            customFormulaForMasterProduct:
                "Defines whether the option âFormula for master productâ is displayed when saving custom formula",
            customFormulaForMasterProductDefault:
                "Defines whether the option âFormula for master productâ is checked by default",
            deleteConfirmation:
                "ÐÐºÐ»ÑÑÐ²Ð°Ð½ÐµÑÐ¾ Ð½Ð° ÑÐ°Ð·Ð¸ Ð¾Ð¿ÑÐ¸Ñ ÑÐµ Ð´Ð¾Ð²ÐµÐ´Ðµ Ð´Ð¾ Ð¸Ð·ÑÐºÐ°ÑÐ°ÑÐ¸ Ð¿ÑÐ¾Ð·Ð¾ÑÑÐ¸, Ð·Ð° Ð´Ð° Ð¿Ð¾ÑÐ²ÑÑÐ´Ð¸ÑÐµ Ð¸Ð·ÑÑÐ¸Ð²Ð°Ð½Ðµ Ð½Ð° ÐµÐ»ÐµÐ¼ÐµÐ½Ñ.",
            dropDownCalculate:
                "The drop-down menu to select the formula you are looking for will extend to the bottom of the window.",
            fandeckGroups: "The setting enables hierarchy with fandeck groups if available in the database.",
            fandeckPanelSize: "Set size of fandeck on Formula panel",
            favoriteFormulasInitial: "ÐÐ¾Ð³Ð°ÑÐ¾ ÑÑÐ°ÑÑÐ¸ÑÐ°ÑÐµ %{name}, ÑÐµ ÑÐµ Ð¿Ð¾ÑÐ²Ð¸ Ð¿Ð°Ð½ÐµÐ»ÑÑ Ñ ÐÑÐµÐ´Ð¿Ð¾ÑÐ¸ÑÐ°Ð½Ð¸.",
            formulaAutomaticNaming:
                "ÐÑÐ¾Ð¼ÐµÐ½ÐµÐ½Ð°ÑÐ° ÑÐ¾ÑÐ¼ÑÐ»Ð° ÑÐµ ÑÐµ Ð½Ð°ÑÐ¸ÑÐ° Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐ½Ð¾ Ð²ÑÐ· Ð¾ÑÐ½Ð¾Ð²Ð° Ð½Ð° Ð¼Ð¾Ð´Ð¸ÑÐ¸ÑÐ¸ÑÐ°Ð½Ð¸ÑÐµ Ð¾ÑÐ²ÐµÑÐ¸ÑÐµÐ»Ð¸.",
            formulaPanel: "ÐÐ¾Ð³Ð°ÑÐ¾ Ð¾ÑÐ²Ð¾ÑÐ¸ÑÐµ Ð½Ð¾Ð² ÑÐ°Ð·Ð´ÐµÐ», ÑÐµ ÑÐµ Ð¿Ð¾ÑÐ²Ð¸ ÑÐ¾ÑÐ¼ÑÐ»Ð° Ð¿Ð°Ð½ÐµÐ».",
            formulaPanelInitial: "ÐÐ¾Ð³Ð°ÑÐ¾ ÑÑÐ°ÑÑÐ¸ÑÐ°ÑÐµ %{name}, ÑÐµ ÑÐµ Ð¿Ð¾ÑÐ²Ð¸ Ð¿Ð°Ð½ÐµÐ»ÑÑ Ñ ÑÐ¾ÑÐ¼ÑÐ»Ð¸.",
            formulaPanelSize: "Set size of color on Formula panel",
            formulaPropertiesPosition: "Defines how to access formula properties.",
            generateColorPreview:
                "With this setting on, the color preview will be generated automatically. The resulting preview is not accurate.",
            historicalFormulasPosition: "Defines how to access historical formulas.",
            image: "ÐÐ° Ð¿Ð°Ð½ÐµÐ»Ð° Ð·Ð° ÑÐ¾ÑÐ¼ÑÐ»Ð¸ Ð¸Ð·Ð¾Ð±ÑÐ°Ð¶ÐµÐ½Ð¸ÐµÑÐ¾ Ð½Ð° Ð¿ÑÐ¾Ð´ÑÐºÑÐ° ÑÐµ ÑÐµ Ð²Ð¸Ð¶Ð´Ð° Ð´Ð¾ Ð²Ð¸Ð·ÑÐ°Ð»Ð¸Ð·Ð°ÑÐ¸ÑÑÐ° Ð½Ð° ÑÐ²ÐµÑÐ° Ñ Ð²ÑÐ·Ð¼Ð¾Ð¶Ð½Ð¾ÑÑ Ð·Ð° Ð¾ÑÐ²Ð°ÑÑÐ½Ðµ Ð½Ð° Ð¿Ð°Ð½ÐµÐ»Ð° Ñ Ð¿Ð¾Ð²ÐµÑÐµ Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ.",
            images: "The setting defines the source of image files.",
            infoPanelResizable: "Allows to resize more info panel.",
            initialFormulaTab: "The setting decides which panel will be shown after %{0} starts.",
            moreInfo:
                "ÐÐ° Ð¿Ð°Ð½ÐµÐ»Ð° Ð·Ð° ÑÐ¾ÑÐ¼ÑÐ»Ð¸ ÐÐ½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ð¾Ð½Ð½Ð¸ÑÑ Ð¿Ð°Ð½ÐµÐ» ÑÐµ ÑÐµ Ð²Ð¸Ð¶Ð´Ð° Ð´Ð¾ Ð²Ð¸Ð·ÑÐ°Ð»Ð¸Ð·Ð°ÑÐ¸ÑÑÐ° Ð½Ð° ÑÐ²ÐµÑÐ¾Ð²ÐµÑÐµ Ð¸ Ð²Ð¸Ð·ÑÐ°Ð»Ð¸Ð·Ð°ÑÐ¸ÑÑÐ° Ð½Ð° Ð¸Ð·Ð¾Ð±ÑÐ°Ð¶ÐµÐ½Ð¸ÐµÑÐ¾ Ð½Ð° Ð¿ÑÐ¾Ð´ÑÐºÑÐ°.",
            orderByDistance: "With this setting on, the result of color search is ordered by special distance metric.",
            productCode:
                "The setting enables to use product codes along with product names if available in the database.",
            productFiles: "The setting defines the source of product files which are available on Formula panel.",
            productGroups: "The setting enables hierarchy with product groups if available in the database.",
            productPanelSize: "Set size of product on Formula panel",
            searchNewFormula:
                "ÐÑÐ¸ Ð¾ÑÐ²Ð°ÑÑÐ½Ðµ Ð½Ð° Ð½Ð¾Ð² ÑÐ°Ð·Ð´ÐµÐ» ÑÐµ ÑÐµ Ð¿Ð¾ÑÐ²Ð¸ Ð½Ð¾Ð²Ð° ÑÐ¾ÑÐ¼ÑÐ»Ð° (ÑÑÐ´ÑÑÐ¶Ð° Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ Ð·Ð° Ð¿Ð¾ÑÐ»ÐµÐ´Ð½Ð¸ÑÐµ ÑÐ°Ð·Ð¿ÑÐµÐ´ÐµÐ»ÐµÐ½Ð¸ ÑÐ¾ÑÐ¼ÑÐ»Ð¸ Ð¸ Ð¿ÑÐµÐ´Ð¿Ð¾ÑÐ¸ÑÐ°Ð½Ð¸ ÑÐ¾ÑÐ¼ÑÐ»Ð¸).",
            searchNewFormulaInitial:
                "ÐÐ¾Ð³Ð°ÑÐ¾ ÑÑÐ°ÑÑÐ¸ÑÐ°ÑÐµ %{name}, ÑÐµ ÑÐµ Ð¿Ð¾ÑÐ²Ð¸ Ð½Ð¾Ð²Ð¾ ÑÑÑÑÐ½ÐµÐ½Ðµ Ð½Ð° ÑÐ¾ÑÐ¼ÑÐ»Ð° (ÑÑÐ´ÑÑÐ¶Ð° Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ Ð·Ð° Ð¿Ð¾ÑÐ»ÐµÐ´Ð½Ð¸ÑÐµ ÑÐ°Ð·Ð¿ÑÐµÐ´ÐµÐ»ÐµÐ½Ð¸ ÑÐ¾ÑÐ¼ÑÐ»Ð¸ Ð¸ Ð¿ÑÐµÐ´Ð¿Ð¾ÑÐ¸ÑÐ°Ð½Ð¸ ÑÐ¾ÑÐ¼ÑÐ»Ð¸).",
            searchPanelFormulaItems: "At least one of the formula items must be selected.",
            searchPanelProductItems: "Only one of the product items can be selected.",
            searchPanelQuickSelect:
                "No need to press the load formula button. You will be redirected directly to main formula tab just after formula selection.",
            setCompetitiveColorSearch:
                "With this setting on, the feature of competitive color search in Color Palette and Formula panel (only for not available formulas) is available.",
            setFormulaInfoInPreview:
                "On Formula panel, the selected data type will be always visible in the color preview.",
            setFormulaPreview:
                "The setting changes the position and display of color preview, package image and info data about the color.",
            setFormulaRGBPreviewVisibleInformation:
                "ÐÐ° Ð¿Ð°Ð½ÐµÐ»Ð° Ð·Ð° ÑÐ¾ÑÐ¼ÑÐ»Ð¸ ÐÐ·Ð±ÑÐ°Ð½Ð¸ÑÑ ÑÐ¸Ð¿ Ð´Ð°Ð½Ð½Ð¸ Ð²Ð¸Ð½Ð°Ð³Ð¸ ÑÐµ ÑÐµ Ð²Ð¸Ð¶Ð´Ð° Ð¿ÑÐ¸ Ð²Ð¸Ð·ÑÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ñ Ð½Ð° ÑÐ²ÐµÑÐ¾Ð²ÐµÑÐµ.",
            setFormulaUnit:
                "ÐÐ° Ð¿Ð°Ð½ÐµÐ»Ð° Ð·Ð° ÑÐ¾ÑÐ¼ÑÐ»Ð¸ ÑÐ°Ð·Ð¸ Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ° ÑÐµÑÐ°Ð²Ð° ÐºÐ¾Ð¹ ÑÐ²ÐµÑÐµÐ½ Ð¼Ð¾Ð´ÑÐ» ÑÐµ Ð¾ÑÐ²Ð°ÑÑ ÐºÐ°ÑÐ¾ Ð¿ÑÑÐ²Ð¸ ÑÐ»ÐµÐ´ Ð¸Ð·Ð±Ð¾ÑÐ° Ð½Ð° ÑÐ²ÑÑ. Ð¡ÑÑÐ¾ Ð¿ÑÐ¸Ð»Ð¾Ð¶Ð¸Ð¼ Ð² Ð±ÑÑÐ·Ð¾ ÑÐ¾Ð½Ð¸ÑÐ°Ð½Ðµ.",
            setFormulaVisibilityAndOrder:
                "ÐÑÐ² Ð¤Ð¾ÑÐ¼ÑÐ»Ð° Ð¿Ð°Ð½ÐµÐ» Ð¸Ð·Ð±ÑÐ°Ð½Ð¸ÑÐµ Ð´Ð°Ð½Ð½Ð¸ ÑÐµ ÑÐµ Ð²Ð¸Ð¶Ð´Ð°Ñ Ð² ÑÐ°Ð·Ð´ÐµÐ»Ð° Ð´Ð¾Ð¿ÑÐ»Ð½Ð¸ÑÐµÐ»Ð½Ð° Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ (ÑÐ°Ð¼Ð¾ Ð°ÐºÐ¾ Ð·Ð°Ð´Ð°Ð´ÐµÑÐµ  Ð²Ð¸Ð·ÑÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ñ Ð² Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ°ÑÐ° Ð½Ð° ÑÐ¾ÑÐ¼ÑÐ»Ð°ÑÐ° Ð·Ð°  Ð¸Ð·Ð¾Ð±ÑÐ°Ð¶ÐµÐ½Ð¸Ðµ Ð¸Ð»Ð¸ Ð¿Ð¾Ð²ÐµÑÐµ Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ)",
            setMaxToleranceForCompetitiveColors:
                "Set the maximal Delta E (CIA 2000) tolerance for competitive color search.",
            setNumberOfCompetitiveColors:
                "Define how many competitive master colors should be offered after search. The defined number does not correspond to the number of results.",
            setVisibleUnit:
                "ÐÐ° Ð¿Ð°Ð½ÐµÐ»Ð° Ð·Ð° ÑÐ¾ÑÐ¼ÑÐ»Ð¸ ÑÐ°Ð·Ð¸ Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ° ÑÐµÑÐ°Ð²Ð° ÐºÐ¾Ð¸ ÑÐ²ÐµÑÐ½Ð¸ ÐµÐ´Ð¸Ð½Ð¸ÑÐ¸ ÑÐµ Ð²Ð¸Ð¶Ð´Ð°Ñ ÑÐ»ÐµÐ´ Ð¸Ð·Ð±Ð¾ÑÐ° Ð½Ð° ÑÐ²ÑÑ. Ð¡ÑÑÐ¾ Ð¿ÑÐ¸Ð»Ð¾Ð¶Ð¸Ð¼ Ð² Ð±ÑÑÐ·Ð¾ ÑÐ¾Ð½Ð¸ÑÐ°Ð½Ðµ",
            showColorPreview:
                "ÐÐ° Ð¤Ð¾ÑÐ¼ÑÐ»Ð° Ð¿Ð°Ð½ÐµÐ», Ð¿Ð¾ÐºÐ°Ð·Ð²Ð° Ð¼Ð°Ð»ÑÐº ÑÐ²ÐµÑÐµÐ½ Ð²Ð¸Ð·ÑÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ñ Ð´Ð¾ Ð¸Ð¼ÐµÑÐ¾ Ð½Ð° ÑÐ²ÑÑ, ÐºÐ¾Ð³Ð°ÑÐ¾ ÑÑÑÑÑÑ Ð½Ð¾Ð²Ð° ÑÐ¾ÑÐ¼ÑÐ»Ð°.",
            showSiblingProducts:
                "Defines whether the option âShow sibling productsâ is displayed when saving custom formula",
            useColorCode: "On Formula panel, shows the information about color code."
        },
        formulaValidation: {
            batchNumberInvalid: "Canister (%{colorants}) is filled with a defective batch of colorant.",
            batchNumberWarning: "Colorant (%{colorants}) with this batch number may be damaged.",
            bellowBaseLimit: "Sum of colorant amounts is below base limit.",
            checkColorantBaseRules: "The setting checks if used colorants and base can be used in this combination.",
            checkMinDosableAmount:
                "The minimal tintable amount is the smallest colorant amount which can be dispensed as recommended by the laboratory.",
            checkOverfill:
                "The setting checks if there is enough space in the can for the colorants immediately after the amounts are set.",
            checkTotalCntAmounts:
                "The setting checks if the limits for the minimal and maximal colorant amounts in product base package have been exceeted. These limits are defined in the database.",
            colorantBaseRules: "Colorant is not valid for selected base.",
            colorantMinAmount: "Colorant amount is below the minimal tintable amount.",
            dispensingWithErrorsEnabled:
                "If allowed, a warning message will appear in case of validation violations, but it will be possible to proceed to dispensing nonetheless.",
            invalidBatchNumber: "Colorant has invalid or defective batch number",
            overBaseLimit: "Sum of colorant amounts is over maximal tintable amount.",
            overfill: "Overfill has been detected.",
            unifyColorantBatchForMultipleCans:
                "If allowed, an info refill to max modal will appear when amount of colorant is bigger than maximum of canister and canister is not filled on maximum level.",
            warningConfirmBtn: "I know the risks, continue"
        },
        help: "ÐÐ¾Ð¼Ð¾Ñ",
        helpLink: "ÐÐ¾Ð¼Ð¾ÑÐµÐ½ ÑÐµÐ½ÑÑÑ",
        helper: {
            automaticallyCheckForUpdates:
                "Ð¢Ñ ÑÐµ Ð±ÑÐ´Ðµ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐ½Ð¾ Ð¿ÑÐ¾Ð²ÐµÑÐµÐ½Ð° Ð´Ð°Ð»Ð¸ Ð¸Ð¼Ð° Ð½Ð°Ð»Ð¸ÑÐ½Ð° Ð°ÐºÑÑÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ñ Ð·Ð° %{name} Ð¸Ð»Ð¸ Ð±Ð°Ð·Ð° Ð´Ð°Ð½Ð½Ð¸ Ð² Ð´Ð°Ð´ÐµÐ½Ð¸Ñ Ð¸Ð½ÑÐµÑÐ²Ð°Ð» Ð¾Ñ Ð²ÑÐµÐ¼Ðµ.",
            automaticallyDownloadUpdates:
                "ÐÐºÐ¾ Ðµ Ð½Ð°Ð»Ð¸ÑÐ½Ð° Ð°ÐºÑÑÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ñ, ÑÑ ÑÐµ Ð±ÑÐ´Ðµ Ð¸Ð·ÑÐµÐ³Ð»ÐµÐ½Ð° Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐ½Ð¾, Ð±ÐµÐ· Ð´Ð° Ðµ Ð½ÐµÐ¾Ð±ÑÐ¾Ð´Ð¸Ð¼Ð¾ Ð´Ð° ÑÐµ Ð¿Ð¾ÑÐ²ÑÑÐ¶Ð´Ð°Ð²Ð°.",
            automaticallyInstallNewDatabases:
                "ÐÐºÐ¾ Ð±ÑÐ´Ðµ Ð¸Ð·Ð¿ÑÐ°ÑÐµÐ½Ð° Ð´Ð¾ÑÐµÐ³Ð° Ð»Ð¸Ð¿ÑÐ²Ð°ÑÐ° ÐÐ, ÑÑ ÑÐµ Ð±ÑÐ´Ðµ Ð¸Ð½ÑÑÐ°Ð»Ð¸ÑÐ°Ð½Ð° ÐºÐ°ÑÐ¾ Ð½Ð¾Ð²Ð° ÐÐ.Â Ð¡Ð»ÐµÐ´ ÑÐ¾Ð²Ð° DB Ð¼Ð¾Ð¶Ðµ Ð´Ð° ÑÐµ Ð¸Ð·Ð¿Ð¾Ð»Ð·Ð²Ð°.",
            automaticallyInstallUpdates:
                "ÐÐºÐ¾ Ðµ Ð¸Ð·ÑÐµÐ³Ð»ÐµÐ½Ð° Ð°ÐºÑÑÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ñ, ÑÑ ÑÐµ Ð±ÑÐ´Ðµ Ð¸Ð½ÑÑÐ°Ð»Ð¸ÑÐ°Ð½Ð° Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐ½Ð¾, Ð±ÐµÐ· Ð´Ð° Ðµ Ð½ÐµÐ¾Ð±ÑÐ¾Ð´Ð¸Ð¼Ð¾ Ð´Ð° ÑÐµ Ð¿Ð¾ÑÐ²ÑÑÐ¶Ð´Ð°Ð²Ð°.",
            canBrowseChangeLog:
                "ÐÐ¾Ð³Ð°ÑÐ¾ Ð°ÐºÑÑÐ°Ð»Ð¸Ð·Ð¸ÑÐ°ÑÐµ ÑÐ¾ÑÑÑÐµÑÐ°, Ð¾ÑÐ¸ÑÐ¸Ð°Ð»Ð½Ð¸ÑÑ ÑÐµÐ³Ð¸ÑÑÑÑ Ð½Ð° Ð¿ÑÐ¾Ð¼ÐµÐ½Ð¸ÑÐµ %{name} ÑÐµ Ð±ÑÐ´Ðµ Ð½Ð° ÑÐ°Ð·Ð¿Ð¾Ð»Ð¾Ð¶ÐµÐ½Ð¸Ðµ",
            forceInstall: "The update will be installed by force.",
            installDuringNight: "ÐÐºÑÑÐ°Ð»Ð¸Ð·Ð°ÑÐ¸ÑÑÐ° ÑÐµ Ð±ÑÐ´Ðµ Ð¸Ð½ÑÑÐ°Ð»Ð¸ÑÐ°Ð½Ð° Ð¿ÑÐµÐ· Ð½Ð¾ÑÑÐ°, Ð°ÐºÐ¾ ÐºÐ¾Ð¼Ð¿ÑÑÑÑÑÑ ÑÐ°Ð±Ð¾ÑÐ¸."
        },
        licensing: {
            collect:
                "The logfiles will be downloaded to the selected location. The logfiles are required by the software supplied for bug analysis.",
            company: "The company which supplied the license.",
            computerID: "License identification to help the software supplier in case of required assistance.",
            email: "The email address of the license holder.",
            licenseUuid: "License identification to help the software supplier in case of required assistance.",
            name: "The name of the license holder.",
            openBugreport:
                "Please let us know if there is a bug in the software and send us a report with the bug description.",
            posInfoContactperson: "POS information about the owner to be printed on the label.",
            posInfoMachineInformation:
                "POS information about the dispenser to be printed on the label or recognized in the network.",
            posInfoPos: "POS information about the location to be printed on the label.",
            reactivation: "Reactivation or change of the current license.",
            refresh: "Downloads the newest license information.",
            refreshUnavailable: "License refresh unavailable because you are offline.",
            registrationContactperson: "Registration information to identify the owner of the license.",
            registrationMachineInformation: "Registration information to identify the dispenser of the license.",
            registrationPos: "Registration information to identify the location of the license.",
            versionScope: "The software expiration limits.",
            versionType: "The software product type."
        },
        machineIsBusy: "ÐÑÐµÑÐºÐ¸ÑÐµ Ð½Ðµ Ð¼Ð¾Ð³Ð°Ñ Ð´Ð° Ð±ÑÐ´Ð°Ñ Ð½ÑÐ»Ð¸ÑÐ°Ð½Ð¸, ÑÑÐ¹ ÐºÐ°ÑÐ¾ Ð¼Ð°ÑÐ¸Ð½Ð°ÑÐ° Ðµ Ð·Ð°ÐµÑÐ°.",
        machineSettings: {
            allowManualColorantAddition:
                "ÐÐºÐ¾ Ð¸Ð·Ð¸ÑÐºÐ²Ð°Ð½Ð°ÑÐ° ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾ Ð½Ð° Ð¾ÑÐ²ÐµÑÐ¸ÑÐµÐ» Ð½Ð°Ð´Ð²Ð¸ÑÐ¸ Ð¼Ð°ÐºÑÐ¸Ð¼Ð°Ð»Ð½Ð°ÑÐ° ÑÑÐ¼Ð° Ð·Ð° Ð´Ð¾Ð·Ð¸ÑÐ°Ð½Ðµ, Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ°ÑÐ° Ð¿Ð¾Ð·Ð²Ð¾Ð»ÑÐ²Ð° Ð´Ð° Ñ Ð´Ð¾Ð±Ð°Ð²Ð¸ÑÐµ ÑÑÑÐ½Ð¾ ÑÐ»ÐµÐ´ Ð¿Ð¾Ð´Ð°Ð²Ð°Ð½ÐµÑÐ¾.",
            autotasks:
                "ÐÐ²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐ½Ð¸ÑÐµ Ð·Ð°Ð´Ð°ÑÐ¸ ÑÐ° Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐ½Ð¸ ÑÑÐ±Ð¸ÑÐ¸Ñ Ð·Ð° Ð¿Ð¾Ð´Ð´ÑÑÐ¶ÐºÐ° Ð½Ð° Ð¼Ð°ÑÐ¸Ð½Ð¸ Ð¸ ÐºÐ¾Ð¼Ð¿ÑÑÑÐ¸, ÐºÐ¾Ð¸ÑÐ¾ Ð¼Ð¾Ð³Ð°Ñ Ð´Ð° Ð±ÑÐ´Ð°Ñ Ð·Ð°Ð´Ð°Ð´ÐµÐ½Ð¸ Ð² Ð¾Ð¿ÑÐµÐ´ÐµÐ»ÐµÐ½ Ð¿ÐµÑÐ¸Ð¾Ð´ Ð¾Ñ Ð²ÑÐµÐ¼Ðµ Ð¸Ð»Ð¸ Ð²ÑÐµÐ¼ÐµÐ²Ð¸ Ð¸Ð½ÑÐµÑÐ²Ð°Ð».",
            barcodeRefillValidation: "The setting turns on barcode validation on refill.",
            barcodeRefillValidationBaseAndColorant:
                "Barcode check is performed on canister and colorant package refilling.",
            barcodeRefillValidationColorant: "Barcode check is performed on colorant package refilling.",
            canisterBarcode:
                "The barcode is assigned to the canister in which the colorant is available. The barcode is necessary to ensure correct colorant refilling.",
            checkCanBeforeDispense: "The setting is only valid for Fast & Fluid simulation.",
            checkOverfill: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ°ÑÐ° Ð¿ÑÐ¾Ð²ÐµÑÑÐ²Ð° Ð´Ð°Ð»Ð¸ Ð¸Ð¼Ð° Ð´Ð¾ÑÑÐ°ÑÑÑÐ½Ð¾ Ð¼ÑÑÑÐ¾  Ð·Ð° Ð¾ÑÐ²ÐµÑÐ¸ÑÐµÐ»Ð¸te Ð¿ÑÐµÐ´Ð¸ Ð´Ð¾Ð·Ð¸ÑÐ°Ð½ÐµÑÐ¾.",
            currentlySelectedMachine: "Provides information about the currently selected machine.",
            dispenseInvalidColorants:
                "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ°ÑÐ° Ð¿Ð¾Ð·Ð²Ð¾Ð»ÑÐ²Ð° Ð´Ð° ÑÐµ ÑÐ°Ð·Ð¿ÑÐµÐ´ÐµÐ»ÑÑ Ð¾ÑÐ²ÐµÑÐ¸ÑÐµÐ»Ð¸, ÐºÐ¾Ð¸ÑÐ¾ Ð½Ðµ ÑÐ° Ð´ÐµÑÐ¸Ð½Ð¸ÑÐ°Ð½Ð¸ Ð² ÐºÐ¾Ð½ÑÐ¸Ð³ÑÑÐ°ÑÐ¸ÑÑÐ° Ð½Ð° Ð¼Ð°ÑÐ¸Ð½Ð°ÑÐ°, ÐºÐ°ÑÐ¾ ÑÐµ Ð¿Ð¾Ð¸ÑÐºÐ° ÑÑÑÐ½Ð¾ Ð´Ð¾Ð±Ð°Ð²ÑÐ½Ðµ Ð½Ð° Ð¾ÑÐ²ÐµÑÐ¸ÑÐµÐ».",
            dispenserConfigurationBackup: "Download and save the current machine configuration to maintain a backup.",
            dispensingLogic:
                "Dispensing logic types can ensure different behaviour for each canisters when there is more colorant to be dispensed than allowed or desired. Additional behavior is set in Dispensing Settings.",
            enableTmc: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ°ÑÐ° Ð¿Ð¾Ð·Ð²Ð¾Ð»ÑÐ²Ð° Ð¸Ð·Ð¿ÑÐ°ÑÐ°Ð½Ðµ Ð½Ð° Ð´Ð°Ð½Ð½Ð¸ Ð´Ð¾ TMC.",
            enableUserIdentification: "User has to log in before dispensing is allowed.",
            machineUnit: "ÐÐ°ÑÐ¸Ð½Ð° ÐµÐ´Ð¸Ð½Ð¸ÑÐ° Ð¾Ð¿ÑÐµÐ´ÐµÐ»Ñ Ð¼ÐµÑÐ½Ð°ÑÐ° ÐµÐ´Ð¸Ð½Ð¸ÑÐ° Ð½Ð° Ð¾ÑÐ²ÐµÑÐ¸ÑÐµÐ»Ð¸ Ð² ÐºÐ¾Ð½ÑÐµÐ¹Ð½ÐµÑÐ¸ÑÐµ.",
            minDispensedAmount:
                "ÐÐ¸Ð½Ð¸Ð¼Ð°Ð»Ð½Ð¾ ÑÐ°Ð·Ð¿ÑÐµÐ´ÐµÐ»ÐµÐ½Ð¾ÑÐ¾ ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾ Ð¾Ð¿ÑÐµÐ´ÐµÐ»Ñ ÐºÐ¾Ð»ÐºÐ¾ Ð¾ÑÐ²ÐµÑÐ¸ÑÐµÐ» ÑÑÑÐ±Ð²Ð° Ð´Ð° Ð±ÑÐ´Ðµ Ð´Ð¾Ð·Ð¸ÑÐ°Ð½, Ð·Ð° Ð´Ð° ÑÐµ Ð²Ð·ÐµÐ¼Ðµ Ð¿ÑÐµÐ´Ð²Ð¸Ð´ Ð¸Ð·Ð²ÑÑÑÐµÐ½Ð¾ÑÐ¾ Ð¿ÑÐµÑÐ¸ÑÑÐ²Ð°Ð½Ðµ (Ð·Ð° Ð´Ð° ÑÐµ Ð¸Ð·Ð±ÐµÐ³Ð½Ðµ Ð´Ð¾Ð¿ÑÐ»Ð½Ð¸ÑÐµÐ»Ð½Ð¾ Ð¿ÑÐµÑÐ¸ÑÑÐ²Ð°Ð½Ðµ).",
            minimalDispenseAmount:
                "ÐÐ¸Ð½Ð¸Ð¼Ð°Ð»Ð½Ð¾ ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾ Ð½Ð° Ð´Ð¾Ð·Ð°ÑÐ° Ðµ Ð½Ð°Ð¹-Ð¼Ð°Ð»ÐºÐ¾ÑÐ¾ Ð¿ÑÐµÐ¿Ð¾ÑÑÑÐ°Ð½Ð¾ ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾ Ð¾ÑÐ²ÐµÑÐ¸ÑÐµÐ», ÐºÐ¾ÐµÑÐ¾ Ð¼Ð¾Ð¶Ðµ Ð´Ð° Ð±ÑÐ´Ðµ Ð´Ð¾Ð·Ð¸ÑÐ°Ð½Ð¾. ÐÐºÐ¾ Ð±ÑÐ´Ðµ Ð½Ð°ÑÑÑÐµÐ½Ð¾, ÑÐµ ÑÐµ Ð¿Ð¾ÑÐ²Ð¸ ÑÑÐ¾Ð±ÑÐµÐ½Ð¸Ðµ (Ð¿Ð¾Ð´Ð°Ð²Ð°Ð½ÐµÑÐ¾ Ð²ÑÐµ Ð¾ÑÐµ Ðµ Ð²ÑÐ·Ð¼Ð¾Ð¶Ð½Ð¾)",
            missingAutotaskCanisters: "Ð¢ÑÑÐ±Ð²Ð° Ð´Ð° Ð±ÑÐ´Ðµ Ð¸Ð·Ð±ÑÐ°Ð½ Ð¿Ð¾Ð½Ðµ 1 ÐºÑÑÐ¸Ñ",
            missingAutotaskChannels: "Ð¢ÑÑÐ±Ð²Ð° Ð´Ð° Ð±ÑÐ´Ðµ Ð¸Ð·Ð±ÑÐ°Ð½ Ð¿Ð¾Ð½Ðµ 1 ÐºÐ°Ð½Ð°Ð»",
            missingAutotaskChannelsValue: "Ð¢ÑÑÐ±Ð²Ð° Ð´Ð° ÑÐµ Ð¿Ð¾Ð¿ÑÐ»Ð½Ð¸ Ð¾Ð±ÐµÐ¼ÑÑ Ð½Ð° Ð²ÑÐ¸ÑÐºÐ¸ Ð¸Ð·Ð±ÑÐ°Ð½Ð¸ ÐºÐ°Ð½Ð°Ð»Ð¸",
            missingAutotaskCleanTime: "ÐÑÐµÐ¼ÐµÑÐ¾ Ð·Ð° Ð¿Ð¾ÑÐ¸ÑÑÐ²Ð°Ð½Ðµ ÑÑÑÐ±Ð²Ð° Ð´Ð° Ð±ÑÐ´Ðµ Ð¿Ð¾Ð¿ÑÐ»Ð½ÐµÐ½Ð¾",
            missingAutotaskName: "Ð¢ÑÑÐ±Ð²Ð° Ð´Ð° ÑÐµ Ð¿Ð¾Ð¿ÑÐ»Ð½Ð¸ Ð¸Ð¼ÐµÑÐ¾ Ð½Ð° Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ð½Ð¸Ñ ÑÐºÐ°Ð·Ð°ÑÐµÐ»",
            missingAutotaskRecirculation: "ÐÑÐµÐ¼ÐµÑÐ¾ Ð¸ ÑÐºÐ¾ÑÐ¾ÑÑÑÐ° Ð½Ð° ÑÐµÑÐ¸ÑÐºÑÐ»Ð°ÑÐ¸Ñ ÑÑÑÐ±Ð²Ð° Ð´Ð° Ð±ÑÐ´Ð°Ñ Ð¿Ð¾Ð¿ÑÐ»Ð½ÐµÐ½Ð¸",
            missingAutotaskStirring: "ÐÑÐµÐ¼ÐµÑÐ¾ Ð¸ ÑÐºÐ¾ÑÐ¾ÑÑÑÐ° Ð½Ð° ÑÐ°Ð·Ð±ÑÑÐºÐ²Ð°Ð½Ðµ ÑÑÑÐ±Ð²Ð° Ð´Ð° Ð±ÑÐ´Ð°Ñ Ð¿Ð¾Ð¿ÑÐ»Ð½ÐµÐ½Ð¸",
            missingAutotaskVolume: "Ð¢ÑÑÐ±Ð²Ð° Ð´Ð° ÑÐµ Ð¿Ð¾Ð¿ÑÐ»Ð½Ð¸ Ð¾Ð±ÐµÐ¼ÑÑ Ð½Ð° Ð¿ÑÐ¾Ð´ÑÐ²ÐºÐ°ÑÐ°",
            placeCanSensor:
                "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ°ÑÐ° Ð°ÐºÑÐ¸Ð²Ð¸ÑÐ° ÑÐµÐ½Ð·Ð¾Ñ Ð·Ð° Ð¿Ð¾ÑÑÐ°Ð²ÑÐ½Ðµ Ð½Ð° Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ° - Ð´Ð¾Ð·Ð¸ÑÐ°Ð½ÐµÑÐ¾ Ð½ÑÐ¼Ð° Ð´Ð° Ð·Ð°Ð¿Ð¾ÑÐ½Ðµ, Ð¾ÑÐ²ÐµÐ½ Ð°ÐºÐ¾ ÐºÑÑÐ¸ÑÑÐ° Ð½Ðµ Ðµ Ð¿Ð¾ÑÑÐ°Ð²ÐµÐ½Ð° Ð¿ÑÐ°Ð²Ð¸Ð»Ð½Ð¾.",
            placeCanSensorDelay:
                "ÐÑÐµÐ¿Ð¾ÑÑÑÐ¸ÑÐµÐ»Ð½Ð° Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ°, ÑÐ²ÑÑÐ·Ð°Ð½Ð°  Ð´Ð°ÑÑÐ¸Ðº Ð·Ð° Ð½Ð°Ð»Ð¸ÑÐ¸Ðµ Ð½Ð° Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ°. Ð¢Ð¾Ð¹ Ð³Ð°ÑÐ°Ð½ÑÐ¸ÑÐ°, ÑÐµ Ð´Ð¾Ð·Ð¸ÑÐ°Ð½ÐµÑÐ¾ Ð·Ð°Ð¿Ð¾ÑÐ²Ð° ÑÐ°Ð¼Ð¾ ÑÐ»ÐµÐ´ Ð¾Ð¿ÑÐµÐ´ÐµÐ»ÐµÐ½Ð¸Ñ Ð¿ÐµÑÐ¸Ð¾Ð´ Ð¾Ñ Ð²ÑÐµÐ¼Ðµ, Ð¿ÑÐµÐ· ÐºÐ¾Ð¹ÑÐ¾ Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ°ÑÐ° Ðµ Ð¿Ð¾ÑÑÐ°Ð²ÐµÐ½Ð° Ð¿ÑÐ°Ð²Ð¸Ð»Ð½Ð¾",
            purgeVolume:
                "ÐÐ±ÐµÐ¼ÑÑ Ð½Ð° Ð¿ÑÐ¾ÑÐ¸ÑÑÐ²Ð°Ð½Ðµ Ð¾Ð¿ÑÐµÐ´ÐµÐ»Ñ ÐºÐ¾Ð»ÐºÐ¾ Ð¾ÑÐ²ÐµÑÐ¸ÑÐµÐ» ÑÐµ Ð´Ð¾Ð·Ð¸ÑÐ° Ð¿ÑÐ¸ Ð¸Ð·Ð²ÑÑÑÐ²Ð°Ð½Ðµ Ð½Ð° Ð¸Ð½ÑÐµÐ»Ð¸Ð³ÐµÐ½ÑÐ½Ð° Ð¿ÑÐ¾ÑÐ¸ÑÑÐ²Ð°Ð½Ðµ.",
            rccUrl: "Redlike Control Center (RCC) is responsible for the communication with the dispenser.",
            refillThreshold:
                "If the amount of colorant in the canister with the given UFI or Batch number drops below this limit, such UFI or Batch number will be discarded.",
            refillThresholdBatch:
                "If the amount of colorant in the canister with the given Batch number drops below this limit, such Batch number will be discarded.",
            refillThresholdUfi:
                "If the amount of colorant in the canister with the given UFI drops below this limit, such UFI will be discarded.",
            removeCanSensor:
                "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ°ÑÐ° Ð°ÐºÑÐ¸Ð²Ð¸ÑÐ° ÑÐµÐ½Ð·Ð¾Ñ Ð·Ð° Ð¾ÑÑÑÑÐ°Ð½ÑÐ²Ð°Ð½Ðµ Ð½Ð° Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ°ÑÐ° - Ð´Ð¾Ð·Ð¸ÑÐ°Ð½ÐµÑÐ¾ Ð½Ðµ ÑÐµ ÑÑÐ¸ÑÐ° Ð·Ð° Ð¸Ð·Ð²ÑÑÑÐµÐ½Ð¾, Ð¾ÑÐ²ÐµÐ½ Ð°ÐºÐ¾ Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ°ÑÐ° Ð½Ðµ Ðµ Ð¿ÑÐµÐ¼Ð°ÑÐ½Ð°ÑÐ°.",
            removeCanSensorDelay:
                "ÐÑÐµÐ¿Ð¾ÑÑÑÐ¸ÑÐµÐ»Ð½Ð° Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ°, ÑÐ²ÑÑÐ·Ð°Ð½Ð° ÑÑÑ ÑÐµÐ½Ð·Ð¾Ñ Ð·Ð° Ð¿ÑÐµÐ¼Ð°ÑÐ²Ð°Ð½Ðµ Ð½Ð° Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ°ÑÐ°. Ð¢Ð¾Ð¹ Ð³Ð°ÑÐ°Ð½ÑÐ¸ÑÐ°, ÑÐµ Ð´Ð¾Ð·Ð¸ÑÐ°Ð½ÐµÑÐ¾ Ðµ Ð¿ÑÐ¸ÐºÐ»ÑÑÐ¸Ð»Ð¾ ÑÐ°Ð¼Ð¾ ÑÐ»ÐµÐ´ Ð¾Ð¿ÑÐµÐ´ÐµÐ»ÐµÐ½Ð¸Ñ Ð¿ÐµÑÐ¸Ð¾Ð´ Ð¾Ñ Ð²ÑÐµÐ¼Ðµ, Ð¿ÑÐµÐ· ÐºÐ¾Ð¹ÑÐ¾ Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ°ÑÐ° Ðµ Ð±Ð¸Ð»Ð° Ð¸Ð·Ð²Ð°Ð´ÐµÐ½Ð°.",
            skipPlaceCanDialog:
                "ÐÑÐ¸ Ð²ÐºÐ»ÑÑÐ²Ð°Ð½Ðµ Ð½Ð° ÑÐ°Ð·Ð¸ Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ°, Ð´Ð¾Ð·Ð°ÑÐ¾ÑÑÑ Ð½ÑÐ¼Ð° Ð´Ð° Ð¸Ð·ÑÐ°ÐºÐ° Ð¿ÑÐ¸ Ð¿Ð¾ÑÑÐ°Ð²ÑÐ½ÐµÑÐ¾ Ð½Ð° Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ°, Ð´Ð¾ÐºÐ°ÑÐ¾ ÑÐµ Ð½Ð°ÑÐ¸ÑÐ½Ðµ Ð±ÑÑÐ¾Ð½Ð° OK, Ð½Ð¾ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐ½Ð¾ ÑÐµ Ð·Ð°Ð¿Ð¾ÑÐ½Ðµ Ð¿ÑÐ¾ÑÐµÑÐ° Ð½Ð° Ð´Ð¾Ð·Ð¸ÑÐ°Ð½Ðµ.",
            skipRemoveCanDialog:
                "ÐÑÐ¸ Ð²ÐºÐ»ÑÑÐ²Ð°Ð½Ðµ Ð½Ð° ÑÐ°Ð·Ð¸ Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ°, Ð´Ð¾Ð·Ð°ÑÐ¾ÑÑÑ Ð½ÑÐ¼Ð° Ð´Ð° Ð¸Ð·ÑÐ°ÐºÐ° Ð¿ÑÐ¸ Ð¸Ð·Ð²Ð°Ð¶Ð´Ð°Ð½Ðµ Ð½Ð° Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ°ÑÐ°, Ð´Ð¾ÐºÐ°ÑÐ¾ ÑÐµ Ð½Ð°ÑÐ¸ÑÐ½Ðµ Ð±ÑÑÐ¾Ð½Ð° OK, Ð½Ð¾ ÑÐµ ÑÑÐ¸ÑÐ°, ÑÐµ Ð¿ÑÐ¾ÑÐµÑÑÑ Ð½Ð° Ð´Ð¾Ð·Ð¸ÑÐ°Ð½Ðµ Ðµ Ð·Ð°Ð²ÑÑÑÐµÐ½ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐ½Ð¾.",
            smartPurgeType:
                "Ð¢Ð¸Ð¿ÑÑ Ð½Ð° Ð¿ÑÐ¾ÑÐ¸ÑÑÐ²Ð°Ð½Ðµ Ð¼Ð¾Ð¶Ðµ Ð´Ð° Ð¾Ð±Ð¼Ð¸ÑÐ»Ð¸ ÑÐ°Ð¼Ð¾ Ð´Ð¾Ð·Ð¸ÑÐ°Ð½Ðµ Ð¸Ð»Ð¸ Ð´Ð¾Ð·Ð¸ÑÐ°Ð½Ðµ Ð¿Ð»ÑÑ Ð´ÑÑÐ³Ð¸ ÑÑÐ±Ð¸ÑÐ¸Ñ Ð½Ð° Ð¿ÑÐ¾ÑÐ¸ÑÑÐ²Ð°Ð½Ðµ, ÐºÐ¾Ð¸ÑÐ¾ Ð²Ð°Ð»Ð¸Ð´Ð¸ÑÐ°, Ð°ÐºÐ¾ Ðµ Ð½ÐµÐ¾Ð±ÑÐ¾Ð´Ð¸Ð¼Ð¾ Ð¸Ð½ÑÐµÐ»Ð¸Ð³ÐµÐ½ÑÐ½Ð¾ Ð¿ÑÐ¾ÑÐ¸ÑÑÐ²Ð°Ð½Ðµ.",
            splitFormula:
                "ÐÐºÐ¾ Ð¸Ð·Ð¸ÑÐºÐ²Ð°Ð½Ð°ÑÐ° ÑÑÐ¾Ð¹Ð½Ð¾ÑÑ Ð½Ð° Ð¾ÑÐ²ÐµÑÐ¸ÑÐµÐ» Ð½Ð°Ð´Ð²Ð¸ÑÐ¸ Ð¼Ð°ÐºÑÐ¸Ð¼Ð°Ð»Ð½Ð°ÑÐ° ÑÑÐ¼Ð° Ð·Ð° Ð´Ð¾Ð·Ð¸ÑÐ°Ð½Ðµ, Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ°ÑÐ° Ð¿Ð¾Ð·Ð²Ð¾Ð»ÑÐ²Ð° Ð´Ð° ÑÐµ Ð¾ÑÐ²Ð¾Ð±Ð¾Ð´Ð¸ Ð´Ð¾Ð·Ð° Ð¾ÑÐ²ÐµÑÐ¸ÑÐµÐ», Ð´Ð° ÑÐµ Ð½Ð°Ð¿ÑÐ»Ð½Ð¸ ÐºÐ¾Ð½ÑÐµÐ¹Ð½ÐµÑÐ° Ð¸ ÑÐ»ÐµÐ´ ÑÐ¾Ð²Ð° Ð´Ð° ÑÐµ Ð¿ÑÐ¾Ð´ÑÐ»Ð¶Ð¸ Ð¿Ð¾Ð´Ð°Ð²Ð°Ð½ÐµÑÐ¾ Ð½Ð° Ð¾ÑÑÐ°Ð½Ð°Ð»Ð¾ÑÐ¾ ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾.",
            tintometricSystem:
                "Tintometric system (set of available colorants) defines what colorants and formulas will be available in the application and application settings.",
            validateBarcodeBaseCan:
                "ÐÐ°Ð·Ð°ÑÐ° Ð¼Ð¾Ð¶Ðµ Ð´Ð° ÑÐµ Ð²Ð°Ð»Ð¸Ð´Ð¸ÑÐ° ÑÑÐµÐ· Ð±Ð°ÑÐºÐ¾Ð´, Ð¿ÑÐµÐ´Ð¸ Ð´Ð° ÑÐµ ÑÐ°Ð·ÑÐµÑÐ¸ Ð´Ð¾Ð·Ð¸ÑÐ°Ð½ÐµÑÐ¾. ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ°ÑÐ° Ð³Ð°ÑÐ°Ð½ÑÐ¸ÑÐ°, ÑÐµ ÑÐµ Ð¸Ð·Ð¿Ð¾Ð»Ð·Ð²Ð° Ð¿ÑÐ°Ð²Ð¸Ð»Ð½Ð°ÑÐ° Ð±Ð°Ð·Ð°.",
            validateColorantsDuringInit:
                "The machine configuration will be compared to the database each time when RCC is restarted. In case of mismatches, a notification occurs."
        },
        matchingSettings: {
            matchingInformation: "On matching result panel, %{item} will be available.",
            matchingOptionsColorants: "On matching options panel, colorants panel will be available.",
            matchingOptionsColorfile: "On matching options panel, colorfile selectbox will be available.",
            matchingOptionsSortResults: "On matching options panel, sort results selectbox will be available.",
            matchingRowCount: "Defines how many results should be offered after matching."
        },
        navigation: {
            barcodeScan: "Opens a window with the possibility to enter the barcode manually.",
            canisterBarcodes:
                "ÐÑÐ²Ð°ÑÑ Ð¿ÑÐ¾Ð·Ð¾ÑÐµÑ Ñ Ð¿ÑÐµÐ³Ð»ÐµÐ´ Ð½Ð° Ð±Ð°ÑÐºÐ¾Ð´ Ð½Ð° ÐºÐ°Ð½Ð¸ÑÑÑÑ Ð¸ Ð²ÑÐ·Ð¼Ð¾Ð¶Ð½Ð¾ÑÑ Ð·Ð° Ð·Ð°Ð´Ð°Ð²Ð°Ð½Ðµ Ð½Ð° Ð±Ð°ÑÐºÐ¾Ð´ Ð½Ð° ÐºÐ°Ð½Ð¸ÑÑÑÑ.",
            canisterLevel:
                "ÐÑÐ²Ð°ÑÑ Ð¿ÑÐ¾Ð·Ð¾ÑÐµÑ Ñ Ð¿ÑÐµÐ³Ð»ÐµÐ´ Ð½Ð° Ð½Ð¸Ð²Ð°ÑÐ° Ð½Ð° ÐºÑÑÐ¸ÑÑÐ° Ð¸ Ð²ÑÐ·Ð¼Ð¾Ð¶Ð½Ð¾ÑÑÑÐ° Ð·Ð° Ð·Ð°Ð´Ð°Ð²Ð°Ð½Ðµ Ð½Ð° Ð½Ð¸Ð²Ð¾ Ð½Ð° ÐºÑÑÐ¸ÑÑÐ°.",
            canisters: "ÐÑÐ²Ð°ÑÑ Ð¿Ð°Ð½ÐµÐ» Ñ Ð¿ÑÐµÐ³Ð»ÐµÐ´ Ð½Ð° Ð½Ð¸Ð²Ð°ÑÐ° Ð½Ð° ÐºÑÑÐ¸ÑÑÐ° Ð¸ Ð²ÑÐ·Ð¼Ð¾Ð¶Ð½Ð¾ÑÑ Ð·Ð° Ð·Ð°Ð´Ð°Ð²Ð°Ð½Ðµ Ð½Ð° Ð½Ð¸Ð²Ð¾ Ð½Ð° ÐºÐ°Ð½Ð¸ÑÑÑÐ°ÑÐ°.",
            clean: "Open a window with the possibility to clean machine channels",
            colorPanel: "ÐÑÐ²Ð°ÑÑ Ð¿Ð°Ð½ÐµÐ» Ñ Ð²ÑÐ·Ð¼Ð¾Ð¶Ð½Ð¾ÑÑ Ð·Ð° ÑÑÑÑÐµÐ½Ðµ Ð½Ð° Ð½Ð¾Ð²Ð° ÑÐ¾ÑÐ¼ÑÐ»Ð° Ð² ÐµÐ»ÐµÐºÑÑÐ¾Ð½ÐµÐ½ ÑÐ°Ð½Ð´ÐµÐº.",
            colorSearchTab: "Opens a panel with possibility to search all colors in all fandecks.",
            colorantRefillHistory: "ÐÑÐ²Ð°ÑÑ Ð¿ÑÐ¾Ð·Ð¾ÑÐµÑ Ñ Ð¿ÑÐµÐ³Ð»ÐµÐ´ Ð½Ð° Ð¸Ð·Ð¿ÑÐ»Ð½ÐµÐ½Ð¸ÑÐµ Ð¿ÑÐ»Ð½Ð¸ÑÐµÐ»Ð¸ Ð½Ð° ÐºÑÑÐ¸Ð¸.",
            customFormula: "ÐÑÐ²Ð°ÑÑ Ð¿Ð°Ð½ÐµÐ» Ñ Ð²ÑÐ·Ð¼Ð¾Ð¶Ð½Ð¾ÑÑ Ð·Ð° ÑÑÐ·Ð´Ð°Ð²Ð°Ð½Ðµ Ð½Ð° Ð½Ð¾Ð²Ð° Ð¿ÐµÑÑÐ¾Ð½Ð°Ð»Ð¸Ð·Ð¸ÑÐ°Ð½Ð° ÑÐ¾ÑÐ¼ÑÐ»Ð°.",
            customers: "ÐÑÐ²Ð°ÑÑ Ð¿Ð°Ð½ÐµÐ» Ñ Ð¿ÑÐµÐ³Ð»ÐµÐ´ Ð½Ð° ÐºÐ»Ð¸ÐµÐ½ÑÐ¸ÑÐµ Ð¸ Ð²ÑÐ·Ð¼Ð¾Ð¶Ð½Ð¾ÑÑ Ð·Ð° Ð´Ð¾Ð±Ð°Ð²ÑÐ½Ðµ / ÑÐµÐ´Ð°ÐºÑÐ¸ÑÐ°Ð½Ðµ / Ð¸Ð·ÑÑÐ¸Ð²Ð°Ð½Ðµ.",
            dispensingHistory: "ÐÑÐ²Ð°ÑÑ Ð¿Ð°Ð½ÐµÐ» Ñ Ð¿ÑÐµÐ³Ð»ÐµÐ´ Ð½Ð° Ð¸Ð·Ð²ÑÑÑÐµÐ½Ð¸ÑÐµ Ð´Ð¾Ð·Ð¸.",
            favorites: "ÐÑÐ²Ð°ÑÑ Ð¿Ð°Ð½ÐµÐ» Ñ Ð²ÑÐ·Ð¼Ð¾Ð¶Ð½Ð¾ÑÑ Ð·Ð° Ð¸Ð·Ð±Ð¾Ñ Ð½Ð° Ð»ÑÐ±Ð¸Ð¼Ð° ÑÐ¾ÑÐ¼ÑÐ»Ð°.",
            help: "ÐÑÐ²Ð°ÑÑ Ð¿ÑÐ¾Ð·Ð¾ÑÐµÑ Ñ Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ Ð·Ð° Ð¾Ð±ÑÐ»ÑÐ¶Ð²Ð°Ð½Ðµ Ð½Ð° ÐºÐ»Ð¸ÐµÐ½ÑÐ¸, Ð°ÐºÐ¾ Ðµ Ð¿ÑÐµÐ´Ð¾ÑÑÐ°Ð²ÐµÐ½ Ð¾Ñ Ð´Ð¾ÑÑÐ°Ð²ÑÐ¸ÐºÐ°.",
            hideItems: "Opens a window with the possibility to mark products and fandecks as hidden.",
            historyOfOrders: "ÐÐ°Ð¶Ð¸ Ð¸Ð·ÐºÐ»ÑÑÐ¸ÑÐµÐ»Ð½Ð¾ Ð·Ð° %{name}, Ð¾ÑÐ²Ð°ÑÑ Ð¿Ð°Ð½ÐµÐ» Ñ Ð¿ÑÐµÐ³Ð»ÐµÐ´ Ð½Ð° ÑÐ°Ð·Ð´Ð°Ð´ÐµÐ½Ð¸ÑÐµ Ð¿Ð¾ÑÑÑÐºÐ¸.",
            machineReset: "ÐÐ°Ð¿Ð¾ÑÐ²Ð° Ð½ÑÐ»Ð¸ÑÐ°Ð½Ðµ Ð½Ð° ÑÐ°Ð·Ð¿ÑÐµÐ´ÐµÐ»Ð¸ÑÐµÐ»Ñ.",
            matching: "Opens a panel with the possibility to match new color with a spectro.",
            myOrders: "ÐÐ¾ÑÑÑÐºÐ¸, ÐºÐ¾Ð¸ÑÐ¾ ÑÐ° Ð±Ð¸Ð»Ð¸ Ð¸Ð·Ð¿ÑÐ°ÑÐµÐ½Ð¸ Ð¾Ñ ÑÐ¾Ð·Ð¸ ÐºÐ¾Ð¼Ð¿ÑÑÑÑ",
            purge: "ÐÑÐ²Ð°ÑÑ Ð¿ÑÐ¾Ð·Ð¾ÑÐµÑ Ñ Ð²ÑÐ·Ð¼Ð¾Ð¶Ð½Ð¾ÑÑ Ð·Ð° Ð·Ð°Ð´Ð°Ð²Ð°Ð½Ðµ Ð½Ð° Ð¿ÑÐ¾Ð´ÑÑÐ²Ð°Ð½Ðµ Ð½Ð° ÐºÑÑÐ¸Ð¸.",
            quickTint: "ÐÑÐ²Ð°ÑÑ Ð¿ÑÐ¾Ð·Ð¾ÑÐµÑ Ñ Ð²ÑÐ·Ð¼Ð¾Ð¶Ð½Ð¾ÑÑ Ð·Ð° ÑÑÑÐ½Ð¾ Ð¿Ð¾Ð´Ð°Ð²Ð°Ð½Ðµ.",
            searchFormula: "ÐÑÐ²Ð°ÑÑ Ð¿Ð°Ð½ÐµÐ» Ñ Ð²ÑÐ·Ð¼Ð¾Ð¶Ð½Ð¾ÑÑ Ð·Ð° ÑÑÑÑÐµÐ½Ðµ Ð½Ð° Ð½Ð¾Ð²Ð° ÑÐ¾ÑÐ¼ÑÐ»Ð°.",
            spectro: "ÐÑÐ²Ð°ÑÑ Ð¿Ð°Ð½ÐµÐ» Ñ Ð²ÑÐ·Ð¼Ð¾Ð¶Ð½Ð¾ÑÑ Ð·Ð° Ð¸Ð·Ð¼ÐµÑÐ²Ð°Ð½Ðµ ÑÑÑ ÑÐ¿ÐµÐºÑÑÐ¾.",
            stir: "ÐÑÐ²Ð°ÑÑ Ð¿ÑÐ¾Ð·Ð¾ÑÐµÑ Ñ Ð²ÑÐ·Ð¼Ð¾Ð¶Ð½Ð¾ÑÑ Ð·Ð° Ð½Ð°ÑÑÑÐ¾Ð¹Ð²Ð°Ð½Ðµ Ð½Ð° ÑÐ°Ð·Ð±ÑÑÐºÐ²Ð°Ð½Ðµ Ð½Ð° ÐºÐ°Ð½Ð¸ÑÑÑÐ°ÑÐ°.",
            ticketing: "Opens a ticketing system panel.",
            toDispense: "ÐÐ¾ÑÑÑÐºÐ¸, ÐºÐ¾Ð¸ÑÐ¾ ÑÐ° Ð±Ð¸Ð»Ð¸ Ð¿Ð¾Ð»ÑÑÐµÐ½Ð¸ Ð¾Ñ ÑÐ¾Ð·Ð¸ ÐºÐ¾Ð¼Ð¿ÑÑÑÑ"
        },
        noHelpForLicense: "ÐÐµ Ðµ  Ð´Ð¾ÑÑÑÐ¿Ð½Ð° Ð¿Ð¾Ð¼Ð¾Ñ Ð·Ð° Ð»Ð¸ÑÐµÐ½Ð·Ð° Ð²Ð¸, Ð¿Ð¾ÑÑÐ²ÐµÑÐ²Ð°Ð¹ÑÐµ ÑÐµ Ñ ÐÐ°ÑÐ¸Ñ Ð´Ð¾ÑÑÐ°Ð²ÑÐ¸Ðº, Ð·Ð° Ð´Ð° Ð³Ð¾ Ð´Ð¾Ð±Ð°Ð²Ð¸ÑÐµ.",
        posInfo: {
            sync: "Ð¡Ð¸Ð½ÑÑÐ¾Ð½Ð¸Ð·Ð¸ÑÐ° Ð´Ð°Ð½Ð½Ð¸ÑÐµ Ñ ÑÐ°Ð·Ð´ÐµÐ»Ð° Ð ÐµÐ³Ð¸ÑÑÑÐ°ÑÐ¸Ñ"
        },
        poweredByDeso: "ÐÑÑÑÐµÑÑÐ²ÐµÐ½Ð¾ Ð¾Ñ %{name}",
        priceSettings: {
            VatPrice: "ÐÐÐ¡ Ð½Ð° Ð¾ÑÐ²ÐµÑÐ¸ÑÐµÐ» Ð² %",
            VatPriceProduct: "The generic product VAT will be the same for every colorant. Set in %.",
            basePurchase: "ÐÐ¾ÐºÑÐ¿Ð½Ð° ÑÐµÐ½Ð° Ð·Ð° Ð±Ð°Ð·Ð° (Ð²ÐºÐ». ÐÐ°Ð·Ð° Ð¸Ð·ÐºÐ»ÑÑÐ¸ÑÐµÐ»Ð½Ð¾).",
            basePurchasePriceProduct: "Purchase price for the package of the given base. Set in selected currency.",
            baseSell: "ÐÑÐ¾Ð´Ð°Ð¶Ð½Ð°ÑÐ° ÑÐµÐ½Ð°, ÑÐ°Ð¼Ð¾ Ð·Ð° Ð±Ð°Ð·Ð° (Ð²ÐºÐ». Ð±Ð°Ð·Ð° Ð¸ Ð¼Ð°ÑÐ¶ / Ð·Ð° Ð½Ð°Ð´ÑÐµÐ½ÐºÐ°).",
            baseSellFull: "Sell full price for base.",
            cntName: "Defines which colorant the price is related to.",
            cntPurchase: "ÐÐ¾ÐºÑÐ¿Ð½Ð°ÑÐ° ÑÐµÐ½Ð° Ð·Ð° Ð¾ÑÐ²ÐµÑÐ¸ÑÐµÐ»Ð¸ (Ð²ÐºÐ». Ð¾ÑÐ²ÐµÑÐ¸ÑÐµÐ»Ð¸ Ð¸Ð·ÐºÐ»ÑÑÐ¸ÑÐµÐ»Ð½Ð¾).",
            cntPurchaseByName:
                "ÐÐ¾ÐºÑÐ¿Ð½Ð°ÑÐ° ÑÐµÐ½Ð° Ð·Ð° Ð¾ÑÐ²ÐµÑÐ¸ÑÐµÐ»Ð¸, Ð¸Ð·ÑÐ¸ÑÐ»ÐµÐ½Ð¸ Ð¿Ð¾Ð¾ÑÐ´ÐµÐ»Ð½Ð¾ Ð·Ð° Ð²ÑÐµÐºÐ¸ (Ð²ÐºÐ». Ð¾ÑÐ²ÐµÑÐ¸ÑÐµÐ»Ð¸ Ð¸Ð·ÐºÐ»ÑÑÐ¸ÑÐµÐ»Ð½Ð¾).",
            cntPurchasePricePerLiter: "Ð¡ÐµÐ±ÐµÑÑÐ¾Ð¹Ð½Ð¾ÑÑÑÐ° Ð½Ð° Ð¾ÑÐ²ÐµÑÐ¸ÑÐµÐ» Ð·Ð° Ð»Ð¸ÑÑÑ (Ð±ÐµÐ· Ð¼Ð°ÑÐ¶ Ð¸Ð»Ð¸ Ð½Ð°Ð´ÑÐµÐ½ÐºÐ°).",
            cntSell: "ÐÑÐ¾Ð´Ð°Ð¶Ð½Ð°ÑÐ° ÑÐµÐ½Ð°, ÑÐ°Ð¼Ð¾ Ð·Ð° Ð¾ÑÐ²ÐµÑÐ¸ÑÐµÐ»Ð¸ (Ð²ÐºÐ». Ð¾ÑÐ²ÐµÑÐ¸ÑÐµÐ»Ð¸ Ð¸ Ð¼Ð°ÑÐ¶ / Ð½Ð°Ð´ÑÐµÐ½ÐºÐ°).",
            cntSellByName:
                "ÐÑÐ¾Ð´Ð°Ð¶Ð½Ð°ÑÐ° ÑÐµÐ½Ð° Ð·Ð° Ð²ÑÐ¸ÑÐºÐ¸ Ð¾ÑÐ²ÐµÑÐ¸ÑÐµÐ»Ð¸, Ð¸Ð·Ð¿Ð¾Ð»Ð·Ð²Ð°Ð½Ð¸ Ð² Ð¿ÑÐ¾Ð´ÑÐºÑÐ° Ð¸Ð·ÑÐ¸ÑÐ»ÑÐ²Ð°Ð½Ð¸ Ð¸Ð½Ð´Ð¸Ð²Ð¸Ð´ÑÐ°Ð»Ð½Ð¾ Ð·Ð° Ð²ÑÐµÐºÐ¸ (Ð²ÐºÐ». Ð¾ÑÐ²ÐµÑÐ¸ÑÐµÐ»Ð¸ Ð¸ Ð¼Ð°ÑÐ¶ / Ð½Ð°Ð´ÑÐµÐ½ÐºÐ°).",
            cntSellFull: "Sell full price for colorants.",
            cntSellFullByName: "Sell full price for colorants by name.",
            cntSellPricePerLiter:
                "The sell price of the colorant per liter (incl. colorant exclusively). Set in the selected currency.",
            cntVat: "Colorant VAT value set in %.",
            colorants:
                "ÐÐ±ÑÐ¸ÑÐµ ÑÐµÐ½Ð¸ Ð·Ð° Ð¾ÑÐ²ÐµÑÐ¸ÑÐµÐ» ÑÐµ Ð±ÑÐ´Ð°Ñ ÐµÐ´Ð½Ð¸ Ð¸ ÑÑÑÐ¸ Ð·Ð° Ð²ÑÐµÐºÐ¸ Ð¾ÑÐ²ÐµÑÐ¸ÑÐµÐ». Ð¢Ð°Ð·Ð¸ ÑÑÐ½ÐºÑÐ¸Ñ Ðµ Ð¿Ð¾Ð»ÐµÐ·Ð½Ð°, Ð¾ÑÐ¾Ð±ÐµÐ½Ð¾ Ð·Ð° Ð¾Ð¿ÑÐµÐ´ÐµÐ»ÑÐ½Ðµ Ð½Ð° ÐÐÐ¡.",
            colorantsPosCoeficient: "The generic colorant coeficient for POS.",
            colorantsSellPrice:
                "The generic colorant prices will be the same for every colorant. Sell price is recommended to by modified by discount. Set in selected currency.",
            currencyCodeNew: "ÐÐ¾Ð´ÑÑ Ð½Ð° Ð²Ð°Ð»ÑÑÐ°ÑÐ° ÑÑÑÐ±Ð²Ð° Ð´Ð° Ð±ÑÐ´Ðµ Ð² Ð¾ÑÐ¸ÑÐ¸Ð°Ð»Ð½Ð¸Ñ ÑÐ¾ÑÐ¼Ð°Ñ Ð¾Ñ ÑÑÐ¸ Ð±ÑÐºÐ²Ð¸, Ð½Ð°Ð¿ÑÐ¸Ð¼ÐµÑ EUR.",
            currencyNameNew: "ÐÐ¼ÐµÑÐ¾ Ð½Ð° Ð²Ð°Ð»ÑÑÐ°, Ð½Ð°Ð¿ÑÐ¸Ð¼ÐµÑ Euro.",
            currencyRateNew:
                "ÐÐ±Ð¼ÐµÐ½Ð½Ð¸ÑÑ ÐºÑÑÑ ÐºÑÐ¼ Ð¾ÑÐ½Ð¾Ð²Ð½Ð°ÑÐ° Ð²Ð°Ð»ÑÑÐ°, Ð½Ð°Ð¿ÑÐ¸Ð¼ÐµÑ 25,855 CZK Ð·Ð° â¬1. ÐÑÑÑÑÑ ÑÑÑÐ±Ð²Ð° Ð´Ð° ÑÐµ Ð°ÐºÑÑÐ°Ð»Ð¸Ð·Ð¸ÑÐ° Ð½ÐµÐ¿ÑÐµÐºÑÑÐ½Ð°ÑÐ¾, Ð·Ð° Ð´Ð° ÑÐµ Ð¿Ð¾Ð´Ð´ÑÑÐ¶Ð° Ð²Ð°Ð»Ð¸Ð´ÐµÐ½.",
            currencyRoundingNew:
                "ÐÐ°ÐºÑÑÐ³Ð»ÑÐ²Ð°Ð½ÐµÑÐ¾ Ð·Ð°Ð´Ð°Ð²Ð° Ð½Ð°Ð¹-Ð¼Ð°Ð»ÐºÐ°ÑÐ° Ð²ÑÐ·Ð¼Ð¾Ð¶Ð½Ð° Ð´ÑÐ»Ð¶Ð¸Ð¼Ð° ÑÑÐ¾Ð¹Ð½Ð¾ÑÑ Ð½Ð° Ð²Ð°Ð»ÑÑÐ°ÑÐ°, Ð½Ð°Ð¿ÑÐ¸Ð¼ÐµÑ Euro Ð¸Ð¼Ð° Ð·Ð°ÐºÑÑÐ³Ð»ÑÐ²Ð°Ð½Ðµ 0,01, Ð·Ð°ÑÐ¾ÑÐ¾ Ð½Ð°Ð¹-Ð¼Ð°Ð»ÐºÐ°ÑÐ° Ð²ÑÐ·Ð¼Ð¾Ð¶Ð½Ð° ÑÑÐ¾Ð¹Ð½Ð¾ÑÑ Ðµ 1 ÑÐµÐ½Ñ.",
            currencySymbolNew: "ÐÑÐ¸ÑÐ¸Ð°Ð»Ð½Ð¸ÑÑ ÑÐ¸Ð¼Ð²Ð¾Ð» Ð½Ð° Ð²Ð°Ð»ÑÑÐ°ÑÐ°, Ð½Ð°Ð¿ÑÐ¸Ð¼ÐµÑ â¬ Ð·Ð° ÐµÐ²ÑÐ¾.",
            defaultPrice: "Ð¦ÐµÐ½Ð° Ð½Ð° ÐºÐ¾Ð»Ð¾ÑÐ°Ð½Ñ, Ð·Ð°Ð´Ð°Ð´ÐµÐ½Ð° Ð² Ð¸Ð·Ð±ÑÐ°Ð½Ð°ÑÐ° Ð±Ð°Ð·Ð° Ð´Ð°Ð½Ð½Ð¸ (Ð±ÐµÐ· ÐÐÐ¡).",
            defaultPriceGroup: "Ð¦ÐµÐ½Ð° Ð½Ð° ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ° Ð·Ð° ÑÐµÐ½Ð¾Ð²Ð° Ð³ÑÑÐ¿Ð°, ÑÑÐ·Ð´Ð°Ð´ÐµÐ½Ð° Ð² Ð¸Ð·Ð±ÑÐ°Ð½Ð°ÑÐ° Ð±Ð°Ð·Ð° Ð´Ð°Ð½Ð½Ð¸ (Ð±ÐµÐ· ÐÐÐ¡).",
            defaultVatPrice: "ÐÐ¿ÑÐµÐ´ÐµÐ»Ñ  ÐÐÐ¡ Ð½Ð° ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ° Ð² Ð¸Ð·Ð±ÑÐ°Ð½Ð°ÑÐ° Ð±Ð°Ð·Ð° Ð´Ð°Ð½Ð½Ð¸.",
            discountHeader: "Discount substracts the the defined value from the purchase colorant price. Set in %.",
            discountHeaderProduct:
                "Discount substracts the the defined value from the product colorant price. Set in %.",
            export: "Export a file with the currently inserted prices. It can be imported again after having modified the prices.",
            import: "Import a correctly formated (exported) file to insert or modify the prices.",
            localPrices:
                "Local prices change suggested prices from the main database and are present solely locally on this particular computer.",
            margin: "Choose which price calculation should be used for the definition of the final available price. Margin and markup add up to whereas discount substracts from the given sell price.",
            marginAll: "Ð¦ÐµÐ½Ð°ÑÐ° Ð·Ð° Ð¼Ð°ÑÐ¶ / Ð½Ð°Ð´ÑÐµÐ½ÐºÐ° Ð·Ð° Ð¼Ð½Ð¾Ð¶ÐµÑÑÐ²Ð¾ Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ¸ (Ð²ÐºÐ». Ð¼Ð°ÑÐ¶ / Ð½Ð°Ð´ÑÐµÐ½ÐºÐ°).",
            marginHeader: "Margin adds the defined value up to the purchase colorant price. Set in %.",
            marginHeaderProduct: "Margin adds the defined value up to the purchase product price. Set in %.",
            marginPerPkg: "Ð¦ÐµÐ½Ð°ÑÐ° Ð·Ð° Ð¼Ð°ÑÐ¶ / Ð½Ð°Ð´ÑÐµÐ½ÐºÐ° Ð·Ð° ÐµÐ´Ð¸Ð½ Ð¿Ð°ÐºÐµÑ (Ð²ÐºÐ». Ð¼Ð°ÑÐ¶ / Ð½Ð°Ð´ÑÐµÐ½ÐºÐ°).",
            markupHeader: "Markup adds the defined value up to the purchase colorant price. Set in %.",
            markupHeaderProduct: "Markup adds the defined value up to the purchase product price. Set in %.",
            packagePricing: "ÐÐ¾Ð¿ÑÐ»Ð½Ð¸ÑÐµÐ»Ð½Ð° ÑÐ°ÐºÑÐ° Ð¾Ð¿ÑÐµÐ´ÐµÐ»ÐµÐ½Ð° Ð·Ð° Ð²ÑÐµÐºÐ¸ Ð¾ÑÐ´ÐµÐ»ÐµÐ½ ÑÐ°Ð·Ð¼ÐµÑ Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ°.",
            packageSurcharge: "ÐÐ±ÑÐ¸ÑÐµ Ð¿Ð°ÐºÐµÑÐ½Ð¸ ÑÐµÐ½Ð¸ ÑÐµ Ð±ÑÐ´Ð°Ñ ÐµÐ´Ð½Ð°ÐºÐ²Ð¸ Ð·Ð° Ð²ÑÑÐºÐ° Ð´Ð¾Ð¿ÑÐ»Ð½Ð¸ÑÐµÐ»Ð½Ð° ÑÐ°ÐºÑÐ°.",
            priceDefinition: "The setting defines which price types are used when calculating final prices.",
            priceGroupNumber:
                "The setting defines how many price groups will be used. The range for individual price groups can be set in Default Values.",
            priceGroupPricePerLiter: "Ð¦ÐµÐ½Ð°ÑÐ° Ð½Ð° Ð¾ÑÐ²ÐµÑÐ¸ÑÐµÐ», Ð¸Ð·Ð¿Ð¾Ð»Ð·Ð²Ð°Ð½Ð° Ð¿ÑÐ¸ Ð¸Ð·ÑÐ¸ÑÐ»ÑÐ²Ð°Ð½Ðµ Ð½Ð° ÑÐµÐ½Ð°ÑÐ° Ð½Ð° ÑÐµÐ½Ð¾Ð²Ð°ÑÐ° Ð³ÑÑÐ¿Ð°.",
            priceGroups:
                "Ð¦ÐµÐ½Ð¾Ð²Ð¸ Ð³ÑÑÐ¿Ð¸ Ð¿Ð¾ÐºÐ°Ð·Ð²Ð° Ð½Ð¾Ð¼ÐµÑÐ° Ð½Ð° ÑÑÐ¾ÑÐ²ÐµÑÐ½Ð°ÑÐ° ÑÐµÐ½Ð¾Ð²Ð° Ð³ÑÑÐ¿Ð° (Ð³ÑÐ°Ð½Ð¸ÑÐ¸ÑÐµ ÑÐ° Ð·Ð°Ð´Ð°Ð´ÐµÐ½Ð¸ Ð² Ð±Ð°Ð·Ð°ÑÐ° Ð´Ð°Ð½Ð½Ð¸ Ð¸Ð»Ð¸ Ð² Ð¾Ð±ÑÐ¸ÑÐµ ÑÐµÐ½Ð¸).",
            priceGroupsEnabled:
                "The setting allows you to work with price groups. Define the range in Default Values and individual prices in Colorant Pricing.",
            priceGroupsGeneric:
                "Ð¦ÐµÐ½Ð¾Ð²Ð¸ÑÐµ Ð³ÑÑÐ¿Ð¸ ÑÐ° ÑÐµÐ½Ð¾Ð²Ð¸ Ð¸Ð½ÑÐµÑÐ²Ð°Ð»Ð¸ Ð½Ð° ÑÐ¸Ð½Ð°Ð»Ð½Ð°ÑÐ° Ð±Ð¾Ñ Ð½Ð° Ð±Ð°Ð·Ð°ÑÐ°  ÑÐµÐ½Ð¸ Ð½Ð° Ð¾ÑÐ²ÐµÑÐ¸ÑÐµÐ»ÑÐµ Ð²ÑÐ² ÑÐ¾ÑÐ¼ÑÐ»Ð°ÑÐ°.",
            productBasePackageSellPrice: "Sell price for the package of the given base. Set in selected currency.",
            productBaseSellPrice:
                "Sell price for base calculated per liter (incl. base exclusively). Set in the selected currency.",
            productBaseVat: "Product base VAT value for the given package set in %.",
            productName: "Defines which product base the price is related to.",
            productPosCoeficient: "The generic product coeficient for POS.",
            productPricing: "ÐÐ¾ÐºÑÐ¿Ð½Ð° ÑÐµÐ½Ð° Ð·Ð° Ð²ÑÐ¸ÑÐºÐ¸ Ð¿Ð°ÐºÐµÑÐ¸ ÑÐµ Ð¸Ð·Ð¿Ð¾Ð»Ð·Ð²Ð° Ð¿ÑÐ¸ Ð¾ÑÐ²ÐµÑÑÐ²Ð°Ð½Ðµ Ð½Ð° Ð¿ÐµÑÑÐ¾Ð½Ð°Ð»Ð¸Ð·Ð¸ÑÐ°Ð½Ð¸ Ð¿Ð°ÐºÐµÑÐ¸.",
            productSize: "Defines which package of the given product base the price is related to.",
            productVat: "Product base VAT value set in %.",
            products:
                "ÐÐ±ÑÐ¸ÑÐµ ÑÐµÐ½Ð¸ Ð½Ð° Ð¿ÑÐ¾Ð´ÑÐºÑÐ¸ÑÐµ ÑÐµ Ð±ÑÐ´Ð°Ñ ÐµÐ´Ð½Ð°ÐºÐ²Ð¸ Ð·Ð° Ð²ÑÐµÐºÐ¸ Ð¿ÑÐ¾Ð´ÑÐºÑ. Ð¢Ð°Ð·Ð¸ ÑÑÐ½ÐºÑÐ¸Ñ Ðµ Ð¿Ð¾Ð»ÐµÐ·Ð½Ð° ÑÐ¿ÐµÑÐ¸Ð°Ð»Ð½Ð¾ Ð·Ð° Ð·Ð°Ð´Ð°Ð²Ð°Ð½Ðµ Ð½Ð° ÐÐÐ¡.",
            productsSellPrice:
                "The generic product prices will be the same for every colorant. Sell price is recommended to by modified by discount. Set in selected currency.",
            sellPriceAll:
                "ÐÑÐ¾Ð´Ð°Ð¶Ð½Ð°ÑÐ° ÑÐµÐ½Ð° Ð½Ð° Ð¼Ð½Ð¾Ð¶ÐµÑÑÐ²Ð¾ Ð¿Ð°ÐºÐµÑÐ¸ (Ð²ÐºÐ». Ð±Ð°Ð·Ð°, Ð¾ÑÐ²ÐµÑÐ¸ÑÐµÐ»Ð¸, Ð´Ð¾Ð¿ÑÐ»Ð½Ð¸ÑÐµÐ»Ð½Ð° ÑÐ°ÐºÑÐ° Ð¸ Ð¼Ð°ÑÐ¶/Ð½Ð°Ð´ÑÐµÐ½ÐºÐ°).",
            sellPricePerKg:
                "Ð¿ÑÐ¾Ð´Ð°Ð¶Ð½Ð°ÑÐ° ÑÐµÐ½Ð° Ð½Ð° Ð¿ÑÐ¾Ð´ÑÐºÑÐ° Ð·Ð° ÐºÐ¸Ð»Ð¾Ð³ÑÐ°Ð¼ (Ð²ÐºÐ». Ð±Ð°Ð·Ð°, Ð¾ÑÐ²ÐµÑÐ¸ÑÐµÐ»Ð¸, Ð´Ð¾Ð¿Ð»Ð°ÑÐ°Ð½Ðµ Ð¸ Ð¼Ð°ÑÐ¶ / Ð½Ð°Ð´ÑÐµÐ½ÐºÐ°).",
            sellPricePerL: "Ð¿ÑÐ¾Ð´Ð°Ð¶Ð½Ð°ÑÐ° ÑÐµÐ½Ð° Ð½Ð° Ð¿ÑÐ¾Ð´ÑÐºÑÐ° Ð½Ð° Ð»Ð¸ÑÑÑ (Ð²ÐºÐ». Ð±Ð°Ð·Ð°, Ð¾ÑÐ²ÐµÑÐ¸ÑÐµÐ»Ð¸, Ð´Ð¾Ð¿Ð»Ð°ÑÐ°Ð½Ðµ Ð¸ Ð¼Ð°ÑÐ¶ / Ð½Ð°Ð´ÑÐµÐ½ÐºÐ°)",
            sellPricePerPkg: "Ð¿ÑÐ¾Ð´Ð°Ð¶Ð½Ð°ÑÐ° ÑÐµÐ½Ð° Ð½Ð° ÐµÐ´Ð¸Ð½ Ð¿Ð°ÐºÐµÑ (Ð²ÐºÐ». Ð±Ð°Ð·Ð°, Ð¾ÑÐ²ÐµÑÐ¸ÑÐµÐ»Ð¸, Ð´Ð¾Ð¿Ð»Ð°ÑÐ°Ð½Ðµ Ð¸ Ð¼Ð°ÑÐ¶ / Ð½Ð°Ð´ÑÐµÐ½ÐºÐ°)",
            setPriceTypesVisibilityAndOrder:
                "ÐÐ° Ð¿Ð°Ð½ÐµÐ»Ð° Ð·Ð° ÑÐ¾ÑÐ¼ÑÐ»Ð¸ Ð¸Ð·Ð±ÑÐ°Ð½Ð¸ÑÐµ ÑÐµÐ½Ð¸ ÑÐµ Ð±ÑÐ´Ð°Ñ Ð²Ð¸Ð´Ð¸Ð¼Ð¸ Ð² ÑÐµÐºÑÐ¸ÑÑÐ° Ð·Ð° ÑÐµÐ½Ð¸. ÐÐ°Ð¹-Ð²Ð¸ÑÐ¾ÐºÐ°ÑÐ° Ð¿Ð¾Ð·Ð¸ÑÐ¸Ñ ÑÑÐº Ð´ÐµÑÐ¸Ð½Ð¸ÑÐ° Ð½Ð°Ð¹-Ð»ÑÐ²Ð°ÑÐ° Ð¿Ð¾Ð·Ð¸ÑÐ¸Ñ Ð² ÑÐµÐºÑÐ¸ÑÑÐ°.",
            surchargeAll: "Ð¦ÐµÐ½Ð°ÑÐ° Ð½Ð° Ð´Ð¾Ð¿ÑÐ»Ð½Ð¸ÑÐµÐ»Ð½Ð° ÑÐ°ÐºÑÐ° Ð·Ð° Ð¼Ð½Ð¾Ð¶ÐµÑÑÐ²Ð¾ Ð¿Ð°ÐºÐµÑÐ¸ (Ð²ÐºÐ». ÐÐ¾Ð¿Ð»Ð°ÑÐ°Ð½Ðµ).",
            surchargePerPkg: "Ð¦ÐµÐ½Ð°ÑÐ° Ð½Ð° Ð´Ð¾Ð¿ÑÐ»Ð½Ð¸ÑÐµÐ»Ð½Ð° ÑÐ°ÐºÑÐ° Ð·Ð° ÐµÐ´Ð¸Ð½ Ð¿Ð°ÐºÐµÑ (Ð²ÐºÐ». ÐÐ¾Ð¿Ð»Ð°ÑÐ°Ð½Ðµ).",
            tintPurchaseAll:
                "ÐÐ¾ÐºÑÐ¿Ð½Ð°ÑÐ° ÑÐµÐ½Ð° Ð·Ð° ÑÐµÐ»Ð¸Ñ Ð¿ÑÐ¾ÑÐµÑ Ð·Ð° ÑÐ¾Ð½Ð¸ÑÐ°Ð½Ðµ Ð½Ð° Ð¼Ð½Ð¾Ð¶ÐµÑÑÐ²Ð¾ Ð¿Ð°ÐºÐµÑÐ¸ (Ð²ÐºÐ». ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ¸ Ð¸ Ð´Ð¾Ð¿Ð»Ð°ÑÐ°Ð½Ðµ).",
            tintPurchasePerPkg:
                "ÐÐ¾ÐºÑÐ¿Ð½Ð°ÑÐ° ÑÐµÐ½Ð° Ð·Ð° ÑÐµÐ»Ð¸Ñ Ð¿ÑÐ¾ÑÐµÑ Ð·Ð° ÑÐ¾Ð½Ð¸ÑÐ°Ð½Ðµ Ð½Ð° ÐµÐ´Ð¸Ð½ Ð¿Ð°ÐºÐµÑ (Ð²ÐºÐ». ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ¸ Ð¸ Ð´Ð¾Ð¿Ð»Ð°ÑÐ°Ð½Ðµ).",
            tintSellFullAll: "Tint sell full price for all packages.",
            tintlSellFullAllPerPackage: "Tint sell full price per package.",
            totalPurchaseAll: "ÐÐ±ÑÐ°ÑÐ° ÑÐµÐ½Ð° Ð½Ð° Ð·Ð°ÐºÑÐ¿ÑÐ²Ð°Ð½Ðµ Ð½Ð° Ð¿ÑÐ¾Ð´ÑÐºÑÐ° Ð·Ð° Ð¼Ð½Ð¾Ð¶ÐµÑÑÐ²Ð¾ Ð¿Ð°ÐºÐµÑÐ¸ (Ð²ÐºÐ». Ð±Ð°Ð·Ð¸ Ð¸ Ð¾ÑÐ²ÐµÑÐ¸ÑÐµÐ»Ð¸).",
            totalPurchasePerKg: "ÐÐ±ÑÐ°ÑÐ° ÑÐµÐ½Ð° Ð½Ð° Ð·Ð°ÐºÑÐ¿ÑÐ²Ð°Ð½Ðµ Ð½Ð° Ð¿ÑÐ¾Ð´ÑÐºÑÐ° Ð·Ð° ÐºÐ¸Ð»Ð¾Ð³ÑÐ°Ð¼ (Ð²ÐºÐ». ÐÐ°Ð·Ð° Ð¸ Ð¾ÑÐ²ÐµÑÐ¸ÑÐµÐ»Ð¸).",
            totalPurchasePerL: "ÐÐ±ÑÐ°ÑÐ° ÑÐµÐ½Ð° Ð½Ð° Ð·Ð°ÐºÑÐ¿ÑÐ²Ð°Ð½Ðµ Ð½Ð° Ð¿ÑÐ¾Ð´ÑÐºÑÐ° Ð½Ð° Ð»Ð¸ÑÑÑ (Ð²ÐºÐ». ÐÐ°Ð·Ð° Ð¸ Ð¾ÑÐ²ÐµÑÐ¸ÑÐµÐ»Ð¸).",
            totalPurchasePerPkg: "ÐÐ±ÑÐ°ÑÐ° Ð¿Ð¾ÐºÑÐ¿Ð½Ð° ÑÐµÐ½Ð° Ð½Ð° Ð¿ÑÐ¾Ð´ÑÐºÑÐ° Ð·Ð° ÐµÐ´Ð½Ð° Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ° (Ð²ÐºÐ». ÐÐ°Ð·Ð° Ð¸ Ð¾ÑÐ²ÐµÑÐ¸ÑÐµÐ»Ð¸).",
            totalSellFullAll: "Total sell full price for all packages.",
            totalSellFullPerKg: "Total sell full price per kilogram.",
            totalSellFullPerLiter: "Total sell full price per liter.",
            totalSellFullPerPackage: "Total sell full price per package.",
            withAndWithoutVat:
                "ÐÐ° Ð¿Ð°Ð½ÐµÐ»Ð° Ð¤Ð¾ÑÐ¼ÑÐ»Ð° ÑÐµÐ½Ð°ÑÐ° ÑÐµ Ð±ÑÐ´Ðµ Ð²Ð¸Ð´Ð¸Ð¼Ð° Ð¸ Ð² Ð´Ð²Ð°ÑÐ° Ð²Ð°ÑÐ¸Ð°Ð½ÑÐ°, ÑÑÑ Ð¸ Ð±ÐµÐ· ÐÐÐ¡ ÐµÐ´Ð½Ð¾Ð²ÑÐµÐ¼ÐµÐ½Ð½Ð¾.",
            withVat: "ÐÐ° Ð¿Ð°Ð½ÐµÐ»Ð° Ð¤Ð¾ÑÐ¼ÑÐ»Ð° Ð²ÑÐ¸ÑÐºÐ¸ ÑÐµÐ½Ð¸ ÑÐµ Ð±ÑÐ´Ð°Ñ Ð²Ð¸Ð´Ð¸Ð¼Ð¸ ÑÐ°Ð¼Ð¾ Ñ Ð²ÐºÐ»ÑÑÐµÐ½ ÐÐÐ¡.",
            withoutVat: "ÐÐ° Ð¿Ð°Ð½ÐµÐ»Ð° Ð¤Ð¾ÑÐ¼ÑÐ»Ð° Ð²ÑÐ¸ÑÐºÐ¸ ÑÐµÐ½Ð¸ ÑÐµ Ð±ÑÐ´Ð°Ñ Ð²Ð¸Ð´Ð¸Ð¼Ð¸ ÑÐ°Ð¼Ð¾ Ð±ÐµÐ· ÐÐÐ¡."
        },
        qualityControlSettings: {
            colorDifference: "Color difference model for quality control.",
            deltaA: "Defines tolerance limit for delta A in quality control.",
            deltaB: "Defines tolerance limit for delta B in quality control.",
            deltaE: "Defines tolerance limit for delta E in quality control.",
            deltaL: "Defines tolerance limit for delta L in quality control.",
            deltaMetamerism: "Defines tolerance limit for metamerism delta in quality control."
        },
        registration: {
            sync: "Ð¡Ð¸Ð½ÑÑÐ¾Ð½Ð¸Ð·Ð¸ÑÐ° Ð´Ð°Ð½Ð½Ð¸ÑÐµ ÑÑÑ ÑÐµÐºÑÐ¸ÑÑÐ° POS "
        },
        searchingPleaseWait: "Please wait, the best match is being searched for",
        setupSteps: {
            customData: "Custom Data",
            machineType: "Machine Type",
            userPreferences: "User Preferences"
        },
        spectroSettings: {
            ColorixNanoUseProfiledValues:
                "When using profiled values, the measured results are recalculated to remove the filter effect. Allow this option for universal spectro measuring.",
            XRiteModelRM400: "No drivers required.",
            datacolorDiagnosticTile: "Datacolor use diagnostic tile",
            datacolorSilent: "Datacolor silent",
            measureModes: "Select supported gloss levels.",
            model: "Model",
            simulationPath: "Path to the simulation file. Default preset.",
            spectroType: "Official spectro driver has to be installed. Windows only.",
            spectroTypeCom:
                "Official spectro driver has to be installed. Beware of the used COM Port. Windows as well as Linux.",
            spectroTypeDataColorReader:
                "The computer has to have Bluetooth connection. The spectro has to be paired with the computer. Windows 10 with 2018 automn update required.",
            spectroTypeMinolta2XXXd:
                "Official spectro driver has to be installed. Beware of the used COM Port. Windows as well as Linux.",
            spectroTypeNotSelected: "Select your spectro model.",
            spectroTypeRM400: "No drivers required.",
            spectroTypeSimulation: "Lab values required to obtain simulation results. Windows as well as Linux.",
            spectroTypeXRite: "Windows only."
        },
        ufiCode: {
            baseUfiCodeValidation: "Base can UFI code has to be validated via barcode before dispensing is allowed.",
            enableUfiCodes:
                "UFI codes are used in EU and provide information about how hazardous a product is to environment.",
            invalidUfi: "Invalid UFI code",
            printUfiCode:
                "If a colorant in a formula exceeds the given limit, its UFI code will be printed on the print label.",
            printUfiCodePercentage:
                "If a colorant in a formula exceeds the given limit, its UFI code will be printed on the print label along with its percentage representation.",
            ufiCodesByPercentage:
                "The UFI code which prevails is used for printing considering its actual amount in the canister. Navigate to Canister settings to define the threshold for each canister.",
            ufiCodesFromDatabase:
                "The UFI code from the main database given by the database administrator is used for printing.",
            ufiCodesFromLastFilling:
                "The UFI code from the last refill given by the operator is used for printing regardless the refilled amount."
        },
        userManagement: {
            add: "The setting adds a new user who can log in into the software. The user can have a barcode assigned and can be set to log in automatically after the software is started.",
            assignedGroups:
                "This defines what user groups the user belongs to. Various user groups distribute various privileges.",
            availableGroups:
                "This defines what user groups there are available for the user. Various user groups distribute various privileges.",
            loggedUserDelete: "Currently logged in user cannot be deleted."
        },
        visit: "Ð¸Ð»Ð¸ Ð¿Ð¾ÑÐµÑÐµÑÐµ",
        visitNoLicense: "ÐÐ° Ð¿Ð¾Ð²ÐµÑÐµ Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ, Ð¼Ð¾Ð»Ñ Ð¿Ð¾ÑÐµÑÐµÑÐµ"
    },
    helpSettings: {
        customHelpLink: "ÐÐµÑÑÐ¾Ð½Ð°Ð»Ð¸Ð·Ð¸ÑÐ°Ð½Ð° Ð²ÑÑÐ·ÐºÐ° ÐºÑÐ¼ ÐÐ¾Ð¼Ð¾ÑÐ½Ð¸Ñ ÑÐµÐ½ÑÑÑ",
        helpSettings: "Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ¸ ÐÐ¾Ð¼Ð¾Ñ",
        message: "ÑÑÐ¾Ð±ÑÐµÐ½Ð¸Ðµ"
    },
    helper: {
        automaticallyCheckForUpdates: "ÐÑÐ¾Ð²ÐµÑÐºÐ° Ð·Ð° Ð°ÐºÑÑÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ð¸ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐ½Ð¾",
        automaticallyDownloadUpdates: "ÐÐ·ÑÐµÐ³Ð»ÑÐ½Ðµ Ð½Ð° Ð°ÐºÑÑÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ð¸ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐ½Ð¾",
        automaticallyInstallNewDatabases: "ÐÐ²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐ½Ð¾ Ð¸Ð½ÑÑÐ°Ð»Ð¸ÑÐ°Ð½Ðµ Ð½Ð° Ð½Ð¾Ð²Ð¸ ÐÐ",
        automaticallyInstallUpdates: "ÐÐ²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐ½Ð¾ Ð¸Ð½ÑÑÐ°Ð»Ð¸ÑÐ°Ð½Ðµ Ð½Ð° Ð°ÐºÑÑÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ð¸",
        bugReport: "ÐÐ¾ÐºÐ»Ð°Ð´ Ð·Ð° Ð³ÑÐµÑÐºÐ¸",
        canBrowseChangeLog: "Show online %{name} changelog.",
        collect: "ÐÐ±Ð¾Ð±ÑÐ°Ð²Ð°Ð½Ðµ",
        collectLogFiles: "Ð¡ÑÐ±Ð¸ÑÐ°Ð½Ðµ Ð½Ð° ÑÐµÐ³Ð¸ÑÑÑÐ°ÑÐ¸Ð¾Ð½Ð½Ð¸ÑÐµ ÑÐ°Ð¹Ð»Ð¾Ð²Ðµ",
        component: "ÐÐ¾Ð¼Ð¿Ð¾Ð½ÐµÐ½Ñ",
        content: "Ð¡ÑÐ´ÑÑÐ¶Ð°Ð½Ð¸Ðµ",
        contentSize: "Ð Ð°Ð·Ð¼ÐµÑ Ð½Ð° ÑÑÐ´ÑÑÐ¶Ð°Ð½Ð¸ÐµÑÐ¾",
        download: "ÐÐ·ÑÐµÐ³Ð»Ð¸",
        downloadLogFiles: "ÐÐ·ÑÐµÐ³Ð»ÑÐ½Ðµ Ð½Ð° ÑÐµÐ³Ð¸ÑÑÑÐ°ÑÐ¸Ð¾Ð½Ð½Ð¸ÑÐµ ÑÐ°Ð¹Ð»Ð¾Ð²Ðµ",
        downloadingData: "ÐÐ·ÑÐµÐ³Ð»ÑÐ½ÐµÑÐ¾ Ð½Ð° Ð´Ð°Ð½Ð½Ð¸",
        everyHours: "BÑÐµÐºÐ¸ %{interval} ÑÐ°ÑÐ°",
        forceInstall: "Force to update",
        installDuringNight: "During night (%{start} - %{end}) every %{interval} hour",
        newVersion: "ÐÐ¾Ð²Ð° Ð²ÐµÑÑÐ¸Ñ",
        notConnected: "ÐÐ¾Ð¼Ð¾ÑÐ½Ð¸ÐºÑÑ Ð½Ðµ Ðµ ÑÐ²ÑÑÐ·Ð°Ð½Ð¾",
        openBugReport: "ÐÑÐ²Ð°ÑÑÐ½Ðµ Ð½Ð° Ð¾ÑÑÐµÑ Ð·Ð° Ð³ÑÐµÑÐºÐ¸",
        packageSize: "Ð Ð°Ð·Ð¼ÐµÑ Ð½Ð° Ð¿Ð°ÐºÐµÑÐ°",
        pleaseWait: "ÐÐ¾Ð»Ñ, Ð¸Ð·ÑÐ°ÐºÐ°Ð¹ÑÐµ, ÑÐ¾Ð²Ð° Ð¼Ð¾Ð¶Ðµ Ð´Ð° Ð¾ÑÐ½ÐµÐ¼Ðµ Ð¸Ð·Ð²ÐµÑÑÐ½Ð¾ Ð²ÑÐµÐ¼Ðµ.",
        send: "ÐÐ·Ð¿ÑÐ°ÑÐ¸",
        sendBugReportToCustomerService: "ÐÐ·Ð¿ÑÐ°ÑÐ¸ Ð´Ð¾ÐºÐ»Ð°Ð´ Ð·Ð° Ð³ÑÐµÑÐºÐ° ÐºÑÐ¼ Ð¾Ð±ÑÐ»ÑÐ¶Ð²Ð°Ð½Ðµ Ð½Ð° ÐºÐ»Ð¸ÐµÐ½ÑÐ¸ÑÐµ",
        sendingReport: "ÐÐ·Ð¿ÑÐ°ÑÐ°Ð½Ðµ",
        subject: "ÐÑÐµÐ´Ð¼ÐµÑ"
    },
    helperDialog: {
        1: "ÐÐ¾Ð¶ÐµÑÐµ Ð´Ð° Ð¿ÑÐ¾Ð²ÐµÑÐ¸ÑÐµ Ð·Ð° ÑÐ¾ÑÑÑÐµÑÐ½Ð¸ Ð¸Ð»Ð¸ Ð±Ð°Ð·Ð¸ Ð´Ð°Ð½Ð½Ð¸ Ð°ÐºÑÑÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ð¸.",
        2: "ÐÑÐ¾Ð´ÑÐ»Ð¶Ð°Ð²Ð°Ð½Ðµ ÑÑÑ ÑÐ²Ð°Ð»ÑÐ½ÐµÑÐ¾ Ð½Ð° Ð¿Ð°ÐºÐµÑÐ¸ Ð·Ð° Ð¾Ð±Ð½Ð¾Ð²ÑÐ²Ð°Ð½Ðµ?",
        3: "ÐÑÐ¾Ð´ÑÐ»Ð¶Ð°Ð²Ð°Ð½Ðµ Ñ Ð¸Ð½ÑÑÐ°Ð»Ð¸ÑÐ°Ð½Ðµ Ð½Ð° Ð¸Ð·ÑÐµÐ³Ð»ÐµÐ½Ð¸ÑÐµ Ð¿Ð°ÐºÐµÑÐ¸ Ñ Ð¾Ð±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ñ?",
        10: "ÐÑÐ¾Ð²ÐµÑÐºÐ° Ð·Ð° ÑÐ¾ÑÑÑÐµÑ Ð¸ Ð±Ð°Ð·Ð¸ Ð´Ð°Ð½Ð½Ð¸ Ð°ÐºÑÑÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ð¸, Ð¼Ð¾Ð»Ñ Ð¸Ð·ÑÐ°ÐºÐ°Ð¹ÑÐµ ...",
        11: "ÐÐ¼Ð° Ð½Ð° ÑÐ°Ð·Ð¿Ð¾Ð»Ð¾Ð¶ÐµÐ½Ð¸Ðµ Ð°ÐºÑÑÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ñ Ð·Ð° Ð²Ð°ÑÐ¸Ñ ÐºÐ¾Ð¼Ð¿ÑÑÑÑ. ÐÑÐºÐ°ÑÐµ Ð»Ð¸ Ð´Ð° Ð±ÑÐ´Ðµ Ð¸Ð·ÑÐµÐ³Ð»ÐµÐ½Ð°?",
        12: "ÐÑÐ¼Ð° Ð½Ð°Ð»Ð¸ÑÐ½Ð¸ Ð·Ð° Ð°ÐºÑÑÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ð¸ Ð·Ð° Ð²Ð°ÑÐ¸Ñ ÐºÐ¾Ð¼Ð¿ÑÑÑÑ.",
        14: "ÐÑÐ·Ð½Ð¸ÐºÐ½Ð° Ð³ÑÐµÑÐºÐ° Ð¿Ð¾ Ð²ÑÐµÐ¼Ðµ Ð½Ð° Ð¿ÑÐ¾Ð²ÐµÑÐºÐ°ÑÐ° Ð·Ð° Ð°ÐºÑÑÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ð¸. %{0}",
        15: "Ð¡Ð¸Ð½ÑÑÐ¾Ð½Ð¸Ð·Ð¸ÑÐ°Ð½Ðµ Ð½Ð° Ð±Ð°Ð·Ð¸ Ð´Ð°Ð½Ð½Ð¸ Ð·Ð¾Ð½Ð°, Ð¼Ð¾Ð»Ñ Ð¸Ð·ÑÐ°ÐºÐ°Ð¹ÑÐµ ...",
        20: "ÐÐºÑÑÐ°Ð»Ð¸Ð·Ð°ÑÐ¸ÑÑÐ°  Ð¸Ð·ÑÐµÐ³Ð»Ñ Ð¿Ð°ÐºÐµÑ, Ð¼Ð¾Ð»Ñ Ð¸Ð·ÑÐ°ÐºÐ°Ð¹ÑÐµ ...",
        21: "ÐÐºÑÑÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ñ Ð½Ð° Ð¿Ð°ÐºÐµÑ, ÐºÐ¾Ð¹ÑÐ¾ Ðµ Ð¸Ð·ÑÐµÐ³Ð»ÐµÐ½ ÑÐµ Ð¿ÑÐ¾Ð²ÐµÑÑÐ²Ð° , Ð¼Ð¾Ð»Ñ Ð¸Ð·ÑÐ°ÐºÐ°Ð¹ÑÐµ ...",
        22: "ÐÐ·ÑÐµÐ³Ð»ÑÐ½Ðµ Ð½Ð° Ð¿Ð°ÐºÐµÑ Ð·Ð° Ð°ÐºÑÑÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ñ Ð½Ðµ Ðµ ÑÑÐ¿ÑÐ», Ð¸ÑÐºÐ°ÑÐµ Ð»Ð¸ Ð´Ð° Ð¾Ð¿Ð¸ÑÐ°ÑÐµ Ð¾ÑÐ½Ð¾Ð²Ð¾?",
        23: "ÐÐ·ÑÐµÐ³Ð»ÑÐ½Ðµ Ð½Ð° Ð¿Ð°ÐºÐµÑ Ð·Ð° Ð°ÐºÑÑÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ñ Ð½Ðµ Ðµ ÑÑÐ¿ÑÐ» (ÑÐ°Ð¹Ð»ÑÑ Ðµ Ð¿Ð¾Ð²ÑÐµÐ´ÐµÐ½), Ð¸ÑÐºÐ°ÑÐµ Ð»Ð¸ Ð´Ð° Ð¾Ð¿Ð¸ÑÐ°ÑÐµ Ð¾ÑÐ½Ð¾Ð²Ð¾?",
        24: "ÐÐ° Ð¿ÑÐ¾Ð´ÑÐ»Ð¶Ð° Ð»Ð¸ Ñ Ð¸Ð½ÑÑÐ°Ð»Ð¸ÑÐ°Ð½ÐµÑÐ¾ Ð½Ð° Ð°ÐºÑÑÐ°Ð»Ð¸Ð·Ð°ÑÐ¸ÑÑÐ°?",
        25: "ÐÐ¾Ð½ÑÐ°Ð¶ Ð½Ð° Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐ½Ð° Ð°ÐºÑÑÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ñ ÑÐµ Ð·Ð°Ð¿Ð¾ÑÐ½Ðµ Ð² %{0}",
        26: "ÐÐ¼Ð° Ð½Ð° ÑÐ°Ð·Ð¿Ð¾Ð»Ð¾Ð¶ÐµÐ½Ð¸Ðµ Ð°ÐºÑÑÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ñ Ð·Ð° Ð²Ð°ÑÐ¸Ñ ÐºÐ¾Ð¼Ð¿ÑÑÑÑ. ÐÑÐºÐ°ÑÐµ Ð»Ð¸ Ð´Ð° Ð±ÑÐ´Ðµ Ð¸Ð·ÑÐµÐ³Ð»ÐµÐ½Ð°?",
        27: "ÐÐ° Ð¿ÑÐ¾Ð´ÑÐ»Ð¶Ð° Ð»Ð¸ Ñ Ð¸Ð½ÑÑÐ°Ð»Ð¸ÑÐ°Ð½ÐµÑÐ¾ Ð½Ð° Ð°ÐºÑÑÐ°Ð»Ð¸Ð·Ð°ÑÐ¸ÑÑÐ°?",
        40: "Ð¡Ð¿Ð¸ÑÐ°Ð½Ðµ Ð½Ð° Ð¿ÑÐ¸Ð»Ð¾Ð¶ÐµÐ½Ð¸Ñ Ð¸ ÑÑÐ»ÑÐ³Ð¸, Ð¼Ð¾Ð»Ñ Ð¸Ð·ÑÐ°ÐºÐ°Ð¹ÑÐµ ...",
        41: "ÐÐ¾Ð²Ð¸ÑÐµ ÑÐ°Ð¹Ð»Ð¾Ð²Ðµ ÑÐµ ÐºÐ¾Ð¿Ð¸ÑÐ°Ñ, Ð¼Ð¾Ð»Ñ Ð¸Ð·ÑÐ°ÐºÐ°Ð¹ÑÐµ ...",
        42: "Ð¡ÑÐ°ÑÑÐ¸ÑÐ°Ð½Ðµ Ð½Ð° Ð¿ÑÐ¸Ð»Ð¾Ð¶ÐµÐ½Ð¸Ñ Ð¸ ÑÑÐ»ÑÐ³Ð¸, Ð¼Ð¾Ð»Ñ Ð¸Ð·ÑÐ°ÐºÐ°Ð¹ÑÐµ ...",
        43: "ÐÐ¾Ð²ÑÑÑÐ¸ÑÐµÐ»Ð½Ð¸ Ð°ÐºÑÑÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ñ Ð½Ð° ÑÐ¾ÑÑÑÐµÑÐ°, Ð¼Ð¾Ð»Ñ Ð¸Ð·ÑÐ°ÐºÐ°Ð¹ÑÐµ ...",
        44: "Ð¡Ð¾ÑÑÑÐµÑÑÑ Ð²Ð¸ Ð±Ðµ Ð°ÐºÑÑÐ°Ð»Ð¸Ð·Ð¸ÑÐ°Ð½Ð° ÑÑÐ¿ÐµÑÐ½Ð¾.",
        45: "ÐÑÐºÐ°ÑÐµ Ð»Ð¸ Ð´Ð° Ð¾Ð¿Ð¸ÑÐ°ÑÐµ Ð¾ÑÐ½Ð¾Ð²Ð¾ Ð¸Ð½ÑÑÐ°Ð»Ð°ÑÐ¸Ñ? ÐÐºÐ¾ ÑÐµÑÐ¸ÑÐµ Ð´Ð° Ð¾Ð¿Ð¸ÑÐ°ÑÐµ Ð¾ÑÐ½Ð¾Ð²Ð¾ ÑÐµ ÑÐ²ÐµÑÐµÑÐµ, ÑÐµ ÑÐ¾ÑÑÑÐµÑÐ½Ð¸ÑÐµ ÐºÐ¾Ð¼Ð¿Ð¾Ð½ÐµÐ½ÑÐ¸ Ð² Ð¼Ð¾Ð¼ÐµÐ½ÑÐ° Ð½Ðµ ÑÐ° Ð² ÑÐ¿Ð¾ÑÑÐµÐ±Ð°.",
        46: "ÐÐ·Ð¸ÑÐºÐ²Ð° ÑÐµ ÑÐµÑÑÐ°ÑÑÐ¸ÑÐ°Ð½Ðµ Ð½Ð° ÐºÐ¾Ð¼Ð¿ÑÑÑÑ, Ð·Ð° Ð´Ð° ÑÐµ Ð¾ÑÑÐ°Ð·ÑÑ Ð¿ÑÐ¾Ð¼ÐµÐ½Ð¸ÑÐµ, ÑÐµÑÑÐ°ÑÑÐ¸ÑÐ°Ð½Ðµ ÑÐµ Ð±ÑÐ´Ðµ Ð½Ð°Ð¿ÑÐ°Ð²ÐµÐ½Ð¾ Ð² %{0}",
        999: "Ð½Ð°ÑÑÑÐ¿Ð¸Ð»Ð° ÐÑÑÑÐµÑÐ½Ð° Ð³ÑÐµÑÐºÐ°: %{0}",
        automaticInstallation: "ÐÐ²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐ½Ð¾ Ð¸Ð½ÑÑÐ°Ð»Ð¸ÑÐ°Ð½Ðµ Ð°ÐºÑÑÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ñ",
        btnAbort: "ÐÑÐµÐºÑÐ°ÑÑÐ²Ð°Ð½Ðµ",
        btnCancel: "ÐÑÐºÐ°Ð·",
        btnCheckUpdate: "ÐÑÐ¾Ð²ÐµÑÐ¸ Ð·Ð° Ð¾Ð±Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ñ",
        btnContinue: "ÐÑÐ¾Ð´ÑÐ»Ð¶Ð¸",
        btnDownloadUpdate: "ÐÐ·ÑÐµÐ³Ð»ÑÐ½Ðµ Ð½Ð° Ð¾Ð±Ð½Ð¾Ð²ÑÐ²Ð°Ð½Ðµ",
        btnInstallUpdate: "ÐÐ½ÑÑÐ°Ð»Ð¸ÑÐ°Ð¹ÑÐµ Ð°ÐºÑÑÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ñ",
        btnOk: "ÐÐ¾Ð±ÑÐµ",
        btnRetry: "ÐÐ¾Ð²ÑÐ¾ÑÐµÐ½ Ð¾Ð¿Ð¸Ñ",
        btnSkip: "ÐÑÐ¾Ð¿ÑÑÐ½Ð¸",
        checkingForUpdates: "ÐÑÐ¾Ð²ÐµÑÑÐ²Ð° ÑÐµ Ð·Ð° Ð°ÐºÑÑÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ð¸",
        downloadingFailed: "ÐÐµÑÑÐ¿ÐµÑÐ½Ð¾ Ð¸Ð·ÑÐµÐ³Ð»ÑÐ½Ðµ",
        downloadingPackage: "ÐÐºÑÑÐ°Ð»Ð¸Ð·Ð°ÑÐ¸ÑÑÐ°  Ð¸Ð·ÑÐµÐ³Ð»Ñ Ð¿Ð°ÐºÐµÑ, Ð¼Ð¾Ð»Ñ Ð¸Ð·ÑÐ°ÐºÐ°Ð¹ÑÐµ",
        finishingUpdate: "ÐÐ¾Ð²ÑÑÑÐ¸ÑÐµÐ»Ð½Ð¸ Ð°ÐºÑÑÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ñ",
        installingUpdate: "ÐÐºÑÑÐ°Ð»Ð¸Ð·Ð°ÑÐ¸ÑÑÐ° ÑÐµ Ð¸Ð½ÑÑÐ°Ð»Ð¸ÑÐ°",
        internalError: "ÐÑÑÑÐµÑÐ½Ð° Ð³ÑÐµÑÐºÐ°",
        rebootRequired: "ÐÐµÐ¾Ð±ÑÐ¾Ð´Ð¸Ð¼Ð¾ ÑÐµÑÑÐ°ÑÑÐ¸ÑÐ°Ð½Ðµ",
        startingComponents: "Ð¡ÑÐ°ÑÑÐ¸ÑÐ°Ð½Ðµ Ð½Ð° ÑÐ¾ÑÑÑÐµÑÐ½Ð¸ ÐºÐ¾Ð¼Ð¿Ð¾Ð½ÐµÐ½ÑÐ¸",
        stoppingComponents: "Ð¡Ð¿Ð¸ÑÐ°Ð½Ðµ Ð½Ð° ÑÐ¾ÑÑÑÐµÑÐ½Ð¸ ÐºÐ¾Ð¼Ð¿Ð¾Ð½ÐµÐ½ÑÐ¸",
        synchronizingDatabases: "Ð¡Ð¸Ð½ÑÑÐ¾Ð½Ð¸Ð·Ð¸ÑÐ°Ð½Ðµ Ð½Ð° Ð·Ð°Ð¾Ð½Ð° Ð½Ð° Ð±Ð°Ð·Ð¸ Ð´Ð°Ð½Ð½Ð¸",
        updateAvailable: "ÐÐºÑÑÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ñ Ðµ  Ð½Ð° ÑÐ°Ð·Ð¿Ð¾Ð»Ð¾Ð¶ÐµÐ½Ð¸Ðµ, Ð¸Ð·Ð±ÐµÑÐµÑÐµ ÐºÐ¾Ð¼Ð¿Ð¾Ð½ÐµÐ½ÑÐ¸ÑÐµ Ð·Ð° Ð¾Ð±Ð½Ð¾Ð²ÑÐ²Ð°Ð½Ðµ",
        updateDownloaded: "ÐÐºÑÑÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ñ Ðµ Ð±Ð¸Ð»Ð° Ð¸Ð·ÑÐµÐ³Ð»ÐµÐ½Ð°",
        updateFailed: "ÐÑÐ¾ÑÐµÑÑÑ Ð½Ð° Ð°ÐºÑÑÐ°Ð»Ð¸Ð·Ð¸ÑÐ°Ð½Ðµ Ðµ Ð½ÐµÑÑÐ¿ÐµÑÐµÐ½",
        updateInstalled: "ÐÐºÑÑÐ°Ð»Ð¸Ð·Ð°ÑÐ¸ÑÑÐ° Ðµ Ð¸Ð½ÑÑÐ°Ð»Ð¸ÑÐ°Ð½Ð°",
        verificationFailed: "ÐÐµÑÑÐ¿ÐµÑÐ½Ð° Ð¿ÑÐ¾Ð²ÐµÑÐºÐ° Ð½Ð° Ð¿Ð°ÐºÐµÑÐ° Ð·Ð° Ð°ÐºÑÑÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ñ",
        verifyingPackage: "ÐÑÐ¾Ð²ÐµÑÐºÐ° Ð½Ð° Ð¸Ð·ÑÐµÐ³Ð»ÐµÐ½Ð¸Ñ Ð¿Ð°ÐºÐµÑ",
        yourSoftwareIsUpToDate: "ÐÐ°ÑÐ¸ÑÑ ÑÐ¾ÑÑÑÐµÑ Ðµ Ð°ÐºÑÑÐ°Ð»ÐµÐ½",
        yourSoftwareVersion: "ÐÐ°ÑÐ°ÑÐ° ÑÐ¾ÑÑÑÐµÑÐ½Ð° Ð²ÐµÑÑÐ¸Ñ: %{0}"
    },
    importData: {
        abortImportingData: "ÐÑÐµÐºÑÐ°ÑÑÐ²Ð°Ð½Ðµ Ð½Ð° Ð²Ð½Ð°ÑÑÐ½ÐµÑÐ¾",
        aborted: "ÐÐ¼Ð¿Ð¾ÑÑÑÑ Ð±ÐµÑÐµ Ð¿ÑÐµÑÑÑÐ°Ð½Ð¾Ð²ÐµÐ½.",
        backupLocalDB: "Backup local database",
        confirmRestore: "Do you really want to restore all local settings?",
        dataMissing: "ÐÐ¼Ð¿Ð¾ÑÑÐ¸ÑÐ°Ð½ÐµÑÐ¾ Ð½Ðµ Ð±Ðµ ÑÑÐ¿ÐµÑÐ½Ð¾, ÑÑÐ¹ ÐºÐ°ÑÐ¾ Ð¸Ð·ÑÐ¾Ð´Ð½Ð¸ÑÑ ÑÐ°Ð¹Ð» Ð½Ðµ ÑÑÐ´ÑÑÐ¶Ð°ÑÐµ Ð½Ð¸ÐºÐ°ÐºÐ²Ð¸ Ð´Ð°Ð½Ð½Ð¸.",
        deleteImportedData: "ÐÐ·ÑÑÐ¸Ð²Ð°Ð½Ðµ Ð½Ð° Ð²Ð½ÐµÑÐµÐ½Ð¸ÑÐµ Ð´Ð°Ð½Ð½Ð¸",
        encodingFile: "ÐÐ¾Ð´Ð¸ÑÐ°Ð½Ðµ Ð½Ð° ÑÐ°Ð¹Ð»Ð¾Ð²Ðµ",
        exportLocalSettings: "Export Local Settings",
        exportStaticSql: "Export Static SQL",
        fileDamaged: "ÐÐ¼Ð¿Ð¾ÑÑÐ¸ÑÐ°Ð½ÐµÑÐ¾ Ð½Ðµ Ð±Ðµ ÑÑÐ¿ÐµÑÐ½Ð¾, ÑÑÐ¹ ÐºÐ°ÑÐ¾ Ð¸Ð·Ð³Ð»ÐµÐ¶Ð´Ð°, ÑÐµ Ð¸Ð·ÑÐ¾Ð´Ð½Ð¸ÑÑ ÑÐ°Ð¹Ð» Ðµ Ð¿Ð¾Ð²ÑÐµÐ´ÐµÐ½.",
        fileMissing: "ÐÐ¼Ð¿Ð¾ÑÑÐ¸ÑÐ°Ð½ÐµÑÐ¾ Ð½Ðµ Ð±Ðµ ÑÑÐ¿ÐµÑÐ½Ð¾, ÑÑÐ¹ ÐºÐ°ÑÐ¾ Ð¸Ð·ÑÐ¾Ð´Ð½Ð¸ÑÑ ÑÐ°Ð¹Ð» Ð½Ðµ ÑÑÑÐµÑÑÐ²ÑÐ²Ð°.",
        format: "Ð¤Ð¾ÑÐ¼Ð°Ñ",
        formatPath: "Ð¤Ð¾ÑÐ¼Ð°ÑÐ¸ÑÐ°Ð½Ðµ Ð½Ð° Ð¿ÑÑÑ",
        headerMissing: "ÐÐ¼Ð¿Ð¾ÑÑÐ¸ÑÐ°Ð½ÐµÑÐ¾ Ð½Ðµ Ð±Ðµ ÑÑÐ¿ÐµÑÐ½Ð¾, Ð·Ð°ÑÐ¾ÑÐ¾ Ð»Ð¸Ð¿ÑÐ²Ð° Ð·Ð°Ð³Ð»Ð°Ð²ÐºÐ°ÑÐ° Ð½Ð° ÑÐ°Ð¹Ð»Ð¾Ð²ÐµÑÐµ.",
        import: "ÐÐ½ÐµÑÐ¸",
        importAborted: "ÐÐ½Ð°ÑÑÐ½Ðµ Ð¿ÑÐµÐºÑÐ°ÑÐµÐ½Ð¾",
        importAborting: "Ð²ÐÐ½Ð°ÑÑÐ½Ðµ Ð¿ÑÐµÐºÑÑÐ½Ð°ÑÐ¾",
        importFailed: "ÐÐ¼Ð¿Ð¾ÑÑÐ¸ÑÐ°Ð½ÐµÑÐ¾ Ð½Ðµ Ð±Ðµ ÑÑÐ¿ÐµÑÐ½Ð¾ Ð¿Ð¾ÑÐ°Ð´Ð¸ Ð½ÐµÐ¾ÑÐ°ÐºÐ²Ð°Ð½Ð° Ð³ÑÐµÑÐºÐ°.",
        importLocalSettings: "Import Local Settings",
        importPrices: "ÐÐ½ÐµÑÐ¸ Ð¦ÐµÐ½Ð¸",
        imported: "Ð£ÑÐ¿ÐµÑÐ½Ð¾ Ð¸Ð¼Ð¿Ð¾ÑÑÐ¸ÑÐ°Ð½Ð¸",
        importedWithErrors: "Importing has finished with errors. Error lines have been skipped.",
        importing: "ÐÐ½Ð°ÑÑÐ½Ðµ",
        noFormatAvailable: "ÐÑÐ¼Ð° Ð½Ð°Ð»Ð¸ÑÐµÐ½ ÑÐ¾ÑÐ¼Ð°Ñ",
        processing: "ÐÐ±ÑÐ°Ð±Ð¾ÑÐ²Ð°Ð½Ðµ",
        processingCustomFormulas: "ÐÐ±ÑÐ°Ð±Ð¾ÑÐºÐ° Ð½Ð° Ð¿ÐµÑÑÐ¾Ð½Ð°Ð»Ð¸Ð·Ð¸ÑÐ°Ð½Ð¸ ÑÐ¾ÑÐ¼ÑÐ»Ð¸",
        processingCustomers: "ÐÐ±ÑÐ°Ð±Ð¾ÑÐºÐ° Ð½Ð° ÐºÐ»Ð¸ÐµÐ½ÑÐ¸",
        productsFile: "Ð¤Ð°Ð¹Ð» Ñ Ð¿ÑÐ¾Ð´ÑÐºÑÐ¸",
        restoreLocalSettings: "Restore Local Settings",
        underProgress: "ÐÐ¼Ð¿Ð¾ÑÑÑÑ Ðµ Ð² ÑÐ¾Ð´.",
        unknownFormat: "ÐÐ¼Ð¿Ð¾ÑÑÐ¸ÑÐ°Ð½ÐµÑÐ¾ Ð½Ðµ Ð±Ðµ ÑÑÐ¿ÐµÑÐ½Ð¾, ÑÑÐ¹ ÐºÐ°ÑÐ¾ Ð¸Ð·ÑÐ¾Ð´Ð½Ð¸ÑÑ ÑÐ°Ð¹Ð» Ðµ Ñ Ð½ÐµÐ¸Ð·Ð²ÐµÑÑÐµÐ½ ÑÐ¾ÑÐ¼Ð°Ñ.",
        userFormulasFile: "Ð¤Ð°Ð¹Ð» Ñ Ð¿Ð¾ÑÑÐµÐ±Ð¸ÑÐµÐ»ÑÐºÐ¸ ÑÐ¾ÑÐ¼ÑÐ»Ð¸"
    },
    infoType: {
        baseDensity: "ÐÐ°Ð·Ð¾Ð²Ð° Ð¿Ð»ÑÑÐ½Ð¾ÑÑ",
        baseMass: "Ð¢ÐµÐ³Ð»Ð¾ Ð½Ð° Ð±Ð°Ð·Ð°ÑÐ°",
        baseUfiCode: "Base UFI code",
        baseVolume: "ÐÐ±ÐµÐ¼ Ð½Ð° Ð±Ð°Ð·Ð°ÑÐ°",
        batchNumbersTable: "Batch numbers table",
        bfsGrade: "BFS ÐºÐ»Ð°Ñ",
        colorLab: "Ð¦Ð²ÑÑ Lab",
        colorRgb: "Ð¦Ð²ÑÑ RGB",
        colorRgbHex: "Ð¦Ð²ÑÑ RGB Hex",
        colorXyz: "Ð¦Ð²ÑÑ xyz",
        colorantBatchNumbers: "Colorant batch numbers",
        colorantMass: "Ð¢ÐµÐ³Ð»Ð¾ Ð½Ð° ÐºÐ¾Ð»Ð¾ÑÐ°Ð½Ñ",
        colorantUfiCodes: "Colorant UFI codes",
        colorantVolume: "ÐÐ±ÐµÐ¼ Ð½Ð° ÐºÐ¾Ð»Ð¾ÑÐ°Ð½Ñ",
        formulaDate: "Formula date",
        formulaDatetime: "Formula datetime",
        formulaMoreInfo: "Formula more info",
        formulaMoreInfoInternal: "Formula more info internal",
        formulaMoreInfoPrint: "Formula more info print",
        hbw: "HBW",
        isPackageGravimetric: "ÐÐ°ÐºÐµÑ Ð³ÑÐ°Ð²Ð¸Ð¼ÐµÑÑÐ¸ÑÐµÐ½",
        maxColorantMass: "ÐÐ°ÐºÑÐ¸Ð¼Ð°Ð»Ð½Ð¾ ÑÐ°Ð·ÑÐµÑÐµÐ½Ð° Ð¼Ð°ÑÐ° Ð½Ð° Ð¾ÑÐ²ÐµÑÐ¸ÑÐµÐ»Ñ",
        maxColorantVolume: "ÐÐ°ÐºÑÐ¸Ð¼Ð°Ð»Ð½Ð¾ ÑÐ°Ð·ÑÐµÑÐµÐ½ Ð¾Ð±ÐµÐ¼ Ð½Ð° Ð¾ÑÐ²ÐµÑÐ¸ÑÐµÐ»Ñ",
        nominalMass: "ÐÐ¾Ð¼Ð¸Ð½Ð°Ð»Ð½Ð° Ð¼Ð°ÑÐ° Ð½Ð° Ð¿Ð°ÐºÐµÑÐ°",
        nominalVolume: "ÐÐ¾Ð¼Ð¸Ð½Ð°Ð»ÐµÐ½ Ð¾Ð±ÐµÐ¼ Ð½Ð° Ð¿Ð°ÐºÐµÑÐ°",
        overfillDetected: "ÐÑÐºÑÐ¸ÑÐ¾ Ð¿ÑÐµÐ¿ÑÐ»Ð²Ð°Ð½Ðµ",
        totalPaintDensity: "Total paint density",
        totalPaintMass: "ÐÐ±ÑÐ¾ ÑÐµÐ³Ð»Ð¾ Ð½Ð°  Ð±Ð¾ÑÑÐ°",
        totalPaintVolume: "ÐÐ±Ñ Ð¾Ð±ÐµÐ¼ Ð½Ð° Ð±Ð¾ÑÑÐ°",
        ufiCodesTable: "UFI codes table",
        verifiedFormula: "Verified formula",
        yValue: "Y ÑÑÐ¾Ð¹Ð½Ð¾ÑÑ"
    },
    initialTab: {
        favoriteFormulas: "ÐÑÐ±Ð¸Ð¼Ð¸ ÑÐ¾ÑÐ¼ÑÐ»Ð¸",
        lastDispensedFormulas: "ÐÐ¾ÑÐ»ÐµÐ´Ð½Ð¾ Ð¸Ð·Ð¿ÑÐ»Ð½ÐµÐ½Ð¸ ÑÐ¾ÑÐ¼ÑÐ»Ð¸",
        searchNewFormula: "Ð¢ÑÑÑÐ¸ ÐÐ¾Ð²Ð° ÑÐ¾ÑÐ¼ÑÐ»Ð°"
    },
    invalidBatchNumbersModal: {
        header: "Check colorants Batch number",
        info: "At least one canister is filled with (possibly) defective batch of colorant. Please do not use this batch. Empty the canister using Quick tint.",
        unknownStatus: "Unknown Batch status"
    },
    keyWords: {
        action: "action",
        add: "add",
        addition: "addition",
        additional: "additional",
        address: "address",
        admin: "admin",
        advanced: "Advanced",
        after: "after",
        afterDispensing: "after dispensing",
        alfa: "Alfa",
        all: "all",
        allow: "allow",
        alphabetically: "alphabetically",
        amount: "amount",
        api: "api",
        ask: "ask",
        autocap: "autocap",
        autotask: "autotask",
        availablePrice: "available price",
        backup: "backup",
        banner: "banner",
        barcode: "barcode",
        barcodes: "barcodes",
        base: "base",
        before: "before",
        begin: "begin",
        bfs: "bfs",
        bottom: "bottom",
        brand: "brand",
        brush: "brush",
        bug: "bug",
        button: "button",
        buy: "buy",
        cC3: "CC3",
        cM: "CM",
        calibration: "calibration",
        can: "can",
        canHandling: "can handling",
        canister: "canister",
        canisterFilling: "canister filling",
        canisterLevels: "canister levels",
        canisters: "canisters",
        cap: "cap",
        center: "Center",
        centre: "Centre",
        change: "change",
        changelog: "changelog",
        channels: "channels",
        check: "check",
        chunk: "chunk",
        chunks: "chunks",
        city: "city",
        clean: "clean",
        cleaning: "cleaning",
        clientIdentifier: "client identifier",
        close: "close",
        closest: "closest",
        code: "code",
        collect: "collect",
        color: "color",
        colorLink3: "ColorLink3",
        colorPanel: "color palette",
        colorReader: "ColorReader",
        colorant: "colorant",
        colorantConsumption: "colorant consumption",
        colorantPrice: "colorant price",
        colorants: "colorants",
        colorix: "Colorix",
        colour: "colour",
        communication: "communication",
        compare: "compare",
        competitive: "competitive",
        computer: "computer",
        config: "config",
        configuration: "configuration",
        confirm: "confirm",
        confirmation: "confirmation",
        connection: "connection",
        contactPerson: "contact person",
        control: "Control",
        copies: "copies",
        corob: "Corob",
        cost: "cost",
        country: "country",
        create: "create",
        currency: "currency",
        current: "current",
        custom: "custom",
        customers: "customers",
        daily: "daily",
        dark: "Dark",
        data: "data",
        database: "database",
        datacolor: "Datacolor",
        date: "date",
        decimals: "decimals",
        default: "default",
        delay: "delay",
        delete: "delete",
        deletion: "deletion",
        deltaE: "delta e",
        device: "device",
        devices: "devices",
        diagnosticTile: "diagnostic tile",
        dialog: "dialog",
        direct: "direct",
        disconnect: "disconnect",
        discount: "discount",
        dispense: "dispense",
        dispenser: "dispenser",
        dispensing: "dispensing",
        down: "down",
        download: "download",
        driver: "driver",
        dromont: "Dromont",
        dspProxy: "DspProxy",
        edit: "edit",
        editor: "editor",
        email: "email",
        error: "error",
        evoDriver: "EvoDriver",
        evoService: "EvoService",
        excel: "excel",
        expiration: "expiration",
        export: "export",
        eyeOne: "Eye-One",
        fF: "F&F",
        fandeck: "fandeck",
        fastFluid: "Fast & Fluid",
        file: "file",
        fill: "fill",
        fillToMax: "fill to max",
        find: "find",
        first: "first",
        flex: "Flex",
        folder: "folder",
        formula: "formula",
        formulas: "formulas",
        from: "from",
        fts5: "fts5",
        fullScreen: "full screen",
        fullText: "full-text",
        fulltext: "fulltext",
        g: "g",
        genericPricing: "generic pricing",
        hLD: "HLD",
        hard: "hard",
        hbw: "hbw",
        help: "help",
        helpCenter: "help center",
        hero: "Hero",
        history: "history",
        home: "home",
        host: "host",
        humidifier: "humidifier",
        iDD: "IDD",
        identification: "identification",
        image: "image",
        impGallon: "imp. gallon",
        impQuart: "imp. quart",
        import: "import",
        individually: "individually",
        info: "info",
        information: "information",
        initial: "initial",
        initialization: "initialization",
        initialize: "initialize",
        insert: "insert",
        install: "install",
        intellyPurge: "intelly purge",
        invalid: "invalid",
        ipAddress: "ip address",
        italtinto: "Italtinto",
        items: "items",
        keyboard: "keyboard",
        kg: "kg",
        kiosk: "kiosk",
        kioskMode: "kiosk mode",
        l: "l",
        lLD: "LLD",
        lab: "lab",
        label: "label",
        labels: "labels",
        language: "language",
        largo: "largo",
        last: "last",
        lenteq: "Lenteq",
        levels: "levels",
        license: "license",
        light: "Light",
        limit: "limit",
        link: "link",
        linux: "Linux",
        load: "load",
        lock: "lock",
        logFiles: "log files",
        logic: "logic",
        logo: "logo",
        lower: "lower",
        machine: "machine",
        machineConfiguration: "machine configuration",
        machineManagement: "machine management",
        machineName: "machine name",
        main: "main",
        maintenance: "maintenance",
        manual: "manual",
        manualAddition: "manual addition",
        manualDispensing: "manual dispensing",
        manualScan: "manual scan",
        margins: "margins",
        markups: "markups",
        mass: "mass",
        match: "match",
        measure: "measure",
        measurement: "measurement",
        measurementUnits: "measurement units",
        melody: "melody",
        message: "message",
        minimal: "minimal",
        minolta: "Minolta",
        minus: "minus",
        minutes: "minutes",
        misura: "Misura",
        ml: "ml",
        mode: "mode",
        model: "model",
        modification: "modification",
        modify: "modify",
        monthly: "monthly",
        moreInfo: "more info",
        movableTable: "movable table",
        move: "move",
        music: "music",
        myOrders: "my orders",
        name: "name",
        naming: "naming",
        nano: "Nano",
        navigation: "navigation",
        new: "new",
        nextDriver: "NextDriver",
        night: "night",
        nixPro: "Nix Pro",
        notes: "notes",
        notification: "notification",
        number: "number",
        off: "off",
        open: "open",
        order: "order",
        ordering: "ordering",
        overfill: "overfill",
        overview: "overview",
        overwrite: "overwrite",
        own: "own",
        pCPDriver: "PCPDriver",
        package: "package",
        packagePrice: "package price",
        packages: "packages",
        panels: "panels",
        parameter: "parameter",
        path: "path",
        pc: "pc",
        phone: "phone",
        phoneNumber: "phone number",
        picture: "picture",
        place: "place",
        placement: "placement",
        plug: "plug",
        plugger: "plugger",
        plugging: "plugging",
        plugin: "plugin",
        plus: "plus",
        pointOfSale: "point of sale",
        popUp: "pop-up",
        pos: "pos",
        present: "present",
        preview: "preview",
        price: "price",
        priceExport: "price export",
        priceGroup: "price group",
        priceImport: "price import",
        prices: "prices",
        pricing: "pricing",
        primaryCurrency: "primary currency",
        print: "print",
        printer: "printer",
        printing: "printing",
        problem: "problem",
        product: "product",
        productPrice: "product price",
        profiledValues: "profiled values",
        punch: "punch",
        puncher: "puncher",
        punching: "punching",
        purge: "purge",
        purgeType: "purge type",
        purgeVolume: "purge volume",
        quality: "quality",
        quick: "quick",
        quickTint: "quick tint",
        rM: "RM",
        raise: "raise",
        rcc: "rcc",
        reader: "reader",
        reboot: "reboot",
        receive: "receive",
        recirculate: "recirculate",
        recirculation: "recirculation",
        redlike: "Redlike",
        refill: "refill",
        registration: "registration",
        regular: "regular",
        removal: "removal",
        remove: "remove",
        report: "report",
        reset: "reset",
        resolution: "resolution",
        restart: "restart",
        rgb: "rgb",
        rights: "rights",
        rounding: "rounding",
        rules: "rules",
        sanTint: "SanTint",
        save: "save",
        scale: "scale",
        scan: "scan",
        scope: "scope",
        screen: "screen",
        screensaver: "screensaver",
        search: "search",
        secondaryCurrency: "secondary currency",
        select: "select",
        selectedFormula: "Selected formula",
        sell: "sell",
        sensor: "sensor",
        serialNumber: "serial number",
        server: "server",
        servers: "servers",
        service: "service",
        serviceAction: "service action",
        serviceActions: "service actions",
        serviceSoftware: "service software",
        serviceWindow: "service window",
        settings: "settings",
        shelf: "shelf",
        shortcuts: "shortcuts",
        shot: "shot",
        show: "show",
        shutDown: "shut down",
        shutdown: "shutdown",
        silent: "Silent",
        simple: "simple",
        simulation: "simulation",
        size: "size",
        skip: "skip",
        smartPurge: "smart purge",
        software: "software",
        softwareSupplier: "software supplier",
        sort: "sort",
        sound: "sound",
        spectro: "spectro",
        spectrophotometer: "spectrophotometer",
        speed: "speed",
        split: "split",
        start: "start",
        startup: "startup",
        statistics: "statistics",
        status: "status",
        stir: "stir",
        stirring: "stirring",
        street: "street",
        support: "support",
        surcharge: "surcharge",
        tab: "tab",
        tabs: "tabs",
        task: "task",
        template: "template",
        testing: "testing",
        time: "time",
        tintingManagementCenter: "tinting management center",
        to: "to",
        toDispense: "to dispense",
        tolerance: "tolerance",
        top: "top",
        total: "total",
        translation: "translation",
        turnOff: "turn off",
        turntable: "turntable",
        type: "type",
        uIDD: "UIDD",
        uSGallon: "U.S gallon",
        uSQuart: "U.S quart",
        unit: "unit",
        up: "up",
        update: "update",
        url: "url",
        user: "user",
        userGroups: "user groups",
        v1: "v1",
        v2: "v2",
        v3: "v3",
        vAT: "VAT",
        validate: "validate",
        validation: "validation",
        version: "version",
        virtual: "virtual",
        volume: "volume",
        weekly: "weekly",
        window: "window",
        windows: "Windows",
        with: "with",
        without: "without",
        xRite: "X-Rite",
        xrite: "Xrite",
        yValue: "y value",
        zipCode: "zip code",
        zoom: "zoom"
    },
    languages: {
        bg: "Ð±ÑÌÐ»Ð³Ð°ÑÑÐºÐ¸",
        cs: "ÄeÅ¡tina",
        da: "Danish",
        de: "Deutsch",
        el: "ÎÎ»Î»Î·Î½Î¹ÎºÎ¬",
        en: "English",
        es: "EspaÃ±ol",
        fr: "FranÃ§ais",
        hr: "Hrvatski",
        hu: "Magyar",
        id: "Bahasa Indonesia",
        is: "Ãsland",
        it: "Italiano",
        lt: "Lithuanian",
        lv: "Latvian",
        ms: "Melayu",
        nl: "Nederland",
        no: "Norway",
        pl: "Polski",
        pt: "PortuguÃªs",
        ro: "Romana",
        ru: "Ð ÑÑÑÐºÐ¸Ð¹",
        sk: "SlovenÄina",
        sr: "Srpski",
        sv: "Sverige",
        zh: "Chinese"
    },
    license: {
        activateLicense: "ÐÐºÑÐ¸Ð²Ð¸ÑÐ°Ð¹ Ð»Ð¸ÑÐµÐ½Ð·",
        activateNewLicense: "ÐÐºÑÐ¸Ð²Ð¸ÑÐ°Ð½Ðµ Ð½Ð¾Ð² Ð»Ð¸ÑÐµÐ½Ð·",
        checkLicenseKey: "ÐÑÐ¾Ð²ÐµÑÐ¸ ÐºÐ»ÑÑÐ° Ð·Ð° Ð»Ð¸ÑÐµÐ½Ð·Ð°",
        companyId: "ID Ð½Ð° ÐºÐ¾Ð¼Ð¿Ð°Ð½Ð¸ÑÑÐ°",
        contactPerson: "ÐÐ¸ÑÐµ Ð·Ð° ÐºÐ¾Ð½ÑÐ°ÐºÑ",
        copy: "ÐÐ¾Ð¿Ð¸ÑÐ°Ð¹",
        country: "ÐÑÑÐ¶Ð°Ð²Ð°",
        emptyCity: "ÐÑÐ°Ð´ÑÑ Ðµ Ð·Ð°Ð´ÑÐ»Ð¶Ð¸ÑÐµÐ»Ð½Ð° Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ",
        emptyCountry: "ÐÑÑÐ¶Ð°Ð²Ð°ÑÐ° Ðµ Ð·Ð°Ð´ÑÐ»Ð¶Ð¸ÑÐµÐ»Ð½Ð° Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ",
        emptyName: "ÐÐ¼ÐµÑÐ¾ Ð½Ð° Ð¼Ð°Ð³Ð°Ð·Ð¸Ð½Ð° Ðµ Ð·Ð°Ð´ÑÐ»Ð¶Ð¸ÑÐµÐ»Ð½Ð° Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ",
        enterIdentificationKeys: "ÐÑÐ²ÐµÐ´Ð¸ ÑÐ²Ð¾Ñ Ð¸Ð´ÐµÐ½ÑÐ¸ÑÐ¸ÐºÐ°ÑÐ¸Ð¾Ð½ÐµÐ½ ÐºÐ»ÑÑ",
        expirationDate: "ÐÐ°ÑÐ° Ð½Ð° Ð¸Ð·ÑÐ¸ÑÐ°Ð½Ðµ %{dateTime}",
        fillRegistration: "ÐÐ¾Ð¿ÑÐ»Ð½Ð¸ ÑÐµÐ³Ð¸ÑÑÐ°ÑÐ¸Ð¾Ð½Ð½Ð°ÑÐ° ÑÐ¾ÑÐ¼Ð°",
        insertLicense: "ÐÑÐ²ÐµÐ´Ð¸ Ð³ÐµÐ½ÐµÑÐ¸ÑÐ°Ð½Ð¸Ñ Ð»Ð¸ÑÐµÐ½Ð·Ð¸Ð¾Ð½ÐµÐ½ ÐºÐ»ÑÑ",
        invalidEmail: "ÐÑÐ²ÐµÐ¶Ð´Ð°Ð½ÐµÑÐ¾ Ð½Ð° Ð¸Ð¼ÐµÐ¹Ð» Ðµ Ð½ÐµÐ²Ð°Ð»Ð¸Ð´Ð½Ð¾",
        invalidPhone: "ÐÑÐ²ÐµÐ¶Ð´Ð°Ð½ÐµÑÐ¾ Ð½Ð° ÑÐµÐ»ÐµÑÐ¾Ð½ Ðµ Ð½ÐµÐ²Ð°Ð»Ð¸Ð´Ð½Ð¾",
        itemsMarkedasterisk: "(Ð¿Ð¾Ð»ÐµÑÐ°ÑÐ°, Ð¼Ð°ÑÐºÐ¸ÑÐ°Ð½Ð¸ ÑÑÑ Ð·Ð²ÐµÐ·Ð´Ð¸ÑÐºÐ°, ÑÑÑÐ±Ð²Ð° Ð´Ð° Ð±ÑÐ´Ð°Ñ Ð¿Ð¾Ð¿ÑÐ»Ð½ÐµÐ½Ð¸)",
        lastUpdate: "Last change %{dateTime}",
        leasedLicense: "ÐÐ¸ÑÐµÐ½Ð· Ð¿Ð¾Ð´ Ð»Ð¸Ð·Ð¸Ð½Ð³",
        licenseActivated: "License already activated",
        licenseStatus: "Ð¡ÑÐ°ÑÑÑ Ð½Ð° Ð»Ð¸ÑÐµÐ½Ð·Ð°",
        licenseWillExpire: "ÐÐ°ÑÐ¸ÑÑ Ð»Ð¸ÑÐµÐ½Ð· Ð¸Ð·ÑÐ¸ÑÐ° ÑÐ»ÐµÐ´ %{dayCount} Ð´Ð½Ð¸",
        licenseWillExpireOneDay: "Your license expires in %{dayCount} day",
        machineInformation: "Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ Ð·Ð° Ð¼Ð°ÑÐ¸Ð½Ð°ÑÐ°",
        noLicenseAvailable: "ÐÐ¸ÑÐµÐ½Ð· Ð½Ðµ Ð½Ð°Ð»Ð¸ÑÐµÐ½",
        noProductsForKey: "ÐÑÐ¼Ð° Ð½Ð°Ð»Ð¸ÑÐ½Ð¸ Ð¿ÑÐ¾Ð´ÑÐºÑÐ¸ Ð·Ð° Ð¿Ð¾ÑÐ¾ÑÐµÐ½Ð¸ÑÐµ Ð¸Ð´ÐµÐ½ÑÐ¸ÑÐ¸ÐºÐ°ÑÐ¸Ð¾Ð½Ð½Ð¸ ÐºÐ»ÑÑÐ¾Ð²Ðµ.",
        pointOfSale: "ÐÑÑÑÐ¾ Ð½Ð° Ð¿ÑÐ¾Ð´Ð°Ð¶Ð±Ð°",
        producer: "ÐÑÐ¾Ð¸Ð·Ð²Ð¾Ð´Ð¸ÑÐµÐ»",
        reactivate: "Reactivate",
        reactivateLicense: "Reactivate license",
        region: "Ð ÐµÐ³Ð¸Ð¾Ð½",
        registerLicense: "Ð ÐµÐ³Ð¸ÑÑÑÐ¸ÑÐ°Ð¹ Ð»Ð¸ÑÐµÐ½Ð·Ð°",
        registrationForm: "Ð ÐµÐ³Ð¸ÑÑÑÐ°ÑÐ¸Ñ",
        selectProduct: "ÐÐ·Ð±ÐµÑÐ¸ Ð¿ÑÐ¾Ð´ÑÐºÑ",
        serialNumber: "Ð¡ÐµÑÐ¸ÐµÐ½ Ð½Ð¾Ð¼ÐµÑ",
        skipNewLicense: "If you want to activate new license later you can click on Skip",
        unlimitedLicense: "ÐÐµÐ¾Ð³ÑÐ°Ð½Ð¸ÑÐµÐ½ Ð»Ð¸ÑÐµÐ½Ð·",
        userId: "ID Ð½Ð° Ð¿Ð¾ÑÑÐµÐ±Ð¸ÑÐµÐ»",
        uuid: "ÐÐ¸ÑÐµÐ½Ð· UUID",
        versionDetails: "ÐÐµÑÑÐ¸Ñ ÐÐµÑÐ°Ð¹Ð»Ð¸",
        versionScope: "ÐÐ±ÑÐ²Ð°Ñ Ð½Ð° Ð²ÐµÑÑÐ¸ÑÑÐ°",
        versionType: "Ð¢Ð¸Ð¿ Ð²ÐµÑÑÐ¸Ñ",
        zip: "ÐÐ"
    },
    login: {
        authenticate: "Authenticate",
        logIn: "ÐÐ¿Ð¸ÑÐ²Ð°Ð½Ðµ",
        loginAs: "ÐÐ»ÐµÐ·ÑÐµ ÐºÐ°ÑÐ¾ Ð´ÑÑÐ³ Ð¿Ð¾ÑÑÐµÐ±Ð¸ÑÐµÐ»",
        messages: {
            incorrectUsername: "ÐÐµÐºÐ¾ÑÐµÐºÑÐ½Ð¾ Ð¿Ð¾ÑÑÐµÐ±Ð¸ÑÐµÐ»ÑÐºÐ¾ Ð¸Ð¼Ðµ"
        },
        password: "ÐÐ°ÑÐ¾Ð»Ð°",
        username: "ÐÐ¾ÑÑÐµÐ±Ð¸ÑÐµÐ»ÑÐºÐ¾ Ð¸Ð¼Ðµ"
    },
    machineActionHistory: {
        actionHistory: "ÐÑÑÐ¾ÑÐ¸Ñ Ð½Ð° Ð´ÐµÐ¹ÑÑÐ²ÑÑÐ°"
    },
    machineErrors: {
        channel: "ÐÐ°Ð½Ð°Ð»",
        code: "ÐÐ¾Ð´",
        machineErrors: "ÐÑÐµÑÐºÐ¸ Ð½Ð° Ð¼Ð°ÑÐ¸Ð½Ð°ÑÐ°",
        noMachineErrors: "There are currently no machine errors",
        resetErrors: "ÐÑÐ»Ð¸ÑÐ°Ð½Ðµ Ð½Ð° Ð³ÑÐµÑÐºÐ¸ÑÐµ"
    },
    machineSettings: {
        action: "ÐÐµÐ¹ÑÑÐ²Ð¸Ðµ",
        addAutotask: "Add autotask",
        autoCanisterIn: "ÐÐ²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐ½Ð¾ Ð²ÑÐ²ÐµÐ¶Ð´Ð°Ð½Ðµ Ð½Ð° ÑÐµÐ·ÐµÑÐ²Ð¾Ð°Ñ",
        autoCanisterOut: "ÐÐ²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐ½Ð¾ Ð¸Ð·Ð²ÐµÐ¶Ð´Ð°Ð½Ðµ Ð½Ð° ÑÐµÐ·ÐµÑÐ²Ð¾Ð°Ñ",
        automaticRefill: "ÐÐ²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐ½Ð¾ Ð¿ÑÐµÐ·Ð°ÑÐµÐ¶Ð´Ð°Ð½Ðµ",
        autotaskSettings: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ Ð·Ð° Ð°Ð²ÑÐ¾Ð·Ð°Ð´Ð°ÑÐ°",
        backupConfiguration: "Ð ÐµÐ·ÐµÑÐ²Ð½Ð° ÐºÐ¾Ð½ÑÐ¸Ð³ÑÑÐ°ÑÐ¸Ñ Ð½Ð° Ð´Ð¾Ð·Ð°ÑÐ¾ÑÐ°",
        brushMaintenance: "ÐÐ¾Ð´Ð´ÑÑÐ¶ÐºÐ° Ð½Ð° ÑÐµÑÐºÐ°ÑÐ°",
        capMaintenance: "ÐÐ¾Ð´Ð´ÑÑÐ¶ÐºÐ° Ð½Ð° ÐºÐ°Ð¿Ð°ÑÐºÐ°ÑÐ°",
        checkCanisterBeforeDispense: "ÐÑÐ¾Ð²ÐµÑÐ¸ ÑÐµÐ·ÐµÑÐ²Ð¾Ð°ÑÐ¸ÑÐµ Ð¿ÑÐµÐ´Ð¸ Ð´Ð¾Ð·Ð¸ÑÐ°Ð½Ðµ",
        checkColorantBaseRules: "Check colorant base rules",
        checkMinDosableAmount: "Check the minimal tintable amount of colorants",
        checkOverfill: "Check can overfill",
        checkTotalCntAmounts: "Check total colorants amount for base paint",
        cleanAll: "ÐÐ¾ÑÐ¸ÑÑÐµÑÐµ Ð²ÑÐ¸ÑÐºÐ¸",
        computerReboot: "ÐÐ¾Ð¼Ð¿ÑÑÑÑÐ½Ð° ÑÐµÑÑÐ°ÑÑÐ¸ÑÐ°Ð½Ðµ",
        computerShutdown: "ÐÐ·ÐºÐ»ÑÑÐ²Ð°Ð½Ðµ Ð½Ð° ÐºÐ¾Ð¼Ð¿ÑÑÑÑÐ°",
        connectMachine: "Ð¡Ð²ÑÑÐ¶Ð¸ Ð¼Ð°ÑÐ¸Ð½Ð°ÑÐ°",
        days: "ÐÐ½Ð¸",
        daysOfMonth: "ÐÐ½Ð¸ Ð½Ð° Ð¼ÐµÑÐµÑ",
        devices: "Ð£ÑÑÑÐ¾Ð¹ÑÑÐ²Ð°",
        disabled: "ÐÐ°Ð±ÑÐ°Ð½ÐµÐ½Ð¾",
        dispenseAndPurge: "ÐÐ¾Ð·Ð¸ÑÐ°Ð½Ðµ Ð¸ Ð¿ÑÐ¾ÑÐ¸ÑÑÐ²Ð°Ð½Ðµ",
        dispenseOnly: "Ð¡Ð°Ð¼Ð¾ Ð´Ð¾Ð·Ð¸ÑÐ°Ð½Ðµ",
        dispenserCleaning: "ÐÐ¾ÑÐ¸ÑÑÐ²Ð°Ð½Ðµ Ð½Ð° Ð´Ð¸ÑÐ¿ÐµÐ½ÑÐµÑÐ°",
        dispensingWithErrorsEnabled: "Allow dispensing despite the validation errors",
        editAutotask: "Edit autotask",
        firstRun: "First run",
        hours: "Ð§Ð°ÑÐ°",
        humidifier: "ÐÐ²Ð»Ð°Ð¶Ð½Ð¸ÑÐµÐ»",
        humidifierWaterLevelMaintenance: "ÐÑÐµÐ³Ð»ÐµÐ´ Ð½Ð° Ð½Ð¸Ð²Ð¾ÑÐ¾ Ð½Ð° Ð²Ð¾Ð´Ð°ÑÐ° Ð·Ð° Ð¾Ð²Ð»Ð°Ð¶Ð½ÑÐ²Ð°Ð½Ðµ",
        machineConfigurationNoCanisters: "The machine configuration contains no canisters.",
        machineName: "ÐÐ¼Ð° Ð½Ð° Ð¼Ð°ÑÐ¸Ð½Ð°ÑÐ°",
        machineSettings: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ Ð½Ð° Ð¼Ð°ÑÐ¸Ð½Ð°ÑÐ°",
        manualPuncher: "Ð ÑÑÐµÐ½ Ð¿ÐµÑÑÐ¾ÑÐ°ÑÐ¾Ñ",
        minDispensedAmount: "ÐÐ¸Ð½Ð¸Ð¼Ð°Ð»Ð½Ð¾ Ð´Ð¾Ð·Ð¸ÑÐ°Ð½Ð¾ ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾",
        minutes: "ÐÐ¸Ð½ÑÑÐ¸",
        nextRun: "Ð¡Ð»ÐµÐ´Ð²Ð°ÑÐ° ÑÐµÑÐ¸Ñ",
        noAutotasksSet: "No autotasks set",
        noDataAvailable: "No data available",
        noMachine: "ÐÑÐ¼Ð° Ð¼Ð°ÑÐ¸Ð½Ð°",
        onStart: "ÐÐ° ÑÑÐ°ÑÑ",
        plugger: "ÐÐ°Ð¿ÑÑÐ°Ð»ÐºÐ°",
        postpone: "Postpone",
        puncher: "ÐÐµÑÑÐ¾ÑÐ°ÑÐ¾Ñ",
        purgeAll: "ÐÑÐ¾ÑÐ¸ÑÑÐ²Ð°Ð½Ðµ",
        purgeOnly: "Purge only",
        recirculateAll: "Ð ÐµÑÐ¸ÑÐºÑÐ»Ð°ÑÐ¸Ñ Ð½Ð° Ð²ÑÐ¸ÑÐºÐ¸",
        recirculateChannels: "Ð ÐµÑÐ¸ÑÐºÑÐ»Ð°ÑÐ¸Ñ Ð½Ð° ÐºÐ°Ð½Ð°Ð»Ð¸",
        recirculationSpeed: "Ð¡ÐºÐ¾ÑÐ¾ÑÑ Ð¿ÑÐ¸ ÑÐµÑÐ¸ÑÐºÑÐ»Ð°ÑÐ¸Ñ",
        recirculationTime: "ÐÑÐµÐ¼Ðµ Ð½Ð° ÑÐµÑÐ¸ÑÐºÑÐ»Ð°ÑÐ¸Ñ",
        refillAll: "ÐÐ°ÑÐµÐ´Ð¸ Ð²ÑÐ¸ÑÐºÐ¸",
        refillCanisters: "ÐÐ°ÑÐµÐ´Ð¸ ÑÐµÐ·ÐµÑÐ²Ð¾Ð°ÑÐ¸",
        runAt: "Run at",
        runDefinedDaysAt: "ÐÐµÑÐ¸Ð½Ð¸ÑÐ°Ð½Ð¸ Ð´Ð½Ð¸ Ð²",
        runEvery: "ÐÐ·Ð¿ÑÐ»Ð½ÐµÑÐµ Ð²ÑÐµÐºÐ¸",
        runInDays: "ÐÐ·Ð¿ÑÐ»Ð½Ð¸ Ð² Ð´Ð½Ð¸",
        serialNum: "Ð¡ÐµÑÐ¸ÐµÐ½ Ð½Ð¾Ð¼ÐµÑ",
        settingsMachine: "ÐÐ°ÑÐ¸Ð½Ð½Ð¸ Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ¸",
        smartPurgeAll: "Ð£Ð¼Ð½Ð¾ Ð¿ÑÐ¾ÑÐ¸ÑÑÐ²Ð°Ð½Ðµ Ð½Ð° Ð²ÑÐ¸ÑÐºÐ¸",
        smartPurgeChannels: "Ð£Ð¼Ð½Ð¾ Ð¿ÑÐ¾ÑÐ¸ÑÑÐ²Ð°Ð½Ðµ Ð½Ð° ÐºÐ°Ð½Ð°Ð»Ð¸",
        smartPurgeRules: "ÐÑÐ°Ð²Ð¸Ð»Ð° Ð·Ð° ÑÐ¼Ð½Ð¾ Ð¿ÑÐ¾ÑÐ¸ÑÑÐ²Ð°Ð½Ðµ",
        startType: "ÐÐ°ÑÐ°Ð»ÐµÐ½ ÑÐ¸Ð¿",
        stirAll: "Ð Ð°Ð·Ð±ÑÑÐºÐ°Ð¹ÑÐµ Ð²ÑÐ¸ÑÐºÐ¸",
        stirCanisters: "Ð Ð°Ð·Ð±ÑÑÐºÐ°Ð¹ÑÐµ ÑÐµÐ·ÐµÑÐ²Ð¾Ð°ÑÐ¸",
        stirringSpeed: "Ð¡ÐºÐ¾ÑÐ¾ÑÑ Ð½Ð° ÑÐ°Ð·Ð±ÑÑÐºÐ²Ð°Ð½Ðµ",
        stirringTime: "ÐÑÐµÐ¼Ðµ Ð½Ð° ÑÐ°Ð·Ð±ÑÑÐºÐ²Ð°Ð½Ðµ",
        switchPlateMaintenance: "ÐÐ¾Ð´Ð´ÑÑÐ¶ÐºÐ° Ð¿ÑÐµÐ²ÐºÐ»ÑÑÐ²Ð°ÑÐ° Ð¿Ð»Ð¾ÑÐ°",
        theCurrentlySelectedMachine: "Ð¢ÐµÐºÑÑÐ¾ ÑÐ²ÑÑÐ·Ð°Ð½Ð° Ð½Ð°ÑÐ¸Ð½Ð°",
        threshold: "ÐÑÐ°Ð³",
        turntable: "ÐÐ¾Ð´Ð²Ð¸Ð¶Ð½Ð° Ð¼Ð°ÑÐ°",
        unifyColorantBatchForMultipleCans: "Unify colorant batch for multiple cans dispensings",
        volume: "Ð¡Ð¸Ð»Ð° Ð½Ð° Ð·Ð²ÑÐºÐ°",
        weekdays: "ÐÐ½Ð¸ Ð¾Ñ ÑÐµÐ´Ð¼Ð¸ÑÐ°ÑÐ°"
    },
    mainTab: {
        acceptedFormula: "Accepted formula",
        addBuildingSite: "Add building site",
        addToFavorites: "ÐÐ¾Ð±Ð°Ð²Ð¸ Ð² Ð»ÑÐ±Ð¸Ð¼Ð¸",
        alternativeFormulas: "Alternative formulas",
        alternativeValidFormulas: "Alternative valid formulas",
        buildingSiteSpecification: "Building site specification",
        colorantsAreInvalid: "ÐÐ´Ð¸Ð½ Ð¸Ð»Ð¸ Ð¿Ð¾Ð²ÐµÑÐµ Ð¾ÑÐ²ÐµÑÐ¸ÑÐµÐ»Ð¸ ÑÐ° Ð½ÐµÐ²Ð°Ð»Ð¸Ð´Ð½Ð¸",
        dispensedPackages: "ÐÐ¾Ð·Ð¸ÑÐ°Ð½Ð¸ Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ¸",
        dispensingInProgress: "ÐÐ¾Ð·Ð¸ÑÐ°Ð½ÐµÑÐ¾ Ð² Ð¿ÑÐ¾ÑÐµÑ Ð½Ð° Ð¸Ð·Ð²ÑÑÑÐ²Ð°Ð½Ðµ",
        dispensingIsAborted: "ÐÐ¾Ð·Ð¸ÑÐ°Ð½ÐµÑÐ¾ Ðµ Ð¿ÑÐµÐºÑÐ°ÑÐµÐ½Ð¾",
        dispensingIsNotAvailable: "ÐÐ¾Ð·Ð¸ÑÐ°Ð½ÐµÑÐ¾ Ð½Ðµ Ðµ Ð´Ð¾ÑÑÑÐ¿Ð½Ð¾",
        dispensingProgress: "%{done} Ð½Ð° %{all}",
        editColorant: "Ð ÐµÐ´Ð°ÐºÑÐ¸ÑÐ°Ð½Ðµ Ð½Ð° ÐºÐ¾Ð»Ð¾ÑÐ°Ð½Ñ",
        editNote: "Edit Note",
        findCompetitiveColor: "Try to find the competitive color",
        forceDispensing: "ÐÑÐ¸Ð½ÑÐ´Ð¸ÑÐµÐ»Ð½Ð¾ ÑÐ°Ð·Ð¿ÑÐµÐ´ÐµÐ»ÑÐ½Ðµ",
        formulaInvalidColorants: "Ð¤Ð¾ÑÐ¼ÑÐ»Ð°ÑÐ° ÑÑÐ´ÑÑÐ¶Ð° Ð½ÐµÐ²Ð°Ð»Ð¸Ð´Ð½Ð¸ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ¸: %{colorants}",
        formulaOutOfDate: "Formula may be out of date",
        formulaProperties: "Formula properties",
        hiddenFandecks: "Hidden fandecks",
        hiddenProducts: "Hidden products",
        historicalFormulas: "Ð¤Ð¾ÑÐ¼ÑÐ»Ð¸ Ð¾Ñ Ð¸ÑÑÐ¾ÑÐ¸ÑÑÐ°",
        lowerDeltaNumber: "Lower delta number more accurate match",
        machineError: "ÐÑÐµÑÐºÐ° Ð² Ð¼Ð°ÑÐ¸Ð½Ð°ÑÐ°",
        machineIsBusy: "ÐÐ°ÑÐ¸Ð½Ð°ÑÐ° Ðµ Ð·Ð°ÐµÑÐ°",
        machineNotConnected: "ÐÐ°ÑÐ¸Ð½Ð°ÑÐ° Ð½Ðµ Ðµ ÑÐ²ÑÑÐ·Ð°Ð½Ð°",
        manualColorantAddition: "Ð ÑÑÐ½Ð¾ Ð´Ð¾Ð±Ð°Ð²ÑÐ½Ðµ Ð½Ð° ÐºÐ¾Ð»Ð¾ÑÐ°Ð½Ñ",
        modifiedFormula: "Ð¤Ð¾ÑÐ¼ÑÐ»Ð°ÑÐ° Ðµ Ð¼Ð¾Ð´Ð¸ÑÐ¸ÑÐ¸ÑÐ°Ð½Ð°",
        modifiedFormulaInLab: "Formula modified in laboratory",
        newColorAfterScaling: "New color after scaling",
        newRgbNotAccuratelyMeasured: "New RGB is not accurately measured, it is only indicative",
        noBaseAvailable: "ÐÑÐ¼Ð° Ð½Ð°Ð»Ð¸ÑÐ½Ð° Ð±Ð°Ð·Ð°",
        noBuildingSiteAvailable: "No building site info is available",
        noColorantForCorrection: "No additional colorants for correction selected",
        noColorants: "ÐÐµÐ· ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ¸",
        noCustomer: "ÐÑÐ¼Ð° ÐºÐ»Ð¸ÐµÐ½Ñ",
        noCustomers: "ÐÑÐ¼Ð° Ð½Ð°Ð»Ð¸ÑÐ½Ð¸ ÐºÐ»Ð¸ÐµÐ½ÑÐ¸",
        noDispenseNotesAvailable: "ÐÑÐ¼Ð° Ð±ÐµÐ»ÐµÐ¶ÐºÐ¸ Ð·Ð° Ð´Ð¾Ð·Ð¸ÑÐ°Ð½Ðµ Ð½Ð° ÑÐ°Ð·Ð¿Ð¾Ð»Ð¾Ð¶ÐµÐ½Ð¸Ðµ",
        noFormulaAvailable: "You have selected a combination with no formula!",
        noFormulaSelected: "ÐÐµ Ðµ Ð¸Ð·Ð±ÑÐ°Ð½Ð° ÑÐ¾ÑÐ¼ÑÐ»Ð°",
        noInternalNotesAvailable: "No internal notes are available",
        noNotesAvailable: "ÐÑÐ¼Ð° Ð±ÐµÐ»ÐµÐ¶ÐºÐ¸  Ð½Ð° ÑÐ°Ð·Ð¿Ð¾Ð»Ð¾Ð¶ÐµÐ½Ð¸Ðµ",
        noPackageAvailable: "No package is available",
        noPackageSelected: "ÐÐµ Ðµ Ð¸Ð·Ð±ÑÐ°Ð½ Ð¿Ð°ÐºÐµÑ",
        noProductAvailable: "No product is available",
        noResultsFound: "No results found",
        openLocalFile: "Open from local database",
        openOnlineFile: "Open from the Internet",
        order: "ÐÐ¾ÑÑÑÐºÐ°",
        orderingIsNotAvailable: "ÐÐ¾ÑÑÑÐºÐ°ÑÐ° Ð½Ðµ Ðµ Ð½Ð°Ð»Ð¸ÑÐ½Ð°",
        originalColor: "Original color",
        overAvailableLevel: "ÐÐ°Ð´ Ð½Ð°Ð»Ð¸ÑÐ½Ð¾ÑÐ¾ Ð½Ð¸Ð²Ð¾",
        package: "ÐÐ¿Ð°ÐºÐ¾Ð²ÐºÐ°",
        packageIsRequired: "Package is required",
        packaging: "Packaging",
        partialUpdateReload: "Partial updates may have affected this formula. Reload this tab to see an updated data.",
        printIsNotAvailable: "ÐÐµÑÐ°Ñ Ð½Ðµ Ðµ Ð´Ð¾ÑÑÑÐ¿ÐµÐ½",
        productFiles: "ÐÑÐ¾Ð´ÑÐºÑÐ¾Ð²Ð¸ ÑÐ°Ð¹Ð»Ð¾Ð²Ðµ",
        productFilesViewer: "Product files viewer",
        productNotAvailable: "Product '%{productName}' is not available.",
        properties: "Properties",
        regularPrice: "ÐÐ±Ð¸ÑÐ°Ð¹Ð½Ð° ÑÐµÐ½Ð°",
        resetFormulaData: "ÐÐ¾Ð²Ð° ÑÐ¾ÑÐ¼ÑÐ»Ð°",
        rgbOnlyIndicative: "RGB only indicative!",
        saveAsCustom: "ÐÐ°Ð¿Ð°Ð·Ð¸ ÐºÐ°ÑÐ¾ Ð¿ÐµÑÑÐ¾Ð½Ð°Ð»Ð¸Ð·Ð¸ÑÐ°Ð½Ð°",
        saveToStatsIsNotAvailable: "ÐÐ°Ð¿Ð°Ð·Ð²Ð°Ð½Ðµ  Ð² Ð¸ÑÑÐ¾ÑÐ¸ÑÑÐ° Ð½Ðµ Ðµ Ð½Ð° ÑÐ°Ð·Ð¿Ð¾Ð»Ð¾Ð¶ÐµÐ½Ð¸Ðµ",
        searchForCheaper: "Search for cheaper",
        selectFromCompetitive: "You can select color from the competitive colors.",
        specialPrice: "Ð¡Ð¿ÐµÑÐ¸Ð°Ð»Ð½Ð° ÑÐµÐ½Ð°",
        specialPriceVip: "Ð¡Ð¿ÐµÑÐ¸Ð°Ð»Ð½Ð° ÑÐµÐ½Ð° VIP",
        splitFormula: "Ð Ð°Ð·Ð´ÐµÐ»Ð¸ ÑÐ¾ÑÐ¼ÑÐ»Ð°ÑÐ°",
        withVAT: "Ñ ÐÐÐ¡",
        withoutVAT: "Ð±ÐµÐ· ÐÐÐ¡"
    },
    marginSettings: {
        allBases: "all bases",
        allProducts: "ÐÑÐ¸ÑÐºÐ¸ Ð¿ÑÐ¾Ð´ÑÐºÑÐ¸",
        editMargin: "Ð ÐµÐ´Ð°ÐºÑÐ¸ÑÐ°Ð¹ Ð¿ÐµÑÐ°Ð»Ð±Ð°ÑÐ°",
        marginAndDiscountWarning: "You have to set price calculation option for using margins and discounts.",
        marginSettings: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ Ð·Ð° Ð¿ÐµÑÐ°Ð»Ð±Ð°",
        marginsFor: "ÐÐµÑÐ°Ð»Ð±Ð° Ð·Ð° ",
        markupColorants: "ÐÐ°Ð´ÑÐµÐ½ÐºÐ° ÐºÐ¾Ð»Ð¾ÑÐ°Ð½Ñ",
        sizeOfPackage: "Ð Ð°Ð·Ð¼ÐµÑ Ð½Ð° Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ°",
        valueBase: "Value base",
        valueColorant: "Value colorant"
    },
    matching: {
        actualColor: "Actual color",
        allCorrections: "All corrections",
        allTillItems: "All till the items",
        auto: "Auto",
        autoSelectAll: "Auto all",
        canStartCorrection: "Then you can start correction.",
        canStartMatching: "Then you can start matching.",
        cannotBeUsed: "Matching cannot be used.",
        changeProductAndColorants: "Try change product or colorants",
        checkConfig: "Please check the matching configuration.",
        colorCorrection: "Color correction",
        colorIsIndicative: "Color preview is only indicative.",
        colorNotAccurate: "Color may not be accurately displayed, it always depends on your monitor settings.",
        colorantInDispensedFormula: "Colorants in dispensed formula",
        confirmDispensing: "Confirm dispensing",
        connectionProblem: "Connection problem",
        correctionHistory: "Correction history",
        correctionRunning: "Correction is running",
        draftFormula: "Draft formula",
        exclude: "Exclude",
        excludeAll: "Exclude all",
        include: "Include",
        includeAll: "Include all",
        invalidProduct: "It is not possible to do the matching for product %{productName}",
        itemOnly: "Item only",
        manualColorCorrection: "Manual color correction",
        matchFormula: "Match formula",
        matchingInformation: "Matching information",
        matchingResult: "Matching result",
        matchingRunning: "Matching is running",
        matchingSearchOptions: "Matching search options",
        measurement: "Measurement",
        noCorrection: "No correction found",
        noSpectralCurveProvided:
            "The connected device cannot be used for matching because it doesn't provide spectral curve",
        notAvailableForMatching: "Not available for matching",
        originalFormula: "Original formula",
        reformulate: "Reformulate",
        reformulationRunning: "Reformulation is running",
        resultColor: "Result color",
        saveAsCustomFormula: "Save as custom formula",
        searchInProgress: "Search in progress, please wait",
        selectColorfile: "Please select colorfile.",
        selectRequiredItems: "Please select product, base, colorants and package.",
        selectedResult: "Selected result",
        spectralDataNotAvailable: "Spectral data is not available",
        startCorrection: "Start correction",
        startMatching: "Start matching",
        targetColor: "Target color",
        unsavedDraft: "Unsaved draft",
        unsavedDraftWarning: "Once you are satisfied with formula â do not forget to save your result.",
        usedForMatching: "Used for matching"
    },
    modal: {
        changeColorantUnit: "ÐÑÐ¾Ð¼ÑÐ½Ð° ÐµÐ´Ð¸Ð½Ð¸ÑÐ°ÑÐ° Ð·Ð° ÐºÐ¾Ð»Ð¾ÑÐ°Ð½Ñ",
        payAttention: "ÐÐ±ÑÑÐ½Ð¸ Ð²Ð½Ð¸Ð¼Ð°Ð½Ð¸Ðµ!"
    },
    module: {
        productGroups: "Product groups"
    },
    navigation: {
        globalSearch: {
            fandeckFilter: "Ð¤Ð¸Ð»ÑÑÑ Ð·Ð° ÑÐ²ÐµÑÐ½Ð¸ ÐºÐ°ÑÑÐµÐ»Ð¸",
            formulasOverLimit: "ÐÐ° %{count} ÑÐµÐ·ÑÐ»ÑÐ°ÑÐ¸. ÐÐ¾Ð»Ñ, Ð¾Ð¿Ð¸ÑÐ°Ð¹ÑÐµ Ð´Ð° Ð²ÑÐ²ÐµÐ´ÐµÑÐµ Ð¿Ð¾Ð²ÐµÑÐµ Ð¾Ñ ÐµÐ´Ð¸Ð½ ÑÐ¸Ð¼Ð²Ð¾Ð».",
            foundFormulas: "ÐÐ°Ð¼ÐµÑÐµÐ½i %{count} ÑÐ¾ÑÐ¼ÑÐ»Ð¸",
            help: "ÐÐ¾Ð¼Ð¾Ð³Ð½Ð¸:",
            helpText:
                "ÐÑÐ²ÐµÐ´ÐµÑÐµ Ð¿ÑÐ¸Ð¼ÐµÑÐ½Ð¾ '%{filter}' Ð·Ð° Ð´Ð° ÑÑÑÐ¸ÑÐµ ÑÐ¾ÑÐ¼ÑÐ»Ð¸, Ð·Ð°Ð¿Ð¾ÑÐ²Ð°ÑÐ¸ Ñ '%{formula}', Ð¿ÑÐ¾Ð´ÑÐºÑ Ð·Ð°Ð¿Ð¾ÑÐ²Ð°Ñ ÑÑÑ '%{product}' Ð¸ ÑÐ²ÐµÑÐµÐ½ ÐºÐ°ÑÑÐµÐ», Ð·Ð°Ð¿Ð¾Ð²Ð°Ñ ÑÑÑ '%{fandeck}'.",
            productFilter: "ÐÑÐ¾Ð´ÑÐºÑÐ¾Ð² ÑÐ¸Ð»ÑÑÑ",
            searchInFormulas: "Ð¢ÑÑÑÐ¸ Ð²ÑÐ² ÑÐ¾ÑÐ¼ÑÐ»Ð¸ÑÐµ",
            typeMore: "ÐÐ¾Ð»Ñ Ð²ÑÐ²ÐµÐ´ÐµÑÐµ Ð¿Ð¾Ð²ÐµÑÐµ Ð·Ð½Ð°ÑÐ¸"
        },
        menu: {
            actionHistory: "ÐÑÑÐ¾ÑÐ¸Ñ Ð½Ð° Ð´ÐµÐ¸ÑÑÐ²Ð¸ÑÑÐ°",
            additionalFormulaTab: "ÐÐ¾Ð¿ÑÐ»Ð½Ð¸ÑÐµÐ»ÐµÐ½ ÑÐ°Ð·Ð´ÐµÐ» Ð·Ð° ÑÐ¾ÑÐ¼ÑÐ»Ð°",
            advancedSettings: "Ð Ð°Ð·ÑÐ¸ÑÐµÐ½Ð¸ Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ¸",
            autotaskSettings: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ Ð·Ð° Ð°Ð²ÑÐ¾Ð·Ð°Ð´Ð°ÑÐ¸",
            availableDatabases: "ÐÐ°Ð»Ð¸ÑÐ½Ð¸ Ð±Ð°Ð·Ð¸ Ð´Ð°Ð½Ð½Ð¸",
            availablePrices: "ÐÐ°Ð»Ð¸ÑÐ½Ð¸ ÑÐµÐ½Ð¸",
            bugReport: "Ð£Ð²ÐµÐ´Ð¾Ð¼Ð»ÐµÐ½Ð¸Ðµ Ð·Ð° Ð³ÑÐµÑÐºÐ°",
            canisterBarcodes: "ÐÐ°ÑÐºÐ¾Ð´Ð¾Ð²Ðµ Ð½Ð° ÑÐµÐ·ÐµÑÐ²Ð¾Ð°ÑÐ¸ÑÐµ",
            canisterDispensingLogic: "Ð Ð°Ð·Ð¿ÑÐµÐ´ÐµÐ»ÑÐ½Ðµ Ð½Ð° Ð»Ð¾Ð³Ð¸ÐºÐ°ÑÐ°",
            canisterFilling: "ÐÐ°Ð¿ÑÐ»Ð²Ð°Ð½Ðµ Ð½Ð° ÑÐµÐ·ÐµÑÐ²Ð¾Ð°ÑÐ¸",
            canisterSettings: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ Ð½Ð° ÑÐµÐ·ÐµÑÐ²Ð¾Ð°ÑÐ¸",
            clientServerSettings: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ ÐºÐ»Ð¸ÐµÐ½Ñ/ÑÑÑÐ²ÑÑ",
            closing: "ÐÐ°ÑÐ²Ð°ÑÑÐ½Ðµ",
            color: "ÑÐ²ÑÑ",
            colorModification: "ÐÐ¾Ð´Ð¸ÑÐ¸ÐºÐ°ÑÐ¸Ñ Ð½Ð° ÑÐ²ÐµÑÐ°",
            colorPanel: "Color Palette Settings",
            colorRepresentation: "Ð¦Ð²ÐµÑÐ½Ð¾ Ð¿ÑÐµÐ´ÑÑÐ°Ð²Ð¸ÑÐµÐ»ÑÑÐ²Ð¾ Ð¸ Ð´Ð°Ð½Ð½Ð¸",
            colorSearch: "Ð¢ÑÑÑÐµÐ½Ðµ Ð½Ð° ÑÐ²ÐµÑÐ¾Ð²Ðµ",
            colorant: "ÐÑÐ²ÐµÑÐ¸ÑÐµÐ»",
            colorantConsumption: "Colorant Consumption",
            colorantPricing: "Colorant pricing",
            colorantRefillHistory: "ÐÑÑÐ¾ÑÐ¸Ñ Ð·Ð° Ð·Ð°ÑÐµÐ¶Ð´Ð°Ð½Ðµ Ð½Ð° Ð¾ÑÐ²ÐµÑÐ¸ÑÐµÐ»Ð¸",
            competitiveSearch: "ÐÐ¾Ð½ÐºÑÑÐµÐ½ÑÐ½Ð¾ ÑÑÑÑÐµÐ½Ðµ Ð½Ð° ÑÐ²ÐµÑÐ¾Ð²Ðµ",
            connections: "ÐÑÑÐ·ÐºÐ¸",
            currency: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ Ð·Ð° Ð²Ð°Ð»ÑÑÐ°",
            customData: "Custom Data",
            database: "ÐÐ°Ð·Ð° Ð´Ð°Ð½Ð½Ð¸",
            databaseCheck: "ÐÑÐ¾Ð²ÐµÑÐºÐ° Ð½Ð° Ð±Ð°Ð·Ð° Ð´Ð°Ð½Ð½Ð¸",
            databaseConnection: "Ð¡Ð²ÑÑÐ·Ð²Ð°Ð½Ðµ ÐºÑÐ¼ Ð±Ð°Ð·Ð° Ð´Ð°Ð½Ð½Ð¸",
            defaultValues: "Default Values",
            devices: "ÑÑÑÑÐ¾Ð¹ÑÑÐ²Ð°",
            dispensingHistory: "ÐÑÑÐ¾ÑÐ¸Ñ Ð½Ð° Ð´Ð¾Ð·Ð¸ÑÐ°Ð½Ðµ",
            dispensingSettings: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ Ð·Ð° ÑÐ°Ð·Ð¿ÑÐµÐ´ÐµÐ»ÑÐ½Ðµ",
            driverSettings: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ Ð½Ð° Ð´ÑÐ°Ð¹Ð²ÐµÑÐ°",
            environment: "ÐÐºÐ¾Ð»Ð½Ð° ÑÑÐµÐ´Ð°",
            environmentConfiguration: "Environment settings",
            environmentalSettings: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ Ð½Ð° Ð¾ÐºÐ¾Ð»Ð½Ð°ÑÐ° ÑÑÐµÐ´Ð°",
            favorites: "ÐÑÐ±Ð¸Ð¼Ð¸",
            fileTransfer: "DESO File Transfer",
            formatting: "Formatting",
            formula: "Formula",
            formulaData: "ÐÐ°Ð½Ð½Ð¸",
            formulaModification: "Formula modification",
            formulaPanels: "ÐÐ°Ð½ÐµÐ»Ð¸ Ñ ÑÐ¾ÑÐ¼ÑÐ»Ð¸",
            formulaSettings: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ Ð·Ð° ÑÐ¾ÑÐ¼ÑÐ»Ð°",
            formulaUnit: "Ð¤Ð¾ÑÐ¼ÑÐ»Ð° ÐµÐ´Ð¸Ð½Ð¸ÑÐ°",
            generalSearch: "ÐÐ±ÑÐ¾ ÑÑÑÑÐµÐ½Ðµ",
            globalSettingsSearch: "Global Settings Search",
            helpItems: "Help settings",
            importAndExport: "ÐÐ½Ð¾Ñ Ð¸ Ð¸Ð·Ð½Ð¾Ñ",
            importAndExportData: "ÐÐ½Ð¾Ñ Ð½Ð° Ð¿ÐµÑÑÐ¾Ð½Ð°Ð»Ð¸Ð·Ð¸ÑÐ°Ð½Ð¸ Ð´Ð°Ð½Ð½Ð¸",
            importCustomData: "ÐÐ¼Ð¿Ð¾ÑÑÐ¸ÑÐ°Ð½Ðµ Ð½Ð° Ð´Ð°Ð½Ð½Ð¸",
            initialFormulaTab: "ÐÐ°ÑÐ°Ð»Ð½Ð° ÑÐ¾ÑÐ¼ÑÐ»Ð° Ð½Ð° ÑÐ¾ÑÐ¼ÑÐ»Ð°",
            interfaceSettings: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ Ð½Ð° Ð¸Ð½ÑÐµÑÑÐµÐ¹ÑÐ°",
            keyboardShortcuts: "ÐÐ¾Ð¼Ð±Ð¸Ð½Ð°ÑÐ¸Ñ Ð¾Ñ ÐºÐ»Ð°Ð²Ð¸ÑÐ¸",
            language: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ Ð·Ð° ÐµÐ·Ð¸Ðº",
            languageSettings: "ÐÐ·Ð¸ÐºÐ¾Ð²Ð¸ Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ¸",
            layout: "Ð¾ÑÐ¾ÑÐ¼Ð»ÐµÐ½Ð¸Ðµ",
            license: "ÐÐ¸ÑÐµÐ½Ð·",
            licenseData: "ÐÐ°Ð½Ð½Ð¸ Ð·Ð° Ð»Ð¸ÑÐµÐ½Ð·",
            licenseIdentification: "ÐÐ´ÐµÐ½ÑÐ¸ÑÐ¸ÐºÐ°ÑÐ¸Ñ Ð½Ð° Ð»Ð¸ÑÐµÐ½Ð·",
            licenseStatus: "License status",
            licenseSupplier: "ÐÐ¾ÑÑÐ°Ð²ÑÐ¸Ðº Ð½Ð° Ð»Ð¸ÑÐµÐ½Ð·Ð¸",
            licenseVersion: "ÐÐµÑÑÐ¸Ñ Ð½Ð° Ð»Ð¸ÑÐµÐ½Ð·Ð°",
            localData: "Local Data",
            machine: "ÐÐ°ÑÐ¸Ð½Ð°",
            machineActions: "ÐÐ¾Ð¼Ð°Ð½Ð´Ð¸ Ð·Ð° Ð¼Ð°ÑÐ¸Ð½Ð°ÑÐ°",
            machineAndDevices: "ÐÐ°ÑÐ¸Ð½Ð¸ Ð¸ ÑÑÑÑÐ¾Ð¹ÑÑÐ²Ð°",
            machineManagement: "Ð£Ð¿ÑÐ°Ð²Ð»ÐµÐ½Ð¸Ðµ Ð½Ð° Ð¼Ð°ÑÐ¸Ð½Ð¸ÑÐµ",
            machineSettings: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ Ð½Ð° Ð¼Ð°ÑÐ¸Ð½Ð°ÑÐ°",
            mainSettings: "Main Settings",
            maintenance: "ÐÐ¾Ð´Ð´ÑÑÐ¶ÐºÐ°",
            marginAndDiscount: "Margin and discount",
            matchingSearchResult: "Matching search result",
            matchingSettings: "Matching Settings",
            navigationItems: "ÐÐ°Ð²Ð¸Ð³Ð°ÑÐ¸Ð¾Ð½Ð½Ð¸ ÐµÐ»ÐµÐ¼ÐµÐ½ÑÐ¸",
            newFormulaWindow: "ÐÑÐ¾Ð·Ð¾ÑÐµÑ Ð·Ð° Ð½Ð¾Ð²Ð° ÑÐ¾ÑÐ¼ÑÐ»Ð°",
            orderSearch: "Ð¢ÑÑÑÐµÐ½Ðµ Ð½Ð° Ð¿Ð¾ÑÑÑÐºÐ¸",
            orderSettings: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ Ð·Ð° Ð¿Ð¾ÑÑÑÐºÐ°",
            packageSurcharge: "Package Surcharge",
            popUps: "ÐÐ·ÑÐºÐ°ÑÐ°ÑÐ¸ Ð¿ÑÐ¾Ð·Ð¾ÑÑÐ¸",
            posInfo: "POS info",
            price: "Ð¦ÐµÐ½Ð¸",
            priceManagement: "Ð£Ð¿ÑÐ°Ð²Ð»ÐµÐ½Ð¸Ðµ Ð½Ð° ÑÐµÐ½Ð¸",
            priceSettings: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ Ð½Ð° ÑÐµÐ½Ð¸ÑÐµ",
            pricingOptions: "Pricing Options",
            printSettings: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ Ð·Ð° Ð¿ÐµÑÐ°Ñ",
            productPricing: "Product pricing",
            qualityControlSettings: "Quality Control Settings",
            quickTint: "ÐÑÑÐ·Ð¾ ÑÐ¾Ð½Ð¸ÑÐ°Ð½Ðµ",
            rccConfig: "RCC ÐºÐ¾Ð½ÑÐ¸Ð³ÑÑÐ¸ÑÐ°Ð½Ðµ",
            rccConnection: "RCC ÑÐ²ÑÑÐ·Ð²Ð°Ð½Ðµ",
            rccSettings: "RCC Ð½Ð°ÑÑÐ¾Ð¹ÐºÐ¸",
            refillSettings: "Refill Settings",
            refillingLogic: "Refilling Logic",
            registration: "Ð ÐµÐ³Ð¸ÑÑÑÐ°ÑÐ¸Ñ",
            searchSettings: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ Ð·Ð° ÑÑÑÑÐµÐ½Ðµ",
            serverPlugins: "ÐÑÐ¸ÑÑÐ°Ð²ÐºÐ¸ Ð·Ð° ÑÑÑÐ²ÑÑÐ¸",
            serviceActions: "Ð¡ÐµÑÐ²Ð¸Ð·Ð½Ð¸ ÐºÐ¾Ð¼Ð°Ð½Ð´Ð¸",
            settings: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸",
            simplifiers: "Simplifiers",
            singleActions: "ÐÐ´Ð¸Ð½Ð¸ÑÐ½Ð¸ Ð´ÐµÐ¹ÑÑÐ²Ð¸Ñ",
            smartPurgeRules: "Smart purge rules",
            softwareOptions: "ÐÐ¿ÑÐ¸Ð¸ Ð·Ð° ÑÐ¾ÑÑÑÐµÑ",
            spectroSettings: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ Ð½Ð° ÑÐ¿ÐµÐºÑÑÐ¾ÑÐ¾ÑÐ¾Ð¼ÐµÑÑÑ",
            statistics: "Ð¡ÑÐ°ÑÐ¸ÑÑÐ¸ÐºÐ°",
            switchToFrontdesk: "ÐÑÐµÐ²ÐºÐ»ÑÑÐ¸ Ð½Ð° Frontdesk",
            switchToFullRedlike: "ÐÑÐµÐ²ÐºÐ»ÑÑÐ²Ð°Ð½Ðµ ÐºÑÐ¼ %{name}",
            switchToLight: "ÐÑÐµÐ²ÐºÐ»ÑÑÐ²Ð°Ð½Ðµ ÐºÑÐ¼ %{name}",
            switchToMachine: "ÐÑÐµÐ²ÐºÐ»ÑÑÐ¸ Ð½Ð° Ð¼Ð°ÑÐ¸Ð½Ð°",
            tabs: "Ð Ð°Ð·Ð´ÐµÐ»Ð¸ Ð¸ Ð¸Ð·ÑÐºÐ°ÑÐ°ÑÐ¸ Ð¿ÑÐ¾Ð·Ð¾ÑÑÐ¸",
            testBarcodes: "Test Barcodes",
            updateOptions: "ÐÐ¿ÑÐ¸Ð¸ Ð·Ð° Ð¾Ð±Ð½Ð¾Ð²ÑÐ²Ð°Ð½Ðµ",
            userManagemenet: "Ð£Ð¿ÑÐ°Ð²Ð»ÐµÐ½Ð¸Ðµ Ð½Ð° Ð¿Ð¾ÑÑÐµÐ±Ð¸ÑÐµÐ»Ð¸",
            visibleUnits: "ÐÐ¸Ð´Ð¸Ð¼Ð¸ ÐµÐ´Ð¸Ð½Ð¸ÑÐ¸"
        },
        navBar: {
            barcode: "ÐÐ°ÑÐºÐ¾Ð´",
            help: "ÐÐ¾Ð¼Ð¾Ñ",
            hideItems: "Hide products / fandecks"
        },
        notificationPanel: {
            noNotifications: "ÐÑÐ¼Ð° Ð½Ð¾Ð²Ð¸ ÑÐ²ÐµÐ´Ð¾Ð¼Ð»ÐµÐ½Ð¸Ñ"
        },
        tabBar: {
            closeActive: "ÐÐ°ÑÐ²Ð¾ÑÐ¸ Ð°ÐºÑÐ¸Ð²Ð½Ð¸ÑÐµ",
            closeAll: "ÐÐ°ÑÐ²Ð¾ÑÐ¸ Ð²ÑÐ¸ÑÐºÐ¸",
            closeAllExceptActive: "ÐÐ°ÑÐ²Ð¾ÑÐ¸ Ð²ÑÐ¸ÑÐºÐ¸ Ð¾ÑÐ²ÐµÐ½ Ð°ÐºÑÐ¸Ð²Ð½Ð¸ÑÐµ",
            customFormula: "Custom Formula",
            dispensingHistory: "ÐÑÑÐ¾ÑÐ¸Ñ Ð½Ð° Ð´Ð¾Ð·Ð¸ÑÐ°Ð½Ðµ",
            favorites: "ÐÑÐ±Ð¸Ð¼Ð¸",
            formulaSearch: "Formula search",
            rewriteSettings: "Re-write local settings"
        }
    },
    ordering: {
        assign: "ÐÑÐ¸ÑÐ²Ð¾ÑÐ²Ð°Ð½Ðµ",
        assignment: "ÐÐ°Ð·Ð½Ð°ÑÐ°Ð²Ð°Ð½Ðµ",
        createdDate: "Created date",
        finishDispensing: "ÐÐ°Ð²ÑÑÑÐµÑÐµ Ð´Ð¾Ð·Ð¸ÑÐ°Ð½Ðµ",
        foundInOrders: "ÐÐ°Ð¼ÐµÑÐµÐ½Ð¾ Ð² Ð¿Ð¾ÑÑÑÐºÐ¸",
        inactiveDatabase: "Ð¤Ð¾ÑÐ¼ÑÐ»Ð° Ðµ Ð¾Ñ Ð½ÐµÐ°ÐºÑÐ¸Ð²Ð½Ð° Ð¸Ð»Ð¸ Ð½ÐµÐ¸Ð·Ð²ÐµÑÑÐ½Ð° Ð±Ð°Ð·Ð° Ð´Ð°Ð½Ð½Ð¸ %{0}",
        inactiveUnknownDatabase: "Ð¤Ð¾ÑÐ¼ÑÐ»Ð° Ðµ Ð¾Ñ Ð½ÐµÐ°ÐºÑÐ¸Ð²Ð½Ð° Ð¸Ð»Ð¸ Ð½ÐµÐ¸Ð·Ð²ÐµÑÑÐ½Ð° Ð±Ð°Ð·Ð° Ð´Ð°Ð½Ð½Ð¸",
        newOrderReceived: "ÐÐ¾Ð»ÑÑÐ¸Ð»Ð¸ ÑÑÐµ Ð½Ð¾Ð²Ð° Ð¿Ð¾ÑÑÑÐºÐ°!",
        noOrderSelected: "ÐÐµ Ðµ Ð¸Ð·Ð±ÑÐ°Ð½Ð° Ð¿Ð¾ÑÑÑÐºÐ°",
        release: "ÐÑÐ²Ð¾Ð±Ð¾Ð¶Ð´Ð°Ð²Ð°Ð½Ðµ",
        status: {
            accepted: "Ð¾Ð±ÑÐ¾Ð¿ÑÐ¸ÐµÑ",
            canceled: "Ð¾ÑÐ¼ÐµÐ½ÐµÐ½",
            created: "ÑÑÐ·Ð´Ð°Ð´ÐµÐ½",
            done: "ÑÐ²ÑÑÑÐµÐ½",
            partlyDone: "ÑÐ°ÑÑÐ¸ÑÐ½Ð¾ Ð½Ð°Ð¿ÑÐ°Ð²ÐµÐ½Ð¾",
            preparing: "Ð¿ÑÐ¸Ð³Ð¾ÑÐ²ÑÐ½Ðµ",
            unknown: "Ð½ÐµÐ¸Ð·Ð²ÐµÑÑÐµÐ½"
        }
    },
    partialUpdates: {
        applying: "Applying partial updates",
        cantBeUsedForYourDbVersion: "Updates can't be used for this database. Please update via Helper.",
        newVersionWillBeInstalled: "It will install the new version including all available partial updates.",
        noPartialUpdatesAvailable: "No partial updates available",
        outOfDate: "out of date!",
        partialUpdates: "Partial updates",
        partialUpdatesArePreparing: "Partial updates are preparing",
        partialUpdatesAvailable: "Partial updates available!",
        preparedUpdatesMessage: "The following partial updates are prepared to be applied",
        remindMeLater: "Remind me later (after %{time} minutes)",
        swOutOfDate: "The current version of the software is",
        updateAutomatically: "If you do not response, update will start automatically in: %{time} s",
        updateToNewVersion: "Update to the newest version",
        updateWillTakeMoreTime: "The update will take more time.",
        updatesApplied: "Partial updates were successfully applied.",
        updating: "Updating"
    },
    posInfo: {
        address: "Ð°Ð´ÑÐµÑ",
        contactName: "ÐÐ¼Ðµ Ð·Ð° ÐºÐ¾Ð½ÑÐ°ÐºÑ",
        contactPerson: "ÐÐ¸ÑÐµ Ð·Ð° ÐºÐ¾Ð½ÑÐ°ÐºÑ",
        identification: "ÐÐ´ÐµÐ½ÑÐ¸ÑÐ¸ÐºÐ°ÑÐ¸Ñ",
        machineInformation: "ÐÐ½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ Ð·Ð° Ð¼Ð°ÑÐ¸Ð½Ð°ÑÐ°",
        pos: "Ð¢Ð¾ÑÐºÐ° Ð½Ð° Ð¿ÑÐ¾Ð´Ð°Ð¶Ð±Ð°",
        secondAddress: "ÐÑÐ¾ÑÐ¸ Ð°Ð´ÑÐµÑ",
        shopIdentification: "ÐÐ´ÐµÐ½ÑÐ¸ÑÐ¸ÐºÐ°ÑÐ¸Ñ Ð½Ð° Ð¼Ð°Ð³Ð°Ð·Ð¸Ð½Ð°",
        shopName: "Ð¸Ð¼Ðµ Ð½Ð° Ð¼Ð°Ð³Ð°Ð·Ð¸Ð½Ð°",
        url: "Url",
        zipCode: "ÐÐ¾ÑÐµÐ½ÑÐºÐ¸ ÐºÐ¾Ð´"
    },
    priceTypeList: {
        priceBasePurchase: "Ð¡ÐµÐ±ÐµÑÑÐ¾Ð¹Ð½Ð¾ÑÑ Ð½Ð° Ð±Ð°Ð·Ð°",
        priceBaseSell: "ÐÑÐ¾Ð´Ð°Ð¶Ð½Ð° ÑÐµÐ½Ð° Ð·Ð° Ð±Ð°Ð·Ð°",
        priceBaseSellFull: "Sell full price for base",
        priceCntPurchase: "Ð¡ÐµÐ±ÐµÑÑÐ¾Ð¹Ð½Ð¾ÑÑ Ð½Ð° ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ¸",
        priceCntPurchaseByColorantName: "Ð¡ÐµÐ±ÐµÑÑÐ¾Ð¹Ð½Ð¾ÑÑ Ð½Ð° %{0} ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ¸",
        priceCntPurchaseByName: "Ð¡ÐµÐ±ÐµÑÑÐ¾Ð¹Ð½Ð¾ÑÑ Ð½Ð° ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ¸ Ð¿Ð¾ Ð¸Ð¼Ðµ",
        priceCntSell: "ÐÑÐ¾Ð´Ð°Ð¶Ð½Ð° ÑÐµÐ½Ð° Ð·Ð° ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ¸",
        priceCntSellByColorantName: "ÐÑÐ¾Ð´Ð°Ð¶Ð½Ð° ÑÐµÐ½Ð°  Ð·Ð° %{0} ÐºÐ¾Ð»Ð¾ÑÐ°Ð½Ñ",
        priceCntSellByName: "ÐÑÐ¾Ð´Ð°Ð¶Ð½Ð° ÑÐµÐ½Ð° Ð·Ð° ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ¸ Ð¿Ð¾ Ð¸Ð¼Ðµ",
        priceCntSellFull: "Sell full price for colorants",
        priceCntSellFullByColorantName: "Sell full price for %{0} colorant",
        priceCntSellFullByName: "Sell full price for colorants by name",
        priceGroupBarcode: "Price group barcode",
        priceMarginAll: "ÐÐ°ÑÐ¶ Ð·Ð° Ð²ÑÐ¸ÑÐºÐ¸ Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ¸",
        priceMarginPerPkg: "ÐÐ°ÑÐ¶ Ð·Ð° ÐµÐ´Ð½Ð° Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ°",
        priceSellPriceAll: "ÐÑÐ¾Ð´Ð°Ð¶Ð½Ð°  ÑÐµÐ½Ð° Ð·Ð° Ð²ÑÐ¸ÑÐºÐ¸ Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ¸",
        priceSellPricePerKg: "ÐÑÐ¾Ð´Ð°Ð¶Ð½Ð° ÑÐµÐ½Ð° Ð½Ð° ÐºÐ¸Ð»Ð¾Ð³ÑÐ°Ð¼",
        priceSellPricePerL: "ÐÑÐ¾Ð´Ð°Ð¶Ð½Ð° ÑÐµÐ½Ð° Ð½Ð° Ð»Ð¸ÑÑÑ",
        priceSellPricePerPkg: "ÐÑÐ¾Ð´Ð°Ð¶Ð½Ð° ÑÐµÐ½Ð° Ð·Ð° ÐµÐ´Ð½Ð° Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ°",
        priceSurchargeAll: "ÐÐ¾Ð¿Ð»Ð°ÑÐ°Ð½Ðµ Ð·Ð° Ð²ÑÐ¸ÑÐºÐ¸ Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ¸",
        priceSurchargePerPkg: "ÐÐ¾Ð¿Ð»Ð°ÑÐ°Ð½Ðµ Ð·Ð° ÐµÐ´Ð½Ð° Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ°",
        priceTintPurchaseAll: "Ð¡ÐµÐ±ÐµÑÑÐ¾Ð¹Ð½Ð¾ÑÑ Ð½Ð° ÑÐ¾Ð½Ð¸ÑÐ°Ð½Ðµ  Ð·Ð° Ð²ÑÐ¸ÑÐºÐ¸ Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ¸",
        priceTintPurchasePerPkg: "Ð¡ÐµÐ±ÐµÑÑÐ¾Ð¹Ð½Ð¾ÑÑ Ð½Ð° ÑÐ¾Ð½Ð¸ÑÐ°Ð½Ðµ Ð·Ð° ÐµÐ´Ð½Ð° Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ°",
        priceTintSellFullAll: "Tint sell full price for all packages",
        priceTintSellFullAllPerPackage: "Tint sell full price per package",
        priceTotalPurchaseAll: "ÐÐ±ÑÐ° ÑÐµÐ½Ð° Ð·Ð° Ð²ÑÐ¸ÑÐºÐ¸ Ð¾Ð¿ÐºÐ°Ð¾Ð²ÐºÐ¸",
        priceTotalPurchasePerKg: "ÐÐ±ÑÐ° ÑÐµÐ½Ð° ÑÐµÐ½Ð° Ð½Ð° ÐºÐ¸Ð»Ð¾Ð³ÑÐ°Ð¼",
        priceTotalPurchasePerL: "ÐÐ±ÑÐ° ÑÐµÐ½Ð° ÑÐµÐ½Ð° Ð½Ð° Ð»Ð¸ÑÑÑ",
        priceTotalPurchasePerPkg: "ÐÐ±ÑÐ° ÑÐµÐ½Ð° Ð½Ð° ÐµÐ´Ð½Ð° Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ°",
        priceTotalSellFullAll: "Total sell full price for all packages",
        priceTotalSellFullPerKg: "Total sell full price per kilogram",
        priceTotalSellFullPerLiter: "Total sell full price per liter",
        priceTotalSellFullPerPackage: "Total sell full price per package"
    },
    pricing: {
        allBases: "ÐÑÐ¸ÑÐºÐ¸ Ð±Ð°Ð·Ð¸",
        allPackages: "ÐÑÐ¸ÑÐºÐ¸ Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ¸",
        backup: "Backup",
        basesOfProduct: "Bases of %{productName}",
        colorantPricing: "Colorant pricing",
        export: "Ð¸Ð·Ð½Ð¾Ñ",
        import: "Ð²Ð½Ð¾Ñ",
        packagePricing: "Package pricing",
        packageSurcharge: "ÐÐ¾Ð¿Ð»Ð°ÑÐ°Ð½Ðµ Ð½Ð° Ð¾Ð¿ÐºÐ°Ð¾Ð²ÐºÐ°",
        packages: "ÐÐ¿ÐºÐ°Ð¾Ð²ÐºÐ¸",
        packagesOfProduct: "Packages of %{productName}",
        posCoeficient: "POS coeficient",
        priceGroupPricePerLiter: "Ð¦ÐµÐ½Ð° Ð½Ð° Ð»Ð¸ÑÑÑ Ð² ÑÐµÐ½Ð¾Ð²Ð°ÑÐ° Ð³ÑÑÐ¿Ð°",
        priceGroups: "Ð¦ÐµÐ½Ð¾Ð²Ð¸ Ð³ÑÑÐ¿Ð¸",
        pricePerLiter: "Ð¦ÐµÐ½Ð° Ð½Ð° Ð»Ð¸ÑÑÑ",
        productPricing: "Product pricing",
        purchasePrice: "ÐÐ¾ÐºÑÐ¿Ð½Ð° ÑÐµÐ½Ð°",
        purchasePricePerLiter: "ÐÐ¾ÐºÑÐ¿Ð½Ð°ÑÐ° ÑÐµÐ½Ð° Ð½Ð° Ð»Ð¸ÑÑÑ",
        sellPrice: "Sell price",
        surcharge: "ÐÐ¾Ð¿Ð»Ð°ÑÐ°Ð½Ðµ"
    },
    print: {
        adminRightsRequired: "Admin rights are required to edit or create a new template.",
        allowAutomaticPrint: "ÐÐ¾Ð·Ð²Ð¾Ð»ÐµÑÐµ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÐ½ Ð¿ÐµÑÐ°Ñ",
        allowPrintAfterDispensing: "ÐÐ¾Ð·Ð²Ð¾Ð»ÐµÑÐµ Ð¿ÐµÑÐ°Ñ ÑÐ»ÐµÐ´ Ð´Ð¾Ð·Ð¸ÑÐ°Ð½Ðµ",
        allowPrintBeforeDispensing: "ÐÐ¾Ð·Ð²Ð¾Ð»ÐµÑÐµ Ð¿ÐµÑÐ°Ñ Ð¿ÑÐµÐ´Ð¸ Ð´Ð¾Ð·Ð¸ÑÐ°Ð½Ðµ",
        automaticPrint: "ÐÐµÑÐ°ÑÐ°Ð¹ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐ½Ð¾",
        choosePrinter: "Choose printer",
        chooseSettings: "Edit Settings",
        chooseTemplate: "Choose template",
        copies: "Copies",
        createTemplate: "Create template",
        createTemplateHint: "Create a new template from scratch. Save it to the templates folder and restart RCC.",
        defaultPrinter: "ÐÑÐ¸Ð½ÑÐµÑ",
        defaultSettings: "Default settings",
        defaultTemplate: "Ð¨Ð°Ð±Ð»Ð¾Ð½ Ð¿Ð¾ Ð¿Ð¾Ð´ÑÐ°Ð·Ð±Ð¸ÑÐ°Ð½Ðµ",
        editTemplate: "Edit template",
        editTemplateHint: "Edit %{name}. Changes will be visible after RCC restart.",
        noEditTemplate: "No template to edit",
        noPrinterSelected: "ÐÐµ Ðµ Ð¸Ð·Ð±ÑÐ°Ð½ Ð¿ÑÐ¸Ð½ÑÐµÑ",
        noPrintersAvailable: "ÐÐµ ÑÐ° Ð½Ð°Ð»Ð¸ÑÐ½Ð¸ Ð¿ÑÐ¸Ð½ÑÐµÑÐ¸",
        noTemplateSelected: "ÐÐµ Ðµ Ð¸Ð·Ð±ÑÐ°Ð½ ÑÐ°Ð±Ð»Ð¾Ð½",
        noTemplatesAvailable: "ÐÑÐ¼Ð° Ð½Ð°Ð»Ð¸ÑÐ½Ð¸ ÑÐ°Ð±Ð»Ð¾Ð½Ð¸",
        numberOfCopies: "ÐÑÐ¾Ð¹ ÐºÐ¾Ð¿Ð¸Ñ",
        openTemplateEditor: "ÐÑÐ²Ð¾ÑÐ¸ ÑÐµÐ´Ð°ÐºÑÐ¾Ñ Ð½Ð° ÑÐ°Ð±Ð»Ð¾Ð½",
        printAfterDispensing: "ÐÐµÑÐ°Ñ ÑÐ»ÐµÐ´ Ð´Ð¾Ð·Ð¸ÑÐ°Ð½Ðµ",
        printAsImage: "ÐÐµÑÐ°Ñ ÐºÐ°ÑÐ¾ Ð¸Ð·Ð¾Ð±ÑÐ°Ð¶ÐµÐ½Ð¸Ðµ",
        printBeforeDispensing: "ÐÐµÑÐ°Ñ Ð¿ÑÐµÐ´Ð¸ Ð´Ð¾Ð·Ð¸ÑÐ°Ð½Ðµ",
        printOnRequest: "ÐÐµÑÐ°Ñ Ð¿ÑÐ¸ Ð¿Ð¾Ð¸ÑÐºÐ²Ð°Ð½Ðµ",
        printOptions: "ÐÐ¿ÑÐ¸Ð¸ Ð·Ð° Ð¿ÐµÑÐ°Ñ",
        printPagesAfterDispensing: "ÐÑÐ¾Ð¹ ÐºÐ¾Ð¿Ð¸Ñ ÑÐ»ÐµÐ´  Ð´Ð¾Ð·Ð¸ÑÐ°Ð½Ðµ Ð² Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ°",
        printPagesBeforeDispensing: "ÐÑÐ¾Ð¹ ÐºÐ¾Ð¿Ð¸Ñ Ð¿ÑÐµÐ´Ð¸  Ð´Ð¾Ð·Ð¸ÑÐ°Ð½Ðµ Ð² Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ°",
        printPreview: "ÐÑÐµÐ³Ð»ÐµÐ´ Ð¿ÑÐµÐ´Ð¸ Ð¿ÐµÑÐ°Ñ",
        printSettings: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ Ð½Ð° Ð¿ÑÐ¸Ð½ÑÐµÑÐ°",
        printTaskLinkVariable: "Link to a variable",
        printVariable: "Print variable",
        printerName: "ÐÐ¼Ðµ Ð½Ð° Ð¿ÑÐ¸Ð½ÑÐµÑ",
        printerOptions: "ÐÐ¿ÑÐ¸Ð¸ Ð½Ð° Ð¿ÑÐ¸Ð½ÑÐµÑÐ°",
        printerSettings: "Printer Options",
        quickTintTemplate: "Ð¨Ð°Ð±Ð»Ð¾Ð½ Ð·Ð° Ð±ÑÑÐ·Ð¾ ÑÐ¾Ð½Ð¸ÑÐ°Ð½Ðµ",
        setDefaultPrinter: "ÐÐ°Ð´Ð°Ð²Ð°Ð½Ðµ Ð½Ð° Ð¿ÑÐ¸Ð½ÑÐµÑ Ð¿Ð¾ Ð¿Ð¾Ð´ÑÐ°Ð·Ð±Ð¸ÑÐ°Ð½Ðµ",
        setDefaultTemplate: "ÐÐ°Ð´Ð°Ð²Ð°Ð½Ðµ Ð½Ð°  ÑÐ°Ð±Ð»Ð¾Ð½ Ð¿Ð¾ Ð¿Ð¾Ð´ÑÐ°Ð·Ð±Ð¸ÑÐ°Ð½Ðµ",
        setQuickTintTemplate: "ÐÐ°Ð´Ð°Ð²Ð°Ð½Ðµ Ð½Ð° ÑÐ°Ð±Ð»Ð¾Ð½ Ð·Ð° Ð±ÑÑÐ·Ð¾ ÑÐ¾Ð½Ð¸ÑÐ°Ð½Ðµ",
        showPreviewDialogBeforePrint: "Show preview dialog before print",
        template: "Ð¨Ð°Ð±Ð»Ð¾Ð½",
        templateName: "ÐÐ¼Ðµ Ð½Ð° ÑÐ°Ð±Ð»Ð¾Ð½Ð°",
        templateSettings: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ Ð½Ð° ÑÐ°Ð±Ð»Ð¾Ð½Ð°"
    },
    printTemplate: {
        baseCode: "ÐÐ¾Ð´ Ð½Ð° Ð±Ð°Ð·Ð°ÑÐ°",
        baseName: "ÐÐ¼Ðµ Ð½Ð° Ð±Ð°Ð·Ð°ÑÐ°",
        bfs: "BFS",
        colorantType: "Colorant type",
        customerCity: "ÐÑÐ°Ð´ Ð½Ð° ÐºÐ»Ð¸ÐµÐ½ÑÐ°",
        customerEmail: "ÐÐ¼ÐµÐ¹Ð» Ð½Ð° ÐºÐ»Ð¸ÐµÐ½ÑÐ¸",
        customerName: "ÐÐ¾ÑÑÐµÐ±Ð¸ÑÐµÐ»ÑÐºÐ¾ Ð¸Ð¼Ðµ",
        customerPhone: "Ð¢ÐµÐ»ÐµÑÐ¾Ð½ Ð½Ð° ÐºÐ»Ð¸ÐµÐ½ÑÐ°",
        customerStreet: "Ð£Ð»Ð¸ÑÐ° Ð½Ð° ÐºÐ»Ð¸ÐµÐ½ÑÐ°",
        customerZipCode: "ÐÐ¾ÑÐµÐ½ÑÐºÐ¸ ÐºÐ¾Ð´ Ð½Ð° ÐºÐ»Ð¸ÐµÐ½ÑÐ°",
        destinationOfUse: "Destination of use",
        infoBfsGrade: "BFS ÐºÐ»Ð°Ñ",
        orderQrCode: "QR ÐºÐ¾Ð´",
        packageOrderCount: "Package order count",
        posAddress: "POS Ð°Ð´ÑÐµÑ",
        posAddressSecond: "POS Ð°Ð´ÑÐµÑ 2",
        posCity: "Ð³ÑÐ°Ð´ POS",
        posContact: "POS ÐºÐ¾Ð½ÑÐ°ÐºÑ",
        posEmail: "POS Ð¸Ð¼ÐµÐ¹Ð»",
        posPhone: "POS ÑÐµÐ»ÐµÑÐ¾Ð½",
        posUrl: "POS URL",
        posZipCode: "POS Ð¿Ð¾ÑÐµÐ½ÑÐºÐ¸ ÐºÐ¾Ð´",
        priceBasePurchaseWithTax: "Ð¡ÐµÐ±ÐµÑÑÐ¾Ð¹Ð½Ð¾ÑÑ Ð½Ð° Ð±Ð°Ð·Ð° Ñ ÐÐÐ¡",
        priceBaseSellWithTax: "ÐÑÐ¾Ð´Ð°Ð¶Ð½Ð°ÑÐµÐ½Ð° Ð·Ð° Ð±Ð°Ð·Ð° Ñ ÐÐÐ¡",
        priceCntPurchaseWithTax: "Ð¡ÐµÐ±ÐµÑÑÐ¾Ð¹Ð½Ð¾ÑÑ Ð½Ð° ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ¸ Ñ ÐÐÐ¡",
        priceCntTotalSellWithTax: "ÐÑÐ¾Ð´Ð°Ð¶Ð½Ð° ÑÐµÐ½Ð° Ð·Ð° ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ¸ Ñ ÐÐÐ¡",
        priceMarginAllWithTax: "ÐÐ°ÑÐ¶ Ð·Ð° Ð²ÑÐ¸ÑÐºÐ¸ Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ¸ Ñ ÐÐÐ¡",
        priceMarginPerPkgWithTax: "ÐÐ°ÑÐ¶ Ð·Ð° ÐµÐ´Ð¸Ð½ Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ° Ñ ÐÐÐ¡",
        priceSellPriceAllWithTax: "ÐÑÐ¾Ð´Ð°Ð¶Ð½Ð° ÑÐµÐ½Ð° Ð·Ð° Ð²ÑÐ¸ÑÐºÐ¸ Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ¸ Ñ ÐÐÐ¡",
        priceSellPricePerKgWithTax: "ÐÑÐ¾Ð´Ð°Ð¶Ð½Ð° ÑÐµÐ½Ð° Ð·Ð° ÐºÐ¸Ð»Ð¾Ð³ÑÐ°Ð¼ Ñ ÐÐÐ¡",
        priceSellPricePerLWithTax: "ÐÑÐ¾Ð´Ð°Ð¶Ð½Ð° ÑÐµÐ½Ð° Ð½Ð° Ð»Ð¸ÑÑÑ Ñ ÐÐÐ¡",
        priceSellPricePerPkgWithTax: "ÐÑÐ¾Ð´Ð°Ð¶Ð½Ð° ÑÐµÐ½Ð° Ð·Ð° ÐµÐ´Ð¸Ð½ Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ° Ñ ÐÐÐ¡",
        priceSurchargeAllWithTax: "ÐÐ¾Ð¿Ð»Ð°ÑÐ°Ð½Ðµ Ð·Ð° Ð²ÑÐ¸ÑÐºÐ¸ Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ¸ Ñ ÐÐÐ¡",
        priceSurchargePerPkgWithTax: "ÐÐ¾Ð¿Ð»Ð°ÑÐ°Ð½Ðµ Ð·Ð° ÐµÐ´Ð½Ð° Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ° Ñ ÐÐÐ¡",
        priceTintPurchaseAllWithTax: "Ð¡ÐµÐ±ÐµÑÑÐ¾Ð¹Ð½Ð¾ÑÑ Ð½Ð° ÑÐ¾Ð½Ð¸ÑÐ°Ð½Ðµ Ð·Ð° Ð²ÑÐ¸ÑÐºÐ¸ Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ¸ Ñ ÐÐÐ¡",
        priceTintPurchasePerPkgWithTax: "Ð¡ÐµÐ±ÐµÑÑÐ¾Ð¹Ð½Ð¾ÑÑ Ð½Ð° ÑÐ¾Ð½Ð¸ÑÐ°Ð½Ðµ Ð·Ð° ÐµÐ´Ð½Ð° Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ° Ñ ÐÐÐ¡",
        priceTotalPurchaseAllWithTax: "ÐÐ±ÑÐ° ÑÐµÐ½Ð° Ð½Ð° Ð·Ð° Ð²ÑÐ¸ÑÐºÐ¸ Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ¸ Ñ ÐÐÐ¡",
        priceTotalPurchasePerKgWithTax: "ÐÐ±ÑÐ° ÑÐµÐ½Ð° ÑÐµÐ½Ð° Ð½Ð° ÐºÐ¸Ð»Ð¾Ð³ÑÐ°Ð¼ Ñ ÐÐÐ¡",
        priceTotalPurchasePerLWithTax: "ÐÐ±ÑÐ° ÑÐµÐ½Ð° ÑÐµÐ½Ð° Ð½Ð° Ð»Ð¸ÑÑÑ Ñ ÐÐÐ¡",
        priceTotalPurchasePerPkgWithTax: "ÐÐ±ÑÐ° ÑÐµÐ½Ð° Ð½Ð° ÑÐ°Ð·ÑÐ¾Ð´Ð¸ÑÐµ Ð·Ð° ÐµÐ´Ð½Ð° Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ° Ñ ÐÐÐ¡",
        productAltName: "ÐÑÐ¾Ð´ÑÐºÑ",
        recipeInline: "Ð ÐµÑÐµÐ¿ÑÐ°"
    },
    products: {
        bases: "ÐÐ°Ð·Ð¸",
        numberOfProducts: "ÎÏÎ¹Î¸Î¼ÏÏ Î ÏÎ¿ÏÏÎ½ÏÏÎ½",
        packagesFor: "ÐÐ¿Ð°ÐºÐ¾Ð²ÐºÐ¸ Ð·Ð° ",
        sizeOfPackage: "Ð Ð°Ð·Ð¼ÐµÑ Ð½Ð° Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ°ÑÐ°"
    },
    purgeModal: {
        purgeAll: "ÐÑÐ¾ÑÐ¸ÑÑÐ¸ Ð²ÑÐ¸ÑÐºÐ¸",
        purgeAllChannels: "ÐÑÐ¾ÑÐ¸ÑÑÐµÑÐµ Ð²ÑÐ¸ÑÐºÐ¸ ÐºÐ°Ð½Ð°Ð»Ð¸",
        purgeVolume: "ÐÐ±ÐµÐ¼ Ð½Ð° Ð¿ÑÐ¾ÑÐ¸ÑÑÐ²Ð°Ð½Ðµ",
        startPurge: "Ð¡ÑÐ°ÑÑ Ð½Ð° Ð¿ÑÐ¾ÑÐ¸ÑÑÐ²Ð°Ð½Ðµ"
    },
    qualityControl: {
        darker: "Darker",
        dispensedMeasuredFormula: "Dispensed (measured) formula",
        lighter: "Lighter",
        measureDispensedFormula: "Measure dispensed formula to calculate delta E",
        moreBlue: "More blue",
        moreGreen: "More green",
        moreRed: "More red",
        moreYellow: "More yellow",
        pleaseContinueToFormulaCorrection: "Please continue to formula correction",
        qualityControlFailed: "Quality control failed!",
        qualityControlPassed: "Quality control passed"
    },
    quickTint: {
        dispensingInProgress: "ÐÐ¾Ð·Ð¸ÑÐ°Ð½ÐµÑÐ¾ Ðµ Ð² Ð¿ÑÐ¾ÑÐµÑ",
        dispensingIsNotAvailable: "ÐÐ¾Ð·Ð¸ÑÐ°Ð½ÐµÑÐ¾ Ð½Ðµ Ðµ Ð´Ð¾ÑÑÑÐ¿Ð½Ð¾",
        machineNotConnected: "ÐÐ°ÑÐ¸Ð½Ð°ÑÐ° Ð½Ðµ Ðµ ÑÐ²ÑÑÐ·Ð°Ð½Ð°",
        noColorantsSelected: "ÐÐµ ÑÐ° Ð¸Ð·Ð±ÑÐ°Ð½Ð¸ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ¸",
        noPrinterAvailable: "ÐÐµÑÐ°Ñ Ð½Ðµ Ð¼Ð¾Ð¶Ðµ Ð´Ð° ÑÐµ Ð¸Ð·Ð²ÑÑÑÐ¸, ÑÑÐ¹ ÐºÐ°ÑÐ¾ Ð½ÑÐ¼Ð° Ð½Ð°Ð»Ð¸ÑÐµÐ½ Ð¿ÑÐ¸Ð½ÑÐµÑ.",
        noTemplateAvailable: "ÐÐµÑÐ°Ñ Ð½Ðµ Ð¼Ð¾Ð¶Ðµ Ð´Ð° ÑÐµ Ð¸Ð·Ð²ÑÑÑÐ¸, ÑÑÐ¹ ÐºÐ°ÑÐ¾ Ð½ÑÐ¼Ð° Ð½Ð°Ð»Ð¸ÑÐµÐ½ ÑÐ°Ð±Ð»Ð¾Ð½.",
        overMaxCanisterSize: "One or more colorant amounts are over their maximum"
    },
    quickTintSettings: {
        alphabetically: "ÐÐ¾ Ð°Ð·Ð±ÑÑÐµÐ½ ÑÐµÐ´",
        byCanister: "ÐÐ¾ ÑÐµÐ·ÐµÑÐ²Ð¾Ð°ÑÐ¸",
        closeAfterDispensing: "ÐÐ°ÑÐ²Ð¾ÑÐ¸ ÑÐ»ÐµÐ´ Ð´Ð¾Ð·Ð¸ÑÐ°Ð½Ðµ",
        closeBeforeDispensing: "ÐÐ°ÑÐ²Ð¾ÑÐ¸ Ð¿ÑÐµÐ´Ð¸ Ð´Ð¾Ð·Ð¸ÑÐ°Ð½Ðµ",
        quickTintSettings: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ Ð·Ð° Ð±ÑÑÐ·Ð¾ ÑÐ¾Ð½Ð¸ÑÐ°Ð½Ðµ",
        sorting: "Ð¡Ð¾ÑÑÐ¸ÑÐ°Ð½Ðµ",
        windowClosingRules: "ÐÑÐ°Ð²Ð¸Ð»Ð° Ð·Ð° Ð·Ð°ÑÐ²Ð°ÑÑÐ½Ðµ Ð½Ð° Ð¿ÑÐ¾Ð·Ð¾ÑÐµÑÐ°"
    },
    rccButtons: {
        abort: "Ð¿ÑÐµÐºÑÑÐ²Ð°Ð½Ðµ",
        all: "Ð²ÑÐ¸ÑÐºÐ¾",
        cancel: "Ð°Ð½ÑÐ»Ð¸ÑÐ°Ð½Ðµ",
        continue: "Ð¿ÑÐ¾Ð´ÑÐ»Ð¶Ð¸",
        help: "Ð¿Ð¾Ð¼Ð¾Ñ",
        ignore: "Ð¸Ð³Ð½Ð¾ÑÐ¸ÑÐ°Ð½Ðµ",
        no: "Ð½Ðµ",
        noToAll: "Ð½Ðµ Ð·Ð° Ð²ÑÐ¸ÑÐºÐ¸",
        ok: "Ð´Ð¾Ð±ÑÐµ",
        postpone: "Ð¾ÑÐ»Ð°Ð³Ð°Ð¼",
        resume: "Ð²ÑÐ·Ð¾Ð±Ð½Ð¾Ð²Ð¸",
        retry: "Ð¿Ð¾Ð²ÑÐ¾ÑÐµÐ½ Ð¾Ð¿Ð¸Ñ",
        skip: "Ð¿ÑÐ¾Ð¿ÑÑÐºÐ°Ð½Ðµ",
        yes: "Ð´Ð°",
        yesToAll: "Ð´Ð° Ð½Ð° Ð²ÑÐ¸ÑÐºÐ¾"
    },
    rccDialog: {
        98: "Please Verify the %{0} Base with the Barcode.",
        99: "Please Insert Base %{0} and Confirm (Click OK)",
        100: "ÐÐ¸ÑÐ¿ÐµÐ½ÑÐµÑÑÑ Ðµ Ð² ÑÑÑÑÐ¾ÑÐ½Ð¸Ðµ Ð½Ð° Ð³ÑÐµÑÐºÐ°, ÐÐ£ÐÐÐ ÐÐÐ Ð½Ð° Ð³ÑÐµÑÐºÐ°ÑÐ°?",
        101: "ÐÐ¸ÑÐ¿ÐµÐ½ÑÐµÑÑÑ Ðµ Ð² ÑÑÑÑÐ¾ÑÐ½Ð¸Ðµ Ð½Ð° Ð³ÑÐµÑÐºÐ°, ÐÐ ÐÐÐÐ Ð´Ð° Ð¿ÑÐ¾Ð´ÑÐ»Ð¶Ð¸",
        102: "ÐÑÐ»Ð¸ÑÐ°Ð½ÐµÑÐ¾ Ðµ Ð¾ÑÑÐ²ÑÑÐ»ÐµÐ½Ð¾, Ð½Ðµ Ð¼Ð¾Ð¶Ðµ Ð´Ð° Ð¿ÑÐ¾Ð´ÑÐ»Ð¶Ð¸",
        103: "Ð¤Ð¾ÑÐ¼ÑÐ»Ð°ÑÐ° ÑÑÐ´ÑÑÐ¶Ð° Ð½ÐµÐ²Ð°Ð»Ð¸Ð´ÐµÐ½ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½Ñ: %{0}",
        104: "Ð¤Ð¾ÑÐ¼ÑÐ»Ð°ÑÐ° ÑÑÐ´ÑÑÐ¶Ð° Ð½ÐµÐ²Ð°Ð»Ð¸Ð´Ð½Ð¸ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ¸: %{0}",
        105: "ÐÐ¾Ð»Ð¾ÑÐ°Ð½Ñ %{0} Ðµ Ð¿Ð¾Ð´ Ð¿ÑÐµÐ´ÑÐ¿ÑÐµÐ´Ð¸ÑÐµÐ»Ð½Ð¾ÑÐ¾ Ð½Ð¸Ð²Ð¾",
        106: "ÐÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ¸ %{0} ÑÐ° Ð¿Ð¾Ð´ Ð¿ÑÐµÐ´ÑÐ¿ÑÐµÐ´Ð¸ÑÐµÐ»Ð½Ð¾ÑÐ¾ Ð½Ð¸Ð²Ð¾",
        107: "ÐÐ¾Ð»Ð¾ÑÐ°Ð½Ñ %{0} Ðµ Ð¿Ð¾Ð´ ÐºÑÐ¸ÑÐ¸ÑÐ½Ð¾ÑÐ¾ Ð½Ð¸Ð²Ð¾",
        108: "ÐÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ¸ %{0} ÑÐ° Ð¿Ð¾Ð´ ÐºÑÐ¸ÑÐ¸ÑÐ½Ð¾ÑÐ¾ Ð½Ð¸Ð²Ð¾",
        109: "ÐÐ¾ÑÑÐ°Ð²Ð¸ Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ°",
        110: "Place base can: %{0} for formula: %{1}",
        111: "ÐÐ·ÐµÐ¼Ð¸ Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ°ÑÐ°",
        112: "ÐÐµÑÑÐ¾ÑÐ¸ÑÐ°Ð½Ðµ Ð½Ð° Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ°ÑÐ°?",
        113: "ÐÑÐ»Ð¸ÑÐ°Ð½Ðµ Ð½Ð° Ð³ÑÐµÑÐºÐ¸ÑÐµ, Ð¼Ð¾Ð»Ñ Ð¸Ð·ÑÐ°ÐºÐ°Ð¹",
        114: "ÐÑÐµÐ¼ÐµÑÑÐ²Ð°Ð½Ðµ Ð½Ð° ÑÐ°ÑÑÐ°, Ð¼Ð¾Ð»Ñ Ð¸Ð·ÑÐ°ÐºÐ°Ð¹",
        115: "ÐÐµÑÑÐ¾ÑÐ¸ÑÐ°Ð½Ðµ Ð½Ð° Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ°ÑÐ°, Ð¼Ð¾Ð»Ñ Ð¸Ð·ÑÐ°ÐºÐ°Ð¹",
        116: "Dispensing formula %{0}, please wait|Package: %{1} of %{2}|Product: %{3}|Base: %{4}|Can size: %{5}",
        117: "Dispensing formula %{0}, please wait|Package: %{1} of %{2}|Product: %{3}|Base: %{4}|Can size: %{5}",
        118: "ÐÐ¾Ð·Ð¸ÑÐ°Ð½Ðµ, Ð¼Ð¾Ð»Ñ Ð¸Ð·ÑÐ°ÐºÐ°Ð¹ÑÐµ|Package: %{0} of %{1}",
        119: "ÐÐ¾Ð·Ð¸ÑÐ°Ð½Ðµ, Ð¼Ð¾Ð»Ñ Ð¸Ð·ÑÐ°ÐºÐ°Ð¹ÑÐµ|Package: %{0} of %{1}",
        120: "ÐÐ½ÑÐ»Ð¸ÑÐ°Ð½Ðµ Ð½Ð° Ð´Ð¾Ð·Ð¸ÑÐ°Ð½ÐµÑÐ¾, Ð¼Ð¾Ð»Ñ Ð¸Ð·ÑÐ°ÐºÐ°Ð¹",
        121: "ÐÐ°Ð»Ð¸Ð´Ð¸ÑÐ°Ð½Ðµ Ð±Ð°ÑÐºÐ¾Ð´ Ð½Ð° Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ°ÑÐ°",
        122: "Validate base can barcode|Product: %{0}|Base: %{1}|Can size: %{2}",
        123: "ÐÑÐ¾ÑÐµÑÑÑ Ð½Ð° Ð´Ð¾Ð·Ð¸ÑÐ°Ð½Ðµ Ðµ Ð±Ð¸Ð» Ð°Ð½ÑÐ»Ð¸ÑÐ°Ð½, Ð¸ÑÐºÐ°ÑÐµ Ð»Ð¸ Ð´Ð° Ð²ÑÐ·Ð¾Ð±Ð½Ð¾Ð²Ð¸ÑÐµ Ð´Ð¾Ð·Ð¸ÑÐ°Ð½ÐµÑÐ¾?",
        124: "Dispenser error occurred %{0} : %{1}. Do you want to resume dispensing?",
        125: "Ð£Ð²ÐµÑÐµÑÐµ ÑÐµ, ÑÐµ Ðµ Ð¿Ð¾ÑÑÐ°Ð²ÐµÐ½Ð° Ð¸Ð·Ð¿Ð¾Ð»Ð·Ð²Ð°Ð½Ð°ÑÐ° Ð¿ÑÐµÐ´Ð¸ Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ°",
        126: "Ð£Ð²ÐµÑÐµÑÐµ ÑÐµ, ÑÐµ Ð¸Ð·Ð¿Ð¾Ð»Ð·Ð²Ð°ÑÐµ Ð½Ð¾Ð²Ð° ÐºÑÑÐ¸Ñ, ÑÑÐ¹ ÐºÐ°ÑÐ¾ Ð¿ÑÐ¾ÑÐµÑÑÑ Ð½Ð° Ð´Ð¾Ð·Ð¸ÑÐ°Ð½Ðµ ÑÐµ Ð·Ð°Ð¿Ð¾ÑÐ½Ðµ Ð¾Ñ Ð½ÑÐ»Ð°ÑÐ°,",
        127: "ÐÑÐ²ÐµÑÐ¸ÑÐµÐ»: %{0} Ðµ Ð¿Ð¾Ð´ Ð¼Ð¸Ð½Ð¸Ð¼Ð°Ð»Ð½Ð° ÑÑÐ¼Ð° Ð·Ð° Ð¾ÑÐ²Ð¾Ð±Ð¾Ð¶Ð´Ð°Ð²Ð°Ð½Ðµ. ÐÑÐºÐ°ÑÐµ Ð»Ð¸ Ð´Ð° Ð¿ÑÐ¾Ð´ÑÐ»Ð¶Ð¸ÑÐµ Ð²ÑÐ¿ÑÐµÐºÐ¸ ÑÐ¾Ð²Ð° Ð¿ÑÐµÐ´ÑÐ¿ÑÐµÐ¶Ð´ÐµÐ½Ð¸Ðµ?",
        128: "ÐÑÐ²ÐµÑÐ¸ÑÐµÐ»Ð¸: %{0} ÑÐ° Ð¿Ð¾Ð´ Ð¼Ð¸Ð½Ð¸Ð¼Ð°Ð»Ð½Ð° ÑÑÐ¼Ð° Ð·Ð° Ð¾ÑÐ²Ð¾Ð±Ð¾Ð¶Ð´Ð°Ð²Ð°Ð½Ðµ. ÐÑÐºÐ°ÑÐµ Ð»Ð¸ Ð´Ð° Ð¿ÑÐ¾Ð´ÑÐ»Ð¶Ð¸ÑÐµ Ð²ÑÐ¿ÑÐµÐºÐ¸ ÑÐ¾Ð²Ð° Ð¿ÑÐµÐ´ÑÐ¿ÑÐµÐ¶Ð´ÐµÐ½Ð¸Ðµ?",
        129: "Selected formula brokes the overfill rule, total amount of colorans: %{0} %{1}, maximum allowed amounts of colorants: %{2} %{3}. Do you want to continue despite this warning?",
        130: "ÐÐ¸ÑÐ¿ÐµÐ½ÑÐµÑÑÑ Ðµ Ð² ÑÑÑÑÐ¾ÑÐ½Ð¸Ðµ Ð½Ð° Ð³ÑÐµÑÐºÐ°, ÐÐ£ÐÐÐ ÐÐÐ Ð½Ð° Ð³ÑÐµÑÐºÐ°ÑÐ°?",
        131: "ÐÐ¸ÑÐ¿ÐµÐ½ÑÐµÑÑÑ Ðµ Ð² ÑÑÑÑÐ¾ÑÐ½Ð¸Ðµ Ð½Ð° Ð³ÑÐµÑÐºÐ°, ÐÐ ÐÐÐÐ Ð´Ð° Ð¿ÑÐ¾Ð´ÑÐ»Ð¶Ð¸",
        132: "ÐÑÐ»Ð¸ÑÐ°Ð½ÐµÑÐ¾ Ðµ Ð¾ÑÑÐ²ÑÑÐ»ÐµÐ½Ð¾, Ð½Ðµ Ð¼Ð¾Ð¶Ðµ Ð´Ð° Ð¿ÑÐ¾Ð´ÑÐ»Ð¶Ð¸",
        133: "Ð¤Ð¾ÑÐ¼ÑÐ»Ð°ÑÐ° Ð·Ð° Ð¿ÑÐ¾ÑÐ¸ÑÑÐ²Ð°Ð½Ðµ Ðµ Ð¿ÑÐ°Ð·Ð½Ð°, ÐÐ ÐÐÐÐ Ð´Ð° Ð¿ÑÐ¾Ð´ÑÐ»Ð¶Ð¸",
        134: "Ð¤Ð¾ÑÐ¼ÑÐ»Ð°ÑÐ° Ð·Ð° Ð¿ÑÐ¾ÑÐ¸ÑÑÐ²Ð°Ð½Ðµ ÑÑÐ´ÑÑÐ¶Ð° ÐµÐ»ÐµÐ¼ÐµÐ½ÑÐ¸, ÐºÐ¾Ð¸ÑÐ¾ Ð½Ðµ Ð¼Ð¾Ð³Ð°Ñ Ð´Ð° Ð±ÑÐ´Ð°Ñ Ð¿ÑÐ¾ÑÐ¸ÑÑÐµÐ½Ð¸, Ð¶ÐµÐ»Ð°ÐµÑÐµ Ð»Ð¸ Ð´Ð° Ð¿ÑÐ¾Ð´ÑÐ»Ð¶Ð¸ÑÐµ?",
        135: "ÐÐ¾ÑÑÐ°Ð²Ð¸ Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ° Ð·Ð° Ð¿ÑÐ¾ÑÐ¸ÑÑÐ²Ð°Ð½Ðµ",
        136: "ÐÑÐµÐ¼Ð°ÑÐ½Ð¸ Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ°ÑÐ° Ð·Ð° Ð¿ÑÐ¾ÑÐ¸ÑÑÐ²Ð°Ð½Ðµ",
        137: "ÐÑÐ»Ð¸ÑÐ°Ð½Ðµ Ð½Ð° Ð³ÑÐµÑÑÐºÐ¸ÑÐµ, Ð¼Ð¾Ð»Ñ Ð¸Ð·ÑÐ°ÐºÐ°Ð¹ÑÐµ",
        138: "ÐÑÐµÐ¼ÐµÑÑÐ²Ð°Ð½Ðµ Ð½Ð° ÑÐ°ÑÑÐ°, Ð¼Ð¾Ð»Ñ Ð¸Ð·ÑÐ°ÐºÐ°Ð¹",
        139: "ÐÑÐ¾ÑÐ¸ÑÑÐ²Ð°Ð½Ðµ, Ð¼Ð¾Ð»Ñ Ð¸Ð·ÑÐ°ÐºÐ°Ð¹ÑÐµ",
        140: "ÐÑÐ¾ÑÐ¸ÑÑÐ²Ð°Ð½Ðµ, Ð¼Ð¾Ð»Ñ Ð¸Ð·ÑÐ°ÐºÐ°Ð¹ÑÐµ",
        141: "ÐÐ½ÑÐ»Ð¸ÑÐ°Ð½Ðµ Ð½Ð° Ð¿ÑÐ¾ÑÐ¸ÑÑÐ²Ð°Ð½ÐµÑÐ¾, Ð¼Ð¾Ð»Ñ Ð¸Ð·ÑÐ°ÐºÐ°Ð¹ÑÐµ",
        142: "ÐÐ¿Ð°ÐºÐ¾Ð²ÐºÐ°ÑÐ° Ð·Ð° Ð¿ÑÐ¾ÑÐ¸ÑÑÐ²Ð°Ð½Ðµ Ð»Ð¸Ð¿ÑÐ²Ð°, Ð¿ÑÐ¾Ð²ÐµÑÐµÑÐµ Ð´Ð°Ð»Ð¸ Ðµ Ð¿Ð¾ÑÑÐ°Ð²ÐµÐ½Ð° Ð¿ÑÐ°Ð²Ð¸Ð»Ð½Ð¾",
        143: "Ð¤Ð¾ÑÐ¼ÑÐ»Ð°ÑÐ° Ð·Ð° Ð¿ÑÐ¾ÑÐ¸ÑÑÐ²Ð°Ð½Ðµ ÑÑÐ´ÑÑÐ¶Ð° ÐµÐ»ÐµÐ¼ÐµÐ½ÑÐ¸, ÐºÐ¾Ð¸ÑÐ¾ Ð½Ðµ Ð¼Ð¾Ð³Ð°Ñ Ð´Ð° Ð±ÑÐ´Ð°Ñ Ð¿ÑÐ¾ÑÐ¸ÑÑÐµÐ½Ð¸, Ð¸ÑÐºÐ°ÑÐµ Ð»Ð¸ Ð´Ð° Ð¿ÑÐ¾Ð´ÑÐ»Ð¶Ð¸ÑÐµ?",
        144: "ÐÐ¾ÑÑÐ°Ð²Ð¸ Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ° Ð·Ð° Ð¿ÑÐ¾ÑÐ¸ÑÑÐ²Ð°Ð½Ðµ",
        145: "ÐÐ¾Ð´Ð³Ð¾ÑÐ¾Ð²ÐºÐ°, Ð¼Ð¾Ð»Ñ Ð¸Ð·ÑÐ°ÐºÐ°Ð¹ÑÐµ",
        146: "ÐÐ¾Ð²ÑÑÑÐ²Ð°Ð½Ðµ, Ð¼Ð¾Ð»Ñ Ð¸Ð·ÑÐ°ÐºÐ°Ð¹ÑÐµ",
        150: "ÐÐ¾ÑÐ¸ÑÑÐ²ÐµÐ½Ðµ, Ð¼Ð¾Ð»Ñ Ð¸Ð·ÑÐ°ÐºÐ°Ð¹ÑÐµ",
        151: "ÐÐ¾ÑÐ¸ÑÑÐ²Ð°Ð½Ðµ, Ð¼Ð¾Ð»Ñ Ð¸Ð·ÑÐ°ÐºÐ°Ð¹ÑÐµ",
        152: "ÐÐ½ÑÐ»Ð¸ÑÐ°Ð½Ðµ Ð½Ð° Ð¿Ð¾ÑÐ¸ÑÑÐ²Ð°Ð½ÐµÑÐ¾",
        160: "Ð ÐµÑÐ¸ÑÐºÑÐ»Ð°ÑÐ¸Ñ, Ð¼Ð¾Ð»Ñ Ð¸Ð·ÑÐ°ÐºÐ°Ð¹ÑÐµ",
        161: "Ð ÐµÑÐ¸ÑÐºÑÐ»Ð°ÑÐ¸Ñ, Ð¼Ð¾Ð»Ñ Ð¸Ð·ÑÐ°ÐºÐ°Ð¹ÑÐµ",
        162: "ÐÐ½ÑÐ»Ð¸ÑÐ°Ð½Ðµ Ð½Ð° ÑÐµÑÐ¸ÑÐºÑÐ»Ð°ÑÐ¸ÑÑÐ°, Ð¼Ð¾Ð»Ñ Ð¸Ð·ÑÐ°ÐºÐ°Ð¹ÑÐµ",
        170: "Ð Ð°Ð·Ð±ÑÑÐºÐ²Ð°Ð½Ðµ, Ð¼Ð¾Ð»Ñ Ð¸Ð·ÑÐ°ÐºÐ°Ð¹ÑÐµ",
        171: "Ð Ð°Ð·Ð±ÑÑÐºÐ²Ð°Ð½Ðµ, Ð¼Ð¾Ð»Ñ Ð¸Ð·ÑÐ°ÐºÐ°Ð¹ÑÐµ",
        172: "ÐÐ½ÑÐ»Ð¸ÑÐ°Ð½Ðµ Ð½Ð° ÑÐ°Ð·Ð±ÑÑÐºÐ²Ð°Ð½ÐµÑÐ¾, Ð¼Ð¾Ð»Ñ Ð¸Ð·ÑÐºÐ°Ð¹ÑÐµ",
        180: "ÐÐ½Ð¸ÑÐ¸Ð°Ð»Ð¸Ð·Ð¸ÑÐ°Ð½Ðµ Ð½Ð° Ð²ÑÑÐ·ÐºÐ°ÑÐ° ÐºÑÐ¼ Ð´Ð¸ÑÐ¿ÐµÐ½ÑÐµÑÐ°, Ð¼Ð¾Ð»Ñ Ð¸Ð·ÑÐ°ÐºÐ°Ð¹ÑÐµ",
        181: "Connection to the dispenser cannot be established %{0}: %{1}",
        182: "ÐÐµ Ð¼Ð¾Ð¶Ðµ Ð´Ð° ÑÐµ ÑÑÑÐ°Ð½Ð¾Ð²Ð¸ Ð²ÑÑÐ·ÐºÐ° Ñ Ð´Ð¾Ð·Ð°ÑÐ¾ÑÐ°, Ð¼Ð¾Ð»Ñ Ð¿ÑÐ¾Ð²ÐµÑÐµÑÐµ log ÑÐ°Ð¹Ð»Ð°",
        183: "Ð Ð´Ð¾Ð·Ð°ÑÐ¾ÑÐ° Ð»Ð¸Ð¿ÑÐ²Ð° Ð¾ÑÐ²ÐµÑÐ¸ÑÐµÐ»: %{0}, ÐºÐ¾Ð¹ÑÐ¾ Ðµ Ð´ÐµÑÐ¸Ð½Ð¸ÑÐ°Ð½ Ð²ÑÐ² Ð²Ð°ÑÐ°ÑÐ° Ð±Ð°Ð·Ð° Ð´Ð°Ð½Ð½Ð¸",
        184: "Ð Ð´Ð¾Ð·Ð°ÑÐ¾ÑÐ° Ð»Ð¸Ð¿ÑÐ²Ð°Ñ Ð¾ÑÐ²ÐµÑÐ¸ÑÐµÐ»Ð¸: %{0}, ÐºÐ¾Ð¸ÑÐ¾ ÑÐ° Ð´ÐµÑÐ¸Ð½Ð¸ÑÐ°Ð½Ð¸ Ð²ÑÐ² Ð²Ð°ÑÐ°ÑÐ° Ð±Ð°Ð·Ð° Ð´Ð°Ð½Ð½Ð¸",
        185: "ÐÐ°ÑÐ²Ð°ÑÑÐ½Ðµ Ð½Ð° Ð²ÑÑÐ·ÐºÐ°ÑÐ° ÐºÑÐ¼ Ð´Ð¾Ð·Ð°ÑÐ¾ÑÐ°, Ð¼Ð¾Ð»Ñ Ð¸Ð·ÑÐ°ÐºÐ°Ð¹ÑÐµ",
        190: "ÐÐ°ÑÐ²Ð¾ÑÐµÑÐµ ÑÐµÑÐ²Ð¸Ð·Ð½Ð¸Ñ Ð¿ÑÐ¾Ð·Ð¾ÑÐµÑ, Ð·Ð° Ð´Ð° Ð¿ÑÐ¾Ð´ÑÐ»Ð¶Ð¸ÑÐµ",
        200: "ÐÑÐ»Ð¸ÑÐ°Ð½Ðµ, Ð¼Ð¾Ð»Ñ Ð¸Ð·ÑÐ°ÐºÐ°Ð¹ÑÐµ",
        201: "Ð¢Ð²ÑÑÐ´Ð¾ Ð½ÑÐ»Ð¸ÑÐ°Ð½Ðµ, Ð¼Ð¾Ð»Ñ Ð¸Ð·ÑÐ°ÐºÐ°Ð¹ÑÐµ",
        202: "ÐÐ½Ð¸ÑÐ¸Ð°Ð»Ð¸Ð·Ð¸ÑÐ°Ð½Ðµ, Ð¼Ð¾Ð»Ñ Ð¸Ð·ÑÐºÐ°Ð¹ÑÐµ",
        203: "ÐÑÐ»Ð¸ÑÐ°Ð½Ðµ Ð½Ð° Ð³ÑÐµÑÐºÐ¸ÑÐµ, Ð¼Ð¾Ð»Ñ Ð¸Ð·ÑÐ°ÐºÐ°Ð¹ÑÐµ",
        205: "ÐÐ°Ð¿Ð°ÑÐºÐ°ÑÐ° ÑÐµ Ð¾ÑÐ²Ð°ÑÑ, Ð¼Ð¾Ð»Ñ Ð¸Ð·ÑÐ°ÐºÐ°Ð¹ÑÐµ",
        206: "ÐÐ°Ð¿Ð°ÑÐºÐ°ÑÐ° ÑÐµ Ð·Ð°ÑÐ²Ð°ÑÑ, Ð¼Ð¾Ð»Ñ Ð¸Ð·ÑÐ°ÐºÐ°Ð¹ÑÐµ",
        207: "ÐÐ°Ð¿Ð°ÑÐºÐ°ÑÐ° ÑÐµ Ð¿ÑÐµÐ¼ÐµÑÑÐ²Ð°, Ð¼Ð¾Ð»Ñ Ð¸Ð·ÑÐ°ÐºÐ°Ð¹ÑÐµ",
        210: "ÐÐµÑÑÐ¾ÑÐ¸ÑÐ°Ð½Ðµ, Ð¼Ð¾Ð»Ñ Ð¸Ð·ÑÐ°ÐºÐ°Ð¹ÑÐµ",
        211: "ÐÐ°Ð¿ÑÑÐ²Ð°Ð½Ðµ, Ð¼Ð¾Ð»Ñ Ð¸Ð·ÑÐ°ÐºÐ°Ð¹ÑÐµ",
        215: "ÐÑÐµÐ¼ÐµÑÑÐ²Ð°Ð½Ðµ Ð½Ð° ÑÐ°ÑÑÐ° Ð½Ð°Ð³Ð¾ÑÐµ, Ð¼Ð¾Ð»Ñ Ð¸Ð·ÑÐ°ÐºÐ°Ð¹ÑÐµ",
        216: "ÐÑÐµÐ¼ÐµÑÑÐ²Ð°Ð½Ðµ Ð½Ð° ÑÐ°ÑÑÐ° Ð½Ð°Ð´Ð¾Ð»Ñ, Ð¼Ð¾Ð»Ñ Ð¸Ð·ÑÐ°ÐºÐ°Ð¹ÑÐµ",
        217: "ÐÑÐµÐ¼ÐµÑÑÐ²Ð°Ð½Ðµ Ð½Ð° ÑÐ°ÑÑÐ°, Ð¼Ð¾Ð»Ñ Ð¸Ð·ÑÐ°ÐºÐ°Ð¹ÑÐµ",
        220: "Moving table to refill position: %{0}, please wait",
        221: "ÐÐ°Ð²ÑÑÑÐ°Ð½Ðµ Ð½Ð° Ð¼Ð°ÑÐ°ÑÐ° Ð² Ð½Ð°ÑÐ°Ð»Ð½Ð° Ð¿Ð¾Ð·Ð¸ÑÐ¸Ñ",
        222: "ÐÐ·Ð²ÑÑÑÐ°Ð½Ðµ Ð½Ð° Ð¼Ð°ÑÐ°ÑÐ°, Ð¼Ð¾Ð»Ñ Ð¸Ð·ÑÐ°ÐºÐ°Ð¹ÑÐµ",
        230: "ÐÐ¾Ð·Ð°ÑÐ¾ÑÑÑ Ðµ Ð·Ð°ÐµÑ, Ð¼Ð¾Ð»Ñ Ð¸Ð·ÑÐºÐ°Ð¹ÑÐµ",
        240: "Refill canister %{0}",
        241: "Please refill canister %{0}",
        242: "ÐÐ¾Ð·Ð¸ÑÐ¸Ð¾Ð½Ð¸ÑÐ° ÑÐµÐ·ÐµÑÐ²Ð¾Ð°Ñ: %{0} (%{1}) ÐºÑÐ¼ Ð¿Ð¾Ð·Ð¸ÑÐ¸Ñ Ð·Ð° Ð¿ÑÐµÐ·Ð°ÑÐµÐ¶Ð´Ð°Ð½Ðµ",
        243: "ÐÐ¾Ð»Ñ, Ð½Ð°Ð¿ÑÐ»Ð½ÐµÑÐµ ÐºÐ°Ð½Ð¸ÑÑÑÐ° %{0}, Ð¸Ð·Ð¿Ð¾Ð»Ð·Ð²Ð°Ð¹ÐºÐ¸ Ð±Ð°ÑÐºÐ¾Ð´",
        244: "ÐÐ¾Ð»Ñ, Ð½Ð°Ð¿ÑÐ»Ð½ÐµÑÐµ ÐºÐ°Ð½Ð¸ÑÑÑÐ° %{0}, Ð¸Ð·Ð¿Ð¾Ð»Ð·Ð²Ð°Ð¹ÐºÐ¸ Ð±Ð°ÑÐºÐ¾Ð´",
        250: "ÐÐ·Ð²Ð°Ð´ÐµÑÐµ ÐºÐ¾Ð½ÑÐµÐ¹Ð½ÐµÑÐ° Ð·Ð° ÑÐµÑÐºÐ°, Ð¿Ð¾ÑÐ¸ÑÑÐµÑÐµ Ð³Ð¾  Ð¸  Ð½Ð°Ð¿ÑÐ»Ð½ÐµÑÐµ Ñ Ð²Ð¾Ð´Ð° Ð² ÑÑÐ¾ÑÐ²ÐµÑÑÑÐ²Ð¸Ðµ Ñ Ð¸Ð½ÑÑÑÑÐºÑÐ¸Ð¸ÑÐµ",
        251: "Put back brush conainer",
        254: "ÐÑÐ²Ð°ÑÑÐ½Ðµ Ð½Ð° Ð°Ð²ÑÐ¾ÐºÐ°Ð¿Ð°ÑÐºÐ°ÑÐ°",
        255: "ÐÐ¾ÑÐ¸ÑÑÐµÑÐµ ÐºÐ°Ð¿Ð°ÑÐºÐ°ÑÐ° ÑÑÐ³Ð»Ð°ÑÐ½Ð¾ Ð¸Ð½ÑÑÑÑÐºÑÐ¸Ð¸ÑÐµ",
        256: "ÐÐ¾ÑÐ²ÑÑÐ´ÐµÑÐµ ÐºÐ¾Ð³Ð° Ð¿Ð¾ÑÐ¸ÑÑÐ²Ð°Ð½ÐµÑÐ¾ Ðµ ÑÐ²ÑÑÑÐ¸Ð»Ð¾ Ð¸ Ð°Ð²ÑÐ¾ÐºÐ°Ð¿Ð°ÑÐºÐ°ÑÐ° Ðµ Ð¾Ð±ÑÐ°ÑÐ½Ð¾ Ð½Ð° Ð¼ÑÑÑÐ¾",
        257: "ÐÐ°ÑÐ²Ð°ÑÑÐ½Ðµ Ð½Ð° Ð°Ð²ÑÐ¾ÐºÐ°Ð¿Ð°ÑÐºÐ°ÑÐ°",
        260: "ÐÐ·Ð²Ð°Ð´ÐµÑÐµ Ð¿ÑÐµÐ²ÐºÐ»ÑÑÐ²Ð°ÑÐ°ÑÐ° Ð¿Ð»Ð¾ÑÐ° Ð¸ Ñ Ð¿Ð¾ÑÐ¸ÑÑÐµÑÐµ",
        261: "ÐÐ¾ÑÑÐ°Ð²ÐµÑÐµ Ð¾Ð±ÑÐ°ÑÐ½Ð¾ Ð¿ÑÐµÐ²ÐºÐ»ÑÑÐ²Ð°ÑÐ°ÑÐ° Ð¿Ð»Ð¾ÑÐ°",
        265: "ÐÐ¾ÑÐ¸ÑÑÐµÑÐµ Ð¼Ð°ÑÐ¸Ð½Ð°ÑÐ° Ñ ÐºÑÑÐ¿Ð° Ð¸ Ð¾ÑÑÑÑÐ°Ð½ÐµÑÐµ Ð²ÑÐ¸ÑÐºÐ¸ ÑÐ°Ð·Ð»ÑÑÐ¸ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ¸ Ð¸ ÑÐµÑÐ½Ð¾ÑÑÐ¸",
        266: "ÐÐ¾ÑÐ²ÑÑÐ´ÐµÑÐµ, ÐºÐ¾Ð³Ð°ÑÐ¾ Ðµ Ð³Ð¾ÑÐ¾Ð²Ð¾",
        270: "ÐÐ°Ð¿ÑÐ»Ð½ÐµÑÐµ ÑÐµÐ·ÐµÑÐ²Ð¾Ð°ÑÐ° Ð·Ð°  Ð¾Ð²Ð»Ð°Ð¶Ð½Ð¸ÑÐµÐ» Ð¸ Ð¿Ð¾ÑÐ²ÑÑÐ´ÐµÑÐµ, ÐºÐ¾Ð³Ð°ÑÐ¾ Ðµ Ð³Ð¾ÑÐ¾Ð²Ð¾",
        271: "ÐÐ°Ð¿ÑÐ»Ð½ÐµÑÐµ ÑÐµÐ·ÐµÑÐ²Ð¾Ð°ÑÐ° Ð·Ð° Ð¾Ð²Ð»Ð°Ð¶Ð½Ð¸ÑÐµÐ» Ð¸ Ð¿Ð¾ÑÐ²ÑÑÐ´ÐµÑÐµ, ÐºÐ¾Ð³Ð°ÑÐ¾ Ðµ Ð³Ð¾ÑÐ¾Ð²Ð¾",
        272: "ÐÐ¸Ð²Ð¾ÑÐ¾ Ð½Ð° Ð²Ð¾Ð´Ð°ÑÐ° Ðµ Ð²ÑÐµ Ð¾ÑÐµ Ð½Ð¸ÑÐºÐ¾, Ð¿ÑÐ¾Ð²ÐµÑÐµÑÐµ Ð¾ÑÐ½Ð¾Ð²Ð¾",
        273: "ÐÐ¸Ð²Ð¾ÑÐ¾ Ð½Ð° Ð²Ð¾Ð´Ð°ÑÐ° Ðµ Ð²ÑÐµ Ð¾ÑÐµ Ð½Ð¸ÑÐºÐ¾, Ð¿ÑÐ¾Ð²ÐµÑÐµÑÐµ Ð¾ÑÐ½Ð¾Ð²Ð¾",
        274: "Check the water level in humidifier container",
        275: "ÐÐ¾Ð»Ñ Ð¸Ð·ÑÐ°ÐºÐ°Ð¹",
        280: "Ð ÐµÑÑÐ°ÑÑÐ¸ÑÐ°Ð½Ðµ Ð½Ð° ÐºÐ¾Ð¼Ð¿ÑÑÑÑÐ°",
        281: "ÐÐ·ÐºÐ»ÑÑÐ²Ð°Ð½Ðµ Ð½Ð° ÐºÐ¾Ð¼Ð¿ÑÑÑÑÐ°",
        300: "Base can missing, check that the can is properly placed",
        301: "ÐÐ¾Ð´Ð³Ð¾ÑÐ¾Ð²ÐºÐ°, Ð¼Ð¾Ð»Ñ Ð¸Ð·ÑÐ°ÐºÐ°Ð¹ÑÐµ",
        302: "ÐÐ¾Ð²ÑÑÑÐ²Ð°Ð½Ðµ, Ð¼Ð¾Ð»Ñ Ð¸Ð·ÑÐ°ÐºÐ°Ð¹ÑÐµ",
        303: "Ð¤Ð¾ÑÐ¼ÑÐ»Ð°ÑÐ° Ð½Ðµ Ð¼Ð¾Ð¶Ðµ Ð´Ð° ÑÐµ Ð¸Ð·Ð¿ÑÐ»Ð½Ð¸, ÑÑÐ¹ ÐºÐ°ÑÐ¾ ÑÑÐ´ÑÑÐ¶Ð° Ð¾ÑÐ²ÐµÑÐ¸ÑÐµÐ»: %{0} ÐºÐ¾Ð¹ÑÐ¾ Ðµ Ð½Ð°Ð´ Ð¼Ð°ÐºÑÐ¸Ð¼Ð°Ð»Ð½Ð°ÑÐ° ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾ Ð·Ð° Ð´Ð¾Ð·Ð¸ÑÐ°Ð½Ðµ, Ð¾Ð¿ÑÐµÐ´ÐµÐ»ÐµÐ½Ð° Ð·Ð° ÐºÐ¾Ð½ÑÐµÐ¹Ð½ÐµÑ",
        304: "Ð¤Ð¾ÑÐ¼ÑÐ»Ð° Ð½Ðµ Ð¼Ð¾Ð³Ð°Ñ Ð´Ð° ÑÐµ Ð¸Ð·Ð¿ÑÐ»Ð½Ð¸, ÑÑÐ¹ ÐºÐ°ÑÐ¾ ÑÑÐ´ÑÑÐ¶Ð° ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ¸: %{0}, ÐºÐ¾Ð¸ÑÐ¾ ÑÐ° Ð½Ð°Ð´ Ð¼Ð°ÐºÑÐ¸Ð¼Ð°Ð»Ð½Ð¾ Ð¾Ð¿ÑÐµÐ´ÐµÐ»ÐµÐ½Ð¸ÑÐµ Ð·Ð° ÑÐµÐ·ÐµÑÐ²Ð¾Ð°ÑÐ¸",
        305: "ÐÐ¾Ð»Ð¾ÑÐ°Ð½Ñ: %{0} Ð½Ðµ Ð¼Ð¾Ð¶Ðµ Ð´Ð° Ð±ÑÐ´Ðµ Ð´Ð¾Ð·Ð¸ÑÐ°Ð½ Ð²ÐµÐ´Ð½Ð°Ð³Ð°, Ð¸ÑÐºÐ°Ñ Ð»Ð¸ Ð´Ð° ÑÐµ ÑÐ°Ð·Ð´ÐµÐ»Ð¸  ÑÐ¾ÑÐ¼ÑÐ»Ð°ÑÐ°?",
        306: "ÐÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ¸: %{0} Ð½Ðµ Ð¼Ð¾Ð³Ð°Ñ Ð´Ð° Ð±ÑÐ´Ðµ Ð´Ð¾Ð·Ð¸ÑÐ°Ð½Ð¸ Ð²ÐµÐ´Ð½Ð°Ð³Ð°, Ð¸ÑÐºÐ°Ñ Ð»Ð¸ Ð´Ð° ÑÐµ ÑÐ°Ð·Ð´ÐµÐ»Ð¸ ÑÐ¾ÑÐ¼ÑÐ»Ð°ÑÐ°?",
        307: "ÐÐ¾Ð»Ð¾ÑÐ°Ð½Ñ: %{0} Ð½ÑÐ¼Ð° Ð´Ð° Ð±ÑÐ´Ðµ Ð´Ð¾Ð·Ð¸ÑÐ°Ð½ Ð¾Ñ Ð´Ð¸ÑÐ¿ÐµÐ½ÑÐµÑÐ°, Ð¸ÑÐºÐ°ÑÐµ Ð»Ð¸ Ð´Ð° Ð¿ÑÐ¾Ð´ÑÐ»Ð¶Ð¸ÑÐµ Ð¸ Ð´Ð° Ð³Ð¾ Ð´Ð¾Ð±Ð°Ð²Ð¸ÑÐµ ÑÑÑÐ½Ð¾?",
        308: "ÐÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ¸: %{0} Ð½Ðµ Ð¼Ð¾Ð³Ð°Ñ Ð´Ð° Ð±ÑÐ´Ð°Ñ Ð´Ð¾Ð·Ð¸ÑÐ°Ð½Ð¸ Ð¾Ñ Ð´Ð¸ÑÐ¿ÐµÐ½ÑÐµÑÐ°, Ð¸ÑÐºÐ°ÑÐµ Ð»Ð¸ Ð´Ð° Ð¿ÑÐ¾Ð´ÑÐ»Ð¶Ð¸ÑÐµ Ð¸ Ð´Ð° Ð³Ð¸ Ð´Ð¾Ð±Ð°Ð²Ð¸ÑÐµ ÑÑÑÐ½Ð¾?",
        309: "ÐÐ·Ð±ÑÐ°Ð½Ð°ÑÐ° ÑÐ¾ÑÐ¼ÑÐ»Ð° Ðµ Ð¿ÑÐ°Ð·Ð½Ð°, Ð¸Ð·Ð¿Ð¾Ð»Ð·Ð²Ð°Ð¹ÑÐµ Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ°ÑÐ° Ð½Ð° Ð±Ð°Ð·Ð°ÑÐ° Ð¼Ð¾Ð¶Ðµ, ÑÐ°ÐºÐ° ÐºÐ°ÐºÑÐ¾ Ðµ",
        310: "ÐÑÐ¼Ð° Ð´Ð° ÑÐµ Ð´Ð¾Ð·Ð¸ÑÐ°Ñ ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ¸, Ð¿Ð¾Ð´Ð³Ð¾ÑÐ²ÐµÑÐµ Ð±Ð°Ð·Ð°ÑÐ° Ð·Ð° ÑÑÑÐ½Ð¾ Ð¾ÑÐ²ÐµÑÑÐ²Ð°Ð½Ðµ",
        311: "ÐÑÐµÐ¼Ð°ÑÐ½Ð¸ Ð½Ð° Ð¾Ð¿Ð°ÐºÐ¾Ð²Ð°ÐºÐ°ÑÐ° Ð½Ð° Ð±Ð°Ð·Ð°ÑÐ°  Ð³Ð¾ Ð¿Ð¾Ð´Ð³Ð¾ÑÐ²ÐµÑÐµ Ð·Ð° ÑÑÑÐ½Ð¾ Ð´Ð¾Ð±Ð°Ð²ÑÐ½Ðµ Ð½Ð° ÐºÐ¾Ð»Ð¾ÑÐ°Ð½ÑÐ¸",
        312: "ÐÐ¾Ð±Ð°Ð²ÐµÑÐµ ÑÑÑÐ½Ð¾ %{0} %{1} Ð½Ð° Ð¾ÑÐ²ÐµÑÐ¸ÑÐµÐ»: %{2}, Ð¿Ð¾ÑÐ²ÑÑÐ´ÐµÑÐµ, ÐºÐ¾Ð³Ð°ÑÐ¾ Ð¿ÑÐ¸ÐºÐ»ÑÑÐ¸ÑÐµ",
        313: "Ð ÑÑÐ½Ð¾ Ð´Ð¾Ð·Ð¸ÑÐ°Ð½Ðµ Ð½Ð° ÑÐ¾ÑÐ¼ÑÐ»Ð°",
        314: "ÐÐ·Ð±ÑÐ°Ð½Ð°ÑÐ° ÑÐ¾ÑÐ¼ÑÐ»Ð° Ð½Ð°ÑÑÑÐ°Ð²Ð° Ð¿ÑÐ°Ð²Ð¸Ð»Ð¾ÑÐ¾ Ð·Ð° Ð¿ÑÐµÐ¿ÑÐ»Ð²Ð°Ð½Ðµ, Ð¾Ð±ÑÐ¾ÑÐ¾ ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾ Ð¾ÑÐ²ÐµÑÐ¸ÑÐµÐ»Ð¸: %{0} %{1}, Ð¼Ð°ÐºÑÐ¸Ð¼Ð°Ð»Ð½Ð¾ ÑÐ°Ð·ÑÐµÑÐµÐ½Ð¸ ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð° Ð¾ÑÐ²ÐµÑÐ¸ÑÐµÐ»Ð¸: %{2} %{3}.Â ÐÑÐºÐ°ÑÐµ Ð»Ð¸ Ð´Ð° Ð¿ÑÐ¾Ð´ÑÐ»Ð¶Ð¸ÑÐµ, Ð²ÑÐ¿ÑÐµÐºÐ¸ ÑÐ¾Ð²Ð° Ð¿ÑÐµÐ´ÑÐ¿ÑÐµÐ¶Ð´ÐµÐ½Ð¸Ðµ?",
        315: "Scan or type UFI code of base can",
        316: "Scan or type UFI code of base can|Product: %{0}|Base: %{1}|Can size: %{2}",
        317: "Prepare colorant: %{0} for manual addition, confirm when done",
        318: "Prepare colorants: %{0} for manual addition, confirm when done",
        319: "Add manually colorant: %{0}, confirm when done",
        320: "Add manually colorants: %{0}, confirm when done",
        400: "ÐÐ²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐ½Ð¾ Ð¿ÑÐ¾ÑÐ¸ÑÑÐ²Ð°Ð½Ðµ ÑÐµ Ð±ÑÐ´Ðµ ÑÑÐ°ÑÑÐ¸ÑÐ°Ð½Ð¾",
        401: "ÐÐ²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐ½Ð¾ Ð¿ÑÐ¾ÑÐ¸ÑÑÐ²Ð°Ð½Ðµ ÑÐµ Ð±ÑÐ´Ðµ ÑÑÐ°ÑÑÐ¸ÑÐ°Ð½Ð¾",
        405: "ÐÐ¾Ð½ÑÐµÐ¹Ð½ÐµÑÑÑ Ð½Ð° ÑÐµÑÐºÐ°ÑÐ° ÑÐµ Ð½ÑÐ¶Ð´Ð°Ðµ Ð¾Ñ Ð¿ÑÐ¾Ð²ÐµÑÐºÐ°",
        406: "ÐÐ¾Ð½ÑÐµÐ¹Ð½ÐµÑÑÑ Ð½Ð° ÑÐµÑÐºÐ°ÑÐ° ÑÐµ Ð½ÑÐ¶Ð´Ð°Ðµ Ð¾Ñ Ð¿ÑÐ¾Ð²ÐµÑÐºÐ°",
        410: "ÐÐ²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐ½Ð¾ Ð¿ÑÐ¾ÑÐ¸Ð»Ð°ÐºÑÐ¸ÐºÐ° ÐºÐ°Ð¿Ð°ÑÐºÐ° ÑÐµ Ð±ÑÐ´Ðµ ÑÑÐ°ÑÑÐ¸ÑÐ°Ð½Ð¾",
        411: "ÐÐ²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐ½Ð¾ Ð¿ÑÐ¾ÑÐ¸Ð»Ð°ÐºÑÐ¸ÐºÐ° ÐºÐ°Ð¿Ð°ÑÐºÐ° ÑÐµ Ð±ÑÐ´Ðµ ÑÑÐ°ÑÑÐ¸ÑÐ°Ð½Ð¾",
        415: "ÐÑÐµÐ²ÐºÐ»ÑÑÐ²Ð°ÑÐ° Ð¿Ð»Ð¾ÑÐ° ÑÑÑÐ±Ð²Ð° Ð´Ð° Ð±ÑÐ´Ð°Ñ Ð¿Ð¾ÑÐ¸ÑÑÐµÐ½Ð°",
        416: "ÐÑÐµÐ²ÐºÐ»ÑÑÐ²Ð°Ð½Ðµ Ð¿Ð»Ð¾ÑÐ° ÑÑÑÐ±Ð²Ð° Ð´Ð° Ð±ÑÐ´Ð°Ñ Ð¿Ð¾ÑÐ¸ÑÑÐµÐ½Ð¸",
        420: "ÐÐ¸ÑÐ¿ÐµÐ½ÑÐµÑÑÑ ÑÑÑÐ±Ð²Ð° Ð´Ð° Ð±ÑÐ´Ðµ Ð¿Ð¾ÑÐ¸ÑÑÐµÐ½",
        421: "ÐÐ¸ÑÐ¿ÐµÐ½ÑÐµÑÑÑ ÑÑÑÐ±Ð²Ð° Ð´Ð° Ð±ÑÐ´Ðµ Ð¿Ð¾ÑÐ¸ÑÑÐµÐ½",
        425: "ÐÐ°ÑÐµÐ¶Ð´Ð°Ð½Ðµ Ð½Ð° ÑÐµÐ·ÐµÑÐ²Ð¾Ð°ÑÐ¸ÑÐµ ÑÐµ Ð±ÑÐ´Ðµ ÑÑÐ°ÑÑÐ¸ÑÐ°Ð½Ð¾",
        426: "ÐÐ°ÑÐµÐ¶Ð´Ð°Ð½Ðµ Ð½Ð° ÑÐµÐ·ÐµÑÐ²Ð¾Ð°ÑÐ¸ÑÐµ ÑÐµ Ð±ÑÐ´Ðµ ÑÑÐ°ÑÑÐ¸ÑÐ°Ð½Ð¾",
        430: "ÐÐ»Ð°Ð½Ð¸ÑÐ°Ð½Ð¾ Ðµ ÑÐµÑÑÐ°ÑÑÐ¸ÑÐ°Ð½Ðµ Ð½Ð° ÐºÐ¾Ð¼Ð¿ÑÑÑÑÐ°",
        431: "ÐÐ»Ð°Ð½Ð¸ÑÐ°Ð½Ð¾ Ðµ ÑÐµÑÑÐ°ÑÑÐ¸ÑÐ°Ð½Ðµ Ð½Ð° ÐºÐ¾Ð¼Ð¿ÑÑÑÑÐ°",
        435: "ÐÐ»Ð°Ð½Ð¸ÑÐ°Ð½Ð¾ Ðµ Ð¸Ð·ÐºÐ»ÑÑÐ²Ð°Ð½Ðµ Ð½Ð° ÐºÐ¾Ð¼Ð¿ÑÑÑÑÐ°",
        436: "ÐÐ»Ð°Ð½Ð¸ÑÐ°Ð½Ð¾ Ðµ Ð¸Ð·ÐºÐ»ÑÑÐ²Ð°Ð½Ðµ Ð½Ð° ÐºÐ¾Ð¼Ð¿ÑÑÑÑÐ°",
        440: "ÐÐ¾ÑÐ¸ÑÑÐ²Ð°Ð½ÐµÑÐ¾ Ð½Ð° Ð´Ð¾Ð·Ð°ÑÐ¾ÑÐ° Ðµ Ð¿Ð»Ð°Ð½Ð¸ÑÐ°Ð½Ð¾",
        441: "ÐÐ¾ÑÐ¸ÑÑÐ²Ð°Ð½ÐµÑÐ¾ Ð½Ð° Ð´Ð¾Ð·Ð°ÑÐ¾ÑÐ° Ðµ Ð¿Ð»Ð°Ð½Ð¸ÑÐ°Ð½Ð¾",
        445: "ÐÐ»Ð°Ð½Ð¸ÑÐ°Ð½Ð°  Ðµ ÑÐµÑÐ¸ÑÐºÑÐ»Ð°ÑÐ¸Ñ Ð² Ð´Ð¸ÑÐ¿ÐµÐ½ÑÐµÑÐ°",
        446: "ÐÐ»Ð°Ð½Ð¸ÑÐ°Ð½Ð°  Ðµ ÑÐµÑÐ¸ÑÐºÑÐ»Ð°ÑÐ¸Ñ Ð² Ð´Ð¸ÑÐ¿ÐµÐ½ÑÐµÑÐ°",
        450: "ÐÐ»Ð°Ð½Ð¸ÑÐ°Ð½Ð¾ Ðµ ÑÐ°Ð·Ð±ÑÑÐºÐ²Ð°Ð½Ðµ Ð² Ð´Ð¸ÑÐ¿ÐµÐ½ÑÐµÑÐ°",
        451: "ÐÐ»Ð°Ð½Ð¸ÑÐ°Ð½Ð¾ Ðµ ÑÐ°Ð·Ð±ÑÑÐºÐ²Ð°Ð½Ðµ Ð² Ð´Ð¸ÑÐ¿ÐµÐ½ÑÐµÑÐ°",
        990: "Dispenser error occurred %{0} : %{1}. Do you want to retry the task?",
        991: "Internal error occurred: %{0}",
        200000001: "ÐÐ¾ÑÑÐ°Ð²Ð¸ Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ°",
        200000002: "ÐÑÐµÐ¼Ð°ÑÐ½Ð¸ Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ°ÑÐ°",
        200000003: "ÐÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾ÑÐ¾ Ð·Ð° %{0} Ðµ Ð¿Ð¾Ð´ Ð¼Ð¸Ð½Ð¸Ð¼Ð°Ð»Ð½Ð¾ÑÐ¾ Ð·Ð° Ð´Ð¾Ð·Ð¸ÑÐ°Ð½Ðµ, ÑÐµ Ð¿ÑÐ¾Ð´ÑÐ»Ð¶Ð¸ÑÐµ Ð½Ð° ÑÐ¾Ð±ÑÑÐ²ÐµÐ½ ÑÐ¸ÑÐº?",
        200000004: "ÐÐ°ÑÐµÐ¶Ð´Ð°Ð½Ðµ %{0}"
    },
    rccDriverSettings: {
        databasePath: "ÐÑÑ Ð½Ð° Ð±Ð°Ð·Ð° Ð´Ð°Ð½Ð½Ð¸",
        dispenser: "ÐÐ¸ÑÐ¿ÐµÐ½ÑÐµÑ",
        dispenserConfigurationFile: "ÐÐ¾Ð½ÑÐ¸Ð³ÑÑÐ°ÑÐ¸Ð¾Ð½ÐµÐ½ ÑÐ°Ð¹Ð» Ð½Ð° Ð´Ð¾Ð·Ð°ÑÐ¾ÑÐ°",
        driverPath: "ÐÑÑ Ð½Ð° Ð´ÑÐ°Ð¹Ð²ÐµÑÐ°",
        extensionPath: "ÐÑÑ ÐºÑÐ¼ ÑÐ°Ð·ÑÐ¸ÑÐµÐ½Ð¸Ðµ",
        folder: "ÐÐ°Ð¿ÐºÐ°",
        formulaPath: "ÐÑÑ ÐºÑÐ¼ ÑÐ¾ÑÐ¼ÑÐ»Ð°",
        host: "ÐÐ¾Ð¼Ð°ÐºÐ¸Ð½",
        iddPath: "IDD ÐºÐ¾Ð½ÑÐ¸Ð³ÑÑÐ°ÑÐ¸Ð¾Ð½ÐµÐ½ ÑÐ°Ð¹Ð»",
        italtintoPath: "Italtinto ÐºÐ¾Ð½ÑÐ¸Ð³ÑÑÐ°ÑÐ¸Ñ",
        lldPath: "LLD Ð¿ÑÑÐµÑÐºÐ°",
        machineType: "ÐÐ¾Ð´ÐµÐ» Ð½Ð° Ð¼Ð°ÑÐ¸Ð½Ð°ÑÐ°",
        noMachineAvailable: "ÐÑÐ¼Ð° Ð½Ð°Ð»Ð¸ÑÐ½Ð° Ð¼Ð°ÑÐ¸Ð½Ð°",
        protocolVersion: "ÐÐµÑÑÐ¸Ñ Ð½Ð° Ð¿ÑÐ¾ÑÐ¾ÐºÐ¾Ð»Ð°",
        rccDriverSettings: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ Ð½Ð° RCC Ð´ÑÐ°Ð¹Ð²ÐµÑ",
        resultPath: "ÐÑÑ ÐºÑÐ¼ ÑÐµÐ·ÑÐ»ÑÐ°ÑÐ°",
        save: "ÐÐ°Ð¿Ð°Ð·Ð¸ Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ¸ÑÐµ",
        saveSettingsWarning: "ÐÑÐµÐ´ÑÐ¿ÑÐµÐ¶Ð´ÐµÐ½Ð¸Ðµ! ÐÑÐ¾Ð¼ÐµÐ½Ð¸ÑÐµ Ð² ÑÐ°Ð·Ð¸ ÑÐµÐºÑÐ¸Ñ Ð¼Ð¾Ð¶Ðµ Ð´Ð° Ð¿ÑÐ¸ÑÐ¸Ð½ÑÑ Ð½ÐµÐ¸Ð·Ð¿ÑÐ°Ð²Ð½Ð¾ÑÑ Ð½Ð° Ð´Ð¾Ð·Ð°ÑÐ¾ÑÐ°",
        serviceSwPath: "ÐÑÑ ÐºÑÐ¼ ÑÐµÑÐ²Ð¸Ð·Ð½Ð¸Ñ ÑÐ¾ÑÑÑÐµÑ",
        simulationPath: "Ð¡Ð¸Ð¼ÑÐ»Ð°ÑÐ¸Ñ"
    },
    rccMachineSettings: {
        allowManualColorantAddition: "Ð Ð°Ð·ÑÐµÑÐµÑÐµ ÑÑÑÐ½Ð¾ÑÐ¾ Ð´Ð¾Ð¿ÑÐ»Ð²Ð°Ð½Ðµ Ð½Ð° ÐºÐ¾Ð»Ð¾ÑÐ°Ð½Ñ",
        ask: "ÐÐ¸ÑÐ°Ð¹",
        canHandlingOptions: "ÐÐ¿ÑÐ¸Ð¸ Ð·Ð° Ð¾Ð±ÑÐ°Ð±Ð¾ÑÐºÐ° Ð½Ð° Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ°",
        checkCanBeforeDispense: "ÐÑÐ¾Ð²ÐµÑÐµÑÐµ Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ°ÑÐ° Ð¿ÑÐµÐ´Ð¸ Ð´Ð¾Ð·Ð¸ÑÐ°Ð½Ðµ",
        checkOverfill: "ÐÑÐ¾Ð²ÐµÑÐµÑÐµ Ð·Ð° Ð¿ÑÐµÐ¿ÑÐ»Ð²Ð°Ð½Ðµ",
        colorantBatchNumbers: "Colorant batch numbers",
        colorantPackageValidation: "Colorant package validation only",
        disable: "ÐÐ°Ð±ÑÐ°Ð½ÑÐ²Ð°Ð½Ðµ",
        dispenseInvalidColorants: "Ð Ð°Ð·Ð¿ÑÐµÐ´ÐµÐ»ÐµÑÐµ Ð½ÐµÐ²Ð°Ð»Ð¸Ð´Ð½Ð¸ Ð¾ÑÐ²ÐµÑÐ¸ÑÐµÐ»Ð¸",
        dispensingOptions: "ÐÐ¿ÑÐ¸Ð¸ Ð·Ð° Ð´Ð¾Ð·Ð¸ÑÐ°Ð½Ðµ",
        enable: "ÐÐºÑÐ¸Ð²Ð¸ÑÐ°Ð½Ðµ",
        enableUserIdentification: "User identification",
        fullValidation: "Full validation",
        machineAccuracyWarning: "ÐÑÐµÐ´ÑÐ¿ÑÐµÐ¶Ð´ÐµÐ½Ð¸Ðµ Ð·Ð° ÑÐ¾ÑÐ½Ð¾ÑÑÐ½Ð°  Ð¼Ð°ÑÐ¸Ð½Ð°ÑÐ°",
        machineOptions: "ÐÐ¿ÑÐ¸Ð¸ Ð½Ð° Ð¼Ð°ÑÐ¸Ð½Ð°ÑÐ°",
        machineUnit: "ÐÐ°ÑÐ¸Ð½Ð° ÐµÐ´Ð¸Ð½Ð¸ÑÐ°",
        minimalDispenseAmount: "ÐÐ¸Ð½Ð¸Ð¼Ð°Ð»Ð½Ð¾ ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾ Ð½Ð° Ð´Ð¾Ð·Ð¸ÑÐ°Ð½Ðµ",
        placeCanSensor: "ÐÐ°ÑÑÐ¸Ðº Ð·Ð° Ð½Ð°Ð»Ð¸ÑÐ¸Ðµ Ð½Ð° Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ°",
        placeCanSensorDelay: "ÐÐ°ÐºÑÑÐ½ÐµÐ½Ð¸Ðµ Ð½Ð° Ð´Ð°ÑÑÐ¸ÐºÐ° Ð·Ð° Ð½Ð°Ð»Ð¸ÑÐ¸Ðµ Ð½Ð° Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ°",
        rccMachineSettings: "ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ Ð½Ð° Ð¼Ð°ÑÐ¸Ð½Ð°ÑÐ°",
        refillBarcodeValidation: "Refill barcode validation",
        refillBarcodeValidationCanisterAndColorant: "Validate Canister and Colorant package",
        refillBarcodeValidationColorant: "Validate only colorant package",
        refillSettings: "Refill settings",
        removeCanSensor: "ÐÐ°ÑÑÐ¸Ðº Ð·Ð° Ð¼Ð°ÑÐ°Ð½Ðµ Ð½Ð° Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ°ÑÐ°",
        removeCanSensorDelay: "ÐÐ°ÐºÑÑÐ½ÐµÐ½Ð¸Ðµ Ð½Ð° Ð´Ð°ÑÑÐ¸ÐºÐ° Ð·Ð° Ð¼Ð°ÑÐ°Ð½Ðµ Ð½Ð° Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ°ÑÐ°",
        save: "ÐÐ°Ð¿Ð°Ð·Ð¸ Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ¸ÑÐµ",
        sec: "sec",
        skipPlaceCanDialog: "ÐÑÐ¾Ð¿ÑÑÐºÐ°Ð½Ðµ Ð½Ð° Ð´Ð¸Ð°Ð»Ð¾Ð³Ð° Ð·Ð° Ð¿Ð¾ÑÑÐ°Ð²ÑÐ½Ðµ Ð½Ð° Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ°",
        skipRemoveCanDialog: "ÐÑÐ¾Ð¿ÑÑÐºÐ°Ð½Ðµ Ð½Ð° Ð´Ð¸Ð°Ð»Ð¾Ð³Ð° Ð·Ð° Ð¼Ð°ÑÐ°Ð½Ðµ Ð½Ð° Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ°",
        splitFormula: "Split Formula",
        tmcEnabled: "ÐÐºÑÐ¸Ð²Ð¸ÑÐ°Ð½Ðµ Ð½Ð° TMC",
        ufiCode: "UFI code",
        validateBarcodeBaseCan: "ÐÑÐ¾Ð²ÐµÑÐºÐ° Ð½Ð° Ð±Ð°ÑÐºÐ¾Ð´ Ð½Ð° Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ° Ð½Ð° Ð±Ð°Ð·Ð°ÑÐ°",
        validateBarcodeRefill: "Refill barcode validation",
        validateColorantsDuringInit: "ÐÑÐ¾Ð²ÐµÑÐºÐ° Ð½Ð° Ð¾ÑÐ²ÐµÑÐ¸ÑÐµÐ»Ð¸ÑÐµ Ð¿Ð¾ Ð²ÑÐµÐ¼Ðµ Ð½Ð° Ð¸Ð½Ð¸ÑÐ¸Ð°Ð»Ð¸Ð·Ð°ÑÐ¸Ñ"
    },
    rccPanel: {
        actionsRunningOnDispenser: "ÐÐµÐ¹ÑÑÐ²Ð¸Ñ Ð¸Ð·Ð¿ÑÐ»Ð½ÑÐ²Ð°Ð½Ð¸ Ð¾Ñ Ð¼Ð°ÑÐ¸Ð½Ð°ÑÐ°",
        addLevel: "ÐÐ¾Ð±Ð°Ð²Ð¸ Ð½Ð¸Ð²Ð¾",
        addManually: "Add manually",
        barcodeNotSet: "Canister %{colorantName} (%{canisterName}) has no barcode assigned.",
        cancel: "ÐÑÐµÐºÑÑÐ½Ð¸",
        dispenseFormula: "ÐÐ¿Ð¸ÑÐ°Ð½Ð¸Ðµ",
        dispenserIdle: "ÐÐ°ÑÐ¸Ð½Ð°ÑÐ° Ðµ Ð² ÑÐµÐ¶Ð¸Ð¼ Ð¾ÑÐ°ÐºÐ²Ð°Ð½Ðµ",
        dispenserIsBusy: "ÐÐ°ÑÐ¸Ð½Ð°ÑÐ° Ðµ Ð·Ð°ÐµÑÐ°",
        dispenserIsIdle: "ÐÐ°ÑÐ¸Ð½Ð°ÑÐ° Ð½Ðµ Ðµ Ð·Ð°ÐµÑÐ°",
        dispenserIsReady: "ÐÐ°ÑÐ¸Ð½Ð°ÑÐ° Ðµ Ð³Ð¾ÑÐ¾Ð²Ð°",
        dispensingFormula: "ÐÐ¾Ð·Ð¸ÑÐ°Ð½Ðµ",
        errorCode: "ÐÐ¾Ð´ Ð½Ð° Ð³ÑÐµÑÐºÐ°",
        explanation: "ÐÐ±ÑÑÐ½ÐµÐ½Ð¸Ðµ",
        fillToMax: "ÐÐ°Ð¿ÑÐ»Ð½Ð¸ Ð´Ð¾ max",
        finished: "Finished",
        inProgress: "In progress",
        machineIsReady: "ÐÐ°ÑÐ¸Ð½Ð°ÑÐ° Ðµ Ð³Ð¾ÑÐ¾Ð²Ð°",
        moveToFill: "ÐÑÐµÐ¼ÐµÑÑÐµÑÐµ Ð·Ð° Ð·Ð°ÑÐµÐ¶Ð´Ð°Ð½Ðµ",
        noMachineDialog: "ÐÑÐ¼Ð° Ð´Ð¸Ð°Ð»Ð¾Ð³ Ñ Ð¼Ð°ÑÐ¸Ð½Ð°ÑÐ°",
        of: "ÐÑ",
        packageSize: "Ð Ð°Ð·Ð¼ÐµÑ Ð½Ð° Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ°ÑÐ°",
        placeBaseCan: "ÐÐ¾ÑÑÐ°Ð²Ð¸ Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ°ÑÐ° Ð½Ð° Ð±Ð°Ð·Ð°ÑÐ°",
        pleaseCheckYourMachineConnection: "ÐÐ¾Ð»Ñ, Ð¿ÑÐ¾Ð²ÐµÑÐµÑÐµ Ð²ÑÑÐ·ÐºÐ°ÑÐ° Ñ Ð¼Ð°ÑÐ¸Ð½Ð°ÑÐ°.",
        pleaseRefill: "ÐÐ¾Ð»Ñ ÐÐ¾Ð¿ÑÐ»Ð½Ð¸",
        solution: "Ð ÐµÑÐµÐ½Ð¸Ðµ",
        subErrors: "ÐÐ¾Ð´Ð³ÑÐµÑÐºÐ¸",
        timeToEnd: "ÐÑÑÐ°Ð²Ð°ÑÐ¾ Ð²ÑÐµÐ¼Ðµ",
        tintingFormula: "Ð¤Ð¾ÑÐ¼ÑÐ»Ð° Ð·Ð° ÑÐ¾Ð½Ð¸ÑÐ°Ð½Ðµ",
        tintingPleaseWait: "ÐÐ¾Ð·Ð¸ÑÐ°Ð½Ðµ, ÐÐ¾Ð»Ñ Ð¸Ð·ÑÐ°ÐºÐ°Ð¹",
        validateBaseCan: "ÐÑÐ¾Ð²ÐµÑÐ¸ Ð±Ð°Ð·Ð¾Ð²Ð°ÑÐ° Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ°",
        waiting: "Waiting"
    },
    rccSettigns: {
        rccSettigns: "RCC Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ¸",
        rccUrl: "RCC URL"
    },
    rccSpectroDialog: {
        100: "Ð¡Ð²ÑÑÐ·Ð²Ð°Ð½Ðµ Ñ Ð²Ð°ÑÐµÑÐ¾ ÑÑÑÑÐ¾Ð¹ÑÑÐ²Ð¾ Ð¿ÑÐµÐ· Bluetooth Ð£Ð²ÐµÑÐµÑÐµ ÑÐµ, ÑÐµ ÑÑÐµ Ð°ÐºÑÐ¸Ð²Ð¸ÑÐ°Ð»Ð¸ Bluetooth Ð¸ Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½ÑÑÑ Ð²Ð¸ Ðµ Ð²ÐºÐ»ÑÑÐµÐ½.,",
        101: "ÐÐ½ÑÑÑÑÐ¼ÐµÐ½ÑÑÑ Ð½Ðµ Ðµ Ð¾ÑÐºÑÐ¸Ñ. ÐÑÐºÐ°ÑÐµ Ð»Ð¸ Ð´Ð° Ð¾Ð¿Ð¸ÑÐ°ÑÐµ Ð¾ÑÐ½Ð¾Ð²Ð¾?,",
        110: "Ð£Ð²ÐµÑÐµÑÐµ ÑÐµ, ÑÐµ Nano Ðµ ÑÐ²ÑÑÐ·Ð°Ð½ Ð¸ Ð½Ð°ÑÐ¸ÑÐ½ÐµÑÐµ Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½ÑÐ°Ð»Ð½Ð¸Ñ Ð±ÑÑÐ¾Ð½, Ð·Ð° Ð´Ð° ÑÑÐ°ÑÑÐ¸ÑÐ°ÑÐµ Ð¸Ð½Ð¸ÑÐ¸Ð°Ð»Ð¸Ð·Ð°ÑÐ¸ÑÑÐ°,",
        111: "Nano Ð½Ðµ Ðµ Ð¾ÑÐºÑÐ¸Ñ. ÐÑÐºÐ°ÑÐµ Ð»Ð¸ Ð´Ð° Ð¾Ð¿Ð¸ÑÐ°ÑÐµ Ð¾ÑÐ½Ð¾Ð²Ð¾?,",
        112: "ÐÐ·ÐºÐ»ÑÑÐµÑÐµ Nano, Ð¸Ð·ÑÐ°ÐºÐ°Ð¹ÑÐµ 10 ÑÐµÐºÑÐ½Ð´Ð¸, ÑÐ²ÑÑÐ¶ÐµÑÐµ Ð³Ð¾ Ð¾ÑÐ½Ð¾Ð²Ð¾ Ð¸ Ð¿ÑÐ¾Ð´ÑÐ»Ð¶ÐµÑÐµ,",
        120: "Ð¡Ð²ÑÑÐ·Ð²Ð°Ð½Ðµ ÐºÑÐ¼ Ð²Ð°ÑÐµÑÐ¾ ÑÑÑÑÐ¾Ð¹ÑÑÐ²Ð¾, Ð¼Ð¾Ð»Ñ Ð¸Ð·ÑÐ°ÐºÐ°Ð¹ÑÐµ",
        121: "ÐÐ½ÑÑÑÑÐ¼ÐµÐ½Ñ Ð½Ðµ Ðµ Ð¾ÑÐºÑÐ¸Ñ. ÐÑÐºÐ°ÑÐµ Ð»Ð¸ Ð´Ð° Ð¾Ð¿Ð¸ÑÐ°ÑÐµ Ð¾ÑÐ½Ð¾Ð²Ð¾?",
        200: "ÐÐ¾ÑÑÐ°Ð²ÐµÑÐµ Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½ÑÐ° Ð²ÑÑÑÑ ÑÐµÑÐ½Ð° Ð¿Ð»Ð¾ÑÐºÐ° Ð¸ Ð¿ÑÐ¾Ð´ÑÐ»Ð¶ÐµÑÐµ Ð¸Ð»Ð¸ Ð½Ð°ÑÐ¸ÑÐ½ÐµÑÐµ Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½ÑÐ°Ð»Ð½Ð¸Ñ Ð±ÑÑÐ¾Ð½,",
        201: "ÐÐ¾ÑÑÐ°Ð²ÐµÑÐµ Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½ÑÐ° Ð²ÑÑÑÑ ÑÐµÑÐ½Ð° Ð¿Ð»Ð¾ÑÐºÐ° Ð¸ Ð¿ÑÐ¾Ð´ÑÐ»Ð¶ÐµÑÐµ,",
        202: "ÐÐ¾ÑÑÐ°Ð²ÐµÑÐµ Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½ÑÐ° Ð²ÑÑÑÑ ÑÐµÑÐ½Ð° Ð¿Ð»Ð¾ÑÐºÐ° Ð¸ Ð½Ð°ÑÐ¸ÑÐ½ÐµÑÐµ Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½ÑÐ°Ð»Ð½Ð¸Ñ Ð±ÑÑÐ¾Ð½,",
        205: "ÐÐ¾ÑÑÐ°Ð²ÐµÑÐµ Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½ÑÐ° Ð²ÑÑÑÑ Ð±ÑÐ»Ð° Ð¿Ð»Ð¾ÑÐºÐ° Ð¸ Ð¿ÑÐ¾Ð´ÑÐ»Ð¶ÐµÑÐµ Ð¸Ð»Ð¸ Ð½Ð°ÑÐ¸ÑÐ½ÐµÑÐµ Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½ÑÐ°Ð»Ð½Ð¸Ñ Ð±ÑÑÐ¾Ð½,",
        206: "ÐÐ¾ÑÑÐ°Ð²ÐµÑÐµ Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½ÑÐ° Ð²ÑÑÑÑ Ð±ÑÐ»Ð° Ð¿Ð»Ð¾ÑÐºÐ° Ð¸ Ð¿ÑÐ¾Ð´ÑÐ»Ð¶ÐµÑÐµ,",
        207: "ÐÐ¾ÑÑÐ°Ð²ÐµÑÐµ Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½ÑÐ° Ð²ÑÑÑÑ Ð±ÑÐ»Ð° Ð¿Ð»Ð¾ÑÐºÐ° Ð¸ Ð½Ð°ÑÐ¸ÑÐ½ÐµÑÐµ Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½ÑÐ°Ð»Ð½Ð¸Ñ Ð±ÑÑÐ¾Ð½,",
        210: "ÐÐ¾ÑÑÐ°Ð²ÐµÑÐµ Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½ÑÐ° Ð½Ð° Ð´Ð¸Ð°Ð³Ð½Ð¾ÑÑÐ¸ÑÐ½Ð°ÑÐ° Ð¿Ð»Ð¾ÑÐºÐ° Ð¸ Ð¿ÑÐ¾Ð´ÑÐ»Ð¶ÐµÑÐµ Ð¸Ð»Ð¸ Ð½Ð°ÑÐ¸ÑÐ½ÐµÑÐµ Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½ÑÐ°Ð»Ð½Ð¸Ñ Ð±ÑÑÐ¾Ð½,",
        211: "ÐÐ¾ÑÑÐ°Ð²ÐµÑÐµ Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½ÑÐ° Ð½Ð° Ð´Ð¸Ð°Ð³Ð½Ð¾ÑÑÐ¸ÑÐ½Ð°ÑÐ° Ð¿Ð»Ð¾ÑÐºÐ° Ð¸ Ð¿ÑÐ¾Ð´ÑÐ»Ð¶ÐµÑÐµ,",
        212: "ÐÐ¾ÑÑÐ°Ð²ÐµÑÐµ Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½ÑÐ° Ð²ÑÑÑÑ Ð´Ð¸Ð°Ð³Ð½Ð¾ÑÑÐ¸ÑÐ½Ð°ÑÐ° Ð¿Ð»Ð¾ÑÐºÐ° Ð¸ Ð½Ð°ÑÐ¸ÑÐ½ÐµÑÐµ Ð±ÑÑÐ¾Ð½Ð° Ð½Ð° Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½ÑÐ°,",
        215: "ÐÐ°ÑÐ²Ð¾ÑÐµÑÐµ ÐºÐ°Ð¿Ð°ÐºÐ° Ð½Ð° Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½ÑÐ° Ð¸ Ð¿ÑÐ¾Ð´ÑÐ»Ð¶ÐµÑÐµ Ð¸Ð»Ð¸ Ð½Ð°ÑÐ¸ÑÐ½ÐµÑÐµ Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½ÑÐ°Ð»Ð½Ð¸Ñ Ð±ÑÑÐ¾Ð½,",
        216: "ÐÐ°ÑÐ²Ð¾ÑÐµÑÐµ ÐºÐ°Ð¿Ð°ÐºÐ° Ð½Ð° Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½ÑÐ° Ð¸ Ð¿ÑÐ¾Ð´ÑÐ»Ð¶ÐµÑÐµ,",
        217: "ÐÐ°ÑÐ²Ð¾ÑÐµÑÐµ ÐºÐ°Ð¿Ð°ÐºÐ° Ð½Ð° Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½ÑÐ° Ð¸ Ð½Ð°ÑÐ¸ÑÐ½ÐµÑÐµ Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½ÑÐ°Ð»Ð½Ð¸Ñ Ð±ÑÑÐ¾Ð½,",
        220: "ÐÐ¾ÑÑÐ°Ð²ÐµÑÐµ Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½ÑÐ° Ð½Ð° Ð½ÑÐ»ÐµÐ²Ð° Ð¿Ð»Ð¾ÑÐºÐ° Ð¸ Ð¿ÑÐ¾Ð´ÑÐ»Ð¶ÐµÑÐµ Ð¸Ð»Ð¸ Ð½Ð°ÑÐ¸ÑÐ½ÐµÑÐµ Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½ÑÐ°Ð»Ð½Ð¸Ñ Ð±ÑÑÐ¾Ð½,",
        221: "ÐÐ¾ÑÑÐ°Ð²ÐµÑÐµ Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½ÑÐ° Ð½Ð° Ð½ÑÐ»ÐµÐ²Ð° Ð¿Ð»Ð¾ÑÐºÐ° Ð¸ Ð¿ÑÐ¾Ð´ÑÐ»Ð¶ÐµÑÐµ,",
        222: "ÐÐ¾ÑÑÐ°Ð²ÐµÑÐµ Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½ÑÐ° Ð½Ð° Ð½ÑÐ»ÐµÐ²Ð° Ð¿Ð»Ð¾ÑÐºÐ° Ð¸ Ð½Ð°ÑÐ¸ÑÐ½ÐµÑÐµ Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½ÑÐ°Ð»Ð½Ð¸Ñ Ð±ÑÑÐ¾Ð½,",
        224: "Place the instrument on calibration pad and continue or press instrument button",
        225: "Place the instrument on calibration pad and continue",
        226: "Place the instrument on calibration pad and press instrument button",
        227: "Place the instrument on calibration pad and press instrument button",
        295: "ÐÐ°Ð²ÑÑÑÐ²Ð°Ð½Ðµ Ð½Ð° ÐºÐ°Ð»Ð¸Ð±ÑÐ¸ÑÐ°Ð½ÐµÑÐ¾ Ð² Ð¿ÑÐ¾Ð·Ð¾ÑÐµÑÐ° Ð½Ð° Ð´ÑÐ°Ð¹Ð²ÐµÑÐ°,",
        296: "Instrument is not connected, do you want to open connection to it?",
        297: "ÐÐ¾Ð´Ð³Ð¾ÑÐ¾Ð²ÐºÐ° Ð·Ð° ÑÑÑÐ¿ÐºÐ° Ð·Ð° ÐºÐ°Ð»Ð¸Ð±ÑÐ¸ÑÐ°Ð½Ðµ, Ð¼Ð¾Ð»Ñ Ð¸Ð·ÑÐ°ÐºÐ°Ð¹ÑÐµ,",
        298: "ÐÐ°Ð»Ð¸Ð±ÑÐ¸ÑÐ°Ð½Ðµ, Ð¼Ð¾Ð»Ñ Ð¸Ð·ÑÐ°ÐºÐ°Ð¹ÑÐµ,",
        299: "ÐÐ°Ð²ÑÑÑÐ²Ð°Ð½Ðµ Ð½Ð° ÐµÑÐ°Ð¿Ð° Ð½Ð° ÐºÐ°Ð»Ð¸Ð±ÑÐ¸ÑÐ°Ð½Ðµ, Ð¼Ð¾Ð»Ñ Ð¸Ð·ÑÐ°ÐºÐ°Ð¹ÑÐµ,",
        300: "ÐÐ¾ÑÑÐ°Ð²ÐµÑÐµ ÑÑÐµÐ´Ð° Ð²ÑÑÑÑ Ð¿ÑÐ¾Ð±Ð°ÑÐ° Ð¸ Ð¿ÑÐ¾Ð´ÑÐ»Ð¶ÐµÑÐµ Ð¸Ð»Ð¸ Ð½Ð°ÑÐ¸ÑÐ½ÐµÑÐµ Ð±ÑÑÐ¾Ð½ Ð½Ð°  Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½ÑÐ°",
        301: "ÐÐ¾ÑÑÐ°Ð²ÐµÑÐµ Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½ÑÐ° Ð²ÑÑÑÑ Ð¿ÑÐ¾Ð±Ð°ÑÐ° Ð¸ Ð¿ÑÐ¾Ð´ÑÐ»Ð¶ÐµÑÐµ,",
        302: "ÐÐ¾ÑÑÐ°Ð²ÐµÑÐµ Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½ÑÐ° Ð²ÑÑÑÑ Ð¿ÑÐ¾Ð±Ð°ÑÐ° Ð¸ Ð½Ð°ÑÐ¸ÑÐ½ÐµÑÐµ Ð±ÑÑÐ¾Ð½Ð° Ð½Ð° Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½ÑÐ°,",
        303: "Instrument is not calibrated, do you want to proceed with calibration?",
        304: "Instrument is not connected, do you want to open connection to it?",
        390: "Select measure mode",
        395: "ÐÐ°Ð²ÑÑÑÐµÑÐµ Ð¸Ð·Ð¼ÐµÑÐ²Ð°Ð½ÐµÑÐ¾ Ð² Ð¿ÑÐ¾Ð·Ð¾ÑÐµÑÐ° Ð½Ð° Ð´ÑÐ°Ð¹Ð²ÐµÑÐ°,",
        397: "ÐÐ¾Ð´Ð³Ð¾ÑÐ¾Ð²ÐºÐ° Ð·Ð° Ð¸Ð·Ð¼ÐµÑÐ²Ð°Ð½Ðµ, Ð¼Ð¾Ð»Ñ Ð¸Ð·ÑÐ°ÐºÐ°Ð¹ÑÐµ,",
        398: "ÐÐ·Ð¼ÐµÑÐ²Ð°Ð½Ðµ, Ð¼Ð¾Ð»Ñ Ð¸Ð·ÑÐ°ÐºÐ°Ð¹ÑÐµ,",
        399: "ÐÐ°Ð²ÑÑÑÐ²Ð°Ð½Ðµ Ð½Ð° Ð¸Ð·Ð¼ÐµÑÐ²Ð°Ð½ÐµÑÐ¾, Ð¼Ð¾Ð»Ñ Ð¸Ð·ÑÐ°ÐºÐ°Ð¹ÑÐµ,",
        498: "ÐÐ·ÑÐµÐ³Ð»ÑÐ½Ðµ Ð½Ð° Ð¸Ð·Ð¼ÐµÑÐ²Ð°Ð½Ðµ, Ð¼Ð¾Ð»Ñ Ð¸Ð·ÑÐ°ÐºÐ°Ð¹ÑÐµ,",
        499: "ÐÐ·ÑÐµÐ³Ð»ÑÐ½Ðµ Ð½Ð° Ð²ÑÐ¸ÑÐºÐ¸ Ð¸Ð·Ð¼ÐµÑÐ²Ð°Ð½Ð¸Ñ, Ð¼Ð¾Ð»Ñ Ð¸Ð·ÑÐ°ÐºÐ°Ð¹ÑÐµ,",
        900: "ÐÑÐ·Ð½Ð¸ÐºÐ½Ð° Ð³ÑÐµÑÐºÐ° Ð½Ð° Ð¸Ð½ÑÑÑÑÐ¼ÐµÐ½ÑÐ° %{0} %{1} ÐÑÐºÐ°ÑÐµ Ð»Ð¸ Ð´Ð° Ð¾Ð¿Ð¸ÑÐ°ÑÐµ Ð¾ÑÐ½Ð¾Ð²Ð¾? ",
        901: "Internal error occurred: %{0}"
    },
    rccSpectroSettings: {
        DatacolorColorReader:
            "ÐÐ¾Ð¼Ð¿ÑÑÑÑÑÑ ÑÑÑÐ±Ð²Ð° Ð´Ð° Ð¸Ð¼Ð° Bluetooth Ð²ÑÑÐ·ÐºÐ°.Â Ð¡Ð¿ÐµÐºÑÑÐ¾ÑÐ¾ ÑÑÑÐ±Ð²Ð° Ð´Ð° Ð±ÑÐ´Ðµ ÑÐ´Ð²Ð¾ÐµÐ½Ð¾ Ñ ÐºÐ¾Ð¼Ð¿ÑÑÑÑÐ°.Â ÐÐµÐ¾Ð±ÑÐ¾Ð´Ð¸Ð¼Ð° Ðµ Ð°ÐºÑÑÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ñ Ð½Ð° Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐ½Ð°ÑÐ° Ð²ÐµÑÑÐ¸Ñ Ð½Ð° Windows 10 Ñ 2018.",
        DatacolorSilent:
            "ÐÐ¾Ð³Ð°ÑÐ¾ Ð¸Ð·Ð¿Ð¾Ð»Ð·Ð²Ð°ÑÐµ Ð±ÐµÐ·ÑÑÐ¼ÐµÐ½ ÑÐµÐ¶Ð¸Ð¼, Ð¿ÑÐ¾Ð·Ð¾ÑÑÐ¸ÑÐµ Ð½Ð° Datacolor ÑÐµ Ð¿Ð¾ÐºÐ°Ð·Ð²Ð°Ñ Ð´Ð¸ÑÐµÐºÑÐ½Ð¾ Ð² %{name}.Â Ð ÑÐµÐ·Ð¸ Ð¿ÑÐ¾Ð·Ð¾ÑÑÐ¸ ÑÐ¿ÐµÐºÑÑÐ¾Ð¼ÐµÑÑÐ¸ÑÐ½Ð¸ÑÐµ Ð¿Ð°ÑÐ°Ð¼ÐµÑÑÐ¸ Ð½Ðµ Ð¼Ð¾Ð³Ð°Ñ Ð´Ð° Ð±ÑÐ´Ð°Ñ Ð¿ÑÐ¾Ð¼ÐµÐ½ÑÐ½Ð¸.",
        DatacolorUseDiagnosticTile: "ÐÐ·Ð¿Ð¾Ð»Ð·Ð²Ð°Ð½ÐµÑÐ¾ Ð½Ð° Ð´Ð¸Ð°Ð³Ð½Ð¾ÑÑÐ¸ÑÐ½Ð° Ð¿Ð»Ð¾ÑÐºÐ° Ð¿Ð¾Ð´Ð¾Ð±ÑÑÐ²Ð° ÐºÐ°ÑÐµÑÑÐ²Ð¾ÑÐ¾ Ð½Ð° Ð¸Ð·Ð¼ÐµÑÐ²Ð°Ð½Ðµ.",
        comPort: "Com Port",
        diagnosticTile: "Datacolor Ð´Ð¸Ð°Ð³Ð½Ð¾ÑÑÐ¸ÑÐ½Ð° Ð¿Ð»Ð¾ÑÐºÐ°",
        measureModes: "Measure modes",
        measureModesOrder: "Measure modes order",
        model: "ÐÐ¾Ð´ÐµÐ»",
        noSpectroAvailable: "ÐÑÐ¼Ð° Ð½Ð°Ð»Ð¸ÑÐµÐ½ ÑÐ¿ÐµÐºÑÑÐ¾ÑÐºÐ¾Ð¿",
        rccSpectroSettings: "Ð¡Ð¿ÐµÐºÑÑÐ¾ Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ¸",
        save: "ÐÐ°Ð¿Ð°Ð·Ð¸ Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ¸ÑÐµ",
        silent: "Datacolor Ð¼ÑÐ»ÑÐ°Ð½Ð¸Ðµ",
        simulationPath: "Ð¡Ð¸Ð¼ÑÐ»Ð°ÑÐ¸Ñ",
        spectroType: "ÐÐ¾Ð´ÐµÐ» ÑÐ¿ÐµÐºÑÑÐ¾",
        useProfiledValues: "ÐÐ·Ð¿Ð¾Ð»Ð·Ð²Ð°Ð½Ðµ Ð½Ð° Ð¿ÑÐ¾ÑÐ¸Ð»Ð¸ÑÐ°Ð½Ð¸ ÑÑÐ¾Ð¹Ð½Ð¾ÑÑÐ¸"
    },
    recirculateChannels: {
        recirculateAllChannels: "Recirculate all",
        recirculateChannels: "Recirculate channels",
        recirculatingSpeed: "Ð¡ÐºÐ¾ÑÐ¾ÑÑÐ° Ð½Ð° ÑÐµÑÐ¸ÑÐºÑÐ»Ð°ÑÐ¸Ñ",
        recirculatingTime: "ÐÑÐµÐ¼Ðµ Ð·Ð° ÑÐµÑÐ¸ÑÐºÑÐ»Ð°ÑÐ¸Ñ",
        startRecirculating: "Ð¡ÑÐ°ÑÑ Ð½Ð° ÑÐµÑÐ¸ÑÐºÑÐ»Ð°ÑÐ¸Ñ"
    },
    redlikeLight: {
        finishPreviousSteps: "ÐÐ¾Ð»Ñ, Ð·Ð°Ð²ÑÑÑÐ¸ Ð¿ÑÐµÐ´Ð¸ÑÐ½Ð¸ÑÐµ ÑÑÑÐ¿ÐºÐ¸",
        searchBySpectro: "Ð¢ÑÑÑÐµÐ½Ðµ ÑÑÑ ÑÐ¿ÐµÐºÑÑÐ¾",
        searchFormula: "Ð¢ÑÑÑÐµÐ½Ðµ Ð½Ð° ÑÐ¾ÑÐ¼ÑÐ»Ð°",
        selectBase: "Select base",
        selectColor: "ÐÐ·Ð±Ð¾Ñ Ð½Ð° ÑÐ²ÑÑ",
        selectCustomer: "ÐÐ·Ð±ÐµÑÐµÑÐµ ÐºÐ»Ð¸ÐµÐ½Ñ",
        selectFandeck: "ÐÐ·Ð±ÐµÑÐµÑÐµ ÑÐ²ÐµÑÐµÐ½ ÐºÐ°ÑÑÐµÐ»",
        selectPackage: "ÐÐ·Ð±ÐµÑÐµÑÐµ Ð¾Ð¿Ð°ÐºÐ¾Ð²ÐºÐ°",
        selectProduct: "ÐÐ·Ð±ÐµÑÐµÑÐµ Ð¿ÑÐ¾Ð´ÑÐºÑ",
        startSelectFandeck: "Start to select fandeck",
        startSelectProduct: "Start to select product",
        stepByStepProgress: "ÐÐ¾Ð¶ÐµÑÐµ Ð´Ð° Ð½Ð°Ð¿ÑÐµÐ´Ð²Ð°ÑÐµ ÑÑÑÐ¿ÐºÐ° Ð¿Ð¾ ÑÑÑÐ¿ÐºÐ°",
        typeHereToSearch: "ÐÐ¸ÑÐµÑÐµ ÑÑÐº, Ð·Ð° Ð´Ð° ÑÑÑÑÐ¸ÑÐµ",
        typeToFilter: "ÐÑÐ²ÐµÐ´ÐµÑÐµ Ð·Ð° ÑÐ¸Ð»ÑÑÐ¸ÑÐ°Ð½Ðµ"
    },
    restartModal: {
        computerNeedsRestart: "ÐÐ¾Ð¼Ð¿ÑÑÑÑÑÑ ÑÐµ Ð½ÑÐ¶Ð´Ð°Ðµ Ð¾Ñ ÑÐµÑÑÐ°ÑÑÐ¸ÑÐ°Ð½Ðµ!",
        notCompletelyTranslated:
            "ÐÑÐ¾Ð¼ÑÐ½Ð°ÑÐ° Ð½Ð° ÐµÐ·Ð¸ÐºÐ° Ð¸Ð·Ð¸ÑÐºÐ²Ð°  ÑÐµÑÑÐ°ÑÑÐ¸ÑÐ°Ð½Ðµ Ð½Ð° ÑÐ¾ÑÑÑÐµÑÐ°. ÐÑÐºÐ¾Ð¸ ÑÐ°ÑÑÐ¸ Ð½Ð° ÑÐ¾ÑÑÑÐµÑÐ° Ð¼Ð¾Ð¶Ðµ Ð´Ð° Ð½Ðµ Ð±ÑÐ´Ð°Ñ Ð¿ÑÐµÐ²ÐµÐ´ÐµÐ½Ð¸ Ð¸Ð·ÑÑÐ»Ð¾ Ð² ÑÐ¾Ð·Ð¸ Ð¼Ð¾Ð¼ÐµÐ½Ñ.",
        restartIsRequired: "Software restart is required after the changes have been made.",
        softwareNeedsRestart: "%{name} needs restart!"
    },
    searchPanel: {
        basePlaceholder: "or type a base name",
        baseStartPlaceholder: "Start by typing a base name",
        colorCodeNamePlaceholder: "or type a formula code/name",
        colorCodeNameStartPlaceholder: "Start by typing a formula code/name",
        colorCodePlaceholder: "ÐÑÐ²ÐµÐ¶Ð´Ð°Ð½Ðµ Ð½Ð° ÐºÐ¾Ð´ Ð½Ð° ÑÐ¾ÑÐ¼ÑÐ»Ð°ÑÐ°",
        colorCodeStartPlaceholder: "ÐÑÐ²ÐµÐ¶Ð´Ð°Ð½Ðµ Ð½Ð° ÐºÐ¾Ð´ Ð½Ð° ÑÐ¾ÑÐ¼ÑÐ»Ð°ÑÐ°",
        colorNameCodePlaceholder: "or type a formula name/code",
        colorNameCodeStartPlaceholder: "Start by typing a formula name/code",
        colorNamePlaceholder: "ÐÑÐ²ÐµÐ¶Ð´Ð°Ð½Ðµ Ð½Ð° Ð¸Ð¼Ðµ Ð½Ð° ÑÐ¾ÑÐ¼ÑÐ»Ð°ÑÐ°",
        colorNameStartPlaceholder: "ÐÑÐ²ÐµÐ¶Ð´Ð°Ð½Ðµ Ð½Ð° Ð¸Ð¼Ðµ Ð½Ð° ÑÐ¾ÑÐ¼ÑÐ»Ð°ÑÐ°",
        colorPreviewIsNotAvailable: "Color preview is not available. Select a fandeck to see relevant color preview.",
        fandeckPlaceholder: "ÐÑÐ²ÐµÐ¶Ð´Ð°Ð½Ðµ Ð½Ð° ÑÐ²ÐµÑÐµÐ½ ÐºÐ°ÑÑÐµÐ»",
        fandeckStartPlaceholder: "ÐÑÐ²ÐµÐ¶Ð´Ð°Ð½Ðµ Ð½Ð° ÑÐ²ÐµÑÐµÐ½ ÐºÐ°ÑÑÐµÐ»",
        formulaByColor: "Ð¤Ð¾ÑÐ¼ÑÐ»Ð° Ð¿Ð¾ ÑÐ²ÑÑ",
        noResultsFound: "No results found",
        packagePlaceholder: "or type a package name",
        packageStartPlaceholder: "Start by typing a package name",
        productPlaceholder: "ÐÑÐ²ÐµÐ¶Ð´Ð°Ð½Ðµ Ð½Ð° Ð¸Ð¼Ðµ Ð½Ð° Ð¿ÑÐ¾Ð´ÑÐºÑ",
        productStartPlaceholder: "ÐÑÐ²ÐµÐ¶Ð´Ð°Ð½Ðµ Ð½Ð° Ð¿ÑÐ¾Ð´ÑÐºÑ",
        standard: "Ð¡ÑÐ°Ð½Ð´Ð°ÑÑ",
        typeFandeckToFilter: "ÐÐ¸ÑÐµÑÐµ ÑÑÐº, Ð·Ð° Ð´Ð° ÑÐ¸Ð»ÑÑÐ¸ÑÐ°ÑÐµ Ð¿Ð¾ Ð¸Ð¼Ðµ Ð½Ð° ÑÐ²ÐµÑÐµÐ½ ÐºÐ°ÑÑÐµÐ»",
        typeProductToFilter: "ÐÐ¸ÑÐµÑÐµ ÑÑÐº, Ð·Ð° Ð´Ð° ÑÐ¸Ð»ÑÑÐ¸ÑÐ°ÑÐµ Ð¿Ð¾ Ð¸Ð¼Ðµ Ð½Ð° Ð¿ÑÐ¾Ð´ÑÐºÑ"
    },
    sendOrderModal: {
        customNote: "ÐÐµÑÑÐ¾Ð½Ð°Ð»Ð¸Ð·Ð¸ÑÐ°Ð½Ð° Ð±ÐµÐ»ÐµÐ¶ÐºÐ°",
        noCompatibleServers: "ÐÐµ ÑÐ° Ð½Ð°Ð»Ð¸ÑÐ½Ð¸ ÑÑÐ²Ð¼ÐµÑÑÐ¸Ð¼Ð¸ ÑÑÑÐ²ÑÑÐ¸ Ð²ÑÐ² Ð²Ð°ÑÐ°ÑÐ° Ð¼ÑÐµÐ¶Ð°",
        orderOverview: "ÐÑÐµÐ³Ð»ÐµÐ´ Ð½Ð° Ð¿Ð¾ÑÑÑÐºÐ°ÑÐ°",
        selectTargetMachine: "Select target machine",
        sendOrder: "ÐÐ·Ð¿ÑÐ°ÑÐ¸ Ð¿Ð¾ÑÑÑÐºÐ°ÑÐ°",
        sendOrderTo: "Your order will be sent to %{serverName}",
        targetMachine: "Ð¦ÐµÐ»ÐµÐ²Ð° Ð¼Ð°ÑÐ¸Ð½Ð°"
    },
    server: {
        computerId: "ÐÐ¾Ð¼Ð¿ÑÑÑÑ  ID",
        ip: "IP",
        selectServer: "ÐÐ¾Ð»Ñ, Ð¸Ð·Ð±ÐµÑÐ¸ ÐµÐ´Ð¸Ð½ Ð¾Ñ Ð´Ð¾ÑÑÑÐ¿Ð½Ð¸ÑÐµ ÑÑÑÐ²ÑÑÐ¸",
        server: "Ð¡ÑÑÐ²ÑÑ"
    },
    serverDialog: {
        1: "There is an error in the brand definition for your license. Please check with your provider.",
        2: "Could not process data for %{0}: %{1}",
        3: "Invalid network path.",
        4: "Invalid path type (only %{0} and %{1} types are supported)",
        5: "Error writing tinting file.",
        6: "Tinting file was created successfully.",
        7: "Could not find colorant with name: '%{0}' on row '%{1}'",
        8: "Could not find package with name: '%{0}' on row '%{1}'",
        9: "Could not find base in product with product name: '%{0}' and base name: '%{1}' on row '%{2}'",
        10: "Could not find base in product package with product name: '%{0}', base name: '%{1}' and package name: '%{2}' on row '%{3}'",
        11: "Could not parse price value: '%{0}' on row '%{1}' in sheet '%{2}'",
        12: "Preparing bases data, please wait",
        13: "Preparing bases in products data, please wait",
        14: "Preparing base packages data, please wait",
        15: "Preparing colors data, please wait",
        16: "Preparing colors in fandecks data, please wait",
        17: "Preparing fandecks data, please wait",
        18: "Preparing data for global search, please wait",
        19: "Preparing products data, please wait",
        30: "Partial updates can't be applied on database '%{0}'. Update your software to the latest version. Minimal required version is '%{1}'.",
        31: "Partial updates can't be applied on database '%{0}'. Database versions doesn't match. Contact your technical support.",
        32: "Partial updates can't be applied on database '%{0}'. Database structure version doesn't match. Contact your technical support.",
        33: "Partial updates can't be applied on database '%{0}'. The update is corrupted. Contact your technical support.",
        34: "Unknown error occurred during partial update. If this error repeats contact your technical support.",
        35: "No partial updates available. Please check your internet connection or contact your technical support.",
        36: "Prepared partial updates for database '%{0}' are for newer version of Redlike. Update your Redlike to the latest version. Minimal required version is '%{1}'.",
        37: "Partial updates can't be prepared. There is not enough space on the drive. Minimal required space is 20 GB.",
        38: "Partial updates can't be applied on database '%{0}'. The update is invalid. Contact your technical support.",
        39: "Partial updates can't be applied on database '%{0}'. The update can't be downloaded. Contact your technical support.",
        40: "Partial updates can't be applied on database '%{0}'. Downloaded file is corrupted. Contact your technical support."
    },
    serverPlugins: {
        activeServerPlugins: "ÐÐºÑÐ¸Ð²Ð½Ð¸ Ð¿Ð»ÑÐ³Ð¸Ð½Ð¸ Ð·Ð° ÑÑÑÐ²ÑÑ",
        currentlyActive: "Ð Ð¼Ð¾Ð¼ÐµÐ½ÑÐ° Ð°ÐºÑÐ¸Ð²Ð½Ð¸ÑÐµ Ð¿ÑÐ¸ÑÑÐ°Ð²ÐºÐ¸",
        plugin: "Plug-in",
        pluginName: "ÐÐ¼Ðµ Ð½Ð° Ð¿ÑÐ¸ÑÑÐ°Ð²ÐºÐ°ÑÐ°",
        statusActive: "ÐÐºÑÐ¸Ð²ÐµÐ½",
        statusInactive: "ÐÐºÑÑÐ°Ð»Ð½Ð°"
    },
    serviceActionsSettings: {
        canisterLevel: "ÐÐ¸Ð²Ð¾ Ð² ÑÐµÐ·ÐµÑÐ²Ð¾Ð°ÑÐ°",
        capClose: "ÐÐ°ÑÐ²Ð¾ÑÐ¸",
        capMiddle: "Ð¡ÑÐµÐ´ÐµÐ½",
        capOpen: "ÐÑÐ²Ð¾ÑÐµÐ½Ð¾",
        cleanAllChannels: "ÐÐ¾ÑÐ¸ÑÑÐµÑÐµ Ð²ÑÐ¸ÑÐºÐ¸ ÐºÐ°Ð½Ð°Ð»Ð¸",
        cleanChannels: "ÐÐ¾ÑÐ¸ÑÑÐ¸ ÐºÐ°Ð½Ð°Ð»Ð¸",
        computer: "ÐÐ¾Ð¼Ð¿ÑÑÑÑ",
        computerReboot: "Ð ÐµÑÑÐ°ÑÑÐ¸ÑÐ°Ð½Ðµ Ð½Ð° ÐºÐ¾Ð¼Ð¿ÑÑÑÑÐ°",
        computerShutdown: "ÐÐ·ÐºÐ»ÑÑÐ²Ð°Ð½Ðµ Ð½Ð° ÐºÐ¾Ð¼Ð¿ÑÑÑÑÐ°",
        connectMachine: "Ð¡Ð²ÑÑÐ¶Ð¸ Ð¼Ð°ÑÐ¸Ð½Ð°ÑÐ°",
        general: "ÐÐ±Ñ",
        initialize: "ÐÐ½Ð¸ÑÐ¸Ð°Ð»Ð¸Ð·Ð¸ÑÐ°Ð½Ðµ",
        noMachineIsConnected: "ÐÐ°ÑÐ¸Ð½Ð°ÑÐ° Ð½Ðµ Ðµ ÑÐ²ÑÑÐ·Ð°Ð½Ð°",
        plug: "ÐÐºÐ»ÑÑÐµÑÐµ",
        plugger: "ÐÐ°Ð¿ÑÑÐ°Ð»ÐºÐ°",
        punch: "Ð£Ð´Ð°Ñ",
        puncher: "ÐÐµÑÑÐ¾ÑÐ°ÑÐ¾Ñ",
        purgeChannels: "ÐÐ·ÑÐ¸ÑÑÐ¸ ÐºÐ°Ð½Ð°Ð»Ð¸",
        recirculate: "ÑÐµÑÐ¸ÑÐºÑÐ»Ð¸ÑÐ°Ð½Ðµ",
        recirculateAllChannels: "Ð ÐµÑÐ¸ÑÐºÑÐ»Ð°ÑÐ¸Ñ Ð½Ð° Ð²ÑÐ¸ÑÐºÐ¸ ÐºÐ°Ð½Ð°Ð»Ð¸",
        recirculateChannels: "Ð ÐµÑÐ¸ÑÐºÑÐ»Ð°ÑÐ¸Ñ Ð½Ð° ÐºÐ°Ð½Ð°Ð»Ð¸",
        serviceActions: "Ð¡ÐµÑÐ²Ð¸Ð·Ð½Ð¸ Ð´ÐµÐ¹Ð½Ð¾ÑÑÐ¸",
        setCanisterLevel: "Set canister level",
        shelfDown: "ÐÐ»Ð¾Ñ Ð½Ð°Ð´Ð¾Ð»Ñ",
        shelfUp: "ÐÐ»Ð¾Ñ Ð½Ð°Ð³Ð¾ÑÐµ",
        showServiceWindow: "ÐÐ¾ÐºÐ°Ð¶Ð¸ Ð¿ÑÐ¾Ð·Ð¾ÑÐµÑÐ° Ð·Ð° ÑÐµÑÐ²Ð¸Ð·Ð½Ð¸ Ð´ÐµÐ¹Ð½Ð¾ÑÑÐ¸",
        smartPurgeAllChannels: "Smart purge all channels",
        smartPurgeChannels: "Smart purge channels",
        startErrorReset: "Ð¡ÑÐ°ÑÑÐ¸ÑÐ°Ð¹ Ð½ÑÐ»Ð¸ÑÐ°Ð½Ðµ Ð½Ð°Ð³ÑÐµÑÐºÐ°",
        startHardReset: "Ð¡ÑÐ°ÑÑÐ¸ÑÐ°Ð¹ ÑÐ²ÑÑÐ´Ð¾ Ð½ÑÐ»Ð¸ÑÐ°Ð½Ðµ",
        startReset: "Ð¡ÑÐ°ÑÑÐ¸ÑÐ°Ð¹ Ð½ÑÐ»Ð¸ÑÐ°Ð½Ðµ Ð½Ð°Ð³ÑÐµÑÐºÐ°",
        stirAllCanisters: "Ð Ð°Ð·Ð±ÑÑÐºÐ°Ð¹ÑÐµ Ð²ÑÐ¸ÑÐºÐ¸ ÑÐµÐ·ÐµÑÐ²Ð¾Ð°ÑÐ¸",
        stirCanisters: "Ð Ð°Ð·Ð±ÑÑÐºÐ°Ð¹ÑÐµ ÑÐµÐ·ÐµÑÐ²Ð¾Ð°ÑÐ¸",
        stirCanistersMore: "Ð Ð°Ð·Ð±ÑÑÐºÐ°Ð¹ÑÐµ ÑÐµÐ·ÐµÑÐ²Ð¾Ð°ÑÐ¸"
    },
    spectroMode: {
        eggshell: "Eggshell",
        flat: "Flat",
        gloss: "Gloss",
        matt: "Matt",
        matte: "Matte",
        pearl: "Pearl",
        satin: "Satin",
        selectGlossLevel: "Compare the color sample to the gloss scale and select gloss level",
        semiGloss: "Semi-Gloss"
    },
    spectroTab: {
        bestMatch: "The best match",
        calibrate: "ÐÐ°Ð»Ð¸Ð±ÑÐ¸ÑÐ°Ð¹",
        calibrateInstrument: "Calibrate instrument",
        connectDevice: "Ð¡Ð²ÑÑÐ¶Ð¸ ÑÑÑÑÐ¾Ð¹ÑÑÐ²Ð¾ÑÐ¾",
        connectedTo: "Ð¡Ð²ÑÑÐ·Ð°Ð½Ð¾ ÑÑÑ",
        connectingDevice: "Ð¡Ð²ÑÑÐ°Ð½Ð¾ ÑÑÑÑÐ¾Ð¹ÑÑÐ²Ð¾",
        deselectAll: "ÐÑÐµÐ¼Ð°ÑÐ²Ð°Ð½Ð¸ Ð²ÑÐ¸ÑÐºÐ¸",
        deviceCalibrated: "Your device has been calibrated and you can start measuring",
        deviceIsNotCalibrated: "Ð£ÑÑÑÐ¾Ð¹ÑÑÐ²Ð¾ÑÐ¾ Ð½Ðµ Ðµ ÐºÐ°Ð»Ð¸Ð±ÑÐ¸ÑÐ°Ð½Ð¾",
        eraseResult: "Erase result",
        filter: "Ð¤Ð¸Ð»ÑÑÑ",
        foundInFormulas: "ÐÐ°Ð¼ÐµÑÐ¸ Ð²ÑÐ² ÑÐ¾ÑÐ¼ÑÐ»Ð¸ÑÐµ",
        inactiveSpectro: "The Spectro function is inactive for selected brand.",
        instrumentCalibration: "Your instrument needs to be calibrated.",
        manualInput: "Manual input",
        measure: "Measure",
        measurementResult: "Ð ÐµÐ·ÑÐ»ÑÐ°Ñ Ð½Ð° Ð¸Ð·Ð¼ÐµÑÐ²Ð°Ð½Ðµ",
        noFilters: "ÐÑÐ¼Ð° Ð½Ð°Ð»Ð¸ÑÐ½Ð¸ ÑÐ¸Ð»ÑÑÐ¸",
        noFormulas: "ÐÐµ ÑÐ° Ð¾ÑÐºÑÐ¸ÑÐ¸ ÑÐ¾ÑÐ¼ÑÐ»Ð¸",
        noSelectedSpectro: "ÐÐµ Ðµ Ð¸Ð·Ð±ÑÐ°Ð½Ð¾ ÑÑÑÑÐ¾Ð¹ÑÑÐ²Ð¾",
        notSelected: "ÐÐµ Ðµ Ð¸Ð·Ð±ÑÐ°Ð½Ð¾",
        pressConnectButton: "ÐÐ°ÑÐ¸ÑÐ½Ð¸ Ð±ÑÑÐ¾Ð½ Ð¡Ð²ÑÑÐ¶Ð¸",
        searchFormulas: "Ð¢ÑÑÑÐ¸ ÑÐ¾ÑÐ¼ÑÐ»Ð¸",
        selectSpectro: "ÐÐ·Ð±ÐµÑÐµÑÐµ Spectro",
        showDetails: "ÐÐ¾ÐºÐ°Ð¶Ð¸ Ð´ÐµÑÐ°Ð¹Ð»Ð¸",
        skipCalibration: "Skip calibration",
        spectroIsConnected: "Spectro Ðµ ÑÐ²ÑÑÐ·Ð°Ð½",
        spectroIsReady: "Spectro Ðµ Ð³Ð¾ÑÐ¾Ð²",
        spectroReady: "Ð£ÑÑÑÐ¾Ð¹ÑÑÐ²Ð¾ÑÐ¾ Ðµ Ð³Ð¾ÑÐ¾Ð²Ð¾ Ð·Ð° Ð¿Ð¾-Ð½Ð°ÑÐ°ÑÑÑÐ½Ð¸ Ð·Ð°Ð´Ð°ÑÐ¸",
        startCalibrateNow: "Start calibrate now",
        startMeasureText: "Ð£ÑÑÑÐ¾Ð¹ÑÑÐ²Ð¾ÑÐ¾ Ðµ Ð½Ð°ÑÑÑÐ¾ÐµÐ½Ð¾ Ð¸ Ð¼Ð¾Ð¶ÐµÑÐµ Ð´Ð° Ð·Ð°Ð¿Ð¾ÑÐ½ÐµÑÐµ Ð¸Ð·Ð¼ÐµÑÐ²Ð°Ð½Ðµ",
        tolerance: "Delta E (CIE 2000)",
        toleranceOfDevitation: "Delta E (CIE 2000) ÑÐ¾Ð»ÐµÑÐ°Ð½Ñ"
    },
    statisticsTab: {
        allRecords: "All records",
        customPackageName: "ÐÐµÑÑÐ¾Ð½Ð°Ð»Ð¸Ð·Ð¸ÑÐ°Ð½ %{1} %{2}",
        deleteSelectedRecords: "ÐÐ·ÑÑÐ¸Ð¹ Ð¸Ð·Ð±ÑÐ°Ð½Ð¸ÑÐµ Ð·Ð°Ð¿Ð¸ÑÐ¸",
        exportHistory: "ÐÑÑÐ¾ÑÐ¸Ñ Ð½Ð° ÐµÐºÑÐ¿Ð¾ÑÑÐ¸ÑÐ°Ð½Ðµ",
        finishFormula: "ÐÐ°Ð²ÑÑÑÐµÑÐµ ÑÐ¾ÑÐ¼ÑÐ»Ð°",
        foundInFormulas: "ÐÐ°Ð¼ÐµÑÐ¸ Ð²ÑÐ² ÑÐ¾ÑÐ¼ÑÐ»Ð¸ÑÐµ",
        hideHiddenRecords: "ÐÐ° Ð½Ðµ ÑÐµ Ð¿Ð¾ÐºÐ°Ð·Ð²Ð°Ñ ÑÐºÑÐ¸ÑÐ¸ÑÐµ Ð·Ð°Ð¿Ð¸ÑÐ¸",
        hideSelectedRecord: "Ð¡ÐºÑÐ¸Ð¹ Ð¸Ð·Ð±ÑÐ°Ð½ Ð·Ð°Ð¿Ð¸Ñ",
        historicalFormula: "Historical formula",
        onlyFiltered: "Only filtered",
        restoreSelectedRecord: "ÐÑÐ·ÑÑÐ°Ð½Ð¾Ð²ÑÐ²Ð°Ð½Ðµ Ð½Ð° Ð¸Ð·Ð±ÑÐ°Ð½Ð¸Ñ Ð·Ð°Ð¿Ð¸Ñ",
        showAllRecords: "ÐÐ¾ÐºÐ°Ð·Ð²Ð°Ð½Ðµ Ð½Ð° Ð²ÑÐ¸ÑÐºÐ¸ Ð·Ð°Ð¿Ð¸ÑÐ¸",
        standardFormula: "Standard formula",
        unknownFormula: "Unknown formula"
    },
    stirCanisters: {
        selectCanisters: "ÐÐ·Ð±ÐµÑÐµÑÐµ ÑÐµÐ·ÐµÑÐ²Ð¾Ð°ÑÐ¸",
        startStirring: "Ð¡ÑÐ°ÑÑ ÑÐ°Ð·Ð±ÑÑÐºÐ²Ð°Ð½Ðµ",
        stirAllCanisters: "Stir all canisters",
        stirCanisters: "Stir canisters",
        stirringSpeed: "Ð¡ÐºÐ¾ÑÐ¾ÑÑ Ð½Ð° ÑÐ°Ð·Ð±ÑÑÐºÐ²Ð°Ð½Ðµ",
        stirringTime: "ÐÑÐµÐ¼Ðµ Ð·Ð° ÑÐ°Ð·Ð±ÑÑÐºÐ²Ð°Ð½Ðµ"
    },
    stock: {
        addColorant: "Add colorant...",
        addColorantPackagesToStock: "Add colorant packages to stock",
        addPackagesToStock: "Add packages to stock",
        addedToStock: "Added to stock",
        allDatabases: "All databases",
        checkStockPackageInventory: "If you used package from stock, please check if your stock inventory is valid.",
        clearAllItems: "Clear all items",
        colorantInventory: "Colorant inventory",
        colorantsStockInventory: "Colorants stock inventory",
        confirmSendingOrder: "Confirm sending order",
        consumptionPrediction: "Consumption prediction for the next %{weeks} weeks",
        createOrder: "Create order (%{sum})",
        expirationDate: "Expiration date",
        inDelivery: "In delivery",
        manualOrder: "Manual order",
        manualOrderProgress: "Step %{step}/%{total}",
        noPackagesFoundInStockForColorant: "There are no packages in stock for this colorant.",
        onStock: "In stock",
        orderSummary: "Order summary",
        prediction: "Prediction",
        removePackageFromStock: "Remove %{colorantName} package from stock",
        removePackageNameFromStock: "Would you like to remove one %{packageName} package from stock?",
        scanBarcodeOrSelectColorant: "Scan barcode from package or select colorant",
        selectPackageToRemove: "Select package to remove",
        sendConfirmed: "Send confirmed",
        setAmountsByPrediction: "Set amounts by prediction",
        sortByColorantName: "Sort by colorant name",
        sortByOrderNeed: "Sort by need to order",
        sortByStockLevel: "Sort by stock level",
        toOrder: "To order"
    },
    testBarcode: {
        noItemAssigned: "ÐÐµ Ðµ Ð¿ÑÐ¸ÑÐ²Ð¾ÐµÐ½ ÐµÐ»ÐµÐ¼ÐµÐ½Ñ ÐºÑÐ¼ Ð±Ð°ÑÐºÐ¾Ð´ %{code}",
        pleaseScanBarcode: "Please scan the barcode of base, product, package or another items",
        testBarcodes: "Test barcodes"
    },
    ticketing: {
        answer: "Answer",
        answered: "Answered",
        chooseType: "Choose type",
        closeRequest: "Close request",
        comment: "Comment",
        create: "Create",
        createNewTicket: "Create new ticket",
        formulaAttached: "The requested formula is attached to the answer. Click the %{loadFormula} button to open it.",
        formulaClaim: "Formula claim",
        formulaRequest: "Formula request",
        formulaUnrealizable: "The requested formula is unrealizable.",
        newTicket: "New ticket",
        noPosInfoFound: "POS information (name, city) not found",
        noTicketSelected: "No ticket selected",
        openTicket: "Open ticket",
        posName: "POS name",
        posted: "Posted",
        request: "Request",
        requestDate: "Request date",
        requestId: "Request ID",
        resolvedBy: "Resolved by",
        responseDate: "Response date",
        saveToCustomFormula: "Save to custom formula",
        sending: "Sending",
        service: "Service",
        successfulCreation: "Ticket successfully created. Sending...",
        ticketAnswered: "A ticket has been answered.",
        ticketDelivered: "A ticket has been delivered.",
        ticketId: "Ticket ID",
        ticketType: "Ticket type",
        waitingForAnswer: "Waiting for answer"
    },
    tutorial: {
        last: "Ð¿Ð¾ÑÐ»ÐµÐ´Ð½Ð¾",
        next: "Ð¡Ð»ÐµÐ´Ð²Ð°ÑÐ¸Ñ"
    },
    ufiCodeModal: {
        currentStatus: "Current Status",
        detailedInfoForColorant: "Detailed info for colorant %{colorantName}",
        userSetUfiCode: "User set UFI code, current value"
    },
    ufiCodeSettings: {
        baseUfiCodeValidation: "Base UFI code validation",
        confirmColorantRefilling: "Confirm colorant refilling",
        enableUfiCodes: "Enable UFI codes",
        printUfiCode: "Print if amount of colorant is over",
        printUfiCodePercentage: "Print percentage if amount of colorant is over",
        scanOrTypeUfiCode: "Scan or type UFI code",
        scanOrTypeUfiCodeOfBase: "Scan or type UFI code of base can",
        ufiCodesByPercentage: "Use UFI codes by percentage",
        ufiCodesFromDatabase: "Use UFI codes from the database",
        ufiCodesFromLastFilling: "Use UFI codes from the last filling"
    },
    userSettings: {
        addUser: "ÐÐ¾Ð±Ð°Ð²ÑÐ½Ðµ Ð½Ð° Ð¿Ð¾ÑÑÐµÐ±Ð¸ÑÐµÐ»",
        assignedUserGroups: "ÐÐ°Ð·Ð½Ð°ÑÐµÐ½Ð¸ Ð¿Ð¾ÑÑÐµÐ±Ð¸ÑÐµÐ»ÑÐºÐ¸ Ð³ÑÑÐ¿Ð¸",
        availableUserGroups: "ÐÐ°Ð»Ð¸ÑÐ½Ð¸ Ð¿Ð¾ÑÑÐµÐ±Ð¸ÑÐµÐ»ÑÐºÐ¸ Ð³ÑÑÐ¿Ð¸",
        barcode: "ÐÐ°ÑÐºÐ¾Ð´",
        confirmNewPassword: "ÐÐ¾ÑÐ²ÑÑÐ´Ð¸ Ð¿Ð°ÑÐ¾Ð»Ð°",
        editPassword: "Ð ÐµÐ´Ð°ÐºÑÐ¸ÑÐ°Ð½Ðµ Ð½Ð° Ð¿Ð°ÑÐ¾Ð»Ð°",
        editUser: "Ð ÐµÐ´Ð°ÐºÑÐ¸ÑÐ°Ð½Ðµ Ð½Ð° Ð¿Ð¾ÑÑÐµÐ±Ð¸ÑÐµÐ»",
        enableAutoLogin: "ÐÐºÑÐ¸Ð²Ð¸ÑÐ°Ð½Ðµ Ð½Ð° Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐ½Ð¾ÑÐ¾ Ð²Ð¿Ð¸ÑÐ²Ð°Ð½Ðµ",
        newPassword: "ÐÐ¾Ð²Ð° Ð¿Ð°ÑÐ¾Ð»Ð°",
        noChange: "ÐÑÐ¼Ð° Ð¿ÑÐ¾Ð¼ÑÐ½Ð°, ÐºÐ¾ÑÑÐ¾ Ð´Ð° Ð±ÑÐ´Ðµ Ð·Ð°Ð¿Ð°Ð·ÐµÐ½Ð°",
        oldPassword: "Ð¡ÑÐ°ÑÐ° Ð¿Ð°ÑÐ¾Ð»Ð°",
        password: "ÐÐ°ÑÐ¾Ð»Ð°",
        passwordsDoNotMatch: "ÐÐ°ÑÐ¾Ð»Ð¸ÑÐµ Ð½Ðµ ÑÑÐ²Ð¿Ð°Ð´Ð°Ñ",
        restoreUser: "This user is deleted. Do you want to restore him?",
        userGroup: "User Group",
        userGroups: "ÐÐ¾ÑÑÐµÐ±Ð¸ÑÐµÐ»ÑÐºÐ¸ Ð³ÑÑÐ¿Ð¸",
        userManagement: "Ð£Ð¿ÑÐ°Ð²Ð»ÐµÐ½Ð¸Ðµ Ð½Ð° Ð¿Ð¾ÑÑÐµÐ±Ð¸ÑÐµÐ»Ð¸",
        userSettings: "User settings",
        username: "ÐÐ¾ÑÑÐµÐ±Ð¸ÑÐµÐ»",
        usernameIsMissing: "ÐÐ¾ÑÑÐµÐ±Ð¸ÑÐµÐ»ÑÐºÐ¾ÑÐ¾ Ð¸Ð¼Ðµ Ð»Ð¸Ð¿ÑÐ²Ð°."
    },
    warningMissingDataModal: {
        continue: "Same data is missing, do you want continue?",
        notFoundBase:
            "This product base is not available. Confirm and be careful to get compatible product base from shelf or cancel this order.",
        notFoundProduct:
            "This product is not available. Confirm and be careful to get compatible product from shelf or cancel this order."
    },
    weekdays: {
        friday: "Ð¿ÐµÑÑÐº",
        monday: "Ð¿Ð¾Ð½ÐµÐ´ÐµÐ»Ð½Ð¸Ðº",
        saturday: "ÑÑÐ±Ð¾ÑÐ°",
        sunday: "Ð½ÐµÐ´ÐµÐ»Ñ",
        thursday: "ÑÐµÑÐ²ÑÑÑÑÐº",
        tuesday: "Ð²ÑÐ¾ÑÐ½Ð¸Ðº",
        wednesday: "ÑÑÑÐ´Ð°"
    },
    welcome: {
        availableDatabase: "Server cannot connect to database. Please check your database configuration.",
        availableDatabaseLocalError:
            "ÐÑÐµÑÐºÐ° Ð¿Ð¾ Ð²ÑÐµÐ¼Ðµ Ð½Ð° ÑÐ²ÑÑÐ·Ð²Ð°Ð½Ðµ ÐºÑÐ¼ Ð»Ð¾ÐºÐ°Ð»Ð½Ð°ÑÐ° Ð±Ð°Ð·Ð° Ð´Ð°Ð½Ð½Ð¸ (Ð³ÑÐµÑÐµÐ½ ÑÐ°Ð¹Ð», Ð½ÐµÐ²Ð°Ð»Ð¸Ð´Ð½Ð° Ð¿Ð°ÑÐ¾Ð»Ð°)",
        availableDatabaseLocalMissing: "ÐÐ¾ÐºÐ°Ð»ÐµÐ½  ÑÐ°Ð¹Ð» Ð½Ð° Ð±Ð°Ð·Ð°ÑÐ° Ð´Ð°Ð½Ð½Ð¸ Ð»Ð¸Ð¿ÑÐ²Ð°",
        availableDatabaseLocalUpdate: "ÐÐ¾ÐºÐ°Ð»Ð½Ð°ÑÐ°  Ð±Ð°Ð·Ð° Ð´Ð°Ð½Ð½Ð¸ ÑÑÑÐ±Ð²Ð° Ð´Ð° Ð±ÑÐ´Ðµ Ð°ÐºÑÑÐ°Ð»Ð¸Ð·Ð¸ÑÐ°Ð½ Ð´Ð¾ Ð¿Ð¾-Ð½Ð¾Ð²Ð° Ð²ÐµÑÑÐ¸Ñ",
        availableDatabaseMainAndLocalError:
            "Error during connecting to both main and local databases (wrong file, invalid password)",
        availableDatabaseMainAndLocalMissing: "ÐÐ¸Ð¿ÑÐ²Ð°Ñ ÑÐ°Ð¹Ð»Ð¾Ð²Ðµ Ð½Ð° Ð¾ÑÐ½Ð¾Ð²Ð½Ð°ÑÐ° Ð¸ Ð»Ð¾ÐºÐ°Ð»Ð½Ð° Ð±Ð°Ð·Ð° Ð´Ð°Ð½Ð½Ð¸",
        availableDatabaseMainAndLocalUpdate:
            "ÐÑÐ½Ð¾Ð²Ð½Ð°ÑÐ° Ð¸ Ð»Ð¾ÐºÐ°Ð»Ð½Ð° Ð±Ð°Ð·Ð° Ð´Ð°Ð½Ð½Ð¸ ÑÑÑÐ±Ð²Ð° Ð´Ð° Ð±ÑÐ´Ð°Ñ Ð°ÐºÑÑÐ°Ð»Ð¸Ð·Ð¸ÑÐ°Ð½Ð¸ Ð´Ð¾ Ð¿Ð¾-Ð½Ð¾Ð²Ð° Ð²ÐµÑÐ·Ð¸Ñ",
        availableDatabaseMainError:
            "ÐÑÐµÑÐºÐ° Ð¿Ð¾ Ð²ÑÐµÐ¼Ðµ Ð½Ð° ÑÐ²ÑÑÐ·Ð²Ð°Ð½Ðµ ÐºÑÐ¼ Ð¾ÑÐ½Ð¾Ð²Ð½Ð°ÑÐ° Ð±Ð°Ð·Ð° Ð´Ð°Ð½Ð½Ð¸ (Ð³ÑÐµÑÐµÐ½ ÑÐ°Ð¹Ð», Ð½ÐµÐ²Ð°Ð»Ð¸Ð´Ð½Ð° Ð¿Ð°ÑÐ¾Ð»Ð°)",
        availableDatabaseMainMissing: "ÐÐ¸Ð¿ÑÐ²Ð° ÑÐ°Ð¹Ð» Ð½Ð° Ð¾ÑÐ½Ð¾Ð²Ð½Ð°ÑÐ°  Ð±Ð°Ð·Ð° Ð´Ð°Ð½Ð½Ð¸",
        availableDatabaseMainPartialUpdate: "Main database needs to be updated to the newer version via partial update",
        availableDatabaseMainPartialUpdateAndLocalUpdate:
            "Main database needs to be updated to the newer version via partial update and local database needs to be updated to the newer version",
        availableDatabaseMainUpdate: "ÐÑÐ½Ð¾Ð²Ð½Ð° Ð±Ð°Ð·Ð° Ð´Ð°Ð½Ð½Ð¸ ÑÑÑÐ±Ð²Ð° Ð´Ð° Ð±ÑÐ´Ðµ Ð°ÐºÑÑÐ°Ð»Ð¸Ð·Ð¸ÑÐ°Ð½Ð° Ð´Ð¾ Ð¿Ð¾-Ð½Ð¾Ð²Ð° Ð²ÐµÑÑÐ¸Ñ",
        closing: "Ð¡Ð¾ÑÑÑÐµÑÑÑ Ð·Ð°ÑÐ²Ð°ÑÑ",
        compatibility:
            "Please check the version of your server. Your client is compatible only with server %{0} or higher.",
        compatibilityCheck: "ÐÑÐ¾Ð²ÐµÑÐºÐ° Ð·Ð° ÑÑÐ²Ð¼ÐµÑÑÐ¸Ð¼Ð¾ÑÑ",
        compatibilityDatabase: "Ð¡ÑÐ²Ð¼ÐµÑÑÐ¾Ð¼Ð¾ÑÑ Ð½Ð° Ð±Ð°Ð·Ð° Ð´Ð°Ð½Ð½Ð¸",
        connectingServer: "Ð¡Ð²ÑÑÐ·Ð²Ð°Ð½Ðµ ÐºÑÐ¼ ÑÑÑÐ²ÑÑ %{ip}",
        databaseCompatibility: "ÐÐ°ÑÐ°ÑÐ° Ð±Ð°Ð·Ð° Ð´Ð°Ð½Ð½Ð¸ Ð½Ðµ Ðµ ÑÑÐ²Ð¼ÐµÑÑÐ¸Ð¼Ð° Ñ ÑÐµÐºÑÑÐ¸Ñ ÑÐ¾ÑÑÑÐµÑ",
        databasesCompatibility: "ÐÐ°ÑÐ¸ÑÐµ Ð±Ð°Ð·Ð¸ Ð´Ð°Ð½Ð½Ð¸ Ð½Ðµ ÑÐ° ÑÑÐ²Ð¼ÐµÑÑÐ¸Ð¼Ð¸ Ñ ÑÐµÐºÑÑÐ¸Ñ ÑÐ¾ÑÑÑÐµÑ",
        licenseVerification: "ÐÑÐ¾Ð²ÐµÑÐºÐ° Ð½Ð° Ð»Ð¸ÑÐµÐ½Ð·Ð°",
        loading: "ÐÐ°ÑÐµÐ¶Ð´Ð°Ð½Ðµ",
        lostConnection: "ÐÐ·Ð³ÑÐ±ÐµÐ½Ð° Ð²ÑÑÐ·ÐºÐ°",
        moduleMessage:
            "Pay attention to module selection, because future change of module will be available only for privileged users.",
        refresh: "ÐÐ±Ð½Ð¾Ð²ÑÐ²Ð°Ð½Ðµ",
        restoring: "ÐÑÐ·ÑÑÐ°Ð½Ð¾Ð²ÑÐ²Ð°Ð½Ðµ Ð½Ð° Ð²ÑÑÐ·ÐºÐ°",
        selectModule: "ÐÐ¾Ð»Ñ, Ð¸Ð·Ð±ÐµÑÐµÑÐµ ÐµÐ´Ð¸Ð½ Ð¾Ñ Ð½Ð°Ð»Ð¸ÑÐ½Ð¸ÑÐµ Ð¼Ð¾Ð´ÑÐ»Ð¸.",
        stopUpdate: "Ð¡Ð¿ÑÐ¸ Ð°ÐºÑÑÐ°Ð»Ð¸Ð·Ð¸ÑÐ°Ð½ÐµÑÐ¾",
        updateDatabase: "ÐÐºÑÑÐ°Ð»Ð¸Ð·Ð¸ÑÐ°Ð½Ðµ Ð½Ð° Ð±Ð°Ð·Ð° Ð´Ð°Ð½Ð½Ð¸",
        updatingDatabase: "ÐÐ°Ð·Ð°ÑÐ° Ð´Ð°Ð½Ð½Ð¸ ÑÐµ Ð°ÐºÑÑÐ°Ð»Ð¸Ð·Ð¸ÑÐ°",
        updatingDatabases: "ÐÐ°Ð·Ð¸ÑÐµ Ð´Ð°Ð½Ð½Ð¸ ÑÐµ Ð°ÐºÑÑÐ°Ð»Ð¸Ð·Ð¸ÑÐ°Ñ",
        updatingWarning: "Database structure is being updated to the newest version, please wait.",
        updatingWarningInfo:
            "Do not close this window as it would result in the necessity to do the update from scratch."
    }
};
